webpackJsonp([3],{

/***/ 1106:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(755);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(35)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1107:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(756);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(35)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1108:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(757);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(35)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1109:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(758);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(35)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1110:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(759);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(35)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1111:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(760);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(35)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1112:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(761);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(35)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1113:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(762);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(35)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./svg-icon.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./svg-icon.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1114:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(763);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(35)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1115:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(764);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(35)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(765);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(35)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1117:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(766);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(35)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules=false!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./core.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules=false!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./core.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1122:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNDEwNzQgNi40MDgxNEM2LjczNjE3IDYuMDgyNyA3LjI2MzgxIDYuMDgyNyA3LjU4OTI1IDYuNDA4MTRMMTIgMTAuODE4OUwxNi40MTA3IDYuNDA4MTRDMTYuNzM2MiA2LjA4MjcgMTcuMjYzOCA2LjA4MjcgMTcuNTg5MiA2LjQwODE0QzE3LjkxNDcgNi43MzM1OCAxNy45MTQ3IDcuMjYxMjEgMTcuNTg5MiA3LjU4NjY1TDEzLjE3ODUgMTEuOTk3NEwxNy41ODkyIDE2LjQwODFDMTcuOTE0NyAxNi43MzM2IDE3LjkxNDcgMTcuMjYxMiAxNy41ODkyIDE3LjU4NjdDMTcuMjYzOCAxNy45MTIxIDE2LjczNjIgMTcuOTEyMSAxNi40MTA3IDE3LjU4NjdMMTIgMTMuMTc1OUw3LjU4OTI1IDE3LjU4NjdDNy4yNjM4MSAxNy45MTIxIDYuNzM2MTcgMTcuOTEyMSA2LjQxMDc0IDE3LjU4NjdDNi4wODUzIDE3LjI2MTIgNi4wODUzIDE2LjczMzYgNi40MTA3NCAxNi40MDgxTDEwLjgyMTUgMTEuOTk3NEw2LjQxMDc0IDcuNTg2NjVDNi4wODUzIDcuMjYxMjEgNi4wODUzIDYuNzMzNTggNi40MTA3NCA2LjQwODE0WiIgZmlsbD0iI0U0NjQyQSIgc3Ryb2tlPSIjRTQ2NDJBIiBzdHJva2Utd2lkdGg9IjAuMzUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 1123:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjMzMzUgN0w5LjgyNzQyIDE2LjMzMzNMNi4wMDAxNiAxMi41NzU2IiBzdHJva2U9IiMxRDlCMzciIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styled = __webpack_require__(468);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = function Container(props) {
    var children = props.children,
        className = props.className,
        zeroPadding = props.zeroPadding;

    var styleProps = { zeroPadding: zeroPadding };

    return _react2.default.createElement(
        _styled.ContainerWrapper,
        _extends({ className: className }, styleProps),
        children
    );
};

Container.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    zeroPadding: _propTypes2.default.bool
};

exports.default = Container;

/***/ }),

/***/ 1144:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1145:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1146:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(384);
__webpack_require__(383);
module.exports = __webpack_require__(385);


/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styled = __webpack_require__(486);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(_ref) {
    var title = _ref.title,
        subtitle = _ref.subtitle;
    return _react2.default.createElement(
        _styled.HeaderWrapper,
        null,
        _react2.default.createElement(
            _styled.MainHeading,
            null,
            title
        ),
        subtitle && _react2.default.createElement(
            _styled.SubHeading,
            null,
            subtitle
        )
    );
};

Header.propTypes = {
    title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
    subtitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};

exports.default = Header;

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(160);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(1115);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withLoader = function withLoader(loadingProp) {
    return function (WrappedComponent) {
        return function (_Component) {
            _inherits(_class, _Component);

            function _class(props) {
                _classCallCheck(this, _class);

                var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

                _this.isLoading = _this.isLoading.bind(_this);
                return _this;
            }

            _createClass(_class, [{
                key: 'isLoading',
                value: function isLoading() {
                    var props = this.props;

                    return props[loadingProp] !== null && props[loadingProp] !== undefined && props[loadingProp] === true;
                }
            }, {
                key: 'render',
                value: function render() {
                    var loadingContent = this.isLoading() ? _react2.default.createElement(
                        'div',
                        { className: _index4.default.loadingContainer },
                        _react2.default.createElement(_index2.default, null)
                    ) : '';

                    return _react2.default.createElement(
                        'div',
                        { className: 'has-a-loader' },
                        loadingContent,
                        _react2.default.createElement(WrappedComponent, this.props)
                    );
                }
            }]);

            return _class;
        }(_react.Component);
    };
};

exports.default = withLoader;

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showPublishModal = exports.SHOW_PUBLISH_MODAL = exports.hideToastRequest = exports.HIDE_TOAST = exports.setCourseCreatorAsClean = exports.SET_COURSE_CREATOR_AS_CLEAN = exports.setCourseCreatorAsModified = exports.SET_COURSE_CREATOR_AS_MODIFIED = exports.openAlertModal = exports.closeAlertModal = exports.CLOSE_ALERT_MODAL = exports.OPEN_ALERT_MODAL = exports.getDefaultCourseFailure = exports.getDefaultCourseSuccess = exports.getDefaultCourse = exports.GET_DEFAULT_COURSE_FAILURE = exports.GET_DEFAULT_COURSE_SUCCESS = exports.GET_DEFAULT_COURSE_REQUEST = exports.cancelValidationErrorsRequest = exports.CANCEL_VALIDATION_ERRORS_REQUEST = exports.publishCourseFailure = exports.publishCourseSuccess = exports.publishCourse = exports.PUBLISH_COURSE_FAILURE = exports.PUBLISH_COURSE_SUCCESS = exports.PUBLISH_COURSE_REQUEST = exports.saveCourseFailure = exports.saveCourseValidationError = exports.saveCourseSuccess = exports.saveCourse = exports.SAVE_COURSE_FAILURE = exports.SAVE_COURSE_VALIDATION_ERROR = exports.SAVE_COURSE_SUCCESS = exports.SAVE_COURSE_REQUEST = exports.updateTopicTreeRequest = exports.getMasterCourseFailure = exports.getMasterCourseSuccess = exports.getMasterCourserequest = exports.UPDATE_TOPIC_TREE_REQUEST = exports.GET_MASTER_COURSE_FAILURE = exports.GET_MASTER_COURSE_SUCCESS = exports.GET_MASTER_COURSE_REQUEST = undefined;

var _constants = __webpack_require__(19);

var GET_MASTER_COURSE_REQUEST = exports.GET_MASTER_COURSE_REQUEST = 'GET_MASTER_COURSE_REQUEST';
var GET_MASTER_COURSE_SUCCESS = exports.GET_MASTER_COURSE_SUCCESS = 'GET_MASTER_COURSE_SUCCESS';
var GET_MASTER_COURSE_FAILURE = exports.GET_MASTER_COURSE_FAILURE = 'GET_MASTER_COURSE_FAILURE';
var UPDATE_TOPIC_TREE_REQUEST = exports.UPDATE_TOPIC_TREE_REQUEST = 'UPDATE_TOPIC_TREE_REQUEST';

var getMasterCourserequest = exports.getMasterCourserequest = function getMasterCourserequest(masterCourseId) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return { type: GET_MASTER_COURSE_REQUEST, masterCourseId: masterCourseId, version: version };
};

var getMasterCourseSuccess = exports.getMasterCourseSuccess = function getMasterCourseSuccess(data) {
    return { type: GET_MASTER_COURSE_SUCCESS,
        masterCourse: data.masterCourse,
        curriculumLevelDescriptions: data.curriculumLevelDescriptions,
        strandSubStrands: data.strandSubStrands
    };
};

var getMasterCourseFailure = exports.getMasterCourseFailure = function getMasterCourseFailure() {
    return { type: GET_MASTER_COURSE_FAILURE };
};

var updateTopicTreeRequest = exports.updateTopicTreeRequest = function updateTopicTreeRequest(request) {
    return { type: UPDATE_TOPIC_TREE_REQUEST, request: request };
};

var SAVE_COURSE_REQUEST = exports.SAVE_COURSE_REQUEST = 'SAVE_COURSE_REQUEST';
var SAVE_COURSE_SUCCESS = exports.SAVE_COURSE_SUCCESS = 'SAVE_COURSE_SUCCESS';
var SAVE_COURSE_VALIDATION_ERROR = exports.SAVE_COURSE_VALIDATION_ERROR = 'SAVE_COURSE_VALIDATION_ERROR';
var SAVE_COURSE_FAILURE = exports.SAVE_COURSE_FAILURE = 'SAVE_COURSE_FAILURE';

var saveCourse = exports.saveCourse = function saveCourse(request) {
    return {
        type: SAVE_COURSE_REQUEST,
        request: request
    };
};

var saveCourseSuccess = exports.saveCourseSuccess = function saveCourseSuccess(newCourseId) {
    return {
        type: SAVE_COURSE_SUCCESS,
        newCourseId: newCourseId
    };
};

var saveCourseValidationError = exports.saveCourseValidationError = function saveCourseValidationError(message) {
    return {
        type: SAVE_COURSE_VALIDATION_ERROR,
        message: message
    };
};

var saveCourseFailure = exports.saveCourseFailure = function saveCourseFailure() {
    return {
        type: SAVE_COURSE_FAILURE
    };
};

var PUBLISH_COURSE_REQUEST = exports.PUBLISH_COURSE_REQUEST = 'PUBLISH_COURSE_REQUEST';
var PUBLISH_COURSE_SUCCESS = exports.PUBLISH_COURSE_SUCCESS = 'PUBLISH_COURSE_SUCCESS';
var PUBLISH_COURSE_FAILURE = exports.PUBLISH_COURSE_FAILURE = 'PUBLISH_COURSE_FAILURE';

var publishCourse = exports.publishCourse = function publishCourse(courseId, productId, context) {
    return {
        type: PUBLISH_COURSE_REQUEST,
        courseId: courseId,
        productId: productId,
        context: context
    };
};

var publishCourseSuccess = exports.publishCourseSuccess = function publishCourseSuccess(context) {
    context.router.history.push(_constants.DEFAULT_COURSES_ROUTE);
    return {
        type: PUBLISH_COURSE_SUCCESS
    };
};

var publishCourseFailure = exports.publishCourseFailure = function publishCourseFailure() {
    return {
        type: PUBLISH_COURSE_FAILURE
    };
};

var CANCEL_VALIDATION_ERRORS_REQUEST = exports.CANCEL_VALIDATION_ERRORS_REQUEST = 'CANCEL_VALIDATION_ERRORS_REQUEST';

var cancelValidationErrorsRequest = exports.cancelValidationErrorsRequest = function cancelValidationErrorsRequest() {
    return {
        type: CANCEL_VALIDATION_ERRORS_REQUEST
    };
};

var GET_DEFAULT_COURSE_REQUEST = exports.GET_DEFAULT_COURSE_REQUEST = 'GET_DEFAULT_COURSE_REQUEST';
var GET_DEFAULT_COURSE_SUCCESS = exports.GET_DEFAULT_COURSE_SUCCESS = 'GET_DEFAULT_COURSE_SUCCESS';
var GET_DEFAULT_COURSE_FAILURE = exports.GET_DEFAULT_COURSE_FAILURE = 'GET_DEFAULT_COURSE_FAILURE';

var getDefaultCourse = exports.getDefaultCourse = function getDefaultCourse(productId, courseId, version) {
    var switchToMasterCourseId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var switchToMasterCourseVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    return {
        type: GET_DEFAULT_COURSE_REQUEST,
        productId: productId,
        courseId: courseId,
        version: version,
        switchToMasterCourseId: switchToMasterCourseId,
        switchToMasterCourseVersion: switchToMasterCourseVersion
    };
};

var getDefaultCourseSuccess = exports.getDefaultCourseSuccess = function getDefaultCourseSuccess(_ref) {
    var masterCourse = _ref.masterCourse,
        assignedSpineNodes = _ref.assignedSpineNodes,
        genericCourse = _ref.genericCourse,
        strandSubStrands = _ref.strandSubStrands,
        curriculumLevelDescriptions = _ref.curriculumLevelDescriptions;

    var assignedSpineItems = assignedSpineNodes.map(function (_ref2) {
        var id = _ref2.id;
        return id;
    });
    return {
        type: GET_DEFAULT_COURSE_SUCCESS,
        masterCourse: masterCourse,
        assignedSpineItems: assignedSpineItems,
        pppCourse: genericCourse,
        strandSubStrands: strandSubStrands,
        curriculumLevelDescriptions: curriculumLevelDescriptions,
        genericCourse: genericCourse
    };
};

var getDefaultCourseFailure = exports.getDefaultCourseFailure = function getDefaultCourseFailure() {
    return {
        type: GET_DEFAULT_COURSE_FAILURE
    };
};

var OPEN_ALERT_MODAL = exports.OPEN_ALERT_MODAL = 'OPEN_ALERT_MODAL';
var CLOSE_ALERT_MODAL = exports.CLOSE_ALERT_MODAL = 'CLOSE_ALERT_MODAL';

var closeAlertModal = exports.closeAlertModal = function closeAlertModal() {
    return {
        type: CLOSE_ALERT_MODAL
    };
};

var openAlertModal = exports.openAlertModal = function openAlertModal() {
    return {
        type: OPEN_ALERT_MODAL
    };
};

var SET_COURSE_CREATOR_AS_MODIFIED = exports.SET_COURSE_CREATOR_AS_MODIFIED = 'SET_COURSE_CREATOR_AS_MODIFIED';

var setCourseCreatorAsModified = exports.setCourseCreatorAsModified = function setCourseCreatorAsModified() {
    return {
        type: SET_COURSE_CREATOR_AS_MODIFIED
    };
};
var SET_COURSE_CREATOR_AS_CLEAN = exports.SET_COURSE_CREATOR_AS_CLEAN = 'SET_COURSE_CREATOR_AS_CLEAN';

var setCourseCreatorAsClean = exports.setCourseCreatorAsClean = function setCourseCreatorAsClean() {
    return {
        type: SET_COURSE_CREATOR_AS_CLEAN
    };
};

var HIDE_TOAST = exports.HIDE_TOAST = 'HIDE_TOAST';

var hideToastRequest = exports.hideToastRequest = function hideToastRequest() {
    return {
        type: HIDE_TOAST
    };
};

var SHOW_PUBLISH_MODAL = exports.SHOW_PUBLISH_MODAL = 'SHOW_PUBLISH_MODAL';

var showPublishModal = exports.showPublishModal = function showPublishModal(showModal) {
    return {
        type: SHOW_PUBLISH_MODAL,
        showModal: showModal
    };
};

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GET_DEFAULT_COURSES_REQUEST = exports.GET_DEFAULT_COURSES_REQUEST = 'GET_DEFAULT_COURSES_REQUEST';
var GET_DEFAULT_COURSES_SUCCESS = exports.GET_DEFAULT_COURSES_SUCCESS = 'GET_DEFAULT_COURSES_SUCCESS';
var GET_DEFAULT_COURSES_FAILURE = exports.GET_DEFAULT_COURSES_FAILURE = 'GET_DEFAULT_COURSES_FAILURE';

var getDefaultCourses = exports.getDefaultCourses = function getDefaultCourses(productId) {
    return { type: GET_DEFAULT_COURSES_REQUEST, productId: productId };
};

var getDefaultCoursesSuccess = exports.getDefaultCoursesSuccess = function getDefaultCoursesSuccess(courses) {
    return { type: GET_DEFAULT_COURSES_SUCCESS, courses: courses };
};

var getDefaultCoursesFailure = exports.getDefaultCoursesFailure = function getDefaultCoursesFailure() {
    return { type: GET_DEFAULT_COURSES_FAILURE };
};

var APPLY_SEARCH_FILTER = exports.APPLY_SEARCH_FILTER = 'APPLY_SEARCH_FILTER';

var applySearchFilter = exports.applySearchFilter = function applySearchFilter(label, value) {
    return { type: APPLY_SEARCH_FILTER, label: label, value: value };
};

var RESET_SEARCH_FILTER = exports.RESET_SEARCH_FILTER = 'RESET_SEARCH_FILTER';

var resetSearchFilter = exports.resetSearchFilter = function resetSearchFilter() {
    return { type: RESET_SEARCH_FILTER };
};

var FILTER_DEFAULT_COURSES = exports.FILTER_DEFAULT_COURSES = 'FILTER_DEFAULT_COURSES';
var FILTER_DEFAULT_SUCCESS = exports.FILTER_DEFAULT_SUCCESS = 'FILTER_DEFAULT_SUCCESS';

var filterDefaultCourses = exports.filterDefaultCourses = function filterDefaultCourses() {
    return { type: FILTER_DEFAULT_COURSES };
};

var filterDefaultCoursesSuccess = exports.filterDefaultCoursesSuccess = function filterDefaultCoursesSuccess(filteredCourses) {
    return { type: FILTER_DEFAULT_SUCCESS, filteredCourses: filteredCourses };
};

var ARCHIVE_SELECTED_COURSE_REQUEST = exports.ARCHIVE_SELECTED_COURSE_REQUEST = 'ARCHIVE_SELECTED_COURSE_REQUEST';
var ARCHIVE_SELECTED_COURSE_FAILURE = exports.ARCHIVE_SELECTED_COURSE_FAILURE = 'ARCHIVE_SELECTED_COURSE_FAILURE';

var archiveSelectedCourse = exports.archiveSelectedCourse = function archiveSelectedCourse(_ref) {
    var productId = _ref.productId,
        courseId = _ref.courseId,
        courseVersion = _ref.courseVersion;
    return { type: ARCHIVE_SELECTED_COURSE_REQUEST, productId: productId, courseId: courseId, courseVersion: courseVersion };
};

var archiveSelectedCourseSuccess = exports.archiveSelectedCourseSuccess = function archiveSelectedCourseSuccess(productId) {
    return { type: GET_DEFAULT_COURSES_REQUEST, productId: productId };
};

var archiveSelectedCourseFailure = exports.archiveSelectedCourseFailure = function archiveSelectedCourseFailure() {
    return { type: ARCHIVE_SELECTED_COURSE_FAILURE };
};

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(15);

exports.default = (0, _reactIntl.defineMessages)({
    header: {
        id: 'app.components.CourseCreator.header',
        defaultMessage: 'Course Manager'
    },
    back: {
        id: 'app.components.CourseCreator.back',
        defaultMessage: 'Back'
    },
    save: {
        id: 'app.components.CourseCreator.save',
        defaultMessage: 'Save as draft'
    },
    publish: {
        id: 'app.components.CourseCreator.publish',
        defaultMessage: 'Publish'
    },
    country: {
        id: 'app.components.CourseCreator.country',
        defaultMessage: 'Country'
    },
    state: {
        id: 'app.components.CourseCreator.state',
        defaultMessage: 'State'
    },
    yearLevel: {
        id: 'app.components.CourseCreator.yearLevel',
        defaultMessage: 'Year'
    },
    curriculum: {
        id: 'app.components.CourseCreator.curriculum',
        defaultMessage: 'Curriculum'
    },
    spine: {
        id: 'app.components.CourseCreator.spine',
        defaultMessage: 'Spine items'
    },
    topics: {
        id: 'app.components.CourseCreator.topics',
        defaultMessage: 'Topics'
    },
    newTopic: {
        id: 'app.components.CourseCreator.newTopic',
        defaultMessage: 'Create New Topic'
    },
    expand: {
        id: 'app.components.CourseCreator.expand',
        defaultMessage: 'Expand'
    },
    collapse: {
        id: 'app.components.CourseCreator.collapse',
        defaultMessage: 'Collapse'
    },
    add: {
        id: 'app.components.CourseCreator.add',
        defaultMessage: 'Add'
    },
    subTopic: {
        id: 'app.components.CourseCreator.subTopic',
        defaultMessage: 'Create Sub Topic'
    },
    requiredFields: {
        id: 'app.components.CourseCreator.requiredFields',
        defaultMessage: 'Required Fields'
    },
    editTopic: {
        id: 'app.components.CourseCreator.editTopic',
        defaultMessage: 'Edit Topic Details'
    },
    topicName: {
        id: 'app.components.CourseCreator.topicName',
        defaultMessage: 'Topic Name'
    },
    topicType: {
        id: 'app.components.CourseCreator.topicType',
        defaultMessage: 'Topic Type'
    },
    strandFilter: {
        id: 'app.components.CourseCreator.strandFilter',
        defaultMessage: 'Strand Filter'
    },
    subStrandFilter: {
        id: 'app.components.CourseCreator.subStrandFilter',
        defaultMessage: 'Sub-Strand Filter'
    },
    curriculumLevelLink: {
        id: 'app.components.CourseCreator.curriculumLevelLink',
        defaultMessage: 'Curriculum Level Link'
    },
    externalKey: {
        id: 'app.components.CourseCreator.externalKey',
        defaultMessage: 'External Key'
    },
    description: {
        id: 'app.components.CourseCreator.description',
        defaultMessage: 'Description'
    },
    update: {
        id: 'app.components.CourseCreator.description',
        defaultMessage: 'Update'
    },
    delete: {
        id: 'app.components.CourseCreator.delete',
        defaultMessage: 'Delete'
    },
    detailsNotSaved: {
        id: 'app.components.CourseCreator.detailsNotSaved',
        defaultMessage: 'Topic details have NOT been saved'
    },
    detailsSaved: {
        id: 'app.components.CourseCreator.detailsSaved',
        defaultMessage: 'Topic has been updated'
    },
    curriculumLinkPlaceholder: {
        id: 'app.containers.CourseCreator.curriculumLinkPlacehoderMessage',
        defaultMessage: 'Search the Curriculum for link node'
    },
    keepTopicNameLessThan: {
        id: 'app.containers.CourseCreator.keepTopicNameLessThan',
        defaultMessage: 'Please keep topic name less than'
    },
    characters: {
        id: 'app.containers.CourseCreator.characters',
        defaultMessage: 'characters'
    },
    spinesUnderSteps: {
        id: 'app.containers.CourseCreator.spinesUnderSteps',
        defaultMessage: 'Spine items can only be added to Steps'
    },
    spinesUnderDescriptor: {
        id: 'app.containers.CourseCreator.spinesUnderDescriptor',
        defaultMessage: 'Spine items can only be added to Descriptors'
    },
    selectProduct: {
        id: 'app.containers.CourseCreator.selectProduct',
        defaultMessage: 'Select product'
    },
    productSelectorHeading: {
        id: 'app.containers.CourseCreator.productSelectorHeading',
        defaultMessage: 'Product:'
    },
    emptySteps: {
        id: 'app.containers.CourseCreator.emptySteps',
        defaultMessage: 'Steps cannot be empty'
    },
    emptyCurriculumLink: {
        id: 'app.containers.CourseCreator.emptyCurriculumLink',
        defaultMessage: 'Spine must belong to the curriculum link specified for this course standard'
    },
    noSpineNode: {
        id: 'app.containers.CourseCreator.noSpineNode',
        defaultMessage: 'Please add spine nodes to course'
    }
});

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(1112);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = function Spinner() {
    return _react2.default.createElement(
        'div',
        { className: _index2.default.loadingContainer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.loadingIcon },
            _react2.default.createElement('div', { className: _index2.default.loader + ' ' + _index2.default.loaderSpeed })
        )
    );
};

exports.default = Spinner;

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(767);

var _iconDictionary = __webpack_require__(65);

var _styled = __webpack_require__(500);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global CustomEvent */


var WAIT_INTERVAL = 500;

var TextInput = function (_PureComponent) {
    _inherits(TextInput, _PureComponent);

    function TextInput(props) {
        _classCallCheck(this, TextInput);

        var _this = _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props));

        _this.state = { value: '' };
        _this.handleClearText = _this.handleClearText.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.triggerChange = _this.triggerChange.bind(_this);
        return _this;
    }

    _createClass(TextInput, [{
        key: 'handleClearText',
        value: function handleClearText() {
            var clearText = this.props.clearText;

            if (clearText && this.inputEl.value !== '') {
                this.inputEl.value = '';
                var event = new CustomEvent('input', { bubbles: true });
                this.inputEl.dispatchEvent(event);
                this.onChange(event);
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            clearTimeout(this.timer);
            this.setState({ value: e.target.value });
            this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
        }
    }, {
        key: 'triggerChange',
        value: function triggerChange() {
            var _props$handleOnChange = this.props.handleOnChange,
                handleOnChange = _props$handleOnChange === undefined ? function () {} : _props$handleOnChange;
            var value = this.state.value;

            handleOnChange(value);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var clearText = this.props.clearText;


            var inputProps = {};
            var clearEl = '';
            var hasClearText = '';

            // Add ref to the input component if clear text mode is enabled
            if (clearText) {
                hasClearText = false;
                inputProps = { ref: function ref(el) {
                        _this2.inputEl = el;
                    } };
                clearEl = _react2.default.createElement(
                    _styled.ClearButton,
                    {
                        disabled: this.props.disabled,
                        icon: _iconDictionary.Cross,
                        iconClassName: 'this.props.css.clearButtonIcon',
                        onClick: this.handleClearText },
                    'x'
                );
            }

            return _react2.default.createElement(
                _styled.TextInputComponent,
                { className: '' + hasClearText },
                _react2.default.createElement(_styled.InputWrapper, _extends({
                    disabled: this.props.disabled,
                    maxLength: this.props.maxLength,
                    name: this.props.name,
                    onChange: this.onChange,
                    placeholder: this.props.placeholder,
                    type: 'text',
                    value: this.props.value
                }, inputProps)),
                clearEl
            );
        }
    }]);

    return TextInput;
}(_react.PureComponent);

TextInput.propTypes = {
    name: _propTypes2.default.string,
    value: _propTypes2.default.string,
    maxLength: _propTypes2.default.number,
    placeholder: _propTypes2.default.string,
    handleOnChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    // Enable clear text mode and display a clear button
    clearText: _propTypes2.default.bool
};

exports.default = TextInput;

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHECK_USER_IS_AUTHORIZED_REQUEST = exports.CHECK_USER_IS_AUTHORIZED_REQUEST = 'CHECK_USER_IS_AUTHORISED_REQUEST';
var CHECK_USER_IS_AUTHORIZED_SUCCEED = exports.CHECK_USER_IS_AUTHORIZED_SUCCEED = 'CHECK_USER_IS_AUTHORISED_SUCCEED';
var CHECK_USER_IS_AUTHORIZED_FAILURE = exports.CHECK_USER_IS_AUTHORIZED_FAILURE = 'CHECK_USER_IS_AUTHORISED_FAILED';

var ALERT_MODAL_DISPLAY_STATUS = exports.ALERT_MODAL_DISPLAY_STATUS = 'ALERT_MODAL_DISPLAY_STATUS';

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GET_MASTER_COURSES_COUNTRIES_REQUEST = exports.GET_MASTER_COURSES_COUNTRIES_REQUEST = 'GET_MASTER_COURSES_COUNTRIES_REQUEST';

var getMasterCoursesCountries = exports.getMasterCoursesCountries = function getMasterCoursesCountries() {
    return { type: GET_MASTER_COURSES_COUNTRIES_REQUEST };
};

var GET_DEFAULT_COURSES_FOR_COUNTRY_REQUEST = exports.GET_DEFAULT_COURSES_FOR_COUNTRY_REQUEST = 'GET_DEFAULT_COURSES_FOR_COUNTRY_REQUEST';
var GET_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS = exports.GET_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS = 'GET_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS';
var GET_DEFAULT_COURSES_FOR_COUNTRY_FAILURE = exports.GET_DEFAULT_COURSES_FOR_COUNTRY_FAILURE = 'GET_DEFAULT_COURSES_FOR_COUNTRY_FAILURE';

var getDefaultCoursesForCountryRequest = exports.getDefaultCoursesForCountryRequest = function getDefaultCoursesForCountryRequest(accessCode, productId) {
    return { type: GET_DEFAULT_COURSES_FOR_COUNTRY_REQUEST, accessCode: accessCode, productId: productId };
};

var getDefaultCoursesForCountrySuccess = exports.getDefaultCoursesForCountrySuccess = function getDefaultCoursesForCountrySuccess(defaultCourses) {
    return { type: GET_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS, defaultCourses: defaultCourses };
};

var getDefaultCoursesForCountryFailure = exports.getDefaultCoursesForCountryFailure = function getDefaultCoursesForCountryFailure() {
    return { type: GET_DEFAULT_COURSES_FOR_COUNTRY_FAILURE };
};

var GET_COURSES_FOR_COUNTRY_REQUEST = exports.GET_COURSES_FOR_COUNTRY_REQUEST = 'GET_COURSES_FOR_COUNTRY_REQUEST';
var GET_COURSES_FOR_COUNTRY_SUCCESS = exports.GET_COURSES_FOR_COUNTRY_SUCCESS = 'GET_COURSES_FOR_COUNTRY_SUCCESS';
var GET_COURSES_FOR_COUNTRY_FAILURE = exports.GET_COURSES_FOR_COUNTRY_FAILURE = 'GET_COURSES_FOR_COUNTRY_FAILURE';

var getCoursesForCountryRequest = exports.getCoursesForCountryRequest = function getCoursesForCountryRequest(countryCode, productId) {
    return { type: GET_COURSES_FOR_COUNTRY_REQUEST, countryCode: countryCode, productId: productId };
};

var getCoursesForCountrySuccess = exports.getCoursesForCountrySuccess = function getCoursesForCountrySuccess(courses) {
    return { type: GET_COURSES_FOR_COUNTRY_SUCCESS, courses: courses };
};

var getCoursesForCountryFailure = exports.getCoursesForCountryFailure = function getCoursesForCountryFailure() {
    return { type: GET_COURSES_FOR_COUNTRY_FAILURE };
};

var SAVE_DEFAULT_COURSES_FOR_COUNTRY_REQUEST = exports.SAVE_DEFAULT_COURSES_FOR_COUNTRY_REQUEST = 'SAVE_DEFAULT_COURSES_FOR_COUNTRY_REQUEST';
var SAVE_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS = exports.SAVE_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS = 'SAVE_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS';
var SAVE_DEFAULT_COURSES_FOR_COUNTRY_FAILURE = exports.SAVE_DEFAULT_COURSES_FOR_COUNTRY_FAILURE = 'SAVE_DEFAULT_COURSES_FOR_COUNTRY_FAILURE';

var saveDefaultCoursesForCountryRequest = exports.saveDefaultCoursesForCountryRequest = function saveDefaultCoursesForCountryRequest(accessCode, productId, defaultCourses) {
    return { type: SAVE_DEFAULT_COURSES_FOR_COUNTRY_REQUEST, accessCode: accessCode, productId: productId, defaultCourses: defaultCourses };
};

var saveDefaultCoursesForCountrySuccess = exports.saveDefaultCoursesForCountrySuccess = function saveDefaultCoursesForCountrySuccess(defaultCourses) {
    return { type: SAVE_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS, defaultCourses: defaultCourses };
};

var saveDefaultCoursesForCountryFailure = exports.saveDefaultCoursesForCountryFailure = function saveDefaultCoursesForCountryFailure() {
    return { type: SAVE_DEFAULT_COURSES_FOR_COUNTRY_FAILURE };
};

var GET_COURSES_REQUEST = exports.GET_COURSES_REQUEST = 'GET_COURSES_REQUEST';
var GET_COURSES_SUCCESS = exports.GET_COURSES_SUCCESS = 'GET_COURSES_SUCCESS';
var GET_COURSES_FAILURE = exports.GET_COURSES_FAILURE = 'GET_COURSES_FAILURE';

var getCoursesRequest = exports.getCoursesRequest = function getCoursesRequest(accessStatus, countryCode, stateCode, productId) {
    return { type: GET_COURSES_REQUEST, accessStatus: accessStatus, countryCode: countryCode, stateCode: stateCode, productId: productId };
};

var getCoursesSuccess = exports.getCoursesSuccess = function getCoursesSuccess(courses) {
    return { type: GET_COURSES_SUCCESS, courses: courses };
};

var getCoursesFailure = exports.getCoursesFailure = function getCoursesFailure() {
    return { type: GET_COURSES_FAILURE };
};

var SAVE_DEFAULT_COURSES_REQUEST = exports.SAVE_DEFAULT_COURSES_REQUEST = 'SAVE_DEFAULT_COURSES_REQUEST';
var SAVE_DEFAULT_COURSES_SUCCESS = exports.SAVE_DEFAULT_COURSES_SUCCESS = 'SAVE_DEFAULT_COURSES_SUCCESS';
var SAVE_DEFAULT_COURSES_FAILURE = exports.SAVE_DEFAULT_COURSES_FAILURE = 'SAVE_DEFAULT_COURSES_FAILURE';

var saveDefaultCoursesRequest = exports.saveDefaultCoursesRequest = function saveDefaultCoursesRequest(accessStatus, countryCode, stateCode, productId, defaultCourses) {
    return { type: SAVE_DEFAULT_COURSES_REQUEST, accessStatus: accessStatus, countryCode: countryCode, stateCode: stateCode, productId: productId, defaultCourses: defaultCourses };
};

var saveDefaultCoursesSuccess = exports.saveDefaultCoursesSuccess = function saveDefaultCoursesSuccess(defaultCourses) {
    return { type: SAVE_DEFAULT_COURSES_SUCCESS, defaultCourses: defaultCourses };
};

var saveDefaultCoursesFailure = exports.saveDefaultCoursesFailure = function saveDefaultCoursesFailure() {
    return { type: SAVE_DEFAULT_COURSES_FAILURE };
};

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _basicResources = __webpack_require__(534);

var _basicResources2 = _interopRequireDefault(_basicResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should call its initialise() method, to set
// up the environment and create all of the resources the application will use.

var Resources = function () {
    function Resources() {
        _classCallCheck(this, Resources);
    }

    _createClass(Resources, null, [{
        key: 'createResources',
        value: function createResources(parentEnv) {
            var env = parentEnv || Resources.env; // eslint-disable-line no-unused-

            /**
             * CURRICULUM/MASTER COURSE
             */
            this.getMasterCoursesCountries = env.resource('getMasterCoursesCountries').baseUrl('@CourseManagerGatewayUrl').service('v1/curriculumCountries');

            this.getMasterCourses = env.resource('getMasterCourses').baseUrl('@CourseManagerGatewayUrl').service('v1/masterCourses');

            this.getMasterCoursesByCountry = env.resource('getMasterCoursesByCountry').baseUrl('@CourseManagerGatewayUrl').service('v1/masterCourses');

            this.getMasterCoursesByAccessStatus = env.resource('getMasterCourses').baseUrl('@CourseManagerGatewayUrl').service('v1/masterCourses/filter');

            this.getMasterCourse = env.resource('getMasterCourse').baseUrl('@CourseManagerGatewayUrl').service('v1/masterCourses/{masterCourseId}/version/{version}');

            /**
             * COURSES
             */
            this.getDefaultCourses = env.resource('getDefaultCourses').baseUrl('@CourseManagerGatewayUrl').service('v1/courses/genericcourses');

            this.getDefaultCourse = env.resource('getDefaultCourse').baseUrl('@CourseManagerGatewayUrl').service('v1/courses/genericcourse/{courseId}/version/{version}');

            this.getDefaultCourseForCountry = env.resource('getDefaultCourseForCountry').baseUrl('@CourseManagerGatewayUrl').service('v1/courses/genericcourse/defaultcourses');

            this.getCourses = env.resource('getCourses').baseUrl('@CourseManagerGatewayUrl').service('v1/courses/defaultcourses/filter');

            this.getCoursesForCountry = env.resource('getCoursesForCountry').baseUrl('@CourseManagerGatewayUrl').service('v1/courses');

            this.saveDefaultCourse = env.resource('saveDefaultCourse').baseUrl('@CourseManagerGatewayUrl').service('v1/courses/genericcourse');

            this.publishDefaultCourse = env.resource('publishDefaultCourse').baseUrl('@CourseManagerGatewayUrl').service('v1/courses/genericcourse/{courseId}/publish');

            this.archiveSelectedCourse = env.resource('archiveSelectedCourse').baseUrl('@CourseManagerGatewayUrl').service('v1/courses/genericcourse/{courseId}/{courseVersion}');

            this.saveDefaultCourses = env.resource('saveDefaultCourses').baseUrl('@CourseManagerGatewayUrl').service('v1/courses/defaultcourses');

            /**
             * SUBJECTS
             */
            this.getSubjects = env.resource('getSubjects').baseUrl('@CourseManagerGatewayUrl').service('v1/subjects');

            /**
             * AUTH
             */
            this.checkUserIsAuthorised = env.resource('checkUserIsAuthorised').baseUrl('@CourseManagerGatewayUrl').service('checkAuthorization');
        }

        // Initialise the environment and resources, based on the provided
        // environment name.  We return the environment so the caller has
        // access to everything, in particular the authToken if one was
        // passed in the query parameters.

    }, {
        key: 'initialise',
        value: function initialise(envName, credentials) {
            Resources.env = _basicResources2.default.initialise(envName, credentials);

            Resources.createResources();

            return Resources.env;
        }
    }]);

    return Resources;
}();

exports.default = Resources;

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mathleticsPortalCommunicationService = __webpack_require__(386);

var _mathleticsPortalCommunicationService2 = _interopRequireDefault(_mathleticsPortalCommunicationService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PortalCommunication = function () {
    function PortalCommunication() {
        _classCallCheck(this, PortalCommunication);
    }

    _createClass(PortalCommunication, null, [{
        key: 'Configure',
        value: function Configure() {
            _mathleticsPortalCommunicationService2.default.requestLoadingSpinner(false);
        }

        // invoke this method to let the 3p-portal know
        // that we want to navigate to current module landing screen

    }, {
        key: 'navigateToLandingScreen',
        value: function navigateToLandingScreen() {
            var moduleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            _mathleticsPortalCommunicationService2.default.requestNavigateToLanding(moduleName);
        }
    }, {
        key: 'serverError',
        value: function serverError(error) {
            _mathleticsPortalCommunicationService2.default.requestServerError(error);
        }
    }]);

    return PortalCommunication;
}();

exports.default = PortalCommunication;

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge = __webpack_require__(952);

var _merge2 = _interopRequireDefault(_merge);

var _defaultTheme = __webpack_require__(546);

var _defaultTheme2 = _interopRequireDefault(_defaultTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ThemeHelper = function () {
    function ThemeHelper() {
        _classCallCheck(this, ThemeHelper);
    }

    _createClass(ThemeHelper, null, [{
        key: 'getTheme',

        /**
         * If props contains no theme object or the theme object is empty, returns the base theme
         * Otherwise recursively merges props.theme on top of base theme
         */
        value: function getTheme(props) {
            if (props.theme && Object.keys(props.theme).length > 0) {
                return (0, _merge2.default)({}, _defaultTheme2.default, props.theme);
            }
            return _defaultTheme2.default;
        }
    }, {
        key: 'getDefaultTheme',
        value: function getDefaultTheme() {
            return _defaultTheme2.default;
        }
    }]);

    return ThemeHelper;
}();

exports.default = ThemeHelper;

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

var DEFAULT_LOCALE = exports.DEFAULT_LOCALE = 'en';
var appName = exports.appName = 'InternalCourseManagerHost';

var YEAR_GROUPS = exports.YEAR_GROUPS = [{ id: '0', value: 'Kindergarten' }, { id: '1', value: 'Year 1' }, { id: '2', value: 'Year 2' }, { id: '3', value: 'Year 3' }, { id: '4', value: 'Year 4' }, { id: '5', value: 'Year 5' }, { id: '6', value: 'Year 6' }, { id: '7', value: 'Year 7' }, { id: '8', value: 'Year 8' }, { id: '9', value: 'Year 9' }, { id: '10', value: 'Year 10' }, { id: '11', value: 'Year 11' }, { id: '12', value: 'Year 12' }];

var STATUSES = exports.STATUSES = [{ id: 0, value: 'Draft' }, { id: 1, value: 'Reviewed' }, { id: 2, value: 'Published' }, { id: 3, value: 'Archived' }, { id: 4, value: 'Retired' }];

var SUPPORTED_LOCALES = exports.SUPPORTED_LOCALES = [{ id: 0, value: 'en-AU' }, { id: 1, value: 'en-CA' }, { id: 2, value: 'en-GB' }, { id: 3, value: 'en-IE' }, { id: 4, value: 'en-NZ' }, { id: 5, value: 'en-UK' }, { id: 6, value: 'en-US' }, { id: 7, value: 'en-ZA' }];

var STATUSES_AS_KEY = exports.STATUSES_AS_KEY = {
    0: 'Draft',
    1: 'Reviewed',
    2: 'Published',
    3: 'Archived',
    4: 'Retired'
};

var MASTER_COURSES_ROUTE = exports.MASTER_COURSES_ROUTE = '/master-courses';
var DEFAULT_COURSES_ROUTE = exports.DEFAULT_COURSES_ROUTE = '/default-courses';
var COURSE_CREATOR_ROUTE = exports.COURSE_CREATOR_ROUTE = '/course-creator';
var SET_DEFAULT_COURSES_ROUTE = exports.SET_DEFAULT_COURSES_ROUTE = '/set-default-courses';
var COURSE_MANAGER_LANDING_SCREEN = exports.COURSE_MANAGER_LANDING_SCREEN = 'Course Manager';

var DROPDOWN_DEFAULT_COUNTRY = exports.DROPDOWN_DEFAULT_COUNTRY = 'AUS';
var DROPDOWN_DEFAULT_COUNTRY_LONG = exports.DROPDOWN_DEFAULT_COUNTRY_LONG = 'Australia';
var DROPDOWN_DEFAULT_LOCALE = exports.DROPDOWN_DEFAULT_LOCALE = 'en-AU';
var DROPDOWN_DEFAULT_COURSE_ID = exports.DROPDOWN_DEFAULT_COURSE_ID = '10';

var DEFAULT_COURSE_ID = exports.DEFAULT_COURSE_ID = 0;
var DEFAULT_PRODUCT_ID = exports.DEFAULT_PRODUCT_ID = '1';
var SPELLING_PRODUCT_ID = exports.SPELLING_PRODUCT_ID = 10;
var WRITING_PRODUCT_ID = exports.WRITING_PRODUCT_ID = 11;
var MATHLETICS_PRODUCT_ID = exports.MATHLETICS_PRODUCT_ID = 1;
var ARCHIVE_STATUS_KEY = exports.ARCHIVE_STATUS_KEY = 3;

var RETIRED_COURSE_ID = exports.RETIRED_COURSE_ID = 4;

var DEFAULT_CURRICULUM_TYPE_ID = exports.DEFAULT_CURRICULUM_TYPE_ID = -1;

var COUNTRY_ACCESS_STATUS = exports.COUNTRY_ACCESS_STATUS = 2;
var STATE_ACCESS_STATUS = exports.STATE_ACCESS_STATUS = 3;

var MASTER_COURSE_ACCESS_KEYS = exports.MASTER_COURSE_ACCESS_KEYS = {
    GLOBAL: 0
};

var COURSE_CREATOR_SUB_ROUTES = exports.COURSE_CREATOR_SUB_ROUTES = {
    COPY: 'copy',
    CLONE: 'clone',
    EDIT: 'edit'
};

var PRODUCT_LIST = exports.PRODUCT_LIST = {
    MATHLETICS: {
        name: 'Mathletics',
        id: 1
    },
    SPELLING: {
        name: 'Spelling',
        id: 10
    },
    WRITING: {
        name: 'Writing',
        id: 11
    }
};

var PUBLISHED_COURSES = exports.PUBLISHED_COURSES = 2;

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Flexbox Mixins
// http://philipwalton.github.io/solved-by-flexbox/
// https://github.com/philipwalton/solved-by-flexbox
//
// Copyright (c) 2013 Brian Franco
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to
// permit persons to whom the Software is furnished to do so, subject to
// the following conditions:
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
// IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
// CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
// SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// This is a set of mixins for those who want to mess around with flexbox
// using the native support of current browsers. For full support table
// check: http://caniuse.com/flexbox
//
// Basically this will use:
//
// * Fallback, old syntax (IE10, mobile webkit browsers - no wrapping)
// * Final standards syntax (FF, Safari, Chrome, IE11, Opera)
//
// This was inspired by:
//
// * http://dev.opera.com/articles/view/advanced-cross-browser-flexbox/
//
// With help from:
//
// * http://w3.org/tr/css3-flexbox/
// * http://the-echoplex.net/flexyboxes/
// * http://msdn.microsoft.com/en-us/library/ie/hh772069(v=vs.85).aspx
// * http://css-tricks.com/using-flexbox/
// * http://dev.opera.com/articles/view/advanced-cross-browser-flexbox/
// * https://developer.mozilla.org/en-us/docs/web/guide/css/flexible_boxes

//----------------------------------------------------------------------

// Flexbox Containers
//
// The 'flex' value causes an element to generate a block-level flex
// container box.
//
// The 'inline-flex' value causes an element to generate a inline-level
// flex container box.
//
// display: flex | inline-flex
//
// http://w3.org/tr/css3-flexbox/#flex-containers
//
// (Placeholder selectors for each type, for those who rather @extend)


var flexbox = function flexbox() {
    return '\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex;\n';
};

var inlineFlexbox = function inlineFlexbox() {
    return '\n    display: -webkit-inline-box;\n    display: -webkit-inline-flex;\n    display: -moz-inline-flex;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n';
};

//----------------------------------------------------------------------

// Flexbox Direction
//
// The 'flex-direction' property specifies how flex items are placed in
// the flex container, by setting the direction of the flex container's
// main axis. This determines the direction that flex items are laid out in.
//
// Values: row | row-reverse | column | column-reverse
// Default: row
//
// http://w3.org/tr/css3-flexbox/#flex-direction-property

var flexDirection = function flexDirection(value) {
    var direction = String(value || 'row').toLowerCase();

    var styles = '';
    if (direction === 'row-reverse') {
        styles += '\n        -webkit-box-direction: reverse;\n        -webkit-box-orient: horizontal;\n        ';
    } else if (direction === 'column') {
        styles += '\n        -webkit-box-direction: normal;\n        -webkit-box-orient: vertical;\n        ';
    } else if (direction === 'column-reverse') {
        styles += '\n        -webkit-box-direction: reverse;\n        -webkit-box-orient: vertical;\n        ';
    } else {
        styles += '\n        -webkit-box-direction: normal;\n        -webkit-box-orient: horizontal;\n        ';
    }

    styles += '\n    -webkit-flex-direction: ' + direction + ';\n    -moz-flex-direction: ' + direction + ';\n    -ms-flex-direction: ' + direction + ';\n    flex-direction: ' + direction + ';\n    ';
    return styles;
};

//----------------------------------------------------------------------

// Flexbox Wrap
//
// The 'flex-wrap' property controls whether the flex container is single-line
// or multi-line, and the direction of the cross-axis, which determines
// the direction new lines are stacked in.
//
// Values: nowrap | wrap | wrap-reverse
// Default: nowrap
//
// http://w3.org/tr/css3-flexbox/#flex-wrap-property

var flexWrap = function flexWrap() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'nowrap';

    var givenValue = String(value).toLowerCase();

    var styles = '';
    if (givenValue === 'nowrap') {
        styles += '\n        -ms-flex-wrap: none;\n        ';
    } else {
        styles += '\n        -ms-flex-wrap: ' + givenValue + ';\n        ';
    }
    styles += '\n    flex-wrap: ' + givenValue + ';\n    ';
    return styles;
};

//----------------------------------------------------------------------

// Flexbox Flow (shorthand)
//
// The 'flex-flow' property is a shorthand for setting the 'flex-direction'
// and 'flex-wrap' properties, which together define the flex container's
// main and cross axes.
//
// Values: <flex-direction> | <flex-wrap>
// Default: row nowrap
//
// http://w3.org/tr/css3-flexbox/#flex-flow-property

// No Webkit Box fallback.
var flexFlow = function flexFlow() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'row nowrap';

    var givenValue = String(value).toLowerCase();

    var styles = '';

    styles += '\n    -webkit-flex-flow: ' + value + ';\n    -moz-flex-flow: ' + value + ';\n    -ms-flex-flow: ' + value + ';\n    flex-flow: ' + value + ';\n    ';
    return styles;
};

// Flexbox Order
//
// The 'order' property controls the order in which flex items appear within
// their flex container, by assigning them to ordinal groups.
//
// Default: 0
//
// http://w3.org/tr/css3-flexbox/#order-property

var order = function order() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    return '\n    -webkit-box-ordinal-group: ' + value + ' + 1;\n    -webkit-order: ' + value + ';\n    -moz-order: ' + value + ';\n    -ms-flex-order: ' + value + ';\n    order: ' + value + ';\n    ';
};

// Flexbox Grow
//
// The 'flex-grow' property sets the flex grow factor. Negative numbers
// are invalid.
//
// Default: 0
//
// http://w3.org/tr/css3-flexbox/#flex-grow-property

var flexGrow = function flexGrow() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    return '\n    -webkit-box-flex: ' + value + ';\n    -webkit-flex-grow: ' + value + ';\n    -moz-flex-grow: ' + value + ';\n    -ms-flex-positive: ' + value + ';\n    flex-grow: ' + value + ';\n    ';
};

// Flexbox Shrink
//
// The 'flex-shrink' property sets the flex shrink factor. Negative numbers
// are invalid.
//
// Default: 1
//
// http://w3.org/tr/css3-flexbox/#flex-shrink-property

var flexShrink = function flexShrink() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return '\n    -webkit-flex-shrink: ' + value + ';\n    -moz-flex-shrink: ' + value + ';\n    -ms-flex-negative: ' + value + ';\n    flex-shrink: ' + value + ';\n    ';
};

//----------------------------------------------------------------------

// Flexbox Basis
//
// The 'flex-basis' property sets the flex basis. Negative lengths are invalid.
//
// Values: Like "width"
// Default: auto
//
// http://www.w3.org/TR/css3-flexbox/#flex-basis-property

var flexBasis = function flexBasis() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto';

    return '\n    -webkit-flex-basis: ' + value + ';\n    -moz-flex-basis: ' + value + ';\n    -ms-flex-preferred-size: ' + value + ';\n    flex-basis: ' + value + ';\n    ';
};

// Flexbox "Flex" (shorthand)
//
// The 'flex' property specifies the components of a flexible length: the
// flex grow factor and flex shrink factor, and the flex basis. When an
// element is a flex item, 'flex' is consulted instead of the main size
// property to determine the main size of the element. If an element is
// not a flex item, 'flex' has no effect.
//
// Values: none | <flex-grow> <flex-shrink> || <flex-basis>
// Default: See individual properties (1 1 0).
//
// http://w3.org/tr/css3-flexbox/#flex-property

var flex = function flex() {
    var fg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1';
    var fs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var fb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    // Set a variable to be used by box-flex properties
    var fgBoxflex = fg;

    var fgArr = String(fg).split(' ');
    if (fgArr.length > 1) {
        fgBoxflex = fgArr[0];
    }

    return '\n    -webkit-box-flex: ' + fgBoxflex + ';\n    -webkit-flex: ' + fg + ' ' + fs + ' ' + fb + ';\n    -moz-box-flex: ' + fgBoxflex + ';\n    -moz-flex: ' + fg + ' ' + fs + ' ' + fb + '|;\n    -ms-flex: ' + fg + ' ' + fs + ' ' + fb + ';\n    flex: ' + fg + ' ' + fs + ' ' + fb + ';\n    ';
};

//----------------------------------------------------------------------

// Flexbox Justify Content
//
// The 'justify-content' property aligns flex items along the main axis
// of the current line of the flex container. This is done after any flexible
// lengths and any auto margins have been resolved. Typically it helps distribute
// extra free space leftover when either all the flex items on a line are
// inflexible, or are flexible but have reached their maximum size. It also
// exerts some control over the alignment of items when they overflow the line.
//
// Note: 'space-*' values not supported in older syntaxes.
//
// Values: flex-start | flex-end | center | space-between | space-around
// Default: flex-start
//
// http://w3.org/tr/css3-flexbox/#justify-content-property

var justifyContent = function justifyContent() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'flex-start';

    var givenValue = String(value).toLowerCase();
    var styles = '';
    if (givenValue === 'flex-start') {
        styles += '\n        -webkit-box-pack: start;\n        -ms-flex-pack: start;\n        ';
    } else if (givenValue === 'flex-end') {
        styles += '\n        -webkit-box-pack: end;\n        -ms-flex-pack: end;\n        ';
    } else if (givenValue === 'space-between') {
        styles += '\n        -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n        ';
    } else if (givenValue === 'space-around') {
        styles += '\n        -ms-flex-pack: distribute;\n        ';
    } else {
        styles += '\n        -webkit-box-pack: ' + givenValue + ';\n        -ms-flex-pack: ' + givenValue + ';\n        ';
    }

    styles += '\n    -webkit-justify-content: ' + givenValue + ';\n    -moz-justify-content: ' + givenValue + ';\n    justify-content: ' + givenValue + ';\n    ';
    return styles;
};

//----------------------------------------------------------------------

// Flexbox Align Items
//
// Flex items can be aligned in the cross axis of the current line of the
// flex container, similar to 'justify-content' but in the perpendicular
// direction. 'align-items' sets the default alignment for all of the flex
// container's items, including anonymous flex items. 'align-self' allows
// this default alignment to be overridden for individual flex items. (For
// anonymous flex items, 'align-self' always matches the value of 'align-items'
// on their associated flex container.)
//
// Values: flex-start | flex-end | center | baseline | stretch
// Default: stretch
//
// http://w3.org/tr/css3-flexbox/#align-items-property

var alignItems = function alignItems() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'stretch';

    var givenValue = String(value).toLowerCase();
    var styles = '';

    if (givenValue === 'flex-start') {
        styles += '\n        -webkit-box-align: start;\n        -ms-flex-align: start;\n        ';
    } else if (givenValue === 'flex-end') {
        styles += '\n        -webkit-box-align: end;\n        -ms-flex-align: end;\n        ';
    } else {
        styles += '\n        -webkit-box-align: ' + givenValue + ';\n        -ms-flex-align: ' + givenValue + ';\n        ';
    }

    styles += '\n    -webkit-align-items: ' + givenValue + ';\n    -moz-align-items: ' + givenValue + ';\n    align-items: ' + givenValue + ';\n    ';
    return styles;
};

//----------------------------------

// Flexbox Align Self
//
// Values: auto | flex-start | flex-end | center | baseline | stretch
// Default: auto

var alignSelf = function alignSelf() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto';

    var givenValue = String(value).toLowerCase();
    // No Webkit Box Fallback.
    var styles = '\n    -webkit-align-self: ' + givenValue + ';\n    -moz-align-self: ' + givenValue + ';\n    ';

    if (givenValue === 'flex-start') {
        styles += '\n        -ms-flex-item-align: start;\n        ';
    } else if (givenValue === 'flex-end') {
        styles += '\n        -ms-flex-item-align: end;\n        ';
    } else {
        styles += '\n        -ms-flex-item-align: ' + givenValue + ';\n        ';
    }

    styles += '\n    align-self: ' + givenValue + ';\n    ';
    return styles;
};

//----------------------------------------------------------------------

// Flexbox Align Content
//
// The 'align-content' property aligns a flex container's lines within the
// flex container when there is extra space in the cross-axis, similar to
// how 'justify-content' aligns individual items within the main-axis. Note,
// this property has no effect when the flexbox has only a single line.
//
// Values: flex-start | flex-end | center | space-between | space-around | stretch
// Default: stretch
//
// http://w3.org/tr/css3-flexbox/#align-content-property

var alignContent = function alignContent() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'stretch';

    var givenValue = String(value).toLowerCase();
    // No Webkit Box Fallback.
    var styles = '\n    -webkit-align-content: ' + givenValue + ';\n    -moz-align-content: ' + givenValue + ';\n    ';

    if (givenValue === 'flex-start') {
        styles += '\n        -ms-flex-line-pack: start;\n        ';
    } else if (givenValue === 'flex-end') {
        styles += '\n        -ms-flex-line-pack: end;\n        ';
    } else {
        styles += '\n        -ms-flex-line-pack: ' + givenValue + ';\n        ';
    }

    styles += '\n    align-content: ' + givenValue + ';\n    ';
    return styles;
};

exports.flexbox = flexbox;
exports.inlineFlexbox = inlineFlexbox;
exports.flexDirection = flexDirection;
exports.flexWrap = flexWrap;
exports.flexFlow = flexFlow;
exports.order = order;
exports.flexGrow = flexGrow;
exports.flexBasis = flexBasis;
exports.flex = flex;
exports.justifyContent = justifyContent;
exports.alignItems = alignItems;
exports.alignSelf = alignSelf;
exports.alignContent = alignContent;
exports.flexShrink = flexShrink;

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withModal = __webpack_require__(509);

var _withModal2 = _interopRequireDefault(_withModal);

var _svgIcon = __webpack_require__(64);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _iconDictionary = __webpack_require__(65);

var _styled = __webpack_require__(465);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Alert = function Alert(props) {
    var buttons = props.buttons,
        title = props.title,
        subTitle = props.subTitle,
        warning = props.warning;

    var icon = '';

    if (warning) {
        icon = _iconDictionary.Warning;
    }

    return _react2.default.createElement(
        _styled.AlertContainer,
        null,
        _react2.default.createElement(
            _styled.AlertIcon,
            null,
            _react2.default.createElement(_svgIcon2.default, { icon: icon })
        ),
        _react2.default.createElement(
            _styled.AlertTitle,
            null,
            title
        ),
        _react2.default.createElement(
            _styled.AlertSubTitle,
            null,
            subTitle
        ),
        buttons
    );
};

Alert.propTypes = {
    buttons: _propTypes2.default.object,
    title: _propTypes2.default.string,
    subTitle: _propTypes2.default.string,
    warning: _propTypes2.default.bool
};

exports.default = (0, _withModal2.default)('isActive')(Alert);

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SpinnerWrapper = exports.CourseInfoWrapper = exports.ModalButtons = exports.CourseCreatorWrapper = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    height: 100%;\n    padding-left: 10px;\n    text-align: left;\n    word-wrap: break-word;\n    line-height: 52px;\n'], ['\n    height: 100%;\n    padding-left: 10px;\n    text-align: left;\n    word-wrap: break-word;\n    line-height: 52px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n'], ['\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    ', '\n    & > div {\n        margin: 5px;\n    }\n\n    .publish {\n        width: 220px;\n        height: 50px;\n    }\n'], ['\n    ', '\n    & > div {\n        margin: 5px;\n    }\n\n    .publish {\n        width: 220px;\n        height: 50px;\n    }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    display: inline-block;\n    margin: 0 15px;\n    max-height: 20px;\n'], ['\n    display: inline-block;\n    margin: 0 15px;\n    max-height: 20px;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _flexbox = __webpack_require__(24);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

var _container = __webpack_require__(114);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var headerColumn = function headerColumn() {
    return (0, _styledComponents.css)(_templateObject);
};

var SpinnerWrapper = _styledComponents2.default.div(_templateObject2);

var CourseCreatorWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme.colours,
        palette = _ThemeHelper$getTheme.palette,
        typography = _ThemeHelper$getTheme.typography;

    return '\n        font-family: ' + typography.family + ';\n\n        .header {\n            ' + (0, _flexbox.flexbox)() + '\n            ' + (0, _flexbox.alignItems)('center') + '\n            background-color: ' + colours.iron + ';\n        }\n\n        .mainHeading {\n            ' + (0, _flexbox.flexbox)() + '\n\n            font-family: ' + typography.family + ';\n            padding: 0 25px;\n            font-size: 30px;\n            font-weight: 500;\n\n            ' + (0, _flexbox.flexbox)('center') + '\n            ' + (0, _flexbox.justifyContent)('space-between') + '\n\n            height: 80px;\n        }\n\n        .title {\n            color: ' + colours.nevada + ';\n            margin: auto;\n            font-size: 30px;\n            font-weight: 500;\n            ' + (0, _flexbox.flex)(1) + '\n        }\n\n        & > ' + _container2.default + ' {\n            margin-bottom: 80px;\n        }\n\n        .footer {\n            ' + (0, _flexbox.flexbox)() + '\n            ' + (0, _flexbox.alignItems)('center') + '\n            ' + (0, _flexbox.justifyContent)('flex-end') + '\n\n            position: fixed;\n            height: 50px;\n            bottom: 0.1px;\n            left: 0.1px;\n            width: 100%;\n            padding-right: 10px;\n            padding-left: 10px;\n            background-color: ' + palette.tertiary.main + ';\n        }\n\n        .save {\n            width: 130px;\n        }\n\n        .publish {\n            width: 95px;\n        }\n\n        .back {\n             width: 95px;\n        }\n\n        .savePanel {\n            ' + (0, _flexbox.flexbox)() + '\n            ' + (0, _flexbox.justifyContent)('flex-end') + '\n            width: 90%;\n\n            & > div {\n                margin-left: 10px;\n            }\n        }\n\n        .backPanel {\n             width: 10%;\n        }\n\n        .content {\n            ' + (0, _flexbox.flexbox)() + '\n            ' + (0, _flexbox.flexDirection)('column') + '\n            width: calc(100% - 16px);\n            height: calc(100vh - 167px);\n            margin: 8px 7px;\n            background-color: ' + palette.primary.text + ';\n            box-shadow: 5px 5px 1px lighten(' + colours.lightGreyShadow + ', 70%);\n            border-radius: 6px;\n        }\n\n        .courseName {\n            color: ' + palette.primary.main + ';\n            font-family: ' + typography.family + ';\n            font-size: 19px;\n            font-weight: 500;\n            line-height: 27px;\n            padding: 0px;\n\n            input, .icon {\n                min-height: 40px;\n            }\n\n            .icon {\n                margin-top: 10px;\n            }\n        }\n\n        .course {\n            ' + (0, _flexbox.flexbox)() + '\n            padding : 10px;\n        }\n\n        .courseInfoContainer {\n            padding-right:10px;\n        }\n\n        .courseHeading {\n            height: 18px;\n            color: ' + palette.primary.dark + ';\n            font-family: ' + typography.family + ';\n            font-size: 16px;\n            font-weight: 400;\n        }\n\n        .courseInfo {\n            height: 18px;\n            color: ' + palette.primary.dark + ';\n            font-family: ' + typography.family + ';\n            font-size: 13px;\n        }\n\n        .coursePanel {\n            ' + (0, _flexbox.flexbox)() + '\n            ' + (0, _flexbox.flexDirection)('column') + '\n        }\n\n        .header {\n            ' + (0, _flexbox.flexbox)() + '\n            ' + (0, _flexbox.flexShrink)(0) + '\n            height: 50px;\n            color: ' + palette.primary.main + ';\n            font-family: ' + typography.family + ';\n            font-size: 13px;\n            font-weight: 600;\n            line-height: 27px;\n        }\n\n        .treeColumn {\n            ' + headerColumn() + '\n            background-color: ' + palette.primary.text + ';\n            border-top: 1px solid ' + palette.tertiary.main + '\n            border-bottom: 1px solid ' + palette.tertiary.main + '\n            width: calc(100%/3);\n        }\n\n        .searchColumn {\n            ' + headerColumn() + '\n            background-color: ' + palette.primary.text + ';\n            border: 1px solid ' + palette.tertiary.main + ';\n            border-right: none;\n            width: calc(100%/3);\n        }\n\n        .topicColumn {\n            ' + headerColumn() + '\n            ' + (0, _flexbox.flexbox)() + '\n            background-color: ' + palette.primary.text + ';\n            border-left: 1px solid ' + palette.tertiary.main + '\n            border-top: 1px solid ' + palette.tertiary.main + '\n            border-bottom: 1px solid ' + palette.tertiary.main + '\n            width: calc(100%/3);\n        }\n\n        .panelRow {\n            ' + (0, _flexbox.flexbox)() + '\n            height: 100vh;\n        }\n\n        .treeRows {\n             width: calc(100%/3);\n             transition: width 0.2s;\n        }\n\n        .fullWidth {\n            width: 100%;\n            transition: width 0.2s;\n        }\n\n        .spineRows {\n             border-left: 1px solid ' + palette.tertiary.main + '\n             width: calc(100%/3);\n        }\n\n        .topics {\n             border-left: 1px solid ' + palette.tertiary.main + '\n             width: calc(100%/3);\n             padding: 10px;\n             overflow: auto;\n        }\n\n        .curriculumHeaderName {\n            float: left;\n            padding-left: 10px;\n        }\n\n        .topicHeader {\n            ' + (0, _flexbox.flexbox)() + '\n            ' + (0, _flexbox.alignItems)('center') + '\n\n            &Icons {\n              ' + (0, _flexbox.flexbox)() + '\n              padding-left: 10px;\n              margin-top: -15px;\n            }\n\n            &Name {\n                text-align: left;\n            }\n\n            &Add {\n                ' + (0, _flexbox.flexbox)() + '\n                ' + (0, _flexbox.flex)(1) + '\n                ' + (0, _flexbox.justifyContent)('center') + '\n                ' + (0, _flexbox.alignItems)('center') + '\n                padding-right: 10px;\n                >div {\n                    padding: 10px;\n                }\n            }\n\n            &NewTopic {\n                ' + (0, _flexbox.flexbox)() + '\n                ' + (0, _flexbox.flex)(1) + '\n                ' + (0, _flexbox.justifyContent)('flex-end') + '\n                padding-right: 10px;\n                >div {\n                    padding: 10px;\n                }\n            }\n        }\n\n        .iconStyle {\n            width: 18px;\n            height: 25px;\n            margin-right:4px;\n            outline: none;\n            cursor: pointer;\n        }\n\n        .newTopicButton {\n            height: 36px;\n        }\n\n        .topicList {\n            padding: 6px;\n        }\n\n        .topicPanel {\n            height: 100%;\n            overflow: auto;\n        }\n\n        .hide {\n            display: none;\n        }\n\n        .dropZone {\n            height: 50px;\n\n            &:hover {\n                border: 2px solid ' + palette.primary.light + ';\n                border-style: dashed;\n            }\n        }\n\n        .hideRow {\n            width: 0%;\n            display: none;\n        }\n\n        .icon {\n            width: 20px;\n            height: 21px;\n            margin-top: 5px;\n            margin-right: 10px;\n            margin-left: 10px;\n            float: right;\n            cursor: pointer;\n            outline: none;\n        }\n\n        .expand {\n            width: 20px;\n            height: 21px;\n            margin-top: 5px;\n            margin-right: 10px;\n            margin-left: 10px;\n            float: left;\n            cursor: pointer;\n            outline: none;\n        }\n\n        .checkbox {\n            ' + (0, _flexbox.inlineFlexbox)() + ';\n\n            margin: -5px;\n\n            .chklabel {\n                width: 20px;\n                height: 20px;\n                border: 1px solid ' + colours.silverDark + ';\n                border-radius: 3px;\n                margin-top: 4px;\n            }\n\n            .name {\n                display: none;\n\n                &:checked + label::after{\n                    background-color: white !important;\n                    content: "\f00c";\n                    color: black;\n                    font-family: "FontAwesome";\n                    font-size: 16px;\n                    top: 0px;\n                    left: 12px;\n                    position: absolute;\n                    height: 0px;\n                }\n            }\n        }\n\n        .spineNode {\n            width: 100px;\n            padding: 5px !important;\n        }\n    ';
});

var ModalButtons = _styledComponents2.default.div(_templateObject3, (0, _flexbox.flexbox)());

var CourseInfoWrapper = _styledComponents2.default.div(_templateObject4);

exports.CourseCreatorWrapper = CourseCreatorWrapper;
exports.ModalButtons = ModalButtons;
exports.CourseInfoWrapper = CourseInfoWrapper;
exports.SpinnerWrapper = SpinnerWrapper;

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _messages = __webpack_require__(159);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTranslations = function getTranslations(_ref) {
    var intl = _ref.intl;
    return {
        backButtonText: intl.formatMessage(_messages2.default.back),
        publishButtonText: intl.formatMessage(_messages2.default.publish),
        productSelectorPlaceholderText: intl.formatMessage(_messages2.default.selectProduct),
        productSelectorHeadingText: intl.formatMessage(_messages2.default.productSelectorHeading),
        saveCourseButtonText: intl.formatMessage(_messages2.default.save)
    };
};

exports.default = getTranslations;

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(214);

var _constants = __webpack_require__(19);

var _styled = __webpack_require__(476);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CourseFilter = function CourseFilter(_ref) {
    var children = _ref.children;

    var styleProps = {};

    ['disabled'].forEach(function (style) {
        if (style) {
            styleProps[style] = true;
        }
    });

    return _react2.default.createElement(
        _styled.CourseFilterWrapper,
        styleProps,
        _react2.default.createElement(
            _styled.FilterTabs,
            null,
            _react2.default.createElement(
                _reactRouterDom.NavLink,
                { exact: true, to: { pathname: _constants.MASTER_COURSES_ROUTE } },
                'Curriculum'
            ),
            _react2.default.createElement(
                _reactRouterDom.NavLink,
                { exact: true, to: { pathname: _constants.DEFAULT_COURSES_ROUTE } },
                '3P Courses'
            )
        ),
        _react2.default.createElement(
            _styled.FilterItems,
            null,
            children
        )
    );
};

CourseFilter.propTypes = {
    children: _propTypes2.default.node,
    disabled: _propTypes2.default.bool
};

exports.default = CourseFilter;

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _dropdownList = __webpack_require__(63);

var _dropdownList2 = _interopRequireDefault(_dropdownList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CourseTypeSelector = function CourseTypeSelector(_ref) {
    var _onChange = _ref.onChange,
        options = _ref.options;
    return _react2.default.createElement(_dropdownList2.default, {
        name: 'courseTypeSelector',
        onChange: function onChange(name, value) {
            return _onChange(value);
        },
        optionKey: 'key',
        options: options,
        optionText: 'value' });
};

CourseTypeSelector.propTypes = {
    onChange: _propTypes.PropTypes.func.isRequired,
    options: _propTypes.PropTypes.array.isRequired
};

CourseTypeSelector.defaultProps = {
    onChange: function onChange() {},
    options: []
};

exports.default = CourseTypeSelector;

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DateTimeRenderer = exports.ActionRenderer = exports.CellRenderer = exports.DataTable = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactTable = __webpack_require__(1042);

var _reactTable2 = _interopRequireDefault(_reactTable);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styled = __webpack_require__(481);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataTable = function DataTable(props) {
    return _react2.default.createElement(
        _styled.ReacTableStyles,
        null,
        _react2.default.createElement(_reactTable2.default, props)
    );
};

var DateTimeRenderer = function DateTimeRenderer(row) {
    return _react2.default.createElement(
        'span',
        { title: row.value },
        new Date(row.value).toString().split('G')[0]
    );
};
var CellRenderer = function CellRenderer(row) {
    return _react2.default.createElement(
        'span',
        { title: row.value },
        row.value
    );
};
var ActionRenderer = function ActionRenderer(props) {
    return _react2.default.createElement(
        _styled.ActionRendererWrapper,
        { className: 'data-table-action-wrapper' },
        props.children
    );
};

ActionRenderer.propTypes = {
    children: _propTypes2.default.node
};

exports.DataTable = DataTable;
exports.CellRenderer = CellRenderer;
exports.ActionRenderer = ActionRenderer;
exports.DateTimeRenderer = DateTimeRenderer;

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = __webpack_require__(1108);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = function Modal(props) {
    var modalElement = props.show ? _react2.default.createElement(
        'div',
        { className: _index2.default.modalBackdrop, id: 'modalBackdrop' },
        _react2.default.createElement(
            'div',
            { className: _index2.default.modal },
            props.children
        )
    ) : null;

    return modalElement;
};

Modal.propTypes = {
    show: _propTypes2.default.bool,
    children: _propTypes2.default.node
};

exports.default = Modal;

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(1109);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PulseLoader = function PulseLoader() {
    return _react2.default.createElement(
        'div',
        { className: _index2.default.pulseLoader },
        _react2.default.createElement('div', null),
        _react2.default.createElement('div', null),
        _react2.default.createElement('div', null),
        _react2.default.createElement('div', null)
    );
};

exports.default = PulseLoader;

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setAlertModalStatus = exports.checkUserIsAuthorizedFailure = exports.checkUserIsAuthorizedSuccess = exports.checkUserIsAuthorized = undefined;

var _actionTypes = __webpack_require__(162);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var checkUserIsAuthorized = exports.checkUserIsAuthorized = function checkUserIsAuthorized() {
    return {
        type: actionTypes.CHECK_USER_IS_AUTHORIZED_REQUEST
    };
};

var checkUserIsAuthorizedSuccess = exports.checkUserIsAuthorizedSuccess = function checkUserIsAuthorizedSuccess(payload) {
    return {
        type: actionTypes.CHECK_USER_IS_AUTHORIZED_SUCCEED,
        payload: payload
    };
};

var checkUserIsAuthorizedFailure = exports.checkUserIsAuthorizedFailure = function checkUserIsAuthorizedFailure() {
    return {
        type: actionTypes.CHECK_USER_IS_AUTHORIZED_FAILURE
    };
};

var setAlertModalStatus = exports.setAlertModalStatus = function setAlertModalStatus(displayModalStatus) {
    return {
        type: actionTypes.ALERT_MODAL_DISPLAY_STATUS,
        displayModalStatus: displayModalStatus
    };
};

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _queryString = __webpack_require__(210);

var _queryString2 = _interopRequireDefault(_queryString);

var _es = __webpack_require__(1014);

var _es2 = _interopRequireDefault(_es);

var _es3 = __webpack_require__(835);

var _es4 = _interopRequireDefault(_es3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
                                                                                                                                                                                                                   * i18n.js
                                                                                                                                                                                                                   *
                                                                                                                                                                                                                   * This will setup the i18n language files and locale data for your app.
                                                                                                                                                                                                                   *
                                                                                                                                                                                                                   *   IMPORTANT: This file is used by the internal build
                                                                                                                                                                                                                   *   script `extract-intl`, and must use CommonJS module syntax
                                                                                                                                                                                                                   *   You CANNOT use import/export in this file.
                                                                                                                                                                                                                   */

var addLocaleData = __webpack_require__(15).addLocaleData; //eslint-disable-line
var enLocaleData = __webpack_require__(1013);

var enTranslationMessages = __webpack_require__(834);

addLocaleData(enLocaleData);
addLocaleData(_es2.default);

var DEFAULT_LOCALE = 'en';

// prettier-ignore
var appLocales = ['en', 'es', 'es-mx'];

var formatTranslationMessages = function formatTranslationMessages(locale, messages) {
    var defaultFormattedMessages = locale !== DEFAULT_LOCALE ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages) : {};
    var flattenFormattedMessages = function flattenFormattedMessages(formattedMessages, key) {
        var formattedMessage = !messages[key] && locale !== DEFAULT_LOCALE ? defaultFormattedMessages[key] : messages[key];
        return Object.assign(formattedMessages, _defineProperty({}, key, formattedMessage));
    };
    return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

var translationMessages = {
    en: formatTranslationMessages('en', enTranslationMessages),
    es: formatTranslationMessages('es', _es4.default),
    'es-mx': formatTranslationMessages('es-mx', _es4.default)
};

var getLocale = function getLocale() {
    var _queryString$parse = _queryString2.default.parse(location.search),
        lang = _queryString$parse.lang;

    return appLocales.indexOf(String(lang).toLowerCase()) !== -1 ? String(lang).toLowerCase() : DEFAULT_LOCALE;
};

exports.appLocales = appLocales;
exports.formatTranslationMessages = formatTranslationMessages;
exports.translationMessages = translationMessages;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
exports.getLocale = getLocale;

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// todo: fill in missing colours
exports.default = {
    primary: {
        light: '#6c7378',
        main: '#415667',
        dark: '#4e5c67',
        text: '#fff'
    },
    secondary: {
        light: '#1981c4',
        main: '#1576b4',
        text: '#fff'
    },
    tertiary: {
        // todo: do we want this?
        light: '#e4eaef',
        main: '#adb6bc',
        dark: '#6c7378',
        text: '#484848'
    },
    success: {
        light: '#5cb85c',
        main: '#5cb85c',
        text: '#fff'
    },
    error: {
        light: '#bf2c30',
        main: '#c53902',
        text: '#fff'
    }
};

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = __webpack_require__(253);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(1106);

var _index4 = _interopRequireDefault(_index3);

var _svgIcon = __webpack_require__(64);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _styled = __webpack_require__(466);

var _styled2 = _interopRequireDefault(_styled);

var _variants = __webpack_require__(467);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The 3p school-roll button.
 *
 * @version 1.0.1
 * @author Voyager
 */

var Button = function Button(props) {
    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$icon = props.icon,
        icon = _props$icon === undefined ? '' : _props$icon,
        _props$iconClassName = props.iconClassName,
        iconClassName = _props$iconClassName === undefined ? '' : _props$iconClassName,
        _props$label = props.label,
        label = _props$label === undefined ? '' : _props$label,
        disabled = props.disabled,
        hidden = props.hidden,
        loading = props.loading,
        loadingLabel = props.loadingLabel,
        handleOnClick = props.handleOnClick,
        _props$buttonContaine = props.buttonContainerDisabled,
        buttonContainerDisabled = _props$buttonContaine === undefined ? '' : _props$buttonContaine,
        children = props.children;


    var styleProps = {};

    [_variants.PRIMARY, _variants.BASIC, _variants.INLINE, _variants.DISABLED, _variants.CIRCLE, _variants.SUCCESS, _variants.WARNING].forEach(function (style) {
        if (props[style]) {
            styleProps[style] = true;
        }
    });

    var iconElement = icon === '' ? _react2.default.createElement('div', null) : _react2.default.createElement(
        'div',
        { className: iconClassName },
        _react2.default.createElement(_svgIcon2.default, { icon: icon })
    );

    var buttonContainerDisabledStyle = buttonContainerDisabled === '' ? _index4.default.buttonContainerDisabled : buttonContainerDisabled;

    var buttonElement = loading ? _react2.default.createElement(
        'div',
        { className: buttonContainerDisabledStyle },
        iconElement,
        _react2.default.createElement(
            'span',
            null,
            loadingLabel
        ),
        _react2.default.createElement(_index2.default, { size: '5px' })
    ) : _react2.default.createElement(
        _styled2.default
        /* eslint-disable */
        ,
        _extends({}, styleProps, {
            className: className,
            hidden: hidden,
            onClick: disabled ? function () {} : handleOnClick,
            role: 'button',
            tabIndex: 0 }),
        _react2.default.createElement(
            'div',
            null,
            iconElement,
            _react2.default.createElement(
                'span',
                null,
                label
            )
        ),
        children
    );

    var finalView = buttonElement;

    if (hidden) {
        finalView = _react2.default.createElement('div', null);
    }

    return finalView;
};

Button.propTypes = {
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    icon: _propTypes2.default.string,
    iconClassName: _propTypes2.default.string,
    loadingLabel: _propTypes2.default.string,
    buttonContainerDisabled: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    hidden: _propTypes2.default.bool,
    loading: _propTypes2.default.bool,
    handleOnClick: _propTypes2.default.func,
    primary: _propTypes2.default.bool,
    basic: _propTypes2.default.bool,
    inline: _propTypes2.default.bool,
    cicle: _propTypes2.default.bool
};
exports.default = Button;

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global window document */
/* eslint-disable no-console */

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(90);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(52);

var _conserveParameters = __webpack_require__(535);

var _conserveParameters2 = _interopRequireDefault(_conserveParameters);

var _config = __webpack_require__(510);

var _config2 = _interopRequireDefault(_config);

var _errorHandling = __webpack_require__(537);

var _errorHandling2 = _interopRequireDefault(_errorHandling);

var _utils = __webpack_require__(97);

var _store = __webpack_require__(544);

var _store2 = _interopRequireDefault(_store);

var _i18n = __webpack_require__(255);

var _mainSaga = __webpack_require__(541);

var _mainSaga2 = _interopRequireDefault(_mainSaga);

var _portalComms = __webpack_require__(165);

var _portalComms2 = _interopRequireDefault(_portalComms);

var _productService = __webpack_require__(540);

var _productService2 = _interopRequireDefault(_productService);

var _rootContainer = __webpack_require__(496);

var _rootContainer2 = _interopRequireDefault(_rootContainer);

var _languageProvider = __webpack_require__(522);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(0, _conserveParameters2.default)(['username', 'password', 'authToken', 'env', 'productId', 'lang']);

var App = function () {
    function App(element, dynamicOptions) {
        var _this = this;

        _classCallCheck(this, App);

        // initial state based on selected product that has been passed in query string
        var initialState = _productService2.default.Configure();
        // Initial config
        this.store = (0, _store2.default)(initialState);
        this.store.runSaga(_mainSaga2.default);
        _config2.default.configure();
        // Add an interceptor to handle errors when accessing resources
        _errorHandling2.default.addResourceResponseErrorInterceptor();
        _portalComms2.default.Configure();

        this.element = element;
        this.options = (0, _utils.handleDefaults)({}, dynamicOptions);

        // Chunked polyfill for browsers without Intl support
        if (!window.Intl) {
            new Promise(function (resolve) {
                resolve(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1148)));
            }).then(function () {
                return Promise.all([
                // eslint-disable-next-line import/extensions
                __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1149)),
                // eslint-disable-next-line import/extensions
                __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1150))]);
            }).then(function () {
                return _this.renderElement(_i18n.translationMessages, _i18n.DEFAULT_LOCALE);
            }).catch(function (err) {
                throw err;
            });
        } else {
            this.renderElement(_i18n.translationMessages, _i18n.DEFAULT_LOCALE);
        }
    }

    _createClass(App, [{
        key: 'renderElement',
        value: function renderElement(messages, locale) {
            // eslint-disable-next-line no-underscore-dangle
            var baseName = window._env_ ? window._env_.BaseName : ''; // definitely resolved
            var currentLocale = (0, _i18n.getLocale)() || locale;

            _reactDom2.default.render(_react2.default.createElement(
                _reactRedux.Provider,
                { store: this.store },
                _react2.default.createElement(
                    _languageProvider.LanguageProvider,
                    { locale: currentLocale, messages: messages },
                    _react2.default.createElement(_rootContainer2.default, { basename: baseName })
                )
            ), document.querySelector(this.element));
        }
    }]);

    return App;
}();

exports.default = App;


window.App = App;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(15);

var _reactSelect = __webpack_require__(217);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRedux = __webpack_require__(52);

var _redux = __webpack_require__(43);

var _messages = __webpack_require__(159);

var _messages2 = _interopRequireDefault(_messages);

var _button = __webpack_require__(37);

var _button2 = _interopRequireDefault(_button);

var _actions = __webpack_require__(95);

var _curriculumTopicLink = __webpack_require__(477);

var _curriculumTopicLink2 = _interopRequireDefault(_curriculumTopicLink);

var _utils = __webpack_require__(464);

var _utils2 = _interopRequireDefault(_utils);

var _styled = __webpack_require__(463);

var _iconDictionary = __webpack_require__(65);

var _svgIcon = __webpack_require__(64);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _constants = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_TOPIC_NAME_LENGTH = 50;
var MAX_STANDARD_NAME_LENGTH = 40;
var MAX_EXTERNAL_KEY_LENGTH = 32;
var MAX_DESCRIPTION_LENGTH = 1000;

var TOPIC_TYPES = {
    STRAND: 'strand',
    STANDARD: 'standard'
};

var AddTopic = function (_Component) {
    _inherits(AddTopic, _Component);

    function AddTopic(props) {
        _classCallCheck(this, AddTopic);

        var _this = _possibleConstructorReturn(this, (AddTopic.__proto__ || Object.getPrototypeOf(AddTopic)).call(this, props));

        _this.handleOnTopicNameChange = function (e) {
            var topicName = e.target.value;

            _this.setState({
                topicName: topicName
            }, function () {
                _this.setUpdateButtonStatus();
            });

            if (!_this.unsavedChanges) {
                _this.unsavedChanges = true;
            }
        };

        _this.handleOnTopicTypeChange = function (topicType) {
            var maxLength = _this.getTopicNameLength(topicType.value);

            _this.setState({
                topicType: topicType.value,
                topicNameMaxLength: maxLength
            }, function () {
                _this.setUpdateButtonStatus();
            });

            _this.topicType = topicType.value;

            if (!_this.unsavedChanges) {
                _this.unsavedChanges = true;
            }
        };

        _this.handleOnUpdate = function () {
            var _this$props = _this.props,
                onClose = _this$props.onClose,
                handleOnUpdateModal = _this$props.handleOnUpdateModal,
                id = _this$props.id;
            var _this$state = _this.state,
                topicName = _this$state.topicName,
                externalKey = _this$state.externalKey,
                description = _this$state.description,
                curriculumLevelCode = _this$state.curriculumLevelCode;


            var updatedObject = {
                curriculumLevelCode: curriculumLevelCode,
                description: description,
                externalKey: externalKey,
                strand: _this.strand,
                subStrand: _this.subStrand,
                topicId: id,
                topicName: topicName,
                topicType: _this.topicType
            };

            handleOnUpdateModal(updatedObject);
            onClose(id);
        };

        _this.getSubtrands = function () {
            var strand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var standardFilters = _this.state.standardFilters;

            if (standardFilters[strand]) {
                _this.subStrandFilterOptions = standardFilters[strand].map(function (substrand) {
                    return {
                        value: substrand,
                        label: substrand
                    };
                });
            }
            if (strand !== 'None') {
                _this.subStrandFilterOptions.unshift({
                    value: 'None', label: 'None'
                });
            }
            return _this.subStrandFilterOptions;
        };

        _this.handleOnStrandChange = function (strand) {
            var _this$state2 = _this.state,
                topicName = _this$state2.topicName,
                topicType = _this$state2.topicType;


            _this.subStrandFilterOptions = strand.value === 'None' ? [{
                value: 'None', label: 'None'
            }] : _this.getSubtrands(strand.value);

            _this.strand = strand.value;
            var selectedSubStrand = strand.value === 'None' ? 'None' : _this.subStrandFilterOptions[0].value;
            _this.setState({
                selectedStrand: strand.value,
                selectedSubStrand: selectedSubStrand
            });
            _this.subStrand = selectedSubStrand;
            _this.setUpdateButtonStatus();

            if (!_this.unsavedChanges && topicName.trim().length && topicType !== '') {
                _this.unsavedChanges = true;
            }
        };

        _this.handleOnSubstrandChange = function (subStrand) {
            var _this$state3 = _this.state,
                topicName = _this$state3.topicName,
                topicType = _this$state3.topicType;

            _this.setState({
                selectedSubStrand: subStrand.value
            });
            _this.subStrand = subStrand.value;
            _this.setUpdateButtonStatus();

            if (!_this.unsavedChanges && topicName.trim().length && topicType !== '') {
                _this.unsavedChanges = true;
            }
        };

        _this.handleOnCloseModal = function () {
            var _this$props2 = _this.props,
                id = _this$props2.id,
                intl = _this$props2.intl,
                onClose = _this$props2.onClose;

            _this.strand = '';
            _this.subStrand = '';
            _this.setState({
                selectedStrand: 'None',
                selectedSubStrand: 'None'
            });
            onClose(id);
            if (_this.unsavedChanges) {
                _this.props.showToast(intl.formatMessage(_messages2.default.detailsNotSaved), 'warning');
            }
        };

        _this.handleCurriculumChange = function (selectedOption) {
            _this.setUpdateButtonStatus();
            if (selectedOption) {
                var code = selectedOption.code,
                    value = selectedOption.value,
                    id = selectedOption.id;

                _this.setState({
                    externalKey: code,
                    description: value,
                    curriculumLevelCode: id
                }, function () {
                    _this.setUpdateButtonStatus();
                });
            } else {
                _this.setState({
                    externalKey: '',
                    description: '',
                    curriculumLevelCode: ''
                }, function () {
                    _this.setUpdateButtonStatus();
                });
            }
        };

        _this.handleKeyChange = function (e) {
            var externalKey = e.target.value || '';
            _this.setUpdateButtonStatus();
            _this.setState({
                externalKey: externalKey
            });
        };

        _this.handleDescriptionChange = function (e) {
            var description = e.target.value || '';
            _this.setUpdateButtonStatus();
            _this.setState({
                description: description
            });
        };

        _this.handleOnDelete = function () {
            _this.setState({ showDeleteConfirmation: true });
        };

        _this.handleOnDeleteConfirm = function () {
            _this.setState({ showDeleteConfirmation: false });
            var _this$props3 = _this.props,
                id = _this$props3.id,
                onClose = _this$props3.onClose,
                onDelete = _this$props3.onDelete;

            onDelete(id);
            onClose();
        };

        _this.handleOnDeleteCancel = function () {
            _this.setState({ showDeleteConfirmation: false });
        };

        _this.getTopicNameLength = function (topicType) {
            if (topicType.toUpperCase() === 'STANDARD') {
                return MAX_STANDARD_NAME_LENGTH;
            }

            return MAX_TOPIC_NAME_LENGTH;
        };

        _this.getTopicNameErrorMessages = function (intl) {
            var _this$state4 = _this.state,
                topicName = _this$state4.topicName,
                topicNameMaxLength = _this$state4.topicNameMaxLength;

            if (topicName.length <= topicNameMaxLength) {
                return null;
            }

            return intl.formatMessage(_messages2.default.keepTopicNameLessThan) + ' ' + _this.state.topicNameMaxLength + ' ' + intl.formatMessage(_messages2.default.characters);
        };

        _this.getIsCurriculumLinkRequired = function () {
            var STRAND = TOPIC_TYPES.STRAND,
                STANDARD = TOPIC_TYPES.STANDARD;
            var selectedProduct = _this.props.selectedProduct;
            var topicType = _this.state.topicType;


            var topicTypeToLowercase = topicType.toLowerCase();
            var isRequiredTopicType = topicTypeToLowercase === STRAND || topicTypeToLowercase === STANDARD;
            var isMathletics = selectedProduct === _constants.MATHLETICS_PRODUCT_ID;

            return isRequiredTopicType && isMathletics;
        };

        _this.setUpdateButtonStatus = function () {
            var _this$state5 = _this.state,
                topicName = _this$state5.topicName,
                topicType = _this$state5.topicType,
                topicNameMaxLength = _this$state5.topicNameMaxLength,
                curriculumLevelCode = _this$state5.curriculumLevelCode;


            var updatedCurriculumLevelCode = curriculumLevelCode || '';
            var hasRequiredFieldValues = !!topicName && !!topicType && topicName.trim().length <= topicNameMaxLength;

            var isEnabled = void 0;

            if (_this.getIsCurriculumLinkRequired()) {
                isEnabled = updatedCurriculumLevelCode !== '' && hasRequiredFieldValues;
            } else {
                isEnabled = hasRequiredFieldValues;
            }

            _this.setState({ enableUpdate: isEnabled });
        };

        _this.unsavedChanges = false;
        _this.enableUpdate = false;
        _this.strand = '';
        _this.subStrand = '';
        _this.topicType = '';
        _this.subStrandFilterOptions = [];

        _this.state = {
            selectedStrand: 'None',
            selectedSubStrand: 'None',
            topicName: '',
            externalKey: '',
            description: '',
            curriculumLevelCode: '',
            topicType: '',
            topicTypes: [],
            standardFilters: {},
            topicNameMaxLength: MAX_TOPIC_NAME_LENGTH,
            enableUpdate: false
        };

        _this.handleOnUpdate = _this.handleOnUpdate.bind(_this);
        _this.handleOnStrandChange = _this.handleOnStrandChange.bind(_this);
        _this.handleOnSubstrandChange = _this.handleOnSubstrandChange.bind(_this);
        _this.handleOnCloseModal = _this.handleOnCloseModal.bind(_this);
        _this.handleOnTopicNameChange = _this.handleOnTopicNameChange.bind(_this);
        _this.getSubtrands = _this.getSubtrands.bind(_this);
        return _this;
    }

    _createClass(AddTopic, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            var modalData = props.modalData,
                parentData = props.parentData,
                modalType = props.modalType,
                standardFilters = props.standardFilters;

            this.unsavedChanges = false;
            this.setUpdateButtonStatus();

            this.strandFilterOptions = Object.keys(props.standardFilters);
            this.strandFilterOptions = this.strandFilterOptions.map(function (strand) {
                return {
                    value: strand,
                    label: strand.toUpperCase()
                };
            });

            this.strandFilterOptions.unshift({
                value: 'None', label: 'NONE'
            });

            this.strand = parentData.strand === '' ? modalData.strand : parentData.strand;
            this.subStrand = parentData.subStrand === '' ? modalData.subStrand : parentData.subStrand;

            this.setState({
                description: modalData.description || '',
                selectedStrand: this.strand,
                selectedSubStrand: this.subStrand,
                topicName: modalData.name || '',
                standardFilters: standardFilters,
                externalKey: modalData.externalKey || '',
                curriculumLevelCode: modalData.curriculumLevelCode,
                topicType: modalData.type || '',
                topicTypes: (0, _utils2.default)(modalType, parentData.type, this.props.topicTypes),
                topicNameMaxLength: modalData.type ? this.getTopicNameLength(modalData.type) : MAX_TOPIC_NAME_LENGTH,
                enableUpdate: false
            });

            this.getSubtrands(this.strand);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                show = _props.show,
                intl = _props.intl,
                curriculumLevelDescriptions = _props.curriculumLevelDescriptions,
                modalType = _props.modalType;
            var _state = this.state,
                _state$externalKey = _state.externalKey,
                externalKey = _state$externalKey === undefined ? '' : _state$externalKey,
                _state$description = _state.description,
                description = _state$description === undefined ? '' : _state$description,
                _state$curriculumLeve = _state.curriculumLevelCode,
                curriculumLevelCode = _state$curriculumLeve === undefined ? '' : _state$curriculumLeve;

            var topicErrorMessage = this.getTopicNameErrorMessages(intl);

            if (show) {
                return _react2.default.createElement(
                    _styled.AddTopicContainer,
                    null,
                    _react2.default.createElement(
                        _styled.ContentWrapper,
                        null,
                        _react2.default.createElement(
                            _styled.Close,
                            { onClick: this.handleOnCloseModal },
                            'X'
                        ),
                        _react2.default.createElement(
                            _styled.EditTopicHeader,
                            null,
                            'Edit Topic Details'
                        ),
                        _react2.default.createElement(
                            _styled.RequiredFields,
                            null,
                            'Required fields'
                        ),
                        _react2.default.createElement(
                            _styled.TopicName,
                            { hasError: topicErrorMessage != null },
                            _react2.default.createElement(
                                'span',
                                null,
                                intl.formatMessage(_messages2.default.topicName)
                            ),
                            _react2.default.createElement('input', {
                                maxLength: this.state.topicNameMaxLength,
                                name: 'topicName',
                                onChange: this.handleOnTopicNameChange,
                                type: 'text',
                                value: this.state.topicName }),
                            _react2.default.createElement(
                                _styled.ErrorMessage,
                                null,
                                topicErrorMessage
                            )
                        ),
                        _react2.default.createElement(
                            _styled.TopicType,
                            null,
                            _react2.default.createElement(
                                'span',
                                null,
                                intl.formatMessage(_messages2.default.topicType)
                            ),
                            _react2.default.createElement(_reactSelect2.default, {
                                className: 'topicTypeSelect',
                                isDisabled: modalType === 'edit',
                                onChange: this.handleOnTopicTypeChange,
                                options: this.state.topicTypes,
                                placeholder: this.state.topicType || 'Select...',
                                value: this.state.topicType })
                        ),
                        _react2.default.createElement(
                            _styled.FilterWrapper,
                            null,
                            _react2.default.createElement(
                                _styled.Filters,
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'strandFilter' },
                                    intl.formatMessage(_messages2.default.strandFilter)
                                ),
                                _react2.default.createElement(_reactSelect2.default, {
                                    id: 'strandFilter',
                                    onChange: this.handleOnStrandChange,
                                    options: this.strandFilterOptions,
                                    placeholder: this.state.selectedStrand.toUpperCase(),
                                    value: this.state.selectedStrand })
                            ),
                            _react2.default.createElement(
                                _styled.Filters,
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'subStrandFilter' },
                                    intl.formatMessage(_messages2.default.subStrandFilter)
                                ),
                                _react2.default.createElement(_reactSelect2.default, {
                                    id: 'subStrandFilter',
                                    onChange: this.handleOnSubstrandChange,
                                    options: this.subStrandFilterOptions,
                                    placeholder: this.state.selectedSubStrand.toUpperCase(),
                                    value: this.state.selectedSubStrand })
                            )
                        ),
                        _react2.default.createElement(
                            _styled.CurriculumLink,
                            {
                                isRequired: this.getIsCurriculumLinkRequired()
                            },
                            _react2.default.createElement(
                                'span',
                                null,
                                intl.formatMessage(_messages2.default.curriculumLevelLink)
                            ),
                            _react2.default.createElement(_curriculumTopicLink2.default, {
                                curriculumLevelDescriptions: curriculumLevelDescriptions,
                                defaultValue: { value: this.state.description, label: this.props.defaultDescription },
                                handleCurriculumChange: this.handleCurriculumChange,
                                placeholder: intl.formatMessage(_messages2.default.curriculumLinkPlaceholder) })
                        ),
                        _react2.default.createElement(
                            _styled.ExternalKey,
                            null,
                            _react2.default.createElement(
                                'span',
                                null,
                                intl.formatMessage(_messages2.default.externalKey)
                            ),
                            _react2.default.createElement('input', { disabled: curriculumLevelCode, maxLength: MAX_EXTERNAL_KEY_LENGTH, name: 'externalKey', onChange: this.handleKeyChange, type: 'text', value: externalKey })
                        ),
                        _react2.default.createElement(
                            _styled.Description,
                            null,
                            _react2.default.createElement(
                                'span',
                                null,
                                intl.formatMessage(_messages2.default.description)
                            ),
                            _react2.default.createElement('textarea', { disabled: curriculumLevelCode, maxLength: MAX_DESCRIPTION_LENGTH, name: 'description', onChange: this.handleDescriptionChange, value: description })
                        ),
                        _react2.default.createElement(
                            _styled.ButtonsWrapper,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'deletePanel' },
                                !this.state.showDeleteConfirmation ? _react2.default.createElement(
                                    'div',
                                    {
                                        className: 'iconStyle',
                                        onClick: this.handleOnDelete,
                                        role: 'button',
                                        tabIndex: '-1' },
                                    _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Delete })
                                ) : _react2.default.createElement(
                                    'div',
                                    { className: 'confirmationPanel' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'message' },
                                        'Are you sure you would like to remove?'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'buttonPanel' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'cross' },
                                            _react2.default.createElement(
                                                'div',
                                                {
                                                    className: 'btnIconStyle',
                                                    onClick: this.handleOnDeleteCancel,
                                                    role: 'button',
                                                    tabIndex: '-1' },
                                                _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Cross })
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'tick' },
                                            _react2.default.createElement(
                                                'div',
                                                null,
                                                _react2.default.createElement(
                                                    'div',
                                                    {
                                                        className: 'btnIconStyle',
                                                        onClick: this.handleOnDeleteConfirm,
                                                        role: 'button',
                                                        tabIndex: '-1' },
                                                    _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Tick })
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(_button2.default, {
                                    disabled: !this.state.enableUpdate,
                                    handleOnClick: this.handleOnUpdate,
                                    label: intl.formatMessage(_messages2.default.update),
                                    primary: true
                                })
                            )
                        )
                    )
                );
            }
            return null;
        }
    }]);

    return AddTopic;
}(_react.Component);

AddTopic.propTypes = {
    show: _propTypes2.default.bool,
    onClose: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    standardFilters: _propTypes2.default.object,
    showToast: _propTypes2.default.func,
    handleOnUpdateModal: _propTypes2.default.func,
    id: _propTypes2.default.string,
    modalData: _propTypes2.default.object,
    curriculumLevelDescriptions: _propTypes2.default.array,
    defaultDescription: _propTypes2.default.string,
    topicTypes: _propTypes2.default.array,
    modalType: _propTypes2.default.string,
    parentData: _propTypes2.default.object,
    onDelete: _propTypes2.default.func,
    selectedProduct: _propTypes2.default.number
};

AddTopic.defaultProps = {
    show: true,
    name: '',
    strand: 'None',
    subStrand: 'None',
    topicTypes: [],
    parentData: {},
    standardFilters: {}
};

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        showToast: _actions.showToast
    }, dispatch);
}

exports.default = (0, _reactRedux.connect)(function () {
    return {};
}, mapDispatchToProps)(AddTopic);

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ErrorMessage = exports.Description = exports.ExternalKey = exports.CurriculumLink = exports.TopicType = exports.FilterWrapper = exports.Filters = exports.ButtonsWrapper = exports.TopicName = exports.RequiredFields = exports.EditTopicHeader = exports.Close = exports.ContentWrapper = exports.AddTopicContainer = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n    ', '\n    ', '\n    ', '\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 999;\n'], ['\n    ', '\n    ', '\n    ', '\n    ', '\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 999;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    right: 50px;\n    font-weight: 100;\n\n    &:before {\n        content: \'* \';\n        color: red;\n    }\n'], ['\n    right: 50px;\n    font-weight: 100;\n\n    &:before {\n        content: \'* \';\n        color: red;\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    top: 160px;\n\n    .topicTypeSelect {\n        width: 200px;\n    }\n'], ['\n    top: 160px;\n\n    .topicTypeSelect {\n        width: 200px;\n    }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    top: 370px;\n'], ['\n    top: 370px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin: 5px;\n    user-select: none;\n    cursor: pointer;\n'], ['\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin: 5px;\n    user-select: none;\n    cursor: pointer;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    ', '\n    position: absolute;\n    bottom: 20px;\n    right: 30px;\n    width: 90%;\n\n    .deletePanel {\n      width: 100%;\n      text-align: left;\n      padding-right: 5px;\n      padding-top: 7px;\n\n      .iconStyle {\n            width: 24px;\n            height: 25px;\n            cursor: pointer;\n            float: right;\n\n             svg {\n                  path { fill: #4e5c67 !important; }\n             }\n        }\n\n        .confirmationPanel {\n          font-weight: 500;\n          ', '\n          width: 100%;\n\n           .message {\n                width: 85%;\n                text-align: right;\n                padding-top: 5px;\n                color: #4e5c67;\n                font-weight: 600;\n           }\n\n           .buttonPanel {\n              width: 15%;\n              text-align: center;\n              ', '\n              ', '\n\n              svg {\n                  path { fill: white !important; }\n              }\n\n              .cross {\n                 width: 24px;\n                 height: 25px;\n                 cursor: pointer;\n                 background: red;\n                 border-radius: 15px\n              }\n\n              .tick {\n                 width: 24px;\n                 height: 25px;\n                 cursor: pointer;\n                 background: green;\n                 border-radius: 15px\n              }\n\n              .btnIconStyle {\n                 width: 15px;\n                 height: 15px;\n                 margin: auto;\n                 padding-top: 5px;\n              }\n           }\n        }\n    }\n'], ['\n    ', '\n    position: absolute;\n    bottom: 20px;\n    right: 30px;\n    width: 90%;\n\n    .deletePanel {\n      width: 100%;\n      text-align: left;\n      padding-right: 5px;\n      padding-top: 7px;\n\n      .iconStyle {\n            width: 24px;\n            height: 25px;\n            cursor: pointer;\n            float: right;\n\n             svg {\n                  path { fill: #4e5c67 !important; }\n             }\n        }\n\n        .confirmationPanel {\n          font-weight: 500;\n          ', '\n          width: 100%;\n\n           .message {\n                width: 85%;\n                text-align: right;\n                padding-top: 5px;\n                color: #4e5c67;\n                font-weight: 600;\n           }\n\n           .buttonPanel {\n              width: 15%;\n              text-align: center;\n              ', '\n              ', '\n\n              svg {\n                  path { fill: white !important; }\n              }\n\n              .cross {\n                 width: 24px;\n                 height: 25px;\n                 cursor: pointer;\n                 background: red;\n                 border-radius: 15px\n              }\n\n              .tick {\n                 width: 24px;\n                 height: 25px;\n                 cursor: pointer;\n                 background: green;\n                 border-radius: 15px\n              }\n\n              .btnIconStyle {\n                 width: 15px;\n                 height: 15px;\n                 margin: auto;\n                 padding-top: 5px;\n              }\n           }\n        }\n    }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    width: 140px;\n'], ['\n    width: 140px;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n    ', '\n    ', '\n    ', '\n    position: absolute;\n    top: 220px;\n    width: 320px;\n    margin-left: 130px;\n'], ['\n    ', '\n    ', '\n    ', '\n    position: absolute;\n    top: 220px;\n    width: 320px;\n    margin-left: 130px;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

var _flexbox = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AddTopicContainer = _styledComponents2.default.div(_templateObject, (0, _flexbox.flexbox)(), (0, _flexbox.justifyContent)('center'), (0, _flexbox.alignItems)('center'), (0, _flexbox.flexDirection)('column'));

var EditTopicHeader = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        palette = _ThemeHelper$getTheme.palette,
        typography = _ThemeHelper$getTheme.typography;

    return '\n    color: ' + palette.primary.dark + ';\n    font-family: ' + typography.family + ';\n    position: absolute;\n    top: 40px;\n    font-weight: 900;\n    ';
});

var RequiredFields = (0, _styledComponents2.default)(EditTopicHeader)(_templateObject2);

var ErrorMessage = _styledComponents2.default.span(function (props) {
    var _ThemeHelper$getTheme2 = _themeHelper2.default.getTheme(props),
        palette = _ThemeHelper$getTheme2.palette;

    return '\n    ' + (0, _flexbox.flexbox)() + '\n    ' + (0, _flexbox.alignItems)('center') + '\n    color: ' + palette.error.main + ';\n    top: 30px;\n    width: 100%;\n    height: 38px;\n    padding: 8px 125px;\n    position: absolute;\n    font-size: 11px;\n    ';
});

var TopicName = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme3 = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme3.colours,
        palette = _ThemeHelper$getTheme3.palette,
        typography = _ThemeHelper$getTheme3.typography;

    return '\n    ' + (0, _flexbox.flexbox)() + '\n    ' + (0, _flexbox.alignItems)('center') + '\n    color: ' + palette.primary.dark + ';\n    font-family: ' + typography.family + ';\n    position: absolute;\n    top: 90px;\n    width: 90%;\n\n    > span {\n        min-width: 115px;\n    }\n\n    > input {\n        width: 100%;\n        height: 38px;\n        padding: 8px 22px;\n        border: 1px solid ' + (props.hasError ? palette.error.main : colours.grey[200]) + ';\n        border-radius: 5px;\n        font-family: ' + typography.family + ';\n        font-size: 15px;\n        outline: none;\n\n        &::-webkit-input-placeholder {\n            color: ' + colours.grey[200] + ';\n            font-size: 15px;\n        }\n\n        &:-ms-input-placeholder {\n            color: ' + colours.grey[200] + ';\n            font-size: 15px;\n        }\n    }\n\n    &: before {\n        content: \'* \';\n        color: red;\n    }\n    ';
});

var TopicType = (0, _styledComponents2.default)(TopicName)(_templateObject3);

var CurriculumLink = (0, _styledComponents2.default)(TopicName)(function (props) {
    var isRequired = props.isRequired;


    return '\n        top: 310px;\n\n        &: before {\n            ' + (isRequired ? '\n                content: \'* \';\n                color: red;\n                ' : 'content: none;') + '\n        }\n    ';
});

var ExternalKey = (0, _styledComponents2.default)(CurriculumLink)(_templateObject4);

var Description = (0, _styledComponents2.default)(ExternalKey)(function (props) {
    var _ThemeHelper$getTheme4 = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme4.colours,
        typography = _ThemeHelper$getTheme4.typography;

    return '\n    top: 420px;\n\n    > textarea {\n        width: 100%;\n        height: 120px;\n        padding: 8px 22px;\n        border: 1px solid ' + colours.grey[200] + ';\n        border-radius: 5px;\n        font-family: ' + typography.family + ';\n        font-size: 15px;\n        outline: none;\n        resize: none;\n    ';
});

var ContentWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme5 = _themeHelper2.default.getTheme(props),
        palette = _ThemeHelper$getTheme5.palette,
        typography = _ThemeHelper$getTheme5.typography;

    return '\n    ' + (0, _flexbox.flexbox)() + '\n    ' + (0, _flexbox.justifyContent)('center') + '\n    ' + (0, _flexbox.alignItems)('left') + '\n    ' + (0, _flexbox.flexDirection)('column') + '\n    color: ' + palette.primary.dark + ';\n    font-family: ' + typography.family + ';\n    border: 1px solid ' + palette.primary.dark + ';\n    position: relative;\n    background-color: white;\n    height: 630px;\n    width: 600px;\n    padding: 20px\n    ';
});

var Close = _styledComponents2.default.div(_templateObject5);

var ButtonsWrapper = _styledComponents2.default.div(_templateObject6, (0, _flexbox.flexbox)(), (0, _flexbox.flexbox)(), (0, _flexbox.flexbox)(), (0, _flexbox.justifyContent)('space-evenly'));

var Filters = _styledComponents2.default.div(_templateObject7);

var FilterWrapper = _styledComponents2.default.div(_templateObject8, (0, _flexbox.flexbox)(), (0, _flexbox.justifyContent)('right'), (0, _flexbox.justifyContent)('space-between'));

exports.AddTopicContainer = AddTopicContainer;
exports.ContentWrapper = ContentWrapper;
exports.Close = Close;
exports.EditTopicHeader = EditTopicHeader;
exports.RequiredFields = RequiredFields;
exports.TopicName = TopicName;
exports.ButtonsWrapper = ButtonsWrapper;
exports.Filters = Filters;
exports.FilterWrapper = FilterWrapper;
exports.TopicType = TopicType;
exports.CurriculumLink = CurriculumLink;
exports.ExternalKey = ExternalKey;
exports.Description = Description;
exports.ErrorMessage = ErrorMessage;

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var filterTopicTypes = function filterTopicTypes(modalType, parentType, topicTypes) {
    var filteredTypes = [];

    if (modalType === 'newTopic') {
        // Strand and Substrand when creating new topic
        filteredTypes = topicTypes.slice(0, 2);
        return filteredTypes;
    }
    parentType = parentType && parentType.toLowerCase();
    switch (parentType) {
        case 'descriptor':
            // Descriptor when parent is Descriptor
            filteredTypes = topicTypes.slice(0, 1);
            break;
        case 'strand':
            // Standard when parent is Strand
            filteredTypes = topicTypes.slice(2, 3);
            break;
        case 'standard':
            // Learning Journey when parent is Standard
            filteredTypes = topicTypes.slice(3, 4);
            break;
        case 'learningjourney':
            // Step when parent is Learning Journey
            filteredTypes = topicTypes.slice(4, 5);
            break;

        default:
            break;
    }

    return filteredTypes;
};

exports.default = filterTopicTypes;

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AlertSubTitle = exports.AlertTitle = exports.AlertIcon = exports.AlertContainer = undefined;

var _templateObject = _taggedTemplateLiteral(['\nwidth: 60px;\nheight: 75px;\nmargin-bottom: 5px;\n'], ['\nwidth: 60px;\nheight: 75px;\nmargin-bottom: 5px;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

var _flexbox = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable */


var AlertContainer = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        palette = _ThemeHelper$getTheme.palette,
        typography = _ThemeHelper$getTheme.typography;

    return '\n    ' + (0, _flexbox.flexbox)() + '\n    ' + (0, _flexbox.justifyContent)('center') + '\n    ' + (0, _flexbox.alignItems)('center') + '\n    ' + (0, _flexbox.flexDirection)('column') + '\n    position: relative;\n    color: ' + palette.primary.dark + ';\n    font-family: ' + typography.family + ';\n    ';
});

var AlertIcon = _styledComponents2.default.div(_templateObject);

var AlertTitle = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme2 = _themeHelper2.default.getTheme(props),
        palette = _ThemeHelper$getTheme2.palette;

    return '\n    color: ' + palette.primary.dark + ';\n    margin: 10px 0;\n    font-size: 28px;\n    font-weight: 500;\n    text-align: center;\n    line-height: 40px;\n    ';
});

var AlertSubTitle = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme3 = _themeHelper2.default.getTheme(props),
        palette = _ThemeHelper$getTheme3.palette;

    return '\n    width: 60%;\n    margin-top: 10px;\n    margin-bottom: 50px;\n    color: black;\n    font-size: 20px;\n    text-align: center;\n    line-height: 27px;\n    ';
});

exports.AlertContainer = AlertContainer;
exports.AlertIcon = AlertIcon;
exports.AlertTitle = AlertTitle;
exports.AlertSubTitle = AlertSubTitle;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _flexbox = __webpack_require__(24);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        layout = _ThemeHelper$getTheme.layout,
        colours = _ThemeHelper$getTheme.colours,
        palette = _ThemeHelper$getTheme.palette;

    var borderColour = 'transparent';
    var bgColor = 'transparent';
    var textColor = palette.primary.main;
    var borderRadius = layout.borderRadius;
    var fontWeight = 300;
    var componentDisplay = (0, _flexbox.flexbox)();
    var isComponentdisabled = '';
    var circleButtonHeight = '';
    var iconStyles = '';

    if (props.primary) {
        borderColour = palette.primary.dark;
        bgColor = palette.primary.main;
        textColor = palette.primary.text;
        borderRadius = '35px';
        fontWeight = 500;
    } else if (props.basic) {
        borderColour = colours.grey[200];
        bgColor = '#fff';
    } else if (props.circle) {
        borderColour = palette.primary.dark;
        borderRadius = '80px';
        circleButtonHeight = 'height: 80px;';
    }

    if (props.inline) {
        componentDisplay = 'display: inline-block;';
    }

    if (props.success) {
        bgColor = palette.success.main;
        borderColour = palette.success.main;
        textColor = '#fff';
    }

    if (props.warning) {
        bgColor = palette.error.main;
        borderColour = palette.error.main;
        textColor = '#fff';
    }

    if (props.warning || props.success) {
        iconStyles = '\n        svg {\n            width: 25px;\n            height: 25px;\n\n            path { fill: #fff !important; }\n        }';
    }

    if (props.disabled) {
        isComponentdisabled = '\n        opacity: 0.4;\n        pointer-events: none;\n        cursor: not-allowed;\n        ';
    }

    return '\n    ' + (0, _flexbox.justifyContent)('center') + '\n    ' + (0, _flexbox.alignItems)('center') + '\n    background-color: ' + bgColor + ';\n    border: 1px solid ' + borderColour + ';\n    border-radius: ' + borderRadius + ';\n    min-width: 80px;\n    outline: none;\n    cursor: pointer;\n    color: ' + textColor + ';\n    font-weight: ' + fontWeight + ';\n\n    ' + componentDisplay + '\n    ' + isComponentdisabled + '\n    ' + circleButtonHeight + '\n    & > div {\n        ' + (0, _flexbox.flexbox)() + '\n        ' + (0, _flexbox.justifyContent)('center') + '\n        ' + (0, _flexbox.alignItems)('center') + '\n\n        padding: ' + layout.spacing + 'px;\n    }\n    ' + iconStyles + '\n    ';
});

exports.default = ButtonWrapper;

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DENIM = exports.DENIM = 'denim';
var DARK = exports.DARK = 'dark';
var LIGHT = exports.LIGHT = 'light';
var CIRCLE_SUCCESS = exports.CIRCLE_SUCCESS = 'circleSuccess';
var CIRCLE_DANGER = exports.CIRCLE_DANGER = 'circleDanger';
var ICON_ONLY = exports.ICON_ONLY = 'iconOnly';
var BOX_LIGHT = exports.BOX_LIGHT = 'boxLight';

var PRIMARY = 'primary';
var INFO = 'info';
var BASIC = 'basic';
var INLINE = 'inline';
var DISABLED = 'disabled';
var CIRCLE = 'circle';
var SUCCESS = 'success';
var WARNING = 'warning';

exports.PRIMARY = PRIMARY;
exports.BASIC = BASIC;
exports.INFO = INFO;
exports.INLINE = INLINE;
exports.DISABLED = DISABLED;
exports.CIRCLE = CIRCLE;
exports.WARNING = WARNING;
exports.SUCCESS = SUCCESS;

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ContainerWrapper = undefined;

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
var ContainerWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        palette = _ThemeHelper$getTheme.palette,
        typography = _ThemeHelper$getTheme.typography;

    var defaultPadding = '20px';
    if (props.zeroPadding) {
        defaultPadding = '0';
    }

    return '\n    margin: 20px;\n    padding: ' + defaultPadding + ';\n    border-radius: 5px;\n    background-color: #fff;\n    box-shadow: 5px 5px rgba(0,0,0,0.07);\n    font-family: ' + typography.family + ';\n    color: ' + palette.primary.dark + ';\n    border: 0px solid #fff;\n    ';
});

exports.ContainerWrapper = ContainerWrapper;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MODAL_TYPES = exports.MODAL_TYPES = {
    newTopic: 'newTopic',
    edit: 'edit',
    newSubTopic: 'newSubTopic'
};

exports.default = MODAL_TYPES;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(15);

var _reactStyleable = __webpack_require__(218);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _index = __webpack_require__(1107);

var _index2 = _interopRequireDefault(_index);

var _constants = __webpack_require__(19);

var _button = __webpack_require__(37);

var _button2 = _interopRequireDefault(_button);

var _translations = __webpack_require__(248);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(_ref) {
    var enablePublish = _ref.enablePublish,
        enableSaveCourse = _ref.enableSaveCourse,
        genericCourse = _ref.genericCourse,
        intl = _ref.intl,
        isEditing = _ref.isEditing,
        onClickBackButton = _ref.onClickBackButton,
        saveCourse = _ref.saveCourse,
        showPublishModal = _ref.showPublishModal;

    /**
     * TRANSLATIONS
     */
    var _getTranslations = (0, _translations2.default)({ intl: intl }),
        backButtonText = _getTranslations.backButtonText,
        publishButtonText = _getTranslations.publishButtonText,
        saveCourseButtonText = _getTranslations.saveCourseButtonText;

    /**
     * VARIABLES
     */


    var genericCourseState = Number(genericCourse.status);
    var isRetiredCourse = genericCourseState === _constants.RETIRED_COURSE_ID;
    var isPublishButtonDisabled = !enablePublish || isRetiredCourse;

    /**
     * FUNCTION
     */
    var renderSavePanel = function renderSavePanel() {
        if (isRetiredCourse && isEditing) return false;

        return _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(_button2.default, {
                disabled: !enableSaveCourse,
                handleOnClick: saveCourse,
                label: saveCourseButtonText,
                primary: true
            }),
            _react2.default.createElement(_button2.default, {
                disabled: isPublishButtonDisabled,
                handleOnClick: function handleOnClick() {
                    return showPublishModal(true);
                },
                label: publishButtonText,
                primary: true
            })
        );
    };

    return _react2.default.createElement(
        'div',
        { className: _index2.default.footer },
        _react2.default.createElement(
            'div',
            { className: _index2.default.backPanel },
            _react2.default.createElement(_button2.default, {
                handleOnClick: onClickBackButton,
                label: backButtonText,
                primary: true
            })
        ),
        _react2.default.createElement(
            'div',
            { className: _index2.default.savePanel },
            renderSavePanel()
        )
    );
};

Footer.propTypes = {
    enablePublish: _propTypes2.default.bool,
    enableSaveCourse: _propTypes2.default.bool,
    genericCourse: _propTypes2.default.object,
    intl: _reactIntl.intlShape.isRequired,
    isEditing: _propTypes2.default.bool,
    onClickBackButton: _propTypes2.default.func,
    saveCourse: _propTypes2.default.func,
    showPublishModal: _propTypes2.default.func
};

exports.default = (0, _reactStyleable2.default)(_index2.default)((0, _reactIntl.injectIntl)(Footer));

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _flexomatic = __webpack_require__(299);

var _styled = __webpack_require__(247);

var _messages = __webpack_require__(159);

var _messages2 = _interopRequireDefault(_messages);

var _iconDictionary = __webpack_require__(65);

var _courseCreatorUtils = __webpack_require__(536);

var _courseCreatorUtils2 = _interopRequireDefault(_courseCreatorUtils);

var _index = __webpack_require__(37);

var _index2 = _interopRequireDefault(_index);

var _header = __webpack_require__(115);

var _header2 = _interopRequireDefault(_header);

var _spineList = __webpack_require__(498);

var _spineList2 = _interopRequireDefault(_spineList);

var _curriculumTree = __webpack_require__(479);

var _curriculumTree2 = _interopRequireDefault(_curriculumTree);

var _inputToggle = __webpack_require__(487);

var _inputToggle2 = _interopRequireDefault(_inputToggle);

var _svgIcon = __webpack_require__(64);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _container = __webpack_require__(114);

var _container2 = _interopRequireDefault(_container);

var _alert = __webpack_require__(246);

var _alert2 = _interopRequireDefault(_alert);

var _multiSelectionList = __webpack_require__(495);

var _multiSelectionList2 = _interopRequireDefault(_multiSelectionList);

var _spinner = __webpack_require__(160);

var _spinner2 = _interopRequireDefault(_spinner);

var _dropdownList = __webpack_require__(63);

var _dropdownList2 = _interopRequireDefault(_dropdownList);

var _textInput = __webpack_require__(161);

var _textInput2 = _interopRequireDefault(_textInput);

var _addTopic = __webpack_require__(462);

var _addTopic2 = _interopRequireDefault(_addTopic);

var _modalButtons = __webpack_require__(472);

var _productSelector = __webpack_require__(473);

var _productSelector2 = _interopRequireDefault(_productSelector);

var _topics = __webpack_require__(474);

var _topics2 = _interopRequireDefault(_topics);

var _footer = __webpack_require__(470);

var _footer2 = _interopRequireDefault(_footer);

var _constants = __webpack_require__(469);

var _constants2 = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CourseCreator = function (_Component) {
    _inherits(CourseCreator, _Component);

    function CourseCreator(props) {
        _classCallCheck(this, CourseCreator);

        var _this = _possibleConstructorReturn(this, (CourseCreator.__proto__ || Object.getPrototypeOf(CourseCreator)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
            courses: [],
            courseName: '',
            isCourseSet: false,
            selectedSpineItems: [],
            topicTree: { childNodes: [] },
            isTreeViewExpanded: false,
            topicId: 1,
            spineIndex: -1,
            girlIndex: -1,
            enableSaveCourse: props.enableSaveCourse,
            enablePublish: props.enablePublish,
            isAlertVisible: true,
            selectedOption: null,
            selectedLocale: '',
            selectedProduct: undefined,
            isTreeExpanded: false,
            selectedTopic: '',
            selectedSpineIds: [],
            displayedSpineNodeList: [],
            isSelectAll: false,
            displayAddTopic: false,
            modalType: '',
            modalData: {
                strand: 'None',
                subStrand: 'None'
            },
            invalidStrands: [],
            invalidStandards: []
        };
        _this.parentData = {
            strand: 'None',
            subStrand: 'None'
        };
        _this.options = [];
        _this.isTreeExpanded = false;
        _this.hasColumnExpand = false;

        _this.onClickBackButton = _this.onClickBackButton.bind(_this);
        _this.onClickExpandButton = _this.onClickExpandButton.bind(_this);
        _this.updateSpineList = _this.updateSpineList.bind(_this);
        _this.onToggleExpandTree = _this.onToggleExpandTree.bind(_this);
        _this.onDelete = _this.onDelete.bind(_this);
        _this.onSelectAll = _this.onSelectAll.bind(_this);
        _this.handleAddTopicModal = _this.handleAddTopicModal.bind(_this);
        _this.handleOnUpdateModal = _this.handleOnUpdateModal.bind(_this);
        return _this;
    }

    _createClass(CourseCreator, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps, nextState) {
            var _this2 = this;

            var _nextProps$assignedSp = nextProps.assignedSpineItems,
                assignedSpineItems = _nextProps$assignedSp === undefined ? [] : _nextProps$assignedSp,
                masterCourse = nextProps.masterCourse,
                pppCourse = nextProps.pppCourse,
                isDefaultCourse = nextProps.isDefaultCourse,
                enableSaveCourse = nextProps.enableSaveCourse,
                enablePublish = nextProps.enablePublish,
                isFetched = nextProps.isFetched,
                genericCourse = nextProps.genericCourse,
                match = nextProps.match;
            var selectedProduct = nextState.selectedProduct;
            var topicTree = this.state.topicTree;


            if (this.state.enableSaveCourse !== enableSaveCourse) {
                this.setState({ enableSaveCourse: enableSaveCourse });
            }
            if (this.state.enablePublish !== enablePublish) {
                this.setState({ enablePublish: enablePublish });
            }

            if (isFetched) {
                if (this.options.length === 0) {
                    this.options = this.getYearGroups(masterCourse, pppCourse, isDefaultCourse);
                }

                if (isDefaultCourse) {
                    if (topicTree.childNodes.length === 0) {
                        topicTree.childNodes = this.getCourseTopics(pppCourse.topics);
                        this.setState({
                            topicTree: topicTree,
                            topicId: Math.floor(Math.random() * 10000)
                        });
                    }

                    if (this.state.selectedOption === null) {
                        var selectedYearGroups = pppCourse.yearGroups && pppCourse.yearGroups.map(function (year) {
                            return {
                                label: _constants2.YEAR_GROUPS.find(function (val) {
                                    return val.id === year.toString();
                                }).value,
                                value: year
                            };
                        });

                        this.setState({ selectedOption: selectedYearGroups });
                    }
                }

                if (this.state.selectedOption === null && !isDefaultCourse) {
                    var _selectedYearGroups = masterCourse.yearGroups && masterCourse.yearGroups.map(function (year) {
                        return {
                            label: _constants2.YEAR_GROUPS.find(function (val) {
                                return val.id === year.shortName;
                            }).value,
                            value: year.yearGroupEnum
                        };
                    });

                    this.setState({ selectedOption: _selectedYearGroups });
                }

                if (!this.state.isCourseSet) {
                    this.enableActionButtons(nextProps);
                    this.setState({
                        courseName: isDefaultCourse ? pppCourse.name : masterCourse.name,
                        courses: masterCourse.spineNodes.map(function (spine) {
                            spine.isSelected = false;
                            return spine;
                        }),
                        selectedSpineItems: assignedSpineItems,
                        selectedLocale: pppCourse.locale || _constants2.DROPDOWN_DEFAULT_LOCALE,
                        isCourseSet: true
                    }, function () {
                        _this2.updateSpineList();
                    });
                }
            }

            var shouldManageProductId = (masterCourse.subjectId || genericCourse.productId) && !selectedProduct;
            if (shouldManageProductId) {
                this.manageProductInitialData({
                    actionType: match.params.actionType,
                    genericCourse: genericCourse,
                    masterCourse: masterCourse
                });
            }
        }
    }, {
        key: 'onToggleExpandTree',
        value: function onToggleExpandTree(expanded) {
            this.isTreeExpanded = expanded;
            this.hasColumnExpand = false;
            this.setState({
                isTreeExpanded: expanded
            });
        }
    }, {
        key: 'onClickBackButton',
        value: function onClickBackButton() {
            var _this3 = this;

            var EDIT = _constants2.COURSE_CREATOR_SUB_ROUTES.EDIT;
            var _props = this.props,
                isDirty = _props.isDirty,
                genericCourse = _props.genericCourse,
                actionType = _props.match.params.actionType;

            if (Number(genericCourse.status) === _constants2.RETIRED_COURSE_ID && actionType === EDIT) {
                this.props.setCourseCreatorAsClean();
                setTimeout(function () {
                    return _this3.props.handleOnback();
                });
                return;
            }

            if (isDirty) {
                this.props.openAlertModal();
            } else {
                this.props.setCourseCreatorAsClean();
                setTimeout(function () {
                    return _this3.props.handleOnback();
                });
            }
        }
    }, {
        key: 'onClickExpandButton',
        value: function onClickExpandButton() {
            this.hasColumnExpand = true;
            this.setState({ isTreeViewExpanded: !this.state.isTreeViewExpanded });
        }

        /**
         * SAVE AS DRAFT
         */


        /**
         * PUBLISH COURSE
         */

    }, {
        key: 'render',


        /**
         * RENDER
         */
        value: function render() {
            var _this4 = this;

            var EDIT = _constants2.COURSE_CREATOR_SUB_ROUTES.EDIT;
            var _props2 = this.props,
                intl = _props2.intl,
                masterCourse = _props2.masterCourse,
                pppCourse = _props2.pppCourse,
                standardFilters = _props2.standardFilters,
                curriculumLevelDescriptions = _props2.curriculumLevelDescriptions,
                isDefaultCourse = _props2.isDefaultCourse,
                genericCourse = _props2.genericCourse,
                showPublishModal = _props2.showPublishModal,
                isFetched = _props2.isFetched,
                actionType = _props2.match.params.actionType;
            var _state = this.state,
                isTreeViewExpanded = _state.isTreeViewExpanded,
                topicName = _state.topicName,
                selectedProduct = _state.selectedProduct,
                enablePublish = _state.enablePublish,
                enableSaveCourse = _state.enableSaveCourse,
                topicTree = _state.topicTree,
                invalidStrands = _state.invalidStrands,
                invalidStandards = _state.invalidStandards;


            if (!isFetched) {
                return _react2.default.createElement(
                    _styled.SpinnerWrapper,
                    null,
                    _react2.default.createElement(_spinner2.default, null)
                );
            }

            return _react2.default.createElement(
                _styled.CourseCreatorWrapper,
                null,
                _react2.default.createElement(_header2.default, { title: intl.formatMessage(_messages2.default.header) }),
                _react2.default.createElement(
                    _container2.default,
                    { zeroPadding: true },
                    _react2.default.createElement(
                        _flexomatic.Grid,
                        { style: { marginTop: 0 } },
                        _react2.default.createElement(
                            _flexomatic.Cell,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'courseName' },
                                _react2.default.createElement(_inputToggle2.default, {
                                    getInputValue: this.updateCourseName,
                                    name: this.state.courseName,
                                    placeHolder: 'Course Name'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            _flexomatic.Cell,
                            { width: [0.1] },
                            _react2.default.createElement(
                                _flexomatic.Grid,
                                { align: 'center', style: { marginTop: 0 } },
                                _react2.default.createElement(
                                    _flexomatic.Cell,
                                    null,
                                    isDefaultCourse && genericCourse.version ? 'Version: ' + genericCourse.id + 'v' + genericCourse.version : ''
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _flexomatic.Cell,
                            { width: [1, 0.35, 0.25] },
                            _react2.default.createElement(
                                _flexomatic.Grid,
                                { align: 'center' },
                                _react2.default.createElement(
                                    _flexomatic.Cell,
                                    { width: [0.15] },
                                    'Locale:'
                                ),
                                _react2.default.createElement(
                                    _flexomatic.Cell,
                                    { width: [0.35] },
                                    _react2.default.createElement(_dropdownList2.default, {
                                        name: 'locale',
                                        onChange: this.onProductSelectorChangeHandler,
                                        options: _constants2.SUPPORTED_LOCALES,
                                        value: this.state.selectedLocale || pppCourse.locale || _constants2.DROPDOWN_DEFAULT_LOCALE
                                    })
                                ),
                                _react2.default.createElement(_productSelector2.default, {
                                    isDisabled: isDefaultCourse,
                                    onChangeHandler: this.onProductSelectorChangeHandler,
                                    selectedProduct: selectedProduct
                                })
                            )
                        ),
                        _react2.default.createElement(
                            _flexomatic.Cell,
                            { width: 1 },
                            _react2.default.createElement(
                                _flexomatic.Grid,
                                null,
                                _react2.default.createElement(
                                    _flexomatic.Cell,
                                    { width: [0.3] },
                                    _react2.default.createElement(
                                        _styled.CourseInfoWrapper,
                                        null,
                                        _react2.default.createElement(
                                            'strong',
                                            null,
                                            intl.formatMessage(_messages2.default.country),
                                            ':'
                                        ),
                                        ' ',
                                        masterCourse.countryCode
                                    ),
                                    _react2.default.createElement(
                                        _styled.CourseInfoWrapper,
                                        null,
                                        _react2.default.createElement(
                                            'strong',
                                            null,
                                            intl.formatMessage(_messages2.default.state),
                                            ':'
                                        ),
                                        ' ',
                                        masterCourse.state
                                    )
                                ),
                                _react2.default.createElement(
                                    _flexomatic.Cell,
                                    { width: [0.5, 0.35, 0.45] },
                                    _react2.default.createElement(
                                        _styled.CourseInfoWrapper,
                                        null,
                                        _react2.default.createElement(
                                            'strong',
                                            null,
                                            intl.formatMessage(_messages2.default.curriculum),
                                            ':'
                                        ),
                                        ' ',
                                        masterCourse.name,
                                        isDefaultCourse && masterCourse.version ? ' v' + masterCourse.version : ''
                                    )
                                ),
                                _react2.default.createElement(
                                    _flexomatic.Cell,
                                    { width: [0.25, 0.35, 0.23] },
                                    _react2.default.createElement(
                                        _flexomatic.Grid,
                                        { align: 'center' },
                                        _react2.default.createElement(
                                            _flexomatic.Cell,
                                            { width: [0.25] },
                                            _react2.default.createElement(
                                                'strong',
                                                null,
                                                intl.formatMessage(_messages2.default.yearLevel),
                                                ':'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            _flexomatic.Cell,
                                            null,
                                            _react2.default.createElement(_multiSelectionList2.default, {
                                                handleChange: this.handleChange,
                                                options: this.options,
                                                value: this.state.selectedOption
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'coursePanel' },
                        _react2.default.createElement(
                            'div',
                            {
                                className: isTreeViewExpanded ? 'fullWidth' + ' ' + 'header' : 'header'
                            },
                            _react2.default.createElement(
                                'div',
                                {
                                    className: isTreeViewExpanded ? 'fullWidth' + ' ' + 'treeColumn' : 'treeColumn'
                                },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'curriculumHeaderName' },
                                    intl.formatMessage(_messages2.default.curriculum)
                                ),
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: 'expand',
                                        onClick: function onClick() {
                                            return _this4.onToggleExpandTree(false);
                                        },
                                        role: 'button',
                                        tabIndex: '-1',
                                        title: intl.formatMessage(_messages2.default.collapse)
                                    },
                                    _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Up })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: 'expand',
                                        onClick: function onClick() {
                                            return _this4.onToggleExpandTree(true);
                                        },
                                        role: 'button',
                                        tabIndex: '-1',
                                        title: intl.formatMessage(_messages2.default.expand)
                                    },
                                    _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Down })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: 'icon',
                                        onClick: this.onClickExpandButton,
                                        role: 'button',
                                        tabIndex: '-1'
                                    },
                                    isTreeViewExpanded && _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Left }),
                                    !isTreeViewExpanded && _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Right })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                {
                                    className: isTreeViewExpanded ? 'hideRow' : 'topicColumn'
                                },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'topicHeaderAdd' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'checkbox' },
                                        _react2.default.createElement('input', {
                                            checked: this.state.isSelectAll,
                                            className: 'name',
                                            id: 'selectAll',
                                            onChange: this.onSelectAll,
                                            type: 'checkbox'
                                        }),
                                        _react2.default.createElement('label', {
                                            className: 'chklabel',
                                            htmlFor: 'selectAll'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'spineNode' },
                                        intl.formatMessage(_messages2.default.spine)
                                    ),
                                    _react2.default.createElement(_textInput2.default, {
                                        handleOnChange: this.searchHandler,
                                        id: 'search',
                                        name: 'search',
                                        placeholder: 'search',
                                        ref: function ref(input) {
                                            _this4.searchQuery = input;
                                        }
                                    }),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'topicHeaderNewTopic' },
                                        _react2.default.createElement(_index2.default, {
                                            className: 'newTopicButton',
                                            disabled: this.state.selectedSpineIds.length === 0 || this.state.selectedTopic === '',
                                            handleOnClick: this.updateTopic,
                                            label: intl.formatMessage(_messages2.default.add),
                                            primary: true
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                {
                                    className: isTreeViewExpanded ? 'hideRow' : 'topicColumn'
                                },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'topicHeader' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'topicHeaderName' },
                                        intl.formatMessage(_messages2.default.topics)
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'topicHeaderIcons' },
                                        _react2.default.createElement(
                                            'div',
                                            {
                                                className: 'iconStyle',
                                                onClick: function onClick() {
                                                    return _this4.handleOnExpandCollapse(true);
                                                },
                                                role: 'button',
                                                tabIndex: 0
                                            },
                                            _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Expand })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            {
                                                className: 'iconStyle',
                                                onClick: function onClick() {
                                                    return _this4.handleOnExpandCollapse(false);
                                                },
                                                role: 'button',
                                                tabIndex: 0
                                            },
                                            _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Collapse })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'topicHeaderNewTopic' },
                                        _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_index2.default, {
                                                className: 'newTopicButton',
                                                handleOnClick: function handleOnClick() {
                                                    return _this4.handleAddTopicModal(_constants.MODAL_TYPES.newTopic, _this4.state.selectedTopic);
                                                },
                                                label: intl.formatMessage(_messages2.default.newTopic),
                                                primary: true
                                            })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_index2.default, {
                                                className: 'newTopicButton',
                                                disabled: !this.state.selectedTopic || this.parentData.type.toLowerCase() === 'step',
                                                handleOnClick: function handleOnClick() {
                                                    return _this4.handleAddTopicModal(_constants.MODAL_TYPES.newSubTopic, _this4.state.selectedTopic);
                                                },
                                                label: intl.formatMessage(_messages2.default.subTopic),
                                                primary: true
                                            })
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'panelRow' },
                            _react2.default.createElement(
                                'div',
                                {
                                    className: isTreeViewExpanded ? 'fullWidth treeRows' : 'treeRows'
                                },
                                _react2.default.createElement(_curriculumTree2.default, _extends({
                                    expandTree: this.isTreeExpanded,
                                    hasColumnExpand: this.hasColumnExpand,
                                    key: masterCourse.id
                                }, this.props))
                            ),
                            _react2.default.createElement(
                                'div',
                                {
                                    className: isTreeViewExpanded ? 'hideRow' : 'spineRows'
                                },
                                _react2.default.createElement(_spineList2.default, {
                                    onChange: this.addSpineItemsToTopic,
                                    spineNodes: this.state.displayedSpineNodeList
                                })
                            ),
                            _react2.default.createElement(_topics2.default, {
                                handleAddTopicModal: this.handleAddTopicModal,
                                invalidStandards: invalidStandards,
                                invalidStrands: invalidStrands,
                                isExpanded: isTreeViewExpanded,
                                onDelete: this.onDelete,
                                onDragEnd: this.onDragEnd,
                                onToggle: this.onToggle,
                                selectTopic: this.selectTopic,
                                topicTree: topicTree,
                                updateTopicExpand: this.updateTopicExpand,
                                updateTopicName: this.updateTopicName
                            })
                        )
                    )
                ),
                _react2.default.createElement(_footer2.default, {
                    enablePublish: enablePublish,
                    enableSaveCourse: enableSaveCourse,
                    genericCourse: genericCourse,
                    isEditing: actionType === EDIT,
                    onClickBackButton: this.onClickBackButton,
                    saveCourse: this.saveCourse,
                    showPublishModal: showPublishModal
                }),
                _react2.default.createElement(_addTopic2.default, {
                    curriculumLevelDescriptions: (0, _courseCreatorUtils.getCurriculumDescriptions)(curriculumLevelDescriptions),
                    defaultDescription: this.getCurriculumLink(),
                    handleOnUpdateModal: this.handleOnUpdateModal,
                    id: this.state.selectedTopic,
                    intl: intl,
                    modalData: this.state.modalData,
                    modalType: this.state.modalType,
                    name: topicName,
                    onClose: this.closeAddTopicModal,
                    onDelete: this.onDelete,
                    parentData: this.parentData,
                    selectedProduct: selectedProduct,
                    show: this.state.displayAddTopic,
                    standardFilters: standardFilters,
                    strand: this.state.strand,
                    subStrand: this.state.subStrand,
                    topicTypes: this.props.topicTypes
                }),
                _react2.default.createElement(_alert2.default, {
                    buttons: (0, _modalButtons.modalButtons)(this.closeAlertModal, this.props.setCourseCreatorAsClean, this.props.handleOnback),
                    isActive: this.props.isAlertVisible,
                    subTitle: 'You have unsaved changes and will lose these changes',
                    title: 'Unsaved Changes',
                    warning: true
                }),
                _react2.default.createElement(_alert2.default, {
                    buttons: (0, _modalButtons.publishModalButtons)(showPublishModal, this.onPublishCourse),
                    isActive: this.props.isPublishModalVisible,
                    subTitle: 'Please confirm that you wish to create a new published version of this course and you understand the impact on teachers using this course',
                    title: 'Are you sure?',
                    warning: true
                })
            );
        }
    }]);

    return CourseCreator;
}(_react.Component);

CourseCreator.contextTypes = {
    router: _propTypes2.default.object.isRequired
};

var _initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.manageProductInitialData = function (_ref) {
        var actionType = _ref.actionType,
            genericCourse = _ref.genericCourse,
            masterCourse = _ref.masterCourse;
        var EDIT = _constants2.COURSE_CREATOR_SUB_ROUTES.EDIT,
            CLONE = _constants2.COURSE_CREATOR_SUB_ROUTES.CLONE,
            COPY = _constants2.COURSE_CREATOR_SUB_ROUTES.COPY;
        var subjectId = masterCourse.subjectId;
        var productId = genericCourse.productId;

        var updatedSelectedProduct = null;

        switch (actionType) {
            case CLONE:
                {
                    updatedSelectedProduct = subjectId;
                    break;
                }
            case EDIT:
            case COPY:
                {
                    updatedSelectedProduct = productId;
                    break;
                }
            default:
                break;
        }

        _this5.setState({
            selectedProduct: updatedSelectedProduct
        });
    };

    this.onSelectAll = function () {
        var _state2 = _this5.state,
            isSelectAll = _state2.isSelectAll,
            displayedSpineNodeList = _state2.displayedSpineNodeList;
        var masterCourse = _this5.props.masterCourse;

        var isSelected = !isSelectAll;
        var selectedSpineIds = [];

        if (isSelected) {
            displayedSpineNodeList.forEach(function (spine) {
                selectedSpineIds.push(spine.id);
            });
        } else {
            selectedSpineIds = [];
        }
        _this5.setState({
            isSelectAll: isSelected,
            courses: masterCourse.spineNodes.map(function (spine) {
                spine.isSelected = isSelected;
                return spine;
            }),
            selectedSpineIds: selectedSpineIds
        });
    };

    this.getYearGroups = function (masterCourse, pppCourse, isDefaultCourse) {
        if (isDefaultCourse && pppCourse.yearGroups) {
            return _constants2.YEAR_GROUPS.filter(function (val) {
                return pppCourse.yearGroups.toString().indexOf(val.id) === -1;
            }).map(function (year) {
                return {
                    label: year.value,
                    value: year.id
                };
            });
        } else if (masterCourse.yearGroups) {
            var yearGroupIds = masterCourse.yearGroups.map(function (year) {
                return year.yearGroupEnum.toString();
            });
            return _constants2.YEAR_GROUPS.filter(function (val) {
                return yearGroupIds.indexOf(val.id) === -1;
            }).map(function (year) {
                return {
                    label: year.value,
                    value: year.id
                };
            });
        }

        return [];
    };

    this.onDragEnd = function (result) {
        var destination = result.destination,
            source = result.source,
            draggableId = result.draggableId;

        var parentId = 0;
        var spineId = 0;
        var subTopic = {};

        if (!destination) {
            return;
        }

        if (destination.droppableId === source.droppableId && source.droppableId === 'spineList') {
            return;
        }

        var topics = _this5.state.topicTree;

        switch (source.droppableId) {
            case 'topicList':
                _this5.reorderList(topics.childNodes, result);
                break;
            default:
                if (draggableId.toLowerCase().indexOf('girl') !== -1) {
                    parentId = draggableId.split('-')[0];
                    spineId = draggableId.split('-')[2];
                    var spine = (0, _courseCreatorUtils.findNode)(parentId + '-' + spineId + '-spine', topics.childNodes);
                    _this5.reorderList(spine.childNodes, result);
                } else if (draggableId.indexOf('-') !== -1) {
                    parentId = draggableId.split('-')[0];
                    subTopic = (0, _courseCreatorUtils.findNode)(parentId, topics.childNodes);
                    _this5.reorderList(subTopic.childNodes, result);
                } else {
                    parentId = draggableId.substring(draggableId.indexOf('#') + 1);
                    subTopic = (0, _courseCreatorUtils.findNode)(parentId, topics.childNodes);
                    _this5.reorderList(subTopic.childNodes, result);
                }
                break;
        }
        _this5.setState({
            topicTree: topics,
            enableSaveCourse: true,
            enablePublish: false
        });
        _this5.props.setCourseCreatorAsModified();
    };

    this.reorderList = function (items, result) {
        var destination = result.destination,
            source = result.source,
            draggableId = result.draggableId;

        var destinationIndex = _this5.getIndex(destination.index, items.length);
        var draggableItem = items.find(function (item) {
            return item.id === draggableId;
        });
        var destinationItem = items.find(function (item) {
            return item.index === destinationIndex;
        });
        destinationItem.index = source.index;
        draggableItem.index = destinationIndex;
        items.splice(source.index, 1);
        items.splice(destinationIndex, 0, draggableItem);
    };

    this.updateIndexes = function (items, type) {
        var girlIndex = _this5.state.girlIndex;
        var spineIndex = _this5.state.spineIndex;
        var response = (0, _courseCreatorUtils.updateIndexes)(items, type, girlIndex, spineIndex);
        _this5.setState({
            spineIndex: response.spineIdx,
            girlIndex: response.girlIdx
        });
        return response.updatedList;
    };

    this.getIndex = function (destinationIndex, maxLength) {
        var index = 0;
        if (destinationIndex < 0) {
            return index;
        } else if (destinationIndex > maxLength) {
            index = maxLength;
        } else {
            index = destinationIndex;
        }
        return index;
    };

    this.updateTopic = function () {
        _this5.hasColumnExpand = true;
        window.document.querySelector('[name="search"]').value = '';
        var _state3 = _this5.state,
            selectedTopic = _state3.selectedTopic,
            selectedSpineIds = _state3.selectedSpineIds,
            topicTree = _state3.topicTree;
        var _props3 = _this5.props,
            genericCourse = _props3.genericCourse,
            masterCourse = _props3.masterCourse;

        var topics = topicTree;
        var topic = null;
        var isSubTopic = false;
        var productId = void 0;

        if (selectedTopic.indexOf('#') !== -1) {
            var filteredTopics = topics.childNodes.find(function (item) {
                return item.id === selectedTopic.split('#')[selectedTopic.split('#').length - 1];
            });
            topic = (0, _courseCreatorUtils.findNode)(selectedTopic, filteredTopics);
            isSubTopic = true;
        } else {
            topic = topics.childNodes.find(function (item) {
                return item.id === selectedTopic;
            });
        }

        if (genericCourse.productId || masterCourse.subjectId) {
            productId = genericCourse.productId ? genericCourse.productId : masterCourse.subjectId;
        }

        if (topic) {
            if (productId === _constants2.MATHLETICS_PRODUCT_ID && topic.type.toLowerCase() !== 'step') {
                _this5.props.showToast(_this5.props.intl.formatMessage(_messages2.default.spinesUnderSteps), 'error');
                return;
            } else if ((productId === _constants2.SPELLING_PRODUCT_ID || productId === _constants2.WRITING_PRODUCT_ID) && topic.type.toLowerCase() !== 'descriptor') {
                _this5.props.showToast(_this5.props.intl.formatMessage(_messages2.default.spinesUnderDescriptor), 'error');
                return;
            }
            var girlIndex = _this5.state.girlIndex + 1;
            var spineIdsInTopic = topic.childNodes.map(function (t) {
                return t.id.split('-')[1];
            });

            var _loop = function _loop(id) {
                // if spine node already exists inside a topic then don't add it again
                if (spineIdsInTopic.indexOf(id) === -1) {
                    var spineNode = _this5.props.masterCourse.spineNodes.find(function (item) {
                        return item.id === id;
                    });
                    spineNode.girls = !spineNode.girls ? [] : spineNode.girls;
                    topic.isExpanded = true;
                    topic.isSelected = false;
                    topic.childNodes.push({
                        id: topic.id + '-' + spineNode.id + '-spine',
                        name: spineNode.id + ': ' + spineNode.description,
                        index: topic.childNodes.length === 0 ? 0 : topic.childNodes.length,
                        groupName: isSubTopic ? 'subTopic' + topic.spineIndex : 'spine' + topic.spineIndex,
                        groupType: isSubTopic ? 'subTopic' + topic.spineIndex : 'spine' + topic.spineIndex,
                        girlIndex: girlIndex,
                        isExpanded: false,
                        isSelected: false,
                        childNodes: spineNode.girls.length > 0 ? _this5.updateGirlResources(spineNode, topic.id, spineNode.id, girlIndex) : [],
                        isEditable: false
                    });
                    girlIndex += 1;
                }
            };

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = selectedSpineIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var id = _step.value;

                    _loop(id);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var courses = _this5.props.masterCourse.spineNodes.map(function (spine) {
                spine.isSelected = false;
                return spine;
            });

            _this5.updateSpineList(selectedSpineIds);
            _this5.setState({
                topicTree: topics,
                girlIndex: girlIndex,
                enableSaveCourse: true,
                enablePublish: false,
                selectedTopic: '',
                selectedSpineIds: [],
                isSelectAll: false,
                displayedSpineNodeList: courses
            });
            _this5.props.setCourseCreatorAsModified();
        }
    };

    this.updateSpineList = function () {
        var copiedSpineItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var selectedSpineItems = [].concat(_toConsumableArray(_this5.state.selectedSpineItems), _toConsumableArray(copiedSpineItems));

        var cleanSelectedSpineItems = selectedSpineItems.filter(function (el) {
            return el !== null;
        });

        var courses = _this5.props.masterCourse.spineNodes.map(function (spine) {
            spine.isSelected = false;
            return spine;
        });

        _this5.setState({
            selectedSpineItems: cleanSelectedSpineItems,
            courses: courses,
            displayedSpineNodeList: courses,
            isSelectAll: false,
            selectedSpineIds: []
        });
    };

    this.addSpineItemsToTopic = function (spineId) {
        _this5.hasColumnExpand = true;

        var displayedSpineNodeList = _this5.state.displayedSpineNodeList;


        var selectedSpineIds = [].concat(_toConsumableArray(_this5.state.selectedSpineIds));

        if (selectedSpineIds.indexOf(spineId) === -1) {
            selectedSpineIds.push(spineId);
        } else {
            selectedSpineIds = selectedSpineIds.filter(function (value) {
                return value !== spineId;
            });
        }

        var isAllSelected = false;
        if (selectedSpineIds.length === _this5.state.displayedSpineNodeList.length) {
            isAllSelected = true;
        }

        var filteredSpineNodes = [];
        if (_this5.state.selectedTopic && _this5.parentData.strand && _this5.parentData.strand.toLowerCase() !== 'none') {
            filteredSpineNodes = (0, _courseCreatorUtils.filterSpineOnStrandSubStrand)(_this5.parentData, displayedSpineNodeList);
        } else {
            filteredSpineNodes = displayedSpineNodeList;
        }

        var filteredNodes = filteredSpineNodes.map(function (spine) {
            if (spine.id === spineId) {
                spine.isSelected = true;
            }
            return spine;
        });

        _this5.setState({
            selectedSpineIds: selectedSpineIds,
            isSelectAll: isAllSelected,
            displayedSpineNodeList: filteredNodes
        });
    };

    this.updateGirlResources = function (spineNode, topicId, id, girlIndex) {
        return spineNode.girls.map(function (item, index) {
            return {
                id: topicId + '-' + item.id + '-' + id,
                name: item.id + '-' + item.teacherTitle,
                index: index,
                groupName: 'girl' + girlIndex,
                groupType: 'girl' + girlIndex,
                childNodes: [],
                isEditable: false,
                isIncluded: true,
                previewUrl: item.previewUrl
            };
        });
    };

    this.closeAddTopicModal = function (id) {
        _this5.setState({
            displayAddTopic: false,
            modalType: '',
            modalData: {
                strand: 'None',
                subStrand: 'None'
            }
        });

        _this5.parentData = {
            strand: 'None',
            subStrand: 'None',
            type: ''
        };

        if (id) {
            _this5.selectTopic(id);
        }
    };

    this.createNewTopic = function (topicParams) {
        var topicName = topicParams.topicName,
            strand = topicParams.strand,
            subStrand = topicParams.subStrand,
            topicType = topicParams.topicType,
            _topicParams$external = topicParams.externalKey,
            externalKey = _topicParams$external === undefined ? '' : _topicParams$external,
            _topicParams$descript = topicParams.description,
            description = _topicParams$descript === undefined ? '' : _topicParams$descript,
            _topicParams$curricul = topicParams.curriculumLevelCode,
            curriculumLevelCode = _topicParams$curricul === undefined ? '' : _topicParams$curricul;


        var id = _this5.state.topicId;
        var spineIndex = _this5.state.spineIndex + 1;
        var topic = {
            id: id.toString(),
            name: topicName,
            index: _this5.state.topicTree.childNodes.length === 0 ? 0 : _this5.state.topicTree.childNodes.length,
            groupName: 'topicList',
            groupType: 'topic',
            childNodes: [],
            isEditable: true,
            isExpanded: false,
            isSelected: false,
            type: topicType,
            strand: strand,
            subStrand: subStrand,
            spineIndex: spineIndex,
            externalKey: externalKey,
            description: description,
            curriculumLevelCode: curriculumLevelCode
        };
        var topics = _this5.state.topicTree;
        topics.childNodes.push(topic);
        _this5.setState({
            topicTree: topics,
            spineIndex: spineIndex,
            enableSaveCourse: true,
            topicId: Math.floor(Math.random() * 10000),
            enablePublish: false
        });

        _this5.props.setCourseCreatorAsModified();
    };

    this.handleAddTopicModal = function (modalType, id) {
        var topics = _this5.state.topicTree;
        var modalData = {};
        if (modalType === _constants.MODAL_TYPES.newTopic) {
            _this5.parentData = {
                strand: 'None',
                subStrand: 'None',
                type: ''
            };
            modalData = {
                strand: 'None',
                subStrand: 'None'
            };
        } else {
            modalData = modalType === _constants.MODAL_TYPES.edit ? (0, _courseCreatorUtils.getStrandSubstrand)(id, topics) : (0, _courseCreatorUtils.getStrandSubstrand)(null, topics);
        }

        _this5.setState({
            displayAddTopic: true,
            modalType: modalType,
            selectedTopic: id,
            modalData: modalData
        });
    };

    this.handleOnUpdateModal = function (updatedObject) {
        var modalType = _this5.state.modalType;
        var curriculumLevelCode = updatedObject.curriculumLevelCode,
            description = updatedObject.description,
            externalKey = updatedObject.externalKey,
            strand = updatedObject.strand,
            subStrand = updatedObject.subStrand,
            topicId = updatedObject.topicId,
            topicName = updatedObject.topicName,
            topicType = updatedObject.topicType;


        switch (modalType) {
            case _constants.MODAL_TYPES.edit:
                _this5.updateTopicName({
                    id: topicId,
                    name: topicName,
                    strand: strand,
                    subStrand: subStrand,
                    externalKey: externalKey,
                    description: description,
                    curriculumLevelCode: curriculumLevelCode
                });
                break;

            case _constants.MODAL_TYPES.newTopic:
                _this5.createNewTopic({
                    topicName: topicName,
                    strand: strand,
                    subStrand: subStrand,
                    topicType: topicType,
                    externalKey: externalKey,
                    description: description,
                    curriculumLevelCode: curriculumLevelCode
                });
                break;

            case _constants.MODAL_TYPES.newSubTopic:
                _this5.createSubTopics({
                    curriculumLevelCode: curriculumLevelCode,
                    description: description,
                    externalKey: externalKey,
                    strand: strand,
                    subStrand: subStrand,
                    subTopicName: topicName,
                    topicType: topicType
                });
                break;

            default:
                break;
        }
    };

    this.createSubTopics = function (subTopicsParams) {
        var _subTopicsParams$curr = subTopicsParams.curriculumLevelCode,
            curriculumLevelCode = _subTopicsParams$curr === undefined ? '' : _subTopicsParams$curr,
            _subTopicsParams$desc = subTopicsParams.description,
            description = _subTopicsParams$desc === undefined ? '' : _subTopicsParams$desc,
            _subTopicsParams$exte = subTopicsParams.externalKey,
            externalKey = _subTopicsParams$exte === undefined ? '' : _subTopicsParams$exte,
            strand = subTopicsParams.strand,
            subStrand = subTopicsParams.subStrand,
            subTopicName = subTopicsParams.subTopicName,
            topicType = subTopicsParams.topicType;


        var topicId = _this5.state.selectedTopic;
        var topics = _this5.state.topicTree;
        var topic = {};
        if (topicId.indexOf('#') === -1) {
            topic = topics.childNodes.find(function (item) {
                return item.id === topicId;
            });
        } else {
            var filteredTopics = topics.childNodes.find(function (item) {
                return item.id === topicId.split('#')[topicId.split('#').length - 1];
            });
            topic = (0, _courseCreatorUtils.findNode)(topicId, filteredTopics);
        }
        var spineIndex = _this5.state.spineIndex + 1;
        topic.isSelected = false;
        topic.isExpanded = true;
        topic.childNodes.push({
            id: _this5.state.topicId.toString() + '#' + topicId,
            name: subTopicName,
            index: topic.childNodes.length === 0 ? 0 : topic.childNodes.length,
            groupName: 'spine' + topic.spineIndex,
            groupType: 'spine' + topic.spineIndex,
            childNodes: [],
            isEditable: true,
            isExpanded: false,
            isSelected: false,
            type: topicType,
            externalKey: externalKey,
            strand: strand,
            subStrand: subStrand,
            spineIndex: spineIndex,
            description: description,
            curriculumLevelCode: curriculumLevelCode
        });
        _this5.setState({
            topicTree: topics,
            spineIndex: spineIndex,
            selectedTopic: '',
            enableSaveCourse: true,
            topicId: Math.floor(Math.random() * 10000),
            enablePublish: false
        });
        _this5.props.setCourseCreatorAsModified();
    };

    this.updateTopicName = function (response) {
        _this5.setState({
            topicTree: (0, _courseCreatorUtils.updateTopicName)(response, _this5.state.topicTree),
            enableSaveCourse: true,
            enablePublish: false
        });
        _this5.props.setCourseCreatorAsModified();
    };

    this.updateTopicExpand = function (id, status) {
        _this5.hasColumnExpand = true;
        _this5.setState({
            topicTree: (0, _courseCreatorUtils.nodeExpandCollapse)(id, status, _this5.state.topicTree)
        });
    };

    this.onDelete = function (id) {
        var topics = _this5.state.topicTree;
        var spineIds = [];

        if (id.indexOf('spine') !== -1) {
            (0, _courseCreatorUtils.deleteNode)(id, topics);
            var spineId = _this5.state.selectedSpineItems.indexOf(id.split('-')[1]);
            if (spineId !== -1) {
                var selectedSpineItems = [].concat(_toConsumableArray(_this5.state.selectedSpineItems));
                delete selectedSpineItems[spineId];
                _this5.setState({ selectedSpineItems: selectedSpineItems }, function () {
                    _this5.updateSpineList();
                });
            }
        } else {
            var deletedTopic = (0, _courseCreatorUtils.deleteNode)(id, topics);
            if (deletedTopic) {
                (0, _courseCreatorUtils.findSpineNode)(deletedTopic, spineIds);
                var newSpineItems = [];
                _this5.state.selectedSpineItems.filter(function (spineItem) {
                    if (spineIds.indexOf(spineItem) === -1) {
                        newSpineItems.push(spineItem);
                    }
                    return spineItem.indexOf(spineIds) === -1;
                });

                _this5.setState({ selectedSpineItems: newSpineItems }, function () {
                    _this5.updateSpineList();
                });
            }
        }
        _this5.setState({
            topicTree: (0, _courseCreatorUtils.updateIndexes)(id, topics),
            enableSaveCourse: true,
            enablePublish: false
        });
        _this5.props.setCourseCreatorAsModified();
    };

    this.onToggle = function (id, status) {
        _this5.setState({
            topicTree: (0, _courseCreatorUtils.onToggle)(id, status, _this5.state.topicTree),
            enableSaveCourse: true,
            enablePublish: false
        });
        _this5.props.setCourseCreatorAsModified();
    };

    this.updateCourseName = function (response) {
        _this5.hasColumnExpand = true;
        _this5.setState({
            courseName: response.name,
            enableSaveCourse: true,
            enablePublish: false
        });
        _this5.props.setCourseCreatorAsModified();
    };

    this.enableActionButtons = function (props) {
        var isDefaultCourse = props.isDefaultCourse,
            pppCourse = props.pppCourse,
            match = props.match;

        var copyMode = match.url.indexOf('copy') !== -1;
        var enableSaveCourse = false;
        var enablePublish = false;
        if (isDefaultCourse) {
            if (copyMode) {
                enableSaveCourse = true;
            } else {
                switch (pppCourse.status) {
                    case '0':
                        enablePublish = true;
                        break;
                    default:
                        break;
                }
            }
        }

        _this5.setState({ enableSaveCourse: enableSaveCourse, enablePublish: enablePublish });
    };

    this.getCourseTopics = function (topics) {
        var girlIndex = _this5.state.girlIndex + 1;
        var spineIndex = _this5.state.spineIndex + 1;
        var response = (0, _courseCreatorUtils.getCourseTopics)(topics, girlIndex, spineIndex);
        _this5.setState({
            spineIndex: response.spineIdx,
            girlIndex: response.girlIdx,
            topicId: response.topicId + 1
        });
        return response.childNodes;
    };

    this.handleChange = function (selectedOption) {
        _this5.hasColumnExpand = true;
        _this5.props.setCourseCreatorAsModified();
        var yearGroupIds = selectedOption.map(function (option) {
            return option.value.toString();
        });
        _this5.options = _constants2.YEAR_GROUPS.filter(function (val) {
            return yearGroupIds.indexOf(val.id) === -1;
        }).map(function (year) {
            return {
                label: year.value,
                value: year.id
            };
        });
        _this5.setState({
            selectedOption: selectedOption,
            enableSaveCourse: true,
            enablePublish: false
        });
    };

    this.handleOnExpandCollapse = function (status) {
        _this5.hasColumnExpand = true;
        _this5.setState({
            topicTree: (0, _courseCreatorUtils.handleOnExpandCollapse)(status, _this5.state.topicTree)
        });
    };

    this.selectTopic = function (id) {
        _this5.hasColumnExpand = true;

        var _state4 = _this5.state,
            topicTree = _state4.topicTree,
            selectedTopic = _state4.selectedTopic,
            courses = _state4.courses,
            displayedSpineNodeList = _state4.displayedSpineNodeList;


        _this5.parentData = (0, _courseCreatorUtils.getStrandSubstrand)(id, topicTree);

        var topicId = (0, _courseCreatorUtils2.default)(id, topicTree, selectedTopic);

        var filteredSpineNodes = [];
        if (topicId && _this5.parentData.strand && _this5.parentData.strand.toLowerCase() !== 'none') {
            filteredSpineNodes = (0, _courseCreatorUtils.filterSpineOnStrandSubStrand)(_this5.parentData, displayedSpineNodeList);
        } else {
            var searchTerm = _this5.searchQuery.state.value.toLowerCase();
            if (searchTerm) {
                filteredSpineNodes = courses.filter(function (el) {
                    var hasResult = el.description.toLowerCase().indexOf(searchTerm) !== -1 || el.id.toLowerCase().indexOf(searchTerm) !== -1;
                    return hasResult;
                });
            } else {
                filteredSpineNodes = courses;
            }
        }
        _this5.setState({
            topicTree: topicTree,
            selectedTopic: topicId,
            displayedSpineNodeList: filteredSpineNodes
        });
    };

    this.closeAlertModal = function () {
        _this5.props.closeAlertModal();
        _this5.setState({ enableSaveCourse: true, enablePublish: false });
    };

    this.disableCreateSubTopic = function () {
        var disable = true;
        var selectedTopic = _this5.state.selectedTopic;

        if (selectedTopic !== '' && selectedTopic.indexOf('#') === -1) {
            disable = false;
        }
        return disable;
    };

    this.searchHandler = function () {
        var searchTerm = _this5.searchQuery.state.value.toLowerCase();
        var displayedSpineNodeList = [];
        var filteredSpineNodes = [];
        var _state5 = _this5.state,
            topicTree = _state5.topicTree,
            selectedTopic = _state5.selectedTopic,
            courses = _state5.courses,
            isSelectAll = _state5.isSelectAll;

        var topic = (0, _courseCreatorUtils.getStrandSubstrand)(selectedTopic, topicTree);

        if (topic) {
            filteredSpineNodes = (0, _courseCreatorUtils.filterSpineOnStrandSubStrand)(topic, courses);
        }
        if (selectedTopic) {
            displayedSpineNodeList = filteredSpineNodes;
        } else {
            displayedSpineNodeList = courses;
        }

        if (searchTerm) {
            displayedSpineNodeList = displayedSpineNodeList.filter(function (el) {
                var hasResult = el.description.toLowerCase().indexOf(searchTerm) !== -1 || el.id.toLowerCase().indexOf(searchTerm) !== -1;
                return hasResult;
            });
        }

        _this5.setState({ displayedSpineNodeList: displayedSpineNodeList });
        if (isSelectAll) {
            _this5.setState({
                isSelectAll: false,
                courses: _this5.props.masterCourse.spineNodes.map(function (spine) {
                    spine.isSelected = false;
                    return spine;
                }),
                selectedSpineIds: []
            });
        }
    };

    this.getCurriculumLink = function () {
        if (_this5.state.modalData.curriculumLevelCode) {
            return (0, _courseCreatorUtils.trimStringWithEllipsis)(_this5.state.modalData.description);
        }
        return '';
    };

    this.onProductSelectorChangeHandler = function (key, value) {
        _this5.props.setCourseCreatorAsModified();
        _this5.setState({
            selectedProduct: value
        });
    };

    this.getSaveCourseRequestId = function () {
        var EDIT = _constants2.COURSE_CREATOR_SUB_ROUTES.EDIT,
            CLONE = _constants2.COURSE_CREATOR_SUB_ROUTES.CLONE,
            COPY = _constants2.COURSE_CREATOR_SUB_ROUTES.COPY;
        var _props4 = _this5.props,
            pppCourse = _props4.pppCourse,
            courseId = _props4.courseId,
            actionType = _props4.match.params.actionType;

        switch (actionType) {
            case EDIT:
                return pppCourse.id;
            case CLONE:
            case COPY:
                return courseId !== 0 ? courseId : 0;
            default:
                return null;
        }
    };

    this.createCurriculumLinkArray = function () {
        var masterCourse = _this5.props.masterCourse;

        var returnedCurriculumLinkIds = [];

        function iterateNodes(nodes) {
            nodes.forEach(function (nodeItem) {
                var isSpineItem = 'girls' in nodeItem;

                if (nodeItem.id && nodeItem.id !== '' && !isSpineItem) {
                    if (returnedCurriculumLinkIds.indexOf(nodeItem.id) === -1) returnedCurriculumLinkIds.push(nodeItem.id);
                }

                if (nodeItem.children && nodeItem.children.length > 0) {
                    iterateNodes(nodeItem.children);
                }
            });
        }

        iterateNodes(masterCourse.tree.nodes);
        return returnedCurriculumLinkIds;
    };

    this.createSpineNodesArray = function () {
        var masterCourse = _this5.props.masterCourse;

        var returnedSpineIds = [];

        masterCourse.spineNodes.forEach(function (spineItem) {
            if (spineItem.id && spineItem.id !== '') {
                returnedSpineIds.push(spineItem.id);
            }
        });

        return returnedSpineIds;
    };

    this.onValidRequest = function () {
        if (_this5.state.invalidStrands.length > 0) {
            _this5.setState({
                invalidStrands: []
            });
        }
        if (_this5.state.invalidStandards.length > 0) {
            _this5.setState({
                invalidStandards: []
            });
        }

        return true;
    };

    this.onInvalidRequest = function (_ref2) {
        var invalidStrands = _ref2.invalidStrands,
            invalidStandards = _ref2.invalidStandards,
            hasSpineNode = _ref2.hasSpineNode;

        if (invalidStrands.length > 0) {
            _this5.setState({
                invalidStrands: invalidStrands
            });
            _this5.props.showToast(_this5.props.intl.formatMessage(_messages2.default.emptySteps), 'error');
        } else {
            _this5.setState({
                invalidStrands: []
            });
        }

        if (invalidStandards.length > 0) {
            _this5.setState({
                invalidStandards: invalidStandards
            });
            _this5.props.showToast(_this5.props.intl.formatMessage(_messages2.default.emptyCurriculumLink), 'error');
        } else {
            _this5.setState({
                invalidStandards: []
            });
        }

        if (!hasSpineNode) {
            _this5.props.showToast(_this5.props.intl.formatMessage(_messages2.default.noSpineNode), 'error');
        }

        return false;
    };

    this.validateSaveCourseRequest = function () {
        var topicTree = _this5.state.topicTree;

        var invalidSpineNodes = [];
        var invalidStrands = [];
        var invalidStandards = [];

        var curriculumLinkArray = _this5.createCurriculumLinkArray();
        var spineNodesArray = _this5.createSpineNodesArray();

        var hasSpineNode = false;

        topicTree.childNodes.forEach(function (topic) {
            if (topic.type.toLowerCase() === 'strand') {
                var strandId = topic.id;

                if (!curriculumLinkArray.includes(topic.curriculumLevelCode)) {
                    if (invalidStrands.indexOf(strandId) === -1) invalidStrands.push(strandId);
                }

                if (topic.childNodes.length > 0) {
                    topic.childNodes.forEach(function (standard) {
                        var standardId = standard.id;

                        if (!curriculumLinkArray.includes(standard.curriculumLevelCode)) {
                            if (invalidStandards.indexOf(standardId) === -1) invalidStandards.push(standardId);
                        }

                        if (standard.childNodes.length > 0) {
                            standard.childNodes.forEach(function (learningJourney) {
                                if (learningJourney.childNodes.length > 0) {
                                    learningJourney.childNodes.forEach(function (step) {
                                        if (step.childNodes.length > 0) {
                                            step.childNodes.forEach(function (spineNode) {
                                                hasSpineNode = true;
                                                var spineNodeId = spineNode.id.split('-')[1];

                                                if (!spineNodesArray.includes(spineNodeId)) {
                                                    if (invalidSpineNodes.indexOf(spineNode.id) === -1) invalidSpineNodes.push(spineNode.id);
                                                    if (invalidStandards.indexOf(standardId) === -1) invalidStandards.push(standardId);
                                                }
                                            });
                                        } else if (invalidStandards.indexOf(standardId) === -1) {
                                            invalidStandards.push(standardId);
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            }
        });

        var hasValidData = invalidStrands.length === 0 && invalidStandards.length === 0 && hasSpineNode;

        if (hasValidData) {
            return _this5.onValidRequest();
        }

        return _this5.onInvalidRequest({
            invalidStrands: invalidStrands,
            invalidStandards: invalidStandards,
            hasSpineNode: hasSpineNode
        });
    };

    this.createSaveCourseRequest = function () {
        var _props5 = _this5.props,
            _props5$masterCourse = _props5.masterCourse,
            masterCourseId = _props5$masterCourse.id,
            masterCourseVersion = _props5$masterCourse.version,
            countryCode = _props5$masterCourse.countryCode,
            state = _props5.pppCourse.state;
        var _state6 = _this5.state,
            topicTree = _state6.topicTree,
            courseName = _state6.courseName,
            selectedLocale = _state6.selectedLocale,
            selectedProduct = _state6.selectedProduct,
            selectedOption = _state6.selectedOption;


        if (_this5.validateSaveCourseRequest()) {
            return {
                id: _this5.getSaveCourseRequestId(),
                masterCourseId: masterCourseId,
                productId: selectedProduct,
                masterCourseVersion: masterCourseVersion,
                name: courseName,
                state: state,
                countryCode: countryCode,
                locale: selectedLocale,
                yearGroups: selectedOption.map(function (item) {
                    return parseInt(item.value, 10);
                }),
                topics: topicTree.childNodes.length > 0 ? (0, _courseCreatorUtils.buildTopicObject)(topicTree) : []
            };
        }

        return false;
    };

    this.saveCourse = function () {
        var request = _this5.createSaveCourseRequest();

        if (request) {
            _this5.props.saveCourse(request);
        }
    };

    this.getPublishCourseId = function () {
        var CLONE = _constants2.COURSE_CREATOR_SUB_ROUTES.CLONE,
            COPY = _constants2.COURSE_CREATOR_SUB_ROUTES.COPY,
            EDIT = _constants2.COURSE_CREATOR_SUB_ROUTES.EDIT;
        var _props6 = _this5.props,
            courseId = _props6.courseId,
            actionType = _props6.match.params.actionType,
            pppCourse = _props6.pppCourse;


        switch (actionType) {
            case CLONE:
                return courseId;
            case COPY:
            case EDIT:
                return courseId > 0 ? courseId : pppCourse.id;
            default:
                return null;
        }
    };

    this.onPublishCourse = function () {
        var selectedProduct = _this5.state.selectedProduct;

        var selectedCourseId = _this5.getPublishCourseId();

        _this5.props.publishCourse(selectedCourseId, selectedProduct);
        _this5.props.showPublishModal(false);
    };
};

CourseCreator.defaultProps = {
    masterCourse: {
        yearGroups: []
    },
    pppCourse: {},
    isDefaultCourse: false,
    genericCourse: {}
};

CourseCreator.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    courseId: _propTypes2.default.number,
    masterCourse: _propTypes2.default.object.isRequired,
    genericCourse: _propTypes2.default.object,
    pppCourse: _propTypes2.default.object,
    handleOnback: _propTypes2.default.func,
    saveCourse: _propTypes2.default.func,
    publishCourse: _propTypes2.default.func,
    enableSaveCourse: _propTypes2.default.bool,
    enablePublish: _propTypes2.default.bool,
    assignedSpineItems: _propTypes2.default.array,
    isDefaultCourse: _propTypes2.default.bool,
    copyMode: _propTypes2.default.bool,
    closeAlertModal: _propTypes2.default.func,
    openAlertModal: _propTypes2.default.func,
    setCourseCreatorAsModified: _propTypes2.default.func,
    setCourseCreatorAsClean: _propTypes2.default.func,
    isAlertVisible: _propTypes2.default.bool,
    isDirty: _propTypes2.default.bool,
    match: _propTypes2.default.object,
    isFetched: _propTypes2.default.bool,
    standardFilters: _propTypes2.default.object,
    curriculumLevelDescriptions: _propTypes2.default.array,
    topicTypes: _propTypes2.default.array,
    showPublishModal: _propTypes2.default.func,
    isPublishModalVisible: _propTypes2.default.bool,
    showToast: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(CourseCreator);

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.publishModalButtons = exports.modalButtons = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styled = __webpack_require__(247);

var _iconDictionary = __webpack_require__(65);

var _button = __webpack_require__(37);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modalButtons = exports.modalButtons = function modalButtons(closeAlertModal, setCourseCreatorAsClean, handleOnback) {
    return _react2.default.createElement(
        _styled.ModalButtons,
        null,
        _react2.default.createElement(_button2.default, {
            circle: true,
            handleOnClick: closeAlertModal,
            icon: _iconDictionary.Cross,
            warning: true }),
        _react2.default.createElement(_button2.default, {
            circle: true,
            handleOnClick: function handleOnClick() {
                setCourseCreatorAsClean();
                handleOnback();
            },
            icon: _iconDictionary.Tick,
            success: true })
    );
};

var publishModalButtons = exports.publishModalButtons = function publishModalButtons(showPublishModal, publishCourse) {
    return _react2.default.createElement(
        _styled.ModalButtons,
        null,
        _react2.default.createElement(_button2.default, {
            circle: true,
            className: 'publish',
            handleOnClick: function handleOnClick() {
                return showPublishModal(false);
            },
            label: 'Take me back to edit',
            warning: true }),
        _react2.default.createElement(_button2.default, {
            circle: true,
            className: 'publish',
            handleOnClick: publishCourse,
            label: 'I understand - continue',
            success: true })
    );
};

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _flexomatic = __webpack_require__(299);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(15);

var _dropdownList = __webpack_require__(63);

var _dropdownList2 = _interopRequireDefault(_dropdownList);

var _translations = __webpack_require__(248);

var _translations2 = _interopRequireDefault(_translations);

var _constants = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * PRODUCT SELECTOR
 * ------------------
 * Used in course-creator copy option top right hand of page
 * Is abstracted to manage growing complexity of components/course-creator
 * Please continue abstraction on further adjustments to prevent components/course-creator becoming unmanageable
 */
var ProductSelector = function ProductSelector(_ref) {
    var intl = _ref.intl,
        isDisabled = _ref.isDisabled,
        onChangeHandler = _ref.onChangeHandler,
        selectedProduct = _ref.selectedProduct;

    /**
     * TRANSLATIONS
     */
    var _getTranslations = (0, _translations2.default)({ intl: intl }),
        productSelectorHeadingText = _getTranslations.productSelectorHeadingText,
        productSelectorPlaceholderText = _getTranslations.productSelectorPlaceholderText;

    /**
     * FUNCTIONS
     */


    var getOptionsExcludingMathletics = function getOptionsExcludingMathletics() {
        return (
            /**
             * BUSINESS RULE: We only display dropdown list when selected product IS NOT Mathletics value
             */
            Object.values(_constants.PRODUCT_LIST).filter(function (product) {
                return product.id !== _constants.PRODUCT_LIST.MATHLETICS.id;
            }).map(function (product) {
                return { key: product.id, value: product.name };
            })
        );
    };

    var renderCellContent = function renderCellContent() {
        switch (selectedProduct) {
            case _constants.PRODUCT_LIST.MATHLETICS.id:
                return _constants.PRODUCT_LIST.MATHLETICS.name;
            default:
                return _react2.default.createElement(_dropdownList2.default, {
                    disabled: isDisabled,
                    name: 'select-product',
                    onChange: onChangeHandler,
                    options: getOptionsExcludingMathletics(),
                    placeholder: productSelectorPlaceholderText,
                    value: selectedProduct
                });
        }
    };

    return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            _flexomatic.Cell,
            { width: [0.15] },
            productSelectorHeadingText
        ),
        _react2.default.createElement(
            _flexomatic.Cell,
            { width: [0.35] },
            renderCellContent()
        )
    );
};

ProductSelector.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    isDisabled: _propTypes2.default.bool,
    onChangeHandler: _propTypes2.default.func,
    selectedProduct: _propTypes2.default.number
};

exports.default = (0, _reactIntl.injectIntl)(ProductSelector);

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBeautifulDnd = __webpack_require__(334);

var _styled = __webpack_require__(475);

var _listItem = __webpack_require__(493);

var _listItem2 = _interopRequireDefault(_listItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Topics = function Topics(_ref) {
    var isExpanded = _ref.isExpanded,
        topicTree = _ref.topicTree,
        invalidStrands = _ref.invalidStrands,
        invalidStandards = _ref.invalidStandards,
        updateTopicName = _ref.updateTopicName,
        handleAddTopicModal = _ref.handleAddTopicModal,
        onDelete = _ref.onDelete,
        selectTopic = _ref.selectTopic,
        onToggle = _ref.onToggle,
        updateTopicExpand = _ref.updateTopicExpand,
        onDragEnd = _ref.onDragEnd;

    var _useState = (0, _react.useState)(''),
        _useState2 = _slicedToArray(_useState, 2),
        className = _useState2[0],
        setClassName = _useState2[1];

    (0, _react.useLayoutEffect)(function () {
        setClassName(isExpanded ? 'hideRow' : 'topics');
    }, [isExpanded]);

    var getGenericListItemProps = function getGenericListItemProps(item) {
        return {
            childNodes: item.childNodes,
            id: item.id.toString(),
            isEditable: item.isEditable,
            isExpanded: item.isExpanded,
            isSelected: item.isSelected,
            name: item.name,
            strand: item.strand,
            subStrand: item.subStrand
        };
    };

    return _react2.default.createElement(
        _reactBeautifulDnd.DragDropContext,
        { onDragEnd: onDragEnd },
        _react2.default.createElement(
            _styled.TopicWrapper,
            { className: className },
            _react2.default.createElement(
                _styled.TopicPanel,
                null,
                _react2.default.createElement(
                    _reactBeautifulDnd.Droppable,
                    { droppableId: 'topicList' },
                    function (provided) {
                        return _react2.default.createElement(
                            'div',
                            _extends({
                                ref: provided.innerRef
                            }, provided.droppableProps),
                            topicTree.childNodes.map(function (item, index) {
                                return _react2.default.createElement(
                                    'div',
                                    {
                                        className: 'topicList',
                                        key: item.id
                                    },
                                    _react2.default.createElement(_listItem2.default, _extends({}, getGenericListItemProps(item), {
                                        getTopicName: updateTopicName,
                                        handleOnEdit: handleAddTopicModal,
                                        index: index,
                                        invalidStandards: invalidStandards,
                                        invalidStrands: invalidStrands,
                                        onDelete: onDelete,
                                        onItemSelect: selectTopic,
                                        onToggle: onToggle,
                                        showIconPanel: true,
                                        updateTopics: updateTopicExpand
                                    }))
                                );
                            }),
                            provided.placeholder,
                            _react2.default.createElement('div', { className: 'dropZone' })
                        );
                    }
                )
            )
        )
    );
};

Topics.propTypes = {
    isExpanded: _propTypes2.default.bool,
    topicTree: _propTypes2.default.object,
    invalidStrands: _propTypes2.default.array,
    invalidStandards: _propTypes2.default.array,
    updateTopicName: _propTypes2.default.func,
    handleAddTopicModal: _propTypes2.default.func,
    onDelete: _propTypes2.default.func,
    selectTopic: _propTypes2.default.func,
    onToggle: _propTypes2.default.func,
    updateTopicExpand: _propTypes2.default.func,
    onDragEnd: _propTypes2.default.func
};

exports.default = Topics;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TopicPanel = exports.TopicWrapper = undefined;

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopicWrapper = exports.TopicWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        palette = _ThemeHelper$getTheme.palette;

    return '\n        .hideRow {\n            width: 0;\n            display: none;\n        }\n\n        .topics {\n            border-left: 1px solid ' + palette.tertiary.main + '\n            width: calc(100%/3);\n            padding: 10px;\n            overflow: auto;\n        }\n    ';
});

var TopicPanel = exports.TopicPanel = _styledComponents2.default.div('\n    height: 100%;\n\n    .topicList {\n        padding: 6px;\n    }\n');

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FilterItems = exports.FilterTabs = exports.CourseFilterWrapper = undefined;

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

var _flexbox = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CourseFilterWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        typography = _ThemeHelper$getTheme.typography;

    return '\n    ' + (0, _flexbox.flexbox)() + '\n    font-family: ' + typography.family + ';';
});

var FilterTabs = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme2 = _themeHelper2.default.getTheme(props),
        palette = _ThemeHelper$getTheme2.palette,
        typography = _ThemeHelper$getTheme2.typography;

    return '\n    ' + (0, _flexbox.flexbox)() + '\n    ' + (0, _flexbox.flex)('20%') + '\n    ' + (0, _flexbox.alignItems)('flex-end') + '\n    font-family: ' + typography.family + ';\n\n    & > a {\n        color: ' + palette.primary.main + ';\n        text-decoration: none;\n        padding: 0 10px;\n        min-width: 100px;\n        height: 55px;\n        line-height: 55px;\n        text-align: center;\n        border-top-left-radius: 10px;\n        border-top-right-radius: 10px;\n        border: 1px solid ' + palette.primary.light + ';\n        cursor: pointer;\n\n        &[aria-current="true"] {\n            background-color: ' + palette.primary.main + ';\n            color: #fff;\n            pointer-events: none;\n        }\n    }';
});

/* eslint-disable arrow-body-style */
var FilterItems = _styledComponents2.default.div(function () {
    return '\n    ' + (0, _flexbox.flexbox)() + '\n    ' + (0, _flexbox.flex)('80%') + '\n    ' + (0, _flexbox.flexDirection)('row') + '\n    ' + (0, _flexbox.alignItems)('center') + '\n    ' + (0, _flexbox.justifyContent)('flex-end') + '\n\n    & > div {\n        margin: 10px 0 10px 10px;\n    }';
});

exports.CourseFilterWrapper = CourseFilterWrapper;
exports.FilterTabs = FilterTabs;
exports.FilterItems = FilterItems;

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(217);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styled = __webpack_require__(478);

var _styled2 = _interopRequireDefault(_styled);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurriculumTopicLink = function CurriculumTopicLink(_ref) {
    var curriculumLevelDescriptions = _ref.curriculumLevelDescriptions,
        placeholder = _ref.placeholder,
        handleCurriculumChange = _ref.handleCurriculumChange,
        defaultValue = _ref.defaultValue;
    return _react2.default.createElement(
        _styled2.default,
        null,
        _react2.default.createElement(_reactSelect2.default, {
            defaultValue: defaultValue,
            isClearable: true,
            isSearchable: true,
            onChange: handleCurriculumChange,
            options: curriculumLevelDescriptions || [],
            placeholder: placeholder
        })
    );
};
CurriculumTopicLink.propTypes = {
    curriculumLevelDescriptions: _propTypes2.default.array,
    placeholder: _propTypes2.default.string,
    handleCurriculumChange: _propTypes2.default.func,
    defaultValue: _propTypes2.default.object
};

exports.default = CurriculumTopicLink;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurriculumLinkWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        typography = _ThemeHelper$getTheme.typography;

    return '\n    font-family: ' + typography.family + ';\n    height: 100%;\n    font-size: 14px;\n    width: 100%\n    ';
});

exports.default = CurriculumLinkWrapper;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSortableTree = __webpack_require__(1038);

var _reactSortableTree2 = _interopRequireDefault(_reactSortableTree);

var _styled = __webpack_require__(480);

var _styled2 = _interopRequireDefault(_styled);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurriculumTree = function (_Component) {
    _inherits(CurriculumTree, _Component);

    _createClass(CurriculumTree, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            if (this.props !== nextProps || this.state !== nextState) {
                return true;
            }
            return false;
        }
    }]);

    function CurriculumTree(props) {
        _classCallCheck(this, CurriculumTree);

        var _this = _possibleConstructorReturn(this, (CurriculumTree.__proto__ || Object.getPrototypeOf(CurriculumTree)).call(this, props));

        _this.CurriculumTree = _react2.default.createRef();
        _this.state = {
            treeData: []
        };
        _this.treeData = [];
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        return _this;
    }

    _createClass(CurriculumTree, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.masterCourse.id && this.treeData.length === 0) {
                this.setState({ treeData: nextProps.masterCourse.tree.node || [] });
                this.treeData = nextProps.masterCourse.tree.nodes;
            }

            if (this.props.masterCourse.id !== nextProps.masterCourse.id) {
                this.setState({ treeData: nextProps.masterCourse.tree.node || [] });
                this.treeData = nextProps.masterCourse.tree.nodes;
            }
            if (!nextProps.hasColumnExpand) {
                this.toggleAllNodes(nextProps.expandTree);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.state = { treeData: [] };
            this.props.masterCourse.id = '';
        }
    }, {
        key: 'handleOnChange',
        value: function handleOnChange(treeData) {
            this.treeData = treeData;
            this.setState({ treeData: treeData });
        }
    }, {
        key: 'toggleAllNodes',
        value: function toggleAllNodes(expandTree) {
            this.treeData = (0, _reactSortableTree.toggleExpandedForAll)({
                treeData: this.treeData,
                expanded: expandTree
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _styled2.default,
                null,
                _react2.default.createElement(_reactSortableTree2.default, {
                    canDrag: false,
                    onChange: this.handleOnChange,
                    ref: this.CurriculumTree,
                    treeData: this.treeData
                })
            );
        }
    }]);

    return CurriculumTree;
}(_react.Component);

CurriculumTree.propTypes = {
    masterCourse: _propTypes2.default.shape({
        tree: _propTypes2.default.object.isRequired,
        spineNodes: _propTypes2.default.array,
        id: _propTypes2.default.string
    }),
    expandTree: _propTypes2.default.bool,
    hasColumnExpand: _propTypes2.default.bool
};
exports.default = CurriculumTree;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurriculumTreeWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        typography = _ThemeHelper$getTheme.typography;

    return '\n    font-family: ' + typography.family + ';\n    height: 100%;\n    font-size: 14px;\n    ';
});

exports.default = CurriculumTreeWrapper;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ActionRendererWrapper = exports.ReacTableStyles = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n    ', '\n    ', '\n'], ['\n    ', '\n    ', '\n    ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\ndisplay: inherit;\n'], ['\ndisplay: inherit;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _flexbox = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable */


var ActionRendererWrapper = _styledComponents2.default.div(_templateObject, (0, _flexbox.flexbox)(), (0, _flexbox.alignItems)('center'), (0, _flexbox.justifyContent)('center'));
var ReacTableStyles = _styledComponents2.default.div(_templateObject2);

exports.ReacTableStyles = ReacTableStyles;
exports.ActionRendererWrapper = ActionRendererWrapper;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateYearRow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styled = __webpack_require__(484);

var _dropdownList = __webpack_require__(63);

var _dropdownList2 = _interopRequireDefault(_dropdownList);

var _messages = __webpack_require__(483);

var _messages2 = _interopRequireDefault(_messages);

var _index = __webpack_require__(37);

var _index2 = _interopRequireDefault(_index);

var _pulseLoader = __webpack_require__(253);

var _pulseLoader2 = _interopRequireDefault(_pulseLoader);

var _constants = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var generateYearRow = exports.generateYearRow = function generateYearRow(years) {
    return years.map(function (year) {
        return _react2.default.createElement(
            _styled.DataRow,
            { key: '_' + year.value },
            year.value
        );
    });
};

var setupDropdownData = function setupDropdownData(_ref) {
    var intl = _ref.intl,
        courses = _ref.courses,
        onDefaultCourseChange = _ref.onDefaultCourseChange,
        defaultCourses = _ref.defaultCourses,
        selectedProductId = _ref.selectedProductId,
        defaultCountry = _ref.defaultCountry,
        selectedState = _ref.selectedState,
        year = _ref.year;

    var defaultValue = defaultCourses[Number(year.id)];
    var courseList = void 0;

    if (parseInt(selectedProductId, 10) !== _constants.MATHLETICS_PRODUCT_ID && defaultCountry === 'AUS' && selectedState === '') {
        courseList = [].concat(_toConsumableArray(courses));
    } else {
        courseList = [{
            courseName: intl.formatMessage(_messages2.default.noCourse),
            id: 0
        }].concat(_toConsumableArray(courses));
        if (!defaultValue) {
            defaultValue = { name: intl.formatMessage(_messages2.default.noCourse) };
        }
    }

    return _react2.default.createElement(
        _styled.DataRow,
        { key: '_' + year.value },
        _react2.default.createElement(_dropdownList2.default, {
            onChange: function onChange(name, courseName) {
                var id = courseList.filter(function (course) {
                    return course.courseName === courseName;
                })[0].id;
                onDefaultCourseChange(year, courseName, id);
            },
            optionKey: 'courseName',
            options: courseList,
            optionText: 'courseName',
            value: defaultValue && defaultValue.name })
    );
};

var DefaultCourses = function DefaultCourses(props) {
    if (!props.countries.isLoaded) {
        return _react2.default.createElement(
            _styled.LoaderWrapper,
            null,
            _react2.default.createElement(_pulseLoader2.default, { size: '5px' })
        );
    }

    return _react2.default.createElement(
        _styled.DefaultCoursesWrapper,
        null,
        _react2.default.createElement(
            _styled.DefaultCoursesContainer,
            null,
            _react2.default.createElement(
                _styled.Header,
                null,
                _react2.default.createElement(
                    _styled.FilterDropdownWrapper,
                    null,
                    _react2.default.createElement(
                        'span',
                        { 'data-testid': 'product' },
                        props.intl.formatMessage(_messages2.default.product),
                        ':'
                    ),
                    _react2.default.createElement(
                        _styled.DropdownWrapper,
                        { 'data-testid': 'product-filter' },
                        _react2.default.createElement(_dropdownList2.default, {
                            name: 'selectProduct',
                            onChange: props.setProduct,
                            optionKey: 'id',
                            options: props.products,
                            optionText: 'name',
                            value: props.selectedProductId })
                    )
                ),
                _react2.default.createElement(
                    _styled.FilterDropdownWrapper,
                    { 'data-testid': 'country-wrapper' },
                    _react2.default.createElement(
                        'span',
                        { 'data-testid': 'country' },
                        props.intl.formatMessage(_messages2.default.country),
                        ':'
                    ),
                    _react2.default.createElement(
                        _styled.DropdownWrapper,
                        { 'data-testid': 'country-filter' },
                        _react2.default.createElement(_dropdownList2.default, {
                            name: 'selectCountry',
                            onChange: props.setCountry,
                            optionKey: 'code',
                            options: props.countries.items,
                            optionText: 'name',
                            value: props.defaultCountry })
                    )
                ),
                _react2.default.createElement(
                    _styled.FilterDropdownWrapper,
                    { 'data-testid': 'state-wrapper' },
                    _react2.default.createElement(
                        'span',
                        { 'data-testid': 'state' },
                        props.intl.formatMessage(_messages2.default.state),
                        ':'
                    ),
                    _react2.default.createElement(
                        _styled.DropdownWrapper,
                        { 'data-testid': 'state-filter' },
                        _react2.default.createElement(_dropdownList2.default, {
                            name: 'selectState',
                            onChange: props.handleOnStateSelect,
                            optionKey: 'code',
                            options: props.countries.items.filter(function (country) {
                                return country.code === props.defaultCountry;
                            })[0].states,
                            optionText: 'name',
                            placeholder: 'Select a state',
                            value: props.selectedState })
                    )
                )
            ),
            _react2.default.createElement(
                _styled.YearDropDownWrapper,
                null,
                _react2.default.createElement(
                    _styled.DataColumn,
                    { width: '150px' },
                    _react2.default.createElement(
                        _styled.DataRow,
                        { isHeader: true },
                        props.intl.formatMessage(_messages2.default.year)
                    ),
                    generateYearRow(props.years)
                ),
                _react2.default.createElement(
                    _styled.DataColumn,
                    { width: '600px' },
                    _react2.default.createElement(
                        _styled.DataRow,
                        { isHeader: true },
                        props.intl.formatMessage(_messages2.default.courses)
                    ),
                    props.years.map(function (year) {
                        return setupDropdownData(_extends({}, props, { year: year }));
                    })
                )
            ),
            _react2.default.createElement(
                _styled.FooterWrapper,
                { className: 'footerWrapper' },
                _react2.default.createElement(_index2.default, {
                    className: 'actionButton',
                    handleOnClick: props.handleBackButton,
                    label: props.intl.formatMessage(_messages2.default.back),
                    primary: true }),
                _react2.default.createElement(_index2.default, {
                    className: 'actionButton',
                    disabled: !props.dataSaved || props.isSaved,
                    handleOnClick: props.handleOnSave,
                    label: props.intl.formatMessage(_messages2.default.save),
                    primary: true })
            )
        )
    );
};

DefaultCourses.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    countries: _propTypes2.default.oneOfType([_propTypes2.default.array.isRequired, _propTypes2.default.object.isRequired]),
    years: _propTypes2.default.array.isRequired,
    defaultCountry: _propTypes2.default.string,
    setCountry: _propTypes2.default.func,
    handleOnSave: _propTypes2.default.func,
    dataSaved: _propTypes2.default.bool,
    isSaved: _propTypes2.default.bool,
    handleBackButton: _propTypes2.default.func,
    products: _propTypes2.default.array,
    setProduct: _propTypes2.default.func,
    selectedProductId: _propTypes2.default.string,
    selectedState: _propTypes2.default.string,
    handleOnStateSelect: _propTypes2.default.func
};

DefaultCourses.defaultProps = {
    courses: [],
    defaultCourses: {},
    onDefaultCourseChange: function onDefaultCourseChange() {}
};

exports.default = (0, _reactIntl.injectIntl)(DefaultCourses);

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(15);

exports.default = (0, _reactIntl.defineMessages)({
    product: {
        id: 'app.components.defaultCourses.product',
        defaultMessage: 'Product'
    },
    country: {
        id: 'app.components.defaultCourses.country',
        defaultMessage: 'Country'
    },
    state: {
        id: 'app.components.defaultCourses.state',
        defaultMessage: 'State'
    },
    selectCourse: {
        id: 'app.components.defaultCourses.selectCourse',
        defaultMessage: 'Select course'
    },
    year: {
        id: 'app.components.defaultCourses.year',
        defaultMessage: 'YEAR'
    },
    courses: {
        id: 'app.components.defaultCourses.courses',
        defaultMessage: 'COURSES'
    },
    back: {
        id: 'app.components.defaultCourses.back',
        defaultMessage: 'Back'
    },
    save: {
        id: 'app.components.defaultCourses.save',
        defaultMessage: 'Save'
    },
    noCourse: {
        id: 'app.components.defaultCourses.noCourse',
        defaultMessage: 'No default option set'
    }
});

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DropdownWrapper = exports.LoaderWrapper = exports.FooterWrapper = exports.DataRow = exports.DataColumn = exports.YearDropDownWrapper = exports.FilterDropdownWrapper = exports.Header = exports.DefaultCoursesContainer = exports.DefaultCoursesWrapper = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n    ', '\n    ', '\n    ', '\n    flex: 1;\n    background-color: white;\n    padding: 15px;\n    width: 100%;\n    border-radius: 3px;\n'], ['\n    ', '\n    ', '\n    ', '\n    ', '\n    flex: 1;\n    background-color: white;\n    padding: 15px;\n    width: 100%;\n    border-radius: 3px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    ', '\n    ', '\n    ', '\n    width: 280px;\n\n    .dropDownContainer {\n        background-color: white;\n    }\n'], ['\n    ', '\n    ', '\n    ', '\n    width: 280px;\n\n    .dropDownContainer {\n        background-color: white;\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    ', '\n    ', '\n    ', '\n    min-height: 40px;\n    width: 100%;\n    margin-bottom: ', ';\n'], ['\n    ', '\n    ', '\n    ', '\n    min-height: 40px;\n    width: 100%;\n    margin-bottom: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    ', '\n    ', '\n    ', '\n\n    position: relative;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 100%;\n'], ['\n    ', '\n    ', '\n    ', '\n\n    position: relative;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 100%;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    background-color: white;\n    border-radius: 5px;\n    margin-left: 10px;\n'], ['\n    background-color: white;\n    border-radius: 5px;\n    margin-left: 10px;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

var _flexbox = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable */


var DefaultCoursesWrapper = exports.DefaultCoursesWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        palette = _ThemeHelper$getTheme.palette,
        typography = _ThemeHelper$getTheme.typography,
        colours = _ThemeHelper$getTheme.colours;

    return '\n    ' + (0, _flexbox.flexbox)() + '\n    ' + (0, _flexbox.alignItems)('center') + '\n    ' + (0, _flexbox.justifyContent)('center') + '\n    background-color: ' + colours.porcelain + '\n    padding: 15px\n    color: ' + palette.primary.dark + '\n    font-family: ' + typography.family + '\n';
});

var DefaultCoursesContainer = exports.DefaultCoursesContainer = _styledComponents2.default.div(_templateObject, (0, _flexbox.flexbox)(), (0, _flexbox.alignItems)('flex-start'), (0, _flexbox.justifyContent)('flex-start'), (0, _flexbox.flexDirection)('column'));

var Header = exports.Header = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme2 = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme2.colours;

    return (0, _flexbox.flexbox)() + '\n    ' + (0, _flexbox.alignItems)('center') + '\n    ' + (0, _flexbox.justifyContent)('flex-start') + '\n    min-height: 60px\n    padding-left: 50px\n    background-color: ' + colours.iron + '\n    border: 1px solid ' + colours.mercury + '\n    width: calc(100% - 50px)\n';
});

var FilterDropdownWrapper = exports.FilterDropdownWrapper = _styledComponents2.default.div(_templateObject2, (0, _flexbox.flexbox)(), (0, _flexbox.alignItems)('center'), (0, _flexbox.justifyContent)('flex-start'));

var YearDropDownWrapper = exports.YearDropDownWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme3 = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme3.colours;

    return '\n    ' + (0, _flexbox.flexbox)() + '\n    width: 100%;\n    border: 1px solid ' + colours.mercury + ';\n';
});

var DataColumn = exports.DataColumn = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme4 = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme4.colours;

    return '\n    ' + (0, _flexbox.flexbox)() + '\n    ' + (0, _flexbox.alignItems)('center') + '\n    ' + (0, _flexbox.justifyContent)('flex-start') + '\n    ' + (0, _flexbox.flexDirection)('column') + '\n    height: 100%;\n    width: ' + props.width + ';\n    border-right: 1px solid ' + colours.mercury + ';\n    padding: 28.5px 18.5px;\n\n    .dropDownContainer {\n        width: 100%;\n    }\n';
});

var DataRow = exports.DataRow = _styledComponents2.default.div(_templateObject3, (0, _flexbox.flexbox)(), (0, _flexbox.alignItems)('center'), (0, _flexbox.justifyContent)('center'), function (props) {
    return props.isHeader ? '20px' : '10px';
});

var FooterWrapper = exports.FooterWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme5 = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme5.colours;

    return '\n    ' + (0, _flexbox.flexbox)() + '\n    ' + (0, _flexbox.alignItems)('center') + '\n    ' + (0, _flexbox.justifyContent)('space-between') + '    \n    min-height: 50px;\n    width: calc(100% - 20px);\n    background-color: ' + colours.hitGray + ';\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    padding: 3px 10px;\n\n    .actionButton {\n        height: 30px;\n        width: 100px;\n        background-color: ' + colours.oxfordBlue + ';\n        border-radius: 15px;\n        color: white;\n    }\n';
});

var LoaderWrapper = exports.LoaderWrapper = _styledComponents2.default.div(_templateObject4, (0, _flexbox.flexbox)(), (0, _flexbox.alignItems)('center'), (0, _flexbox.justifyContent)('center'));

var DropdownWrapper = exports.DropdownWrapper = _styledComponents2.default.div(_templateObject5);

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownListWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        layout = _ThemeHelper$getTheme.layout,
        colours = _ThemeHelper$getTheme.colours,
        palette = _ThemeHelper$getTheme.palette;

    return 'position: relative;\n    display: table;\n    font-family: inherit;\n    border: 1px solid ' + colours.grey[200] + ';\n    border-radius: ' + layout.borderRadius + ';\n\n    .icon {\n        display: block;\n    }\n\n    .icon {\n        width: 0;\n        height: 0;\n        border-left: 6px solid transparent;\n        border-right: 6px solid transparent;\n        border-top: 8px solid #778088;\n        margin-top: -4px;\n        content: " ";\n        position: absolute;\n        top: 50%;\n        right: 8px;\n        pointer-events: none;\n        display: block;\n    }\n\n    select {\n        background: none;\n        border-radius: 0.2em;\n        border: 1px solid transparent;\n        width: 100%;\n        margin: 0;\n        outline: none;\n        padding: 0.55em 0.8em 0.45em;\n        padding-right: 30px;\n        font-family: inherit;\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 1.3;\n        color: ' + palette.primary.main + ';\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        -webkit-box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        box-sizing: border-box;\n\n        &:focus {\n            outline: none;\n        }\n    }\n\n    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n        select::-ms-expand {\n            display: none;\n        }\n\n        select:focus {\n            border-color: orange;\n        }\n\n        select:focus::-ms-value {\n            background: transparent;\n            color: yellow;\n        }\n\n        select {\n            padding-right: 2em;\n            background: none;\n            border: 1px solid transparent;\n        }\n\n        &::after {\n            display: block;\n        }\n    }\n';
});

exports.default = DropdownListWrapper;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SubHeading = exports.MainHeading = exports.HeaderWrapper = undefined;

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _flexbox = __webpack_require__(24);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme.colours;

    return '\n    ' + (0, _flexbox.flexbox)() + '\n    ' + (0, _flexbox.alignItems)('center') + '\n\n    background-color: ' + colours.grey['400'] + ';\n    padding: 10px 20px;\n    ';
}); /* eslint-disable */


var MainHeading = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme2 = _themeHelper2.default.getTheme(props),
        typography = _ThemeHelper$getTheme2.typography,
        palette = _ThemeHelper$getTheme2.palette;

    return '\n    ' + (0, _flexbox.flexbox)() + '\n\n    ' + (0, _flexbox.alignItems)('center') + '\n    ' + (0, _flexbox.justifyContent)('space-between') + '\n    font-family: ' + typography.family + ';\n    color: ' + palette.primary.dark + ';\n    font-size: 30px;\n    font-weight: 500;\n    ';
});

/**
 * @todo Add keppel color to Theme
 */
var SubHeading = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme3 = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme3.colours,
        palette = _ThemeHelper$getTheme3.palette,
        typography = _ThemeHelper$getTheme3.typography;

    return '\n    text-align: center;\n    padding: 6px 20px;\n    margin-left: 20px;\n    border: 2px solid ' + palette.primary.light + ';\n    border-radius: 20px;\n    background-color: ' + colours.grey[400] + ';\n    color: ' + palette.primary.main + ';\n    font-family: ' + typography.family + ';\n    font-size: 15px;\n    line-height: 1.2em;\n    ';
});

exports.HeaderWrapper = HeaderWrapper;
exports.MainHeading = MainHeading;
exports.SubHeading = SubHeading;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styled = __webpack_require__(488);

var _iconDictionary = __webpack_require__(65);

var _svgIcon = __webpack_require__(64);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputToggle = function (_PureComponent) {
    _inherits(InputToggle, _PureComponent);

    function InputToggle(props) {
        _classCallCheck(this, InputToggle);

        var _this = _possibleConstructorReturn(this, (InputToggle.__proto__ || Object.getPrototypeOf(InputToggle)).call(this, props));

        _this.state = {
            isEditable: false,
            title: ''
        };
        _this.handleOnUpdate = _this.handleOnUpdate.bind(_this);
        _this.handleInputLostFocus = _this.handleInputLostFocus.bind(_this);
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        _this.handleOnKeyPress = _this.handleOnKeyPress.bind(_this);
        return _this;
    }

    _createClass(InputToggle, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            this.setState({ title: props.name });
        }
    }, {
        key: 'handleOnUpdate',
        value: function handleOnUpdate() {
            this.nameInput.focus();
            this.setState({ isEditable: true });
        }
    }, {
        key: 'handleInputLostFocus',
        value: function handleInputLostFocus() {
            this.setState({ isEditable: false });
        }
    }, {
        key: 'handleOnChange',
        value: function handleOnChange(e) {
            this.setState({ title: e.target.value });
            this.props.getInputValue({ id: e.target.id, name: e.target.value });
        }
    }, {
        key: 'handleOnKeyPress',
        value: function handleOnKeyPress(e) {
            if (e.key === 'Enter') {
                this.handleInputLostFocus();
                e.target.blur();
                this.props.getInputValue({ id: e.target.id, name: this.state.title });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                placeHolder = _props.placeHolder,
                id = _props.id,
                name = _props.name;

            return _react2.default.createElement(
                _styled.InputToggleWrapper,
                { title: name || this.state.title },
                _react2.default.createElement(
                    'div',
                    {
                        className: 'icon',
                        onClick: this.handleOnUpdate,
                        role: 'button',
                        tabIndex: '-1' },
                    _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Edit })
                ),
                _react2.default.createElement(_styled.Input, {
                    id: id,
                    isEditable: this.state.isEditable,
                    onBlur: this.handleInputLostFocus,
                    onChange: this.handleOnChange,
                    onFocus: this.handleOnUpdate,
                    onKeyPress: this.handleOnKeyPress,
                    placeholder: placeHolder,
                    ref: function ref(input) {
                        _this2.nameInput = input;
                    },
                    type: 'text',
                    value: name || this.state.title
                })
            );
        }
    }]);

    return InputToggle;
}(_react.PureComponent);

InputToggle.propTypes = {
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    getInputValue: _propTypes2.default.func,
    name: _propTypes2.default.string,
    placeHolder: _propTypes2.default.string
};

InputToggle.defaultProps = {
    name: ''
};

exports.default = InputToggle;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InputToggleWrapper = exports.Input = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n    ', '\n\n    .icon {\n        width: 20px;\n        height: 21px;\n        margin: 0 10px;\n        float: right;\n        cursor: pointer;\n        outline: none;\n\n        svg {\n            path { fill: #8b8b8b !important; }\n        }\n    }\n'], ['\n    ', '\n    ', '\n\n    .icon {\n        width: 20px;\n        height: 21px;\n        margin: 0 10px;\n        float: right;\n        cursor: pointer;\n        outline: none;\n\n        svg {\n            path { fill: #8b8b8b !important; }\n        }\n    }\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

var _flexbox = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Input = exports.Input = _styledComponents2.default.input(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        typography = _ThemeHelper$getTheme.typography;

    var borderStyle = props.isEditable ? 'grey' : 'transparent';
    var backgroundStyle = props.isEditable ? 'white' : 'rgba(0, 0, 0, 0)';
    return '\n    width: 100%;\n    background: ' + backgroundStyle + ';\n    border: 1px solid ' + borderStyle + ';\n    font-family: ' + typography.family + ';\n    outline: none;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    ';
});

var InputToggleWrapper = exports.InputToggleWrapper = _styledComponents2.default.div(_templateObject, (0, _flexbox.flexbox)(), (0, _flexbox.alignItems)('end'));

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getMasterCourseKey = function getMasterCourseKey(_ref) {
  var id = _ref.id,
      version = _ref.version;
  return id + "/" + version;
};

exports.default = getMasterCourseKey;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(15);

var _reactRedux = __webpack_require__(52);

var _redux = __webpack_require__(43);

var _styled = __webpack_require__(492);

var _messages = __webpack_require__(491);

var _messages2 = _interopRequireDefault(_messages);

var _helpers = __webpack_require__(489);

var _helpers2 = _interopRequireDefault(_helpers);

var _actions = __webpack_require__(117);

var _actions2 = __webpack_require__(96);

var _modal = __webpack_require__(252);

var _modal2 = _interopRequireDefault(_modal);

var _dropdownList = __webpack_require__(63);

var _dropdownList2 = _interopRequireDefault(_dropdownList);

var _button = __webpack_require__(37);

var _button2 = _interopRequireDefault(_button);

var _spinner = __webpack_require__(160);

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * LINKED COURSE MODAL
 * ---------------------
 * Displayed when user selects 'copy | edit' button from default/3p course table.
 * containers/course-creator initialises modal based off query params.
 * Modal submit handler sets updated master/default courses -> course-creator renders accordingly
 * Key is created to manage both master course id and version
 */
var LinkedCourseModal = function (_Component) {
    _inherits(LinkedCourseModal, _Component);

    function LinkedCourseModal(props) {
        var _this2 = this;

        _classCallCheck(this, LinkedCourseModal);

        var _this = _possibleConstructorReturn(this, (LinkedCourseModal.__proto__ || Object.getPrototypeOf(LinkedCourseModal)).call(this, props));

        _this.manageInitialData = function (_ref) {
            var masterCourseOptions = _ref.masterCourseOptions,
                masterCourse = _ref.masterCourse;

            var selectedMasterCourse = masterCourseOptions.find(function (item) {
                return item.key === masterCourse.key;
            });

            if (selectedMasterCourse) {
                _this.setState({
                    selectedCurriculumKey: selectedMasterCourse.key,
                    initialCurriculumKey: selectedMasterCourse.key
                });
            }
        };

        _this.onSubmitHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var _this$props, _this$props$match$par, productId, defaultCourseId, version, masterCourseOptions, hideModal, _this$state, selectedCurriculumKey, initialCurriculumKey, updatedMasterCourse, shouldUpdateMasterCourse;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this$props = _this.props, _this$props$match$par = _this$props.match.params, productId = _this$props$match$par.productId, defaultCourseId = _this$props$match$par.defaultCourseId, version = _this$props$match$par.version, masterCourseOptions = _this$props.masterCourseOptions, hideModal = _this$props.hideModal;
                            _this$state = _this.state, selectedCurriculumKey = _this$state.selectedCurriculumKey, initialCurriculumKey = _this$state.initialCurriculumKey;
                            updatedMasterCourse = masterCourseOptions.find(function (item) {
                                return item.key === selectedCurriculumKey;
                            });
                            shouldUpdateMasterCourse = selectedCurriculumKey !== initialCurriculumKey;

                            if (!(updatedMasterCourse && shouldUpdateMasterCourse)) {
                                _context.next = 10;
                                break;
                            }

                            _context.next = 7;
                            return _this.props.getDefaultCourse(productId, defaultCourseId, version, updatedMasterCourse.id, updatedMasterCourse.version);

                        case 7:
                            hideModal();
                            _context.next = 11;
                            break;

                        case 10:
                            hideModal();

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.onDropdownChangeHandler = function (key, value) {
            _this.setState({
                selectedCurriculumKey: value
            });
        };

        _this.getWarningMessage = function () {
            var masterCourseOptions = _this.props.masterCourseOptions;
            var _this$state2 = _this.state,
                selectedCurriculumKey = _this$state2.selectedCurriculumKey,
                initialCurriculumKey = _this$state2.initialCurriculumKey;

            var selectedMasterCourse = masterCourseOptions.find(function (item) {
                return item.key === selectedCurriculumKey;
            });
            var initialMasterCourse = masterCourseOptions.find(function (item) {
                return item.key === initialCurriculumKey;
            });

            return 'Update master course from \u2018' + initialMasterCourse.value + '\u2019 to \u2018' + selectedMasterCourse.value + '\u2019?';
        };

        _this.defaultOptionLength = 100;

        _this.state = {
            selectedCurriculumKey: null,
            initialCurriculumKey: null
        };
        return _this;
    }

    _createClass(LinkedCourseModal, [{
        key: 'componentDidMount',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.props.getMasterCourses(null);

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function componentDidMount() {
                return _ref3.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var masterCourse = prevProps.masterCourse,
                masterCourseOptions = prevProps.masterCourseOptions;
            var selectedCurriculumKey = prevState.selectedCurriculumKey;


            var hasLoadedInitialMasterCourse = masterCourse.id && masterCourseOptions.length > 0 && !selectedCurriculumKey;

            if (hasLoadedInitialMasterCourse) {
                this.manageInitialData({
                    masterCourse: masterCourse,
                    masterCourseOptions: masterCourseOptions
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetMasterCourses();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                intl = _props.intl,
                selectedGenericCourse = _props.selectedGenericCourse,
                masterCourseOptions = _props.masterCourseOptions,
                show = _props.show,
                isLoadingMasterCourses = _props.isLoadingMasterCourses,
                isLoadingGenericCourse = _props.isLoadingGenericCourse;
            var _state = this.state,
                selectedCurriculumKey = _state.selectedCurriculumKey,
                initialCurriculumKey = _state.initialCurriculumKey;
            /**
             Since the functionality to change the master course while copying or editing a course is not permission
             based, there is a potential risk of a team member accidentally changing a master course of a 3P course.
             In order to avoid that we need to introduce a warning message to remind the user of the action.
             */

            var showWarning = selectedCurriculumKey !== initialCurriculumKey;

            // Bits of data coming from everywhere... poorly defined in reducers... massive effort to refactor... apologies
            var shouldRenderContent = selectedCurriculumKey && selectedGenericCourse && !isLoadingMasterCourses && !isLoadingGenericCourse;

            return _react2.default.createElement(
                _modal2.default,
                { show: show },
                _react2.default.createElement(
                    _styled.ModalWrapper,
                    null,
                    shouldRenderContent ? _react2.default.createElement(
                        _react.Fragment,
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            intl.formatMessage(_messages2.default.header)
                        ),
                        _react2.default.createElement(
                            _styled.ModalRow,
                            null,
                            _react2.default.createElement(_dropdownList2.default, {
                                onChange: this.onDropdownChangeHandler,
                                optionLength: this.defaultOptionLength,
                                options: masterCourseOptions.filter(function (item) {
                                    return item.subjectId === selectedGenericCourse.productId;
                                }),
                                value: selectedCurriculumKey
                            })
                        ),
                        showWarning && _react2.default.createElement(
                            _styled.ModalRow,
                            null,
                            _react2.default.createElement(
                                _styled.WarningText,
                                null,
                                this.getWarningMessage()
                            )
                        ),
                        _react2.default.createElement(
                            _styled.ModalRow,
                            null,
                            _react2.default.createElement(
                                _styled.ButtonWrapper,
                                null,
                                showWarning && _react2.default.createElement(_button2.default, {
                                    cicle: true,
                                    handleOnClick: function handleOnClick() {
                                        return _this3.setState({
                                            selectedCurriculumKey: initialCurriculumKey
                                        });
                                    },
                                    label: intl.formatMessage(_messages2.default.cancel)
                                }),
                                _react2.default.createElement(_button2.default, {
                                    handleOnClick: function handleOnClick() {
                                        return _this3.onSubmitHandler();
                                    },
                                    label: intl.formatMessage(_messages2.default.button),
                                    primary: true
                                })
                            )
                        )
                    ) : _react2.default.createElement(_spinner2.default, null)
                )
            );
        }
    }]);

    return LinkedCourseModal;
}(_react.Component);

LinkedCourseModal.propTypes = {
    getDefaultCourse: _propTypes2.default.func,
    getMasterCourses: _propTypes2.default.func,
    hideModal: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    masterCourse: _propTypes2.default.object,
    masterCourseOptions: _propTypes2.default.array,
    match: _propTypes2.default.object.isRequired,
    show: _propTypes2.default.bool,
    selectedGenericCourse: _propTypes2.default.object,
    isLoadingMasterCourses: _propTypes2.default.bool,
    isLoadingGenericCourse: _propTypes2.default.bool,
    resetMasterCourses: _propTypes2.default.func
};


function mapStateToProps(state) {
    var _state$courseCreator = state.courseCreator,
        selectedMasterCourse = _state$courseCreator.masterCourse,
        selectedGenericCourse = _state$courseCreator.genericCourse,
        isLoadingGenericCourse = _state$courseCreator.isFetching,
        _state$masterCourse = state.masterCourse,
        availableMasterCourses = _state$masterCourse.masterCourses,
        isLoadingMasterCourses = _state$masterCourse.isLoading;


    return {
        isLoadingMasterCourses: isLoadingMasterCourses,
        isLoadingGenericCourse: isLoadingGenericCourse,
        masterCourse: _extends({}, selectedMasterCourse, {
            key: (0, _helpers2.default)({
                id: selectedMasterCourse.id,
                version: selectedMasterCourse.version
            })
        }),
        masterCourseOptions: availableMasterCourses.map(function (_ref4) {
            var id = _ref4.id,
                version = _ref4.version,
                name = _ref4.name,
                subjectId = _ref4.subjectId;
            return {
                // We include dropdown lists required values & append version number to display name
                id: id,
                version: version,
                value: name + '-V' + version,
                key: (0, _helpers2.default)({
                    id: id,
                    version: version
                }),
                subjectId: subjectId
            };
        }),
        selectedGenericCourse: selectedGenericCourse
    };
}

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getDefaultCourse: _actions.getDefaultCourse,
        getMasterCourses: _actions2.getMasterCourses,
        resetMasterCourses: _actions2.resetMasterCourses
    }, dispatch);
}

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LinkedCourseModal));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(15);

exports.default = (0, _reactIntl.defineMessages)({
    header: {
        id: 'app.containers.LinkedCourseModal.header',
        defaultMessage: 'Choose a curriculum/master course from the drop down below to be linked to the course'
    },
    button: {
        id: 'app.containers.LinkedCourseModal.button',
        defaultMessage: 'Ok'
    },
    cancel: {
        id: 'app.containers.LinkedCourseModal.cancel',
        defaultMessage: 'Cancel'
    }
});

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WarningText = exports.ButtonWrapper = exports.ModalRow = exports.ModalWrapper = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 30px;\n    height: 100%;\n'], ['\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 30px;\n    height: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: 20px 0;\n'], ['\n  margin: 20px 0;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n'], ['\n  display: flex;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    color: red;\n    font-weight: bold;\n    margin: 0;\n'], ['\n    color: red;\n    font-weight: bold;\n    margin: 0;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModalWrapper = exports.ModalWrapper = _styledComponents2.default.div(_templateObject);

var ModalRow = exports.ModalRow = _styledComponents2.default.div(_templateObject2);

var ButtonWrapper = exports.ButtonWrapper = _styledComponents2.default.div(_templateObject3);

var WarningText = exports.WarningText = _styledComponents2.default.p(_templateObject4);

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBeautifulDnd = __webpack_require__(334);

var _styled = __webpack_require__(494);

var _svgIcon = __webpack_require__(64);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _iconDictionary = __webpack_require__(65);

var _index = __webpack_require__(503);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = function (_Component) {
    _inherits(ListItem, _Component);

    function ListItem(props) {
        _classCallCheck(this, ListItem);

        var _this = _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));

        _this.showChildren = function (e, id, status) {
            _this.setState({ showChildren: status });
            _this.props.updateTopics(id, status);
            e.stopPropagation();
        };

        _this.onToggle = function (id, status) {
            _this.props.onToggle(id, status);
        };

        _this.onNodeDelete = function (id) {
            _this.props.onDelete(id);
            _this.isActionEvent = true;
        };

        _this.onListSelection = function (id) {
            if (id.indexOf('-') === -1 && !_this.isActionEvent) {
                _this.props.onItemSelect(id);
            }
            _this.isActionEvent = false;
        };

        _this.onEdit = function (id, isSelected) {
            _this.isActionEvent = true;
            var modalInfo = {
                topicName: _this.props.name
            };
            if (id.indexOf('-') === -1 && !isSelected) {
                _this.props.onItemSelect(id);
            }
            _this.props.handleOnEdit('edit', _this.props.id, modalInfo);
        };

        _this.renderListItem = function (name, index, draggableId, showIconPanel) {
            var isEditable = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
            var showGirlIcons = arguments[5];
            var isIncluded = arguments[6];
            var previewUrl = arguments[7];
            var isExpanded = arguments[8];
            var isSelected = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;
            var showDelete = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : false;
            var _this$props = _this.props,
                _this$props$invalidSt = _this$props.invalidStrands,
                invalidStrands = _this$props$invalidSt === undefined ? [] : _this$props$invalidSt,
                _this$props$invalidSt2 = _this$props.invalidStandards,
                invalidStandards = _this$props$invalidSt2 === undefined ? [] : _this$props$invalidSt2;

            var styledProps = {
                draggableId: draggableId,
                showGirlIcons: showGirlIcons,
                isInvalid: invalidStrands.includes(draggableId) || invalidStandards.includes(draggableId)
            };

            return _react2.default.createElement(
                _reactBeautifulDnd.Draggable,
                { draggableId: draggableId, index: index, key: draggableId },
                function (provided, snapshot) {
                    return _react2.default.createElement(
                        _styled.ListItemWrapper,
                        _extends({}, styledProps, provided.draggableProps, {
                            ref: provided.innerRef
                        }),
                        _react2.default.createElement(
                            'div',
                            {
                                className: 'info',
                                onClick: function onClick() {
                                    return _this.onListSelection(draggableId);
                                },
                                role: 'button',
                                style: (0, _styled.onDraggingStyle)(snapshot.isDragging || isSelected),
                                tabIndex: 0
                            },
                            _react2.default.createElement(
                                'div',
                                _extends({ className: 'moveIcon' }, provided.dragHandleProps),
                                _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Move })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'name', style: (0, _styled.showElement)(isEditable) },
                                _react2.default.createElement(
                                    _styled.InputWrapper,
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        {
                                            className: 'icon',
                                            onClick: function onClick() {
                                                _this.onEdit(draggableId, isSelected);
                                            },
                                            role: 'button',
                                            tabIndex: '-1' },
                                        _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Edit })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        {
                                            id: draggableId,
                                            name: name },
                                        name
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: showGirlIcons ? 'nameNonEditable' : 'name', style: (0, _styled.showElement)(!isEditable) },
                                name
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'iconPanel', style: (0, _styled.showElement)(showIconPanel) },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'iconStyle', onClick: function onClick() {
                                            return _this.onNodeDelete(draggableId);
                                        }, role: 'button', style: (0, _styled.showElement)(showDelete), tabIndex: 0 },
                                    _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Cross })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'iconStyle', onClick: function onClick(e) {
                                                return _this.showChildren(e, draggableId, false);
                                            }, role: 'button', style: (0, _styled.showElement)(isExpanded), tabIndex: 0 },
                                        _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Expand })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'iconStyle', onClick: function onClick(e) {
                                                return _this.showChildren(e, draggableId, true);
                                            }, role: 'button', style: (0, _styled.showElement)(!isExpanded), tabIndex: 0 },
                                        _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Collapse })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'iconPanel', style: (0, _styled.showElement)(showGirlIcons) },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'previewStyle' },
                                    _react2.default.createElement(
                                        'a',
                                        { href: previewUrl, rel: 'noopener noreferrer', target: '_blank' },
                                        ' ',
                                        _react2.default.createElement(_svgIcon2.default, { icon: _iconDictionary.Preview }),
                                        ' '
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'toggle' },
                                    _react2.default.createElement(_index2.default, { onChange: function onChange(status) {
                                            return _this.onToggle(draggableId, status);
                                        }, toggled: isIncluded })
                                )
                            )
                        )
                    );
                }
            );
        };

        _this.renderChildren = function (childNodes) {
            return childNodes.map(function (item, index) {
                var key = index;
                var isGirlItem = item.groupName.indexOf('girl') !== -1;
                var isSpineItem = item.id.indexOf('spine') !== -1;

                return _react2.default.createElement(
                    'div',
                    { className: 'node', key: key },
                    _react2.default.createElement(ListItem, {
                        childNodes: item.childNodes,
                        childTopics: item.childTopics,
                        getTopicName: _this.props.getTopicName,
                        handleOnEdit: _this.props.handleOnEdit,
                        id: item.id,
                        index: index,
                        invalidStandards: _this.props.invalidStandards,
                        invalidStrands: _this.props.invalidStrands,
                        isEditable: item.isEditable,
                        isExpanded: isGirlItem ? false : item.isExpanded,
                        isIncluded: isGirlItem ? item.isIncluded : false,
                        isSelected: item.id.indexOf('-') === -1 ? item.isSelected : false,
                        name: item.name,
                        onDelete: _this.onNodeDelete,
                        onItemSelect: _this.onListSelection,
                        onToggle: _this.onToggle,
                        previewUrl: isGirlItem ? item.previewUrl : '',
                        showDelete: isSpineItem,
                        showGirlIcons: isGirlItem,
                        showIconPanel: !isGirlItem,
                        strand: _this.props.strand,
                        subStrand: _this.props.subStrand,
                        updateTopics: _this.props.updateTopics
                    })
                );
            });
        };

        _this.renderTree = function (childNodes) {
            if (childNodes && childNodes.length > 0) {
                return _react2.default.createElement(
                    _styled.TreeWrapper,
                    { className: 'tree' },
                    _react2.default.createElement(
                        _reactBeautifulDnd.Droppable,
                        { droppableId: childNodes[0].groupName, type: childNodes[0].groupName },
                        function (provided) {
                            return _react2.default.createElement(
                                'div',
                                _extends({
                                    ref: provided.innerRef
                                }, provided.droppableProps),
                                _this.renderChildren(childNodes),
                                provided.placeholder
                            );
                        }
                    )
                );
            }
            return null;
        };

        _this.state = {
            showChildren: _this.props.isExpanded
        };
        _this.isActionEvent = false;
        return _this;
    }

    _createClass(ListItem, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            this.setState({
                strand: props.strand,
                subStrand: props.subStrand
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                index = _props.index,
                id = _props.id,
                childNodes = _props.childNodes,
                showIconPanel = _props.showIconPanel,
                isEditable = _props.isEditable,
                showGirlIcons = _props.showGirlIcons,
                isIncluded = _props.isIncluded,
                previewUrl = _props.previewUrl,
                isExpanded = _props.isExpanded,
                isSelected = _props.isSelected,
                showDelete = _props.showDelete,
                invalidStrands = _props.invalidStrands,
                invalidStandards = _props.invalidStandards;

            var children = void 0;

            if (childNodes != null) {
                children = this.renderTree(childNodes);
            }
            return _react2.default.createElement(
                'div',
                null,
                this.renderListItem(name, index, id, showIconPanel, isEditable, showGirlIcons, isIncluded, previewUrl, isExpanded, isSelected, showDelete, invalidStrands, invalidStandards),
                isExpanded && _react2.default.createElement(
                    _styled.ChildWrapper,
                    { className: 'childPanel' },
                    children
                )
            );
        }
    }]);

    return ListItem;
}(_react.Component);

ListItem.propTypes = {
    id: _propTypes2.default.string,
    name: _propTypes2.default.string,
    previewUrl: _propTypes2.default.string,
    index: _propTypes2.default.number,
    childNodes: _propTypes2.default.array,
    childTopics: _propTypes2.default.array,
    showDelete: _propTypes2.default.bool,
    showIconPanel: _propTypes2.default.bool,
    showGirlIcons: _propTypes2.default.bool,
    isEditable: _propTypes2.default.bool,
    isIncluded: _propTypes2.default.bool,
    // Array of strand ids which have Steps without spine nodes. We highlight these with red border
    invalidStrands: _propTypes2.default.array,
    invalidStandards: _propTypes2.default.array,
    isExpanded: _propTypes2.default.bool,
    isSelected: _propTypes2.default.bool,
    getTopicName: _propTypes2.default.func,
    onToggle: _propTypes2.default.func,
    onItemSelect: _propTypes2.default.func,
    updateTopics: _propTypes2.default.func,
    handleOnEdit: _propTypes2.default.func,
    strand: _propTypes2.default.string,
    subStrand: _propTypes2.default.string,
    onDelete: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)(ListItem);

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InputWrapper = exports.TreeWrapper = exports.ChildWrapper = exports.showElement = exports.ListItemWrapper = exports.onDraggingStyle = exports.ListItemInfo = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n\n    .icon {\n        width: 20px;\n        height: 21px;\n        margin: 0 10px;\n        float: right;\n        cursor: pointer;\n        outline: none;\n\n        svg {\n            path { fill: #8b8b8b !important; }\n        }\n    }\n'], ['\n    ', '\n\n    .icon {\n        width: 20px;\n        height: 21px;\n        margin: 0 10px;\n        float: right;\n        cursor: pointer;\n        outline: none;\n\n        svg {\n            path { fill: #8b8b8b !important; }\n        }\n    }\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _flexbox = __webpack_require__(24);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var onDraggingStyle = function onDraggingStyle(isDragging) {
    return {
        background: isDragging ? '#e7b300' : ''
    };
};

var showElement = function showElement(bool) {
    return {
        display: bool ? '' : 'none'
    };
};

var ChildWrapper = _styledComponents2.default.div(function () {
    return '.childPanel {\n           margin: 5px 0px 0px 10px;\n        }';
});

var ListItemWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme.colours,
        palette = _ThemeHelper$getTheme.palette,
        typography = _ThemeHelper$getTheme.typography;

    var backgroundColor = '#99ffff';
    var infoBorderColor = colours.silverDark;
    var infoBorderSize = '1px';
    var infoHeight = '48px';

    if (props.showGirlIcons) {
        backgroundColor = '#ffcccc';
    } else if (props.draggableId.indexOf('spine') !== -1) {
        backgroundColor = palette.primary.text;
    }
    if (props.isInvalid) {
        infoBorderColor = 'red';
        infoBorderSize = '6px';
        infoHeight = '55px';
    }

    return '\n        .info {\n            ' + (0, _flexbox.flexbox)() + '\n            height: ' + infoHeight + ';\n            border: ' + infoBorderSize + ' solid ' + infoBorderColor + ';\n            border-radius: 7px;\n            box-shadow: 10px 5px 5px rgba(0, 0, 0, 0.1);\n            background: ' + backgroundColor + ';\n            cursor: pointer;\n            outline: none;\n        }\n\n        .moveIcon {\n            width: 24px;\n            height: 25px;\n            ' + (0, _flexbox.flexShrink)(0) + '\n            padding-top: 12px;\n            padding-left: 5px;\n            cursor: pointer;\n        }\n\n        .name {\n            ' + (0, _flexbox.flexShrink)(0) + '\n            ' + (0, _flexbox.justifyContent)('space-between') + '\n            ' + (0, _flexbox.flex)('1') + '\n            padding-left: 5px;\n            color: ' + colours.emperor + ';\n            font-family: ' + typography.family + ';\n            padding-top: 13px;\n            font-size: 14px;\n            font-weight: 500;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            outline: none;\n        }\n\n        .nameNonEditable {\n            ' + (0, _flexbox.flexShrink)(0) + '\n            ' + (0, _flexbox.flex)(1) + ';\n            padding-left: 5px;\n            color: ' + colours.emperor + ';\n            font-family: ' + typography.family + ';\n            padding-top: 13px;\n            font-size: 14px;\n            font-weight: 500;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            outline: none;\n        }\n\n        .iconPanel {\n            padding-top: 12px;\n            ' + (0, _flexbox.flexbox)() + '\n            ' + (0, _flexbox.flexShrink)(0) + '\n            ' + (0, _flexbox.justifyContent)('space-evenly') + '\n        }\n\n        .iconStyle {\n            width: 18px;\n            height: 25px;\n            margin-right:4px;\n            outline: none;\n            cursor: pointer;\n        }\n\n        .previewStyle {\n            width: 18px;\n            height: 25px;\n            padding-top: 3px;\n            margin-right:4px;\n            outline: none;\n            cursor: pointer;\n        }\n\n        .toggle {\n            height: 25px;\n            margin-right:4px;\n            outline: none;\n            cursor: pointer;\n        }\n\n        .tree {\n            height: 100%;\n            overflow: auto;\n        }\n\n        .node {\n            padding: 6px;\n        }\n    ';
});

var InputWrapper = _styledComponents2.default.div(_templateObject, (0, _flexbox.flexbox)());

var ListItemInfo = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme2 = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme2.colours,
        palette = _ThemeHelper$getTheme2.palette;

    return '\n            ' + (0, _flexbox.flexbox)() + '\n            height: 48px;\n            border: 1px solid ' + colours.silverDark + ';\n            border-radius: 7px;\n            box-shadow: 10px 5px 5px rgba(0, 0, 0, 0.1);\n            background-color: ' + palette.primary.text + ';\n        ';
});

var TreeWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme3 = _themeHelper2.default.getTheme(props),
        palette = _ThemeHelper$getTheme3.palette;

    return '\n        .tree {\n            height: 100%;\n            overflow: auto;\n        }\n\n        .dropZone {\n            min-height: 100px;\n        }\n\n        .node {\n            padding: 6px;\n        }\n\n        .dropZone {\n            height: 5px;\n\n            &:hover {\n                border: 2px solid ' + palette.primary.light + ';\n                border-style: dashed;\n            }\n        }\n    ';
});

exports.ListItemInfo = ListItemInfo;
exports.onDraggingStyle = onDraggingStyle;
exports.ListItemWrapper = ListItemWrapper;
exports.showElement = showElement;
exports.ChildWrapper = ChildWrapper;
exports.TreeWrapper = TreeWrapper;
exports.InputWrapper = InputWrapper;

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(217);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultiSelectionList = function MultiSelectionList(props) {
    var value = props.value,
        handleChange = props.handleChange,
        options = props.options;


    return _react2.default.createElement(_reactSelect2.default, {
        isMulti: true,
        onChange: handleChange,
        options: options,
        value: value
    });
};

MultiSelectionList.propTypes = {
    value: _propTypes2.default.array,
    handleChange: _propTypes2.default.func,
    options: _propTypes2.default.array
};

exports.default = MultiSelectionList;

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(214);

var _routes = __webpack_require__(543);

var _routes2 = _interopRequireDefault(_routes);

var _index = __webpack_require__(1110);

var _index2 = _interopRequireDefault(_index);

var _toast = __webpack_require__(501);

var _toast2 = _interopRequireDefault(_toast);

var _withAuth = __webpack_require__(505);

var _withAuth2 = _interopRequireDefault(_withAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RootContainer = function RootContainer(props) {
    var container = _react2.default.createElement(
        'div',
        { className: _index2.default.rootContainer },
        _react2.default.createElement(
            _reactRouterDom.BrowserRouter,
            { basename: props.basename },
            _react2.default.createElement(_routes2.default, null)
        ),
        _react2.default.createElement(_toast2.default, null)
    );
    return container;
};

RootContainer.propTypes = {
    basename: _propTypes2.default.string
};

exports.default = (0, _withAuth2.default)(RootContainer);

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = __webpack_require__(1111);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectableListItem = function (_Component) {
    _inherits(SelectableListItem, _Component);

    function SelectableListItem(props) {
        _classCallCheck(this, SelectableListItem);

        var _this = _possibleConstructorReturn(this, (SelectableListItem.__proto__ || Object.getPrototypeOf(SelectableListItem)).call(this, props));

        _this.onSelection = function (element) {
            var checked = element.target.checked;
            _this.setState({ isChecked: checked });
            _this.props.onChange(element.target.id);
        };

        _this.state = {
            isChecked: props.isChecked
        };
        return _this;
    }

    _createClass(SelectableListItem, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                id = _props.id,
                name = _props.name;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _index2.default.info },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.checkbox },
                        _react2.default.createElement('input', {
                            checked: this.state.isChecked,
                            className: _index2.default.name,
                            id: id,
                            onChange: this.onSelection,
                            type: 'checkbox'
                        }),
                        _react2.default.createElement('label', { className: _index2.default.chklabel, htmlFor: id }),
                        _react2.default.createElement(
                            'span',
                            { className: _index2.default.description },
                            name
                        )
                    )
                )
            );
        }
    }]);

    return SelectableListItem;
}(_react.Component);

SelectableListItem.propTypes = {
    id: _propTypes2.default.string,
    name: _propTypes2.default.string,
    isChecked: _propTypes2.default.bool,
    onChange: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)(SelectableListItem);

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styled = __webpack_require__(499);

var _selectableListItem = __webpack_require__(497);

var _selectableListItem2 = _interopRequireDefault(_selectableListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SpineList = function (_React$Component) {
    _inherits(SpineList, _React$Component);

    function SpineList() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SpineList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SpineList.__proto__ || Object.getPrototypeOf(SpineList)).call.apply(_ref, [this].concat(args))), _this), _this.renderSpineItems = function (spineNodes) {
            if (spineNodes.length > 0) {
                return spineNodes.map(function (item) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'spacer', key: item.id + '_' + item.isSelected },
                        _react2.default.createElement(_selectableListItem2.default, {
                            id: item.id,
                            isChecked: item.isSelected,
                            name: item.id + ': ' + item.description,
                            onChange: _this.props.onChange
                        })
                    );
                });
            }

            return null;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SpineList, [{
        key: 'render',
        value: function render() {
            var spineNodes = this.props.spineNodes;

            return _react2.default.createElement(
                _styled.SpineListWrapper,
                null,
                this.renderSpineItems(spineNodes)
            );
        }
    }]);

    return SpineList;
}(_react2.default.Component);

SpineList.propTypes = {
    spineNodes: _propTypes2.default.array,
    onChange: _propTypes2.default.func
};

SpineList.defaultProps = {
    spineNodes: []
};

exports.default = SpineList;

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SpineItemInfoWrapper = exports.SpineItemNameWrapper = exports.SpineItemIconWrapper = exports.SpineListWrapper = exports.getListStyle = exports.getItemStyle = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n    width: 24px;\n    height: 25px;\n    ', '\n    padding-top: 12px;\n    padding-left: 5px;\n    cursor: pointer;\n'], ['\n    width: 24px;\n    height: 25px;\n    ', '\n    padding-top: 12px;\n    padding-left: 5px;\n    cursor: pointer;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

var _flexbox = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var grid = 8;
var getItemStyle = function getItemStyle(isDragging, draggableStyle) {
    return _extends({
        // some basic styles to make the items look a bit nicer
        userSelect: 'none',
        padding: grid * 2,

        // change background colour if dragging
        background: isDragging ? 'lightgreen' : 'white'

    }, draggableStyle);
};

var getListStyle = function getListStyle(isDraggingOver) {
    return {
        background: isDraggingOver ? 'lightblue' : 'white',
        padding: grid,
        overflowY: 'scroll',
        maxHeight: '80vh',
        position: 'relative'
    };
};

var SpineListWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        palette = _ThemeHelper$getTheme.palette,
        typography = _ThemeHelper$getTheme.typography;

    return '\n    height: 100%;\n    overflow: auto;\n    padding: 5px;\n    font-family: ' + typography.family + ';\n    color: ' + palette.primary.dark + ';\n    \n    .spacer {\n        padding: 2px;\n    }\n    ';
});

var SpineItemIconWrapper = _styledComponents2.default.div(_templateObject, (0, _flexbox.flexShrink)(0));

var SpineItemNameWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme2 = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme2.colours,
        typography = _ThemeHelper$getTheme2.typography;

    return '\n    ' + (0, _flexbox.flexShrink)(0) + '\n    padding-left: 5px;\n    color: ' + colours.emperor + ';\n    font-family: ' + typography.family + ';\n    padding-top: 13px;\n    font-size: 14px;\n    font-weight: 500;\n    width: 85%;\n    white-space: nowrap; \n    overflow: hidden;\n    text-overflow: ellipsis;   \n    ';
});

var SpineItemInfoWrapper = _styledComponents2.default.div(function (props) {
    var _ThemeHelper$getTheme3 = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme3.colours,
        palette = _ThemeHelper$getTheme3.palette;

    return '\n            ' + (0, _flexbox.flexbox)() + '\n            height: 48px;\n            border: 1px solid ' + colours.silverDark + ';\n            border-radius: 7px;\n            box-shadow: 10px 5px 5px rgba(0, 0, 0, 0.1);\n            background-color: ' + palette.primary.text + ';\n            margin: 8px 6px;\n        ';
});

exports.getItemStyle = getItemStyle;
exports.getListStyle = getListStyle;
exports.SpineListWrapper = SpineListWrapper;
exports.SpineItemIconWrapper = SpineItemIconWrapper;
exports.SpineItemNameWrapper = SpineItemNameWrapper;
exports.SpineItemInfoWrapper = SpineItemInfoWrapper;

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InputWrapper = exports.TextInputComponent = exports.ClearButton = undefined;

var _templateObject = _taggedTemplateLiteral(['\ndisplay: inherit;\nposition: relative;\n'], ['\ndisplay: inherit;\nposition: relative;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

var _flexbox = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TextInputComponent = _styledComponents2.default.div(_templateObject);

var InputWrapper = _styledComponents2.default.input(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme.colours,
        typography = _ThemeHelper$getTheme.typography;

    return '\n        width: 100%;    \n        height: 23px;\n        padding: 8px 22px;\n        border: 1px solid ' + colours.grey[200] + ';\n        border-radius: 5px;\n        font-family: ' + typography.family + ';\n        font-size: 15px;\n        outline: none;\n\n        &::-webkit-input-placeholder {\n            color: lightgray;\n            font-size: 15px;\n        }\n\n        &:-ms-input-placeholder {\n            color: lightgray;\n            font-size: 15px;\n        }\n    ';
});

var ClearButton = _styledComponents2.default.button(function (props) {
    var _ThemeHelper$getTheme2 = _themeHelper2.default.getTheme(props),
        colours = _ThemeHelper$getTheme2.colours;

    return '\n        @include ' + (0, _flexbox.alignSelf)('center') + '\n        @include ' + (0, _flexbox.justifyContent)('center') + '\n        @include ' + (0, _flexbox.flex)('none') + '\n    \n        position: absolute;\n        right: 0;\n        top: 50%;\n        background-color: ' + colours.grey[400] + ';\n        height: 20px;\n        width: 20px;\n        margin: -10px 5px 5px;\n        border-radius: 100%;\n        border: 0;\n        outline: none;\n        font-size: 10px;\n    \n        & > div {\n            height: 100%;\n        }\n    ';
});
exports.ClearButton = ClearButton;
exports.TextInputComponent = TextInputComponent;
exports.InputWrapper = InputWrapper;

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(52);

var _redux = __webpack_require__(43);

var _reactStyleable = __webpack_require__(218);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _index = __webpack_require__(1114);

var _index2 = _interopRequireDefault(_index);

var _actions = __webpack_require__(95);

var _button = __webpack_require__(37);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toast = function (_Component) {
    _inherits(Toast, _Component);

    function Toast(props) {
        _classCallCheck(this, Toast);

        var _this = _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).call(this, props));

        _this.startTimer = function () {
            _this.setState({ isToastVisible: false, message: '' });
            if (_this.props.isToastVisible) {
                _this.props.hideToast();
                clearTimeout(_this.timeoutInstance);
            }
        };

        _this.hideToast = function () {
            _this.setState({ isToastVisible: false, message: '' });
            _this.props.hideToast();
            clearTimeout(_this.timeoutInstance);
        };

        _this.setToastColor = function () {
            var messageType = _this.props.messageType;

            var color = '';
            switch (messageType) {
                case 'success':
                    color = '#5cb85c';
                    break;
                case 'warning':
                    color = '#e07e02';
                    break;
                default:
                    color = '#c53902';
                    break;
            }

            return color;
        };

        _this.state = { isToastVisible: false, message: '' };
        return _this;
    }

    _createClass(Toast, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isToastVisible !== this.props.isToastVisible) {
                this.setState({ isToastVisible: nextProps.isToastVisible, message: nextProps.message });
                this.timeoutInstance = setTimeout(this.startTimer, 7000);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var toastStyle = {};
            toastStyle.background = this.setToastColor();
            var toastHtmlElement = this.state.isToastVisible ? _react2.default.createElement(
                'div',
                { className: _index2.default.toast, style: toastStyle },
                _react2.default.createElement(
                    _button2.default,
                    { containerClassName: _index2.default.toastContent, handleOnClick: this.hideToast },
                    _react2.default.createElement(
                        'div',
                        { className: _index2.default.message },
                        this.state.message,
                        ' '
                    )
                )
            ) : _react2.default.createElement('div', { className: _index2.default.empty });
            return toastHtmlElement;
        }
    }]);

    return Toast;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    return _extends({}, state, {
        isToastVisible: state.toast.isToastVisible,
        message: state.toast.message,
        messageType: state.toast.messageType
    });
};

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        hideToast: _actions.hideToast
    }, dispatch);
}

Toast.propTypes = {
    message: _propTypes2.default.string,
    isToastVisible: _propTypes2.default.bool,
    hideToast: _propTypes2.default.func,
    messageType: _propTypes2.default.string
};

var StyledToast = (0, _reactStyleable2.default)(_index2.default)(Toast);
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StyledToast);

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actions.SHOW_TOAST:
            return _extends({}, state, { isToastVisible: action.isToastVisible, message: action.message, messageType: action.messageType });

        case actions.HIDE_TOAST:
            return _extends({}, state, { isToastVisible: action.isToastVisible });
        default:
            return _extends({}, state);
    }
};

var _actions = __webpack_require__(95);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    isToastVisible: false,
    message: '',
    messageType: ''
};

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styled = __webpack_require__(504);

var _styled2 = _interopRequireDefault(_styled);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toggle = function (_Component) {
    _inherits(Toggle, _Component);

    function Toggle(props) {
        _classCallCheck(this, Toggle);

        var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));

        _this.state = {
            checked: props.toggled
        };

        _this.handleOnChange = _this.handleOnChange.bind(_this);
        return _this;
    }

    _createClass(Toggle, [{
        key: 'handleOnChange',
        value: function handleOnChange() {
            var _this2 = this;

            this.setState({ checked: !this.state.checked }, function () {
                _this2.props.onChange(_this2.state.checked);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _styled2.default,
                null,
                _react2.default.createElement('input', { checked: this.state.checked, onChange: this.handleOnChange, type: 'checkbox' }),
                _react2.default.createElement('i', null)
            );
        }
    }]);

    return Toggle;
}(_react.Component);

Toggle.defaultProps = {
    toggled: false
};


Toggle.propTypes = {
    toggled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func
};

exports.default = Toggle;

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeHelper = __webpack_require__(18);

var _themeHelper2 = _interopRequireDefault(_themeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleWrapper = _styledComponents2.default.label(function (props) {
    var _ThemeHelper$getTheme = _themeHelper2.default.getTheme(props),
        palette = _ThemeHelper$getTheme.palette;

    return '\ndisplay: inline-block;\ncursor: pointer;\n-webkit-tap-highlight-color: transparent;\n\ni {\n    position: relative;\n    display: inline-block;\n    margin-right: 0.5rem;\n    width: 46px;\n    height: 26px;\n    background-color: #e6e6e6;\n    border-radius: 23px;\n    vertical-align: text-bottom;\n    transition: all 0.3s linear;\n}\n\ni::before {\n    content: "";\n    position: absolute;\n    left: 0;\n    width: 42px;\n    height: 22px;\n    background-color: #fff;\n    border-radius: 11px;\n    transform: translate3d(2px, 2px, 0) scale3d(1, 1, 1);\n    transition: all 0.25s linear;\n}\n\ni::after {\n    content: "";\n    position: absolute;\n    left: 0;\n    width: 22px;\n    height: 22px;\n    background-color: #fff;\n    border-radius: 11px;\n    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24);\n    transform: translate3d(2px, 2px, 0);\n    transition: all 0.2s ease-in-out;\n}\n\n&:active i::after {\n    width: 28px;\n    transform: translate3d(2px, 2px, 0);\n}\n\n&:active input:checked + i::after { transform: translate3d(16px, 2px, 0); }\n\ninput { display: none; }\n\ninput:checked + i { background-color: ' + palette.primary.main + '; }\n\ninput:checked + i::before { transform: translate3d(18px, 2px, 0) scale3d(0, 0, 0); }\n\ninput:checked + i::after { transform: translate3d(22px, 2px, 0); }\n';
});

exports.default = ToggleWrapper;

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withAuth;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(43);

var _reactRedux = __webpack_require__(52);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _actions = __webpack_require__(254);

var actions = _interopRequireWildcard(_actions);

var _alert = __webpack_require__(246);

var _alert2 = _interopRequireDefault(_alert);

var _styled = __webpack_require__(508);

var _styled2 = _interopRequireDefault(_styled);

var _button = __webpack_require__(37);

var _button2 = _interopRequireDefault(_button);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseAuth = function (_Component) {
    _inherits(BaseAuth, _Component);

    function BaseAuth(props) {
        _classCallCheck(this, BaseAuth);

        var _this = _possibleConstructorReturn(this, (BaseAuth.__proto__ || Object.getPrototypeOf(BaseAuth)).call(this, props));

        _this.handleModalButtonOnClick = function () {
            var setAlertModalStatus = _this.props.setAlertModalStatus;


            setAlertModalStatus(false);
        };

        var _this$props = _this.props,
            checkUserIsAuthorised = _this$props.checkUserIsAuthorised,
            authorized = _this$props.authorized;


        if (authorized == null) {
            checkUserIsAuthorised();
        }
        return _this;
    }

    _createClass(BaseAuth, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                authorized = _props.authorized,
                WrappedComponent = _props.WrappedComponent,
                displayModalStatus = _props.displayModalStatus;

            var modalButtons = _react2.default.createElement(
                _styled2.default,
                null,
                _react2.default.createElement(_button2.default, { handleOnClick: this.handleModalButtonOnClick, label: 'OK', primary: true })
            );

            if (authorized === true) {
                return _react2.default.createElement(WrappedComponent, this.props);
            }

            return _react2.default.createElement(_alert2.default, {
                buttons: modalButtons,
                isActive: displayModalStatus,
                subTitle: 'You don\'t seem to have the right permissions to access this module!',
                title: 'Oops',
                warning: true
            });
        }
    }]);

    return BaseAuth;
}(_react.Component);

BaseAuth.propTypes = {
    checkUserIsAuthorised: _propTypes2.default.func,
    setAlertModalStatus: _propTypes2.default.func,
    authorized: _propTypes2.default.bool,
    displayModalStatus: _propTypes2.default.bool,
    WrappedComponent: _propTypes2.default.func
};
function withAuth(WrappedComponent) {
    function mapStateToProps() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        return {
            authorized: state.authorization.authorized,
            displayModalStatus: state.authorization.displayModalStatus,
            WrappedComponent: WrappedComponent
        };
    }

    function mapDispatchToProps(dispatch) {
        return (0, _redux.bindActionCreators)({
            checkUserIsAuthorised: actions.checkUserIsAuthorized,
            setAlertModalStatus: actions.setAlertModalStatus
        }, dispatch);
    }

    return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BaseAuth);
}

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(162);

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    authorized: null,
    displayModalStatus: false
};

var checkAuthorizationSucceed = function checkAuthorizationSucceed(state, authorized) {
    return _extends({}, state, { authorized: authorized, displayModalStatus: !authorized });
};

var checkAuthorizationFailed = function checkAuthorizationFailed(state) {
    return _extends({}, state, { authorized: false, displayModalStatus: true });
};

var setDisplayAlertModalStatus = function setDisplayAlertModalStatus(state, displayModalStatus) {
    return _extends({}, state, { displayModalStatus: displayModalStatus });
};

var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actionTypes.CHECK_USER_IS_AUTHORIZED_SUCCEED:
            return checkAuthorizationSucceed(state, action.payload);
        case actionTypes.CHECK_USER_IS_AUTHORIZED_FAILURE:
            return checkAuthorizationFailed(state);
        case actionTypes.ALERT_MODAL_DISPLAY_STATUS:
            return setDisplayAlertModalStatus(state, action.displayModalStatus);
        default:
            return state;
    }
};

exports.default = reducer;

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkUserIsAuthorized = checkUserIsAuthorized;
exports.checkUserIsAuthorizedSaga = checkUserIsAuthorizedSaga;

var _effects = __webpack_require__(81);

var _api = __webpack_require__(94);

var api = _interopRequireWildcard(_api);

var _actionTypes = __webpack_require__(162);

var actionTypes = _interopRequireWildcard(_actionTypes);

var _actions = __webpack_require__(254);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(checkUserIsAuthorized),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(checkUserIsAuthorizedSaga);

function checkUserIsAuthorized() {
    var payload;
    return regeneratorRuntime.wrap(function checkUserIsAuthorized$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.checkUserIsAuthorised);

                case 2:
                    payload = _context.sent;

                    if (!(payload.status === 200)) {
                        _context.next = 8;
                        break;
                    }

                    _context.next = 6;
                    return (0, _effects.put)(actions.checkUserIsAuthorizedSuccess(true));

                case 6:
                    _context.next = 15;
                    break;

                case 8:
                    if (!(payload.status === 401)) {
                        _context.next = 13;
                        break;
                    }

                    _context.next = 11;
                    return (0, _effects.put)(actions.checkUserIsAuthorizedSuccess(false));

                case 11:
                    _context.next = 15;
                    break;

                case 13:
                    _context.next = 15;
                    return (0, _effects.put)(actions.checkUserIsAuthorizedFailure());

                case 15:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function checkUserIsAuthorizedSaga() {
    return regeneratorRuntime.wrap(function checkUserIsAuthorizedSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actionTypes.CHECK_USER_IS_AUTHORIZED_REQUEST, checkUserIsAuthorized);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n        & > div {\n            margin: 5px;\n        }\n    '], ['\n    ', '\n        & > div {\n            margin: 5px;\n        }\n    ']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _flexbox = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModalButtons = _styledComponents2.default.div(_templateObject, (0, _flexbox.flexbox)());

exports.default = ModalButtons;

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(252);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withModal = function withModal(visibilityProp) {
    return function (WrappedComponent) {
        return function (_Component) {
            _inherits(_class, _Component);

            function _class(props) {
                _classCallCheck(this, _class);

                var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

                _this.close = _this.close.bind(_this);
                _this.isVisible = _this.isVisible.bind(_this);
                _this.state = {
                    isVisible: false
                };
                return _this;
            }

            _createClass(_class, [{
                key: 'isVisible',
                value: function isVisible() {
                    var props = this.props;

                    return props[visibilityProp] !== null && props[visibilityProp] !== undefined && props[visibilityProp] === true;
                }
            }, {
                key: 'close',
                value: function close(closeCallback) {
                    this.setState({
                        isVisible: false
                    });
                    closeCallback();
                }
            }, {
                key: 'render',
                value: function render() {
                    var modalProps = {
                        close: this.close
                    };

                    var modalContent = this.isVisible() ? _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state, {
                        modal: modalProps
                    })) : '';
                    return _react2.default.createElement(
                        _index2.default,
                        { show: this.isVisible() },
                        _react2.default.createElement(
                            'div',
                            { className: 'is-a-modal' },
                            modalContent
                        )
                    );
                }
            }]);

            return _class;
        }(_react.Component);
    };
};

exports.default = withModal;

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-console */

var _querystring = __webpack_require__(332);

var _querystring2 = _interopRequireDefault(_querystring);

var _resources = __webpack_require__(164);

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Configuration = function () {
    function Configuration() {
        _classCallCheck(this, Configuration);
    }

    _createClass(Configuration, null, [{
        key: 'configure',
        value: function configure() {
            // How we want to configure things depends on where this app is running,
            // and where the services we want to access live.
            //
            // 1. When running on a developer's machine, using a mock server we want
            //    to use a hard-coded config from
            //
            //       helpers/local-resource-config.js
            //
            // 2. When running on a developer's machine, but we want to use back-end
            //    services on demo, QA or live, we want to get the configuration from
            //    the configuration of the host app.
            //
            // 3. When running on demo, QA or live, the configuration will be injected
            //    based on the host app's configuration, but can be overridden by query
            //    parameters.
            //
            // We determine which situation we have by looking at the window location
            // URL and the query parameters, and whether there is a pppAppConfig property
            // on the window object.

            var location = window.location;
            var runningOnDeveloperMachine = /^https?:\/\/localhost/.test(location);
            var queryParams = location.search;
            var query = queryParams.replace('?', '');
            var params = _querystring2.default.parse(query);

            if (runningOnDeveloperMachine) {
                Configuration.configureForDeveloperMachine(params);
            } else {
                Configuration.configureForRemoteHost(params);
            }
        }
    }, {
        key: 'configureForDeveloperMachine',
        value: function configureForDeveloperMachine(params) {
            var envName = params.env;

            if (!envName) {
                console.log('Configuration.configureForDeveloperMachine() - you did not provide an "env" query' + ' parameter, so I am assuming you want to talk to live.');

                envName = 'live';
            }

            var credentials = Configuration.getCredentials(params);

            if (envName === 'local' || Configuration.weHaveUsableCredentials(credentials)) {
                _resources2.default.initialise(envName, credentials);
            }
        }
    }, {
        key: 'configureForRemoteHost',
        value: function configureForRemoteHost(params) {
            // eslint-disable-next-line no-underscore-dangle
            var config = window._env_;
            var envName = config.env || 'live';
            var credentials = Configuration.getCredentials(params);

            if (!config.BaseName) {
                console.log('Configuration.configureForRemoteHost() - your pppAppConfig does not' + ' include a BaseName item; we will assume it should be blank.');

                config.BaseName = '';
            }

            if (Configuration.weHaveUsableCredentials(credentials)) {
                _resources2.default.initialise(envName, credentials);
                _resources2.default.env.setConfiguration(config);
            }
        }
    }, {
        key: 'getCredentials',
        value: function getCredentials(params) {
            var credentials = {};
            var items = ['authToken', 'username', 'password'];

            for (var paramName in params) {
                var value = params[paramName];

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;

                        if (paramName.toLowerCase() === item.toLowerCase()) {
                            credentials[item] = value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            return credentials;
        }
    }, {
        key: 'weHaveUsableCredentials',
        value: function weHaveUsableCredentials(credentials) {
            var usableCredentials = false;

            if (credentials.authToken) {
                usableCredentials = true;
            } else if (credentials.username && credentials.password) {
                usableCredentials = true;
            }

            if (!usableCredentials) {
                /* eslint-disable no-console */
                console.warn('EntryApp.configureForDeveloperMachine() - to execute, we need either an authToken or' + ' a username/password pair.  After combining data from window.pppAppConfig and the query' + ' parameters, I still do not have what I need. The app will probably not function correctly if' + ' it requires any 3P resources.');
                /* eslint-disable no-console */
            }

            return usableCredentials;
        }
    }]);

    return Configuration;
}();

exports.default = Configuration;

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(52);

var _redux = __webpack_require__(43);

var _messages = __webpack_require__(512);

var _messages2 = _interopRequireDefault(_messages);

var _actions = __webpack_require__(95);

var _actions2 = __webpack_require__(117);

var _constants = __webpack_require__(19);

var _withLoader = __webpack_require__(116);

var _withLoader2 = _interopRequireDefault(_withLoader);

var _index = __webpack_require__(471);

var _index2 = _interopRequireDefault(_index);

var _linkedCourseModal = __webpack_require__(490);

var _linkedCourseModal2 = _interopRequireDefault(_linkedCourseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * ENUMS
 */
var EDIT = _constants.COURSE_CREATOR_SUB_ROUTES.EDIT,
    COPY = _constants.COURSE_CREATOR_SUB_ROUTES.COPY,
    CLONE = _constants.COURSE_CREATOR_SUB_ROUTES.CLONE;

var CourseCreator = function (_Component) {
    _inherits(CourseCreator, _Component);

    function CourseCreator(props) {
        _classCallCheck(this, CourseCreator);

        var _this = _possibleConstructorReturn(this, (CourseCreator.__proto__ || Object.getPrototypeOf(CourseCreator)).call(this, props));

        _this.updateTopicTree = function (request) {
            _this.props.updateTopicTreeRequest(request);
        };

        _this.publishCourse = function (courseId, productId) {
            _this.props.publishCourse(courseId, productId, _this.context);
        };

        _this.handleOnBack = function () {
            _this.props.cancelValidationErrorsRequest();
            _this.context.router.history.goBack();
        };

        _this.saveCourse = function (request) {
            if (!_this.isEdit) {
                request.courseId = 0;
            }
            if (request.name !== '' && request.productId !== -1 && request.yearGroups.length > 0 && request.topics.length > 0) {
                _this.props.saveCourse(request);
            } else if (request.topics.length === 0) {
                _this.props.showToast(_this.props.intl.formatMessage(_messages2.default.emptyTopicsValidationMessage), 'error');
            } else if (request.yearGroups.length === 0) {
                _this.props.showToast(_this.props.intl.formatMessage(_messages2.default.emptyYearValidationMessage), 'error');
            } else if (request.productId === -1) {
                _this.props.showToast(_this.props.intl.formatMessage(_messages2.default.productNameSelectionMessage), 'error');
            } else {
                _this.props.showToast(_this.props.intl.formatMessage(_messages2.default.courseNameEmptyMessage), 'error');
            }
        };

        var actionType = _this.props.match.params.actionType;


        _this.state = {
            showLinkedCourseModal: false
        };

        _this.isEdit = actionType === EDIT;
        _this.isCopy = actionType === COPY;
        _this.isClone = actionType === CLONE;

        _this.publishCourse = _this.publishCourse.bind(_this);
        return _this;
    }

    _createClass(CourseCreator, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props$match$params = this.props.match.params,
                masterCourseId = _props$match$params.masterCourseId,
                version = _props$match$params.version,
                productId = _props$match$params.productId,
                defaultCourseId = _props$match$params.defaultCourseId;

            // We intercept 3p courses 'Copy or Edit' with LinkedCourseModal to update Master Course

            if (this.isCopy || this.isEdit) {
                // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                    showLinkedCourseModal: true
                });
            }

            if (this.isClone) {
                this.props.getMasterCourserequest(masterCourseId, version);
            }

            if (this.isCopy || this.isEdit) {
                this.props.getDefaultCourse(productId, defaultCourseId, version);
            }

            if (!this.isCopy && !this.isEdit) {
                this.props.cancelValidationErrorsRequest();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            var isValidationError = props.isValidationError,
                showSuccessSaveMessage = props.showSuccessSaveMessage;


            if (isValidationError) {
                this.props.showToast(props.validationMessage, 'error');
            }

            if (showSuccessSaveMessage) {
                this.props.showToast(this.props.intl.formatMessage(_messages2.default.courseSaveSuccessMessage), 'success');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                match = _props.match,
                masterCourse = _props.masterCourse;
            var showLinkedCourseModal = this.state.showLinkedCourseModal;


            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_linkedCourseModal2.default, {
                    hideModal: function hideModal() {
                        return _this2.setState({
                            showLinkedCourseModal: false
                        });
                    },
                    match: match,
                    selectedMasterCourse: masterCourse,
                    show: showLinkedCourseModal
                }),
                _react2.default.createElement(_index2.default, _extends({}, this.props, {
                    handleOnback: this.handleOnBack,
                    handleOnCreateTopic: this.updateTopicTree,
                    handleOnTopicUpdate: this.updateTopicTree,
                    isDefaultCourse: this.isEdit || this.isCopy,
                    publishCourse: this.publishCourse,
                    saveCourse: this.saveCourse
                }))
            );
        }
    }]);

    return CourseCreator;
}(_react.Component);

CourseCreator.contextTypes = {
    router: _propTypes2.default.object
};
CourseCreator.propTypes = {
    cancelValidationErrorsRequest: _propTypes2.default.func,
    courseId: _propTypes2.default.number,
    getDefaultCourse: _propTypes2.default.func,
    getMasterCourserequest: _propTypes2.default.func,
    getMasterCoursesByCountry: _propTypes2.default.func,
    hideToastRequest: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired,
    isValidationError: _propTypes2.default.bool,
    location: _propTypes2.default.object.isRequired,
    masterCourse: _propTypes2.default.object,
    match: _propTypes2.default.object.isRequired,
    publishCourse: _propTypes2.default.func,
    saveCourse: _propTypes2.default.func,
    selectedProductId: _propTypes2.default.number,
    showSuccessSaveMessage: _propTypes2.default.bool,
    showToast: _propTypes2.default.func,
    updateTopicTreeRequest: _propTypes2.default.func,
    validationMessage: _propTypes2.default.string
};
CourseCreator.defaultProps = {
    selectedCourse: {},
    standardFilters: {}
};


function mapStateToProps(state) {
    return {
        masterCourse: state.courseCreator.masterCourse,
        genericCourse: state.courseCreator.genericCourse,
        pppCourse: state.courseCreator.pppCourse,
        assignedSpineItems: state.courseCreator.assignedSpineItems,
        topicTree: state.courseCreator.topicTree,
        hasLoader: state.courseCreator.isSaving || state.courseCreator.isPublishing,
        enableSaveCourse: state.courseCreator.enableSaveCourse,
        enablePublish: state.courseCreator.enablePublish,
        courseId: state.courseCreator.courseId,
        isValidationError: state.courseCreator.isValidationError,
        showSuccessSaveMessage: state.courseCreator.showSuccessSaveMessage,
        isAlertVisible: state.courseCreator.isAlertVisible,
        isDirty: state.courseCreator.courseCreatorIsModified,
        validationMessage: state.courseCreator.validationMessage,
        isFetched: state.courseCreator.isFetched,
        selectedProductId: state.courseCreator.productId,
        standardFilters: state.courseCreator.standardFilters,
        curriculumLevelDescriptions: state.courseCreator.curriculumLevelDescriptions,
        topicTypes: state.courseCreator.topicTypes,
        isPublishModalVisible: state.courseCreator.isPublishModalVisible
    };
}

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getMasterCourserequest: _actions2.getMasterCourserequest,
        getDefaultCourse: _actions2.getDefaultCourse,
        updateTopicTreeRequest: _actions2.updateTopicTreeRequest,
        publishCourse: _actions2.publishCourse,
        saveCourse: _actions2.saveCourse,
        showToast: _actions.showToast,
        cancelValidationErrorsRequest: _actions2.cancelValidationErrorsRequest,
        closeAlertModal: _actions2.closeAlertModal,
        openAlertModal: _actions2.openAlertModal,
        setCourseCreatorAsModified: _actions2.setCourseCreatorAsModified,
        setCourseCreatorAsClean: _actions2.setCourseCreatorAsClean,
        hideToastRequest: _actions2.hideToastRequest,
        showPublishModal: _actions2.showPublishModal
    }, dispatch);
}
var CourseCreatorWithLoader = (0, _withLoader2.default)('hasLoader')(CourseCreator);
exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CourseCreatorWithLoader));

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(15);

exports.default = (0, _reactIntl.defineMessages)({
    header: {
        id: 'app.containers.CourseCreator.header',
        defaultMessage: 'Course Name'
    },
    viewCurriculum: {
        id: 'app.containers.CourseCreator.viewCurriculum',
        defaultMessage: 'View Curriculum'
    },
    createTopic: {
        id: 'app.containers.CourseCreator.createTopic',
        defaultMessage: 'Create New Topic'
    },
    courseNameEmptyMessage: {
        id: 'app.containers.CourseCreator.courseNameEmptyMessage',
        defaultMessage: 'Course name cannot be empty'
    },
    productNameSelectionMessage: {
        id: 'app.containers.CourseCreator.productNameSelectionMessage',
        defaultMessage: 'Please select a product.'
    },
    courseNameValidationMessage: {
        id: 'app.containers.CourseCreator.courseNameValidationMessage',
        defaultMessage: 'Course name already exists'
    },
    courseSaveSuccessMessage: {
        id: 'app.containers.CourseCreator.courseSaveSuccessMessage',
        defaultMessage: 'Course saved successfully'
    },
    emptyYearValidationMessage: {
        id: 'app.containers.CourseCreator.yearValidationMessage',
        defaultMessage: 'Level/Year cannot be empty'
    },
    emptyTopicsValidationMessage: {
        id: 'app.containers.CourseCreator.emptyTopicsValidationMessage',
        defaultMessage: 'Topics cannot be empty'
    }
}); /*
     * CourseCreator Messages
     *
     * This contains all the text for the CourseCreator component.
     */

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actions.GET_MASTER_COURSE_REQUEST:
            {
                return _extends({}, state, {
                    isLoading: true,
                    isLoaded: false,
                    courseId: 0,
                    isFetching: true,
                    isFetched: false,
                    masterCourse: {
                        tree: {
                            nodes: []
                        }
                    },
                    genericCourse: {}
                });
            }
        case actions.GET_MASTER_COURSE_SUCCESS:
            {
                addSpineNodeIdToChildren(action.masterCourse.tree.nodes);
                return _extends({}, state, {
                    masterCourse: action.masterCourse,
                    curriculumLevelDescriptions: action.curriculumLevelDescriptions,
                    productId: action.masterCourse.subjectId,
                    isLoading: false,
                    isLoaded: true,
                    courseCreatorIsModified: false,
                    isFetching: false,
                    isFetched: true,
                    standardFilters: action.strandSubStrands
                });
            }
        case actions.GET_MASTER_COURSE_FAILURE:
            {
                return _extends({}, state, {
                    isLoading: false,
                    isLoaded: false,
                    isFetching: false,
                    isFetched: false
                });
            }
        case actions.UPDATE_TOPIC_TREE_REQUEST:
            {
                return _extends({}, state, {
                    topicTree: action.request,
                    enableSaveCourse: true
                });
            }
        case actions.SAVE_COURSE_REQUEST:
            {
                return _extends({}, state, {
                    isSaving: true,
                    enableSaveCourse: false,
                    isValidationError: false,
                    showSuccessSaveMessage: false
                });
            }
        case actions.SAVE_COURSE_SUCCESS:
            {
                return _extends({}, state, {
                    isSaving: false,
                    enableSaveCourse: false,
                    enablePublish: true,
                    showSuccessSaveMessage: true,
                    courseId: action.newCourseId,
                    courseCreatorIsModified: false
                });
            }
        case actions.SAVE_COURSE_VALIDATION_ERROR:
            {
                return _extends({}, state, {
                    isSaving: false,
                    enableSaveCourse: true,
                    enablePublish: false,
                    isValidationError: true,
                    validationMessage: action.message
                });
            }
        case actions.SAVE_COURSE_FAILURE:
            {
                return _extends({}, state, {
                    isSaving: false,
                    enableSaveCourse: true
                });
            }
        case actions.PUBLISH_COURSE_REQUEST:
            {
                return _extends({}, state, {
                    isPublishing: true,
                    isPublished: false,
                    enablePublish: false,
                    showSuccessSaveMessage: false
                });
            }
        case actions.PUBLISH_COURSE_SUCCESS:
            {
                return _extends({}, state, {
                    isPublishing: false,
                    isPublished: true
                });
            }
        case actions.PUBLISH_COURSE_FAILURE:
            {
                return _extends({}, state, {
                    isPublishing: false,
                    isPublished: false,
                    enablePublish: true
                });
            }
        case actions.CANCEL_VALIDATION_ERRORS_REQUEST:
            {
                return _extends({}, state, {
                    isValidationError: false,
                    showSuccessSaveMessage: false,
                    enableSaveCourse: false,
                    enablePublish: false
                });
            }
        case actions.GET_DEFAULT_COURSE_REQUEST:
            {
                return _extends({}, state, {
                    isFetching: true,
                    isFetched: false,
                    courseId: 0,
                    pppCourse: {}
                });
            }
        case actions.GET_DEFAULT_COURSE_SUCCESS:
            {
                addSpineNodeIdToChildren(action.masterCourse.tree.nodes);
                return _extends({}, state, {
                    masterCourse: action.masterCourse,
                    genericCourse: action.genericCourse,
                    curriculumLevelDescriptions: action.curriculumLevelDescriptions,
                    assignedSpineItems: action.assignedSpineItems,
                    pppCourse: action.pppCourse,
                    isFetching: false,
                    isFetched: true,
                    standardFilters: action.strandSubStrands
                });
            }
        case actions.GET_DEFAULT_COURSE_FAILURE:
            {
                return _extends({}, state, {
                    isFetching: false,
                    isFetched: false
                });
            }
        case actions.OPEN_ALERT_MODAL:
            {
                return _extends({}, state, {
                    isAlertVisible: true
                });
            }
        case actions.CLOSE_ALERT_MODAL:
            {
                return _extends({}, state, {
                    isAlertVisible: false
                });
            }
        case actions.SET_COURSE_CREATOR_AS_MODIFIED:
            {
                return _extends({}, state, {
                    enableSaveCourse: true,
                    enablePublish: false,
                    courseCreatorIsModified: true
                });
            }
        case actions.SET_COURSE_CREATOR_AS_CLEAN:
            {
                return _extends({}, state, {
                    courseCreatorIsModified: false,
                    isAlertVisible: false
                });
            }
        case actions.HIDE_TOAST:
            {
                return _extends({}, state, {
                    showSuccessSaveMessage: false,
                    isValidationError: false
                });
            }
        case actions.SHOW_PUBLISH_MODAL:
            {
                return _extends({}, state, {
                    isPublishModalVisible: action.showModal
                });
            }
        default:
            return _extends({}, state);
    }
};

var _actions = __webpack_require__(117);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
    courseId: 0,
    productId: 0,
    masterCourse: {
        tree: {
            nodes: []
        }
    },
    topicTree: { childNodes: [] },
    enableSaveCourse: false,
    enablePublish: false,
    isValidationError: false,
    showSuccessSaveMessage: false,
    validationMessage: '',
    standardFilters: {},
    curriculumLevelDescriptions: [],
    isPublishModalVisible: false,
    topicTypes: [{ value: 'Descriptor', label: 'Descriptor' }, { value: 'Strand', label: 'Strand' }, { value: 'Standard', label: 'Standard' }, { value: 'LearningJourney', label: 'Learning Journey' }, { value: 'Step', label: 'Step' }]
};

var addSpineNodeIdToChildren = function addSpineNodeIdToChildren(nodes) {
    nodes.map(function (node) {
        // add standard code
        node.title = node.code !== '' ? node.code + ': ' + node.title : node.title;

        if (node.spineNodes !== null) {
            node.spineNodes.map(function (spineNode) {
                spineNode.title = spineNode.id + ': ' + spineNode.description;
                return spineNode;
            });
            node.children = [].concat(_toConsumableArray(node.spineNodes), _toConsumableArray(node.children));
            return node;
        }

        addSpineNodeIdToChildren(node.children);
        return node;
    });
};

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMasterCourse = getMasterCourse;
exports.getMasterCourseSaga = getMasterCourseSaga;
exports.saveCourse = saveCourse;
exports.saveCourseSaga = saveCourseSaga;
exports.publishCourse = publishCourse;
exports.publishCourseSaga = publishCourseSaga;
exports.getDefaultCourse = getDefaultCourse;
exports.getDefaultCourseSaga = getDefaultCourseSaga;

var _effects = __webpack_require__(81);

var _actions = __webpack_require__(117);

var actions = _interopRequireWildcard(_actions);

var _api = __webpack_require__(94);

var api = _interopRequireWildcard(_api);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getMasterCourse),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getMasterCourseSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(saveCourse),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(saveCourseSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(publishCourse),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(publishCourseSaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(getDefaultCourse),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(getDefaultCourseSaga);

function getMasterCourse(_ref) {
    var masterCourseId = _ref.masterCourseId,
        version = _ref.version;
    var payload;
    return regeneratorRuntime.wrap(function getMasterCourse$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.getMasterCourse, masterCourseId, version);

                case 2:
                    payload = _context.sent;

                    if (!(payload.status === 200)) {
                        _context.next = 8;
                        break;
                    }

                    _context.next = 6;
                    return (0, _effects.put)(actions.getMasterCourseSuccess(payload.data));

                case 6:
                    _context.next = 10;
                    break;

                case 8:
                    _context.next = 10;
                    return (0, _effects.put)(actions.getMasterCourseFailure());

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function getMasterCourseSaga() {
    return regeneratorRuntime.wrap(function getMasterCourseSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_MASTER_COURSE_REQUEST, getMasterCourse);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function saveCourse(_ref2) {
    var request = _ref2.request;
    var payload;
    return regeneratorRuntime.wrap(function saveCourse$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.saveDefaultCourse, request);

                case 2:
                    payload = _context3.sent;

                    if (!(payload.status === 200)) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 6;
                    return (0, _effects.put)(actions.saveCourseSuccess(payload.data));

                case 6:
                    _context3.next = 15;
                    break;

                case 8:
                    if (!(payload.status === 400 || payload.status === 409)) {
                        _context3.next = 13;
                        break;
                    }

                    _context3.next = 11;
                    return (0, _effects.put)(actions.saveCourseValidationError(payload.message));

                case 11:
                    _context3.next = 15;
                    break;

                case 13:
                    _context3.next = 15;
                    return (0, _effects.put)(actions.saveCourseFailure());

                case 15:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function saveCourseSaga() {
    return regeneratorRuntime.wrap(function saveCourseSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.SAVE_COURSE_REQUEST, saveCourse);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function publishCourse(_ref3) {
    var courseId = _ref3.courseId,
        productId = _ref3.productId,
        context = _ref3.context;
    var payload;
    return regeneratorRuntime.wrap(function publishCourse$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.call)(api.publishDefaultCourse, { courseId: courseId, productId: productId });

                case 2:
                    payload = _context5.sent;

                    if (!(payload.status === 200)) {
                        _context5.next = 8;
                        break;
                    }

                    _context5.next = 6;
                    return (0, _effects.put)(actions.publishCourseSuccess(context));

                case 6:
                    _context5.next = 10;
                    break;

                case 8:
                    _context5.next = 10;
                    return (0, _effects.put)(actions.publishCourseFailure());

                case 10:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function publishCourseSaga() {
    return regeneratorRuntime.wrap(function publishCourseSaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.PUBLISH_COURSE_REQUEST, publishCourse);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function getDefaultCourse(_ref4) {
    var productId = _ref4.productId,
        courseId = _ref4.courseId,
        version = _ref4.version,
        switchToMasterCourseId = _ref4.switchToMasterCourseId,
        switchToMasterCourseVersion = _ref4.switchToMasterCourseVersion;
    var payload;
    return regeneratorRuntime.wrap(function getDefaultCourse$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.call)(api.getDefaultCourse, {
                        productId: productId,
                        courseId: courseId,
                        version: version,
                        switchToMasterCourseId: switchToMasterCourseId,
                        switchToMasterCourseVersion: switchToMasterCourseVersion
                    });

                case 2:
                    payload = _context7.sent;

                    if (!(payload.status === 200)) {
                        _context7.next = 8;
                        break;
                    }

                    _context7.next = 6;
                    return (0, _effects.put)(actions.getDefaultCourseSuccess(payload.data));

                case 6:
                    _context7.next = 10;
                    break;

                case 8:
                    _context7.next = 10;
                    return (0, _effects.put)(actions.getDefaultCourseFailure());

                case 10:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function getDefaultCourseSaga() {
    return regeneratorRuntime.wrap(function getDefaultCourseSaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_DEFAULT_COURSE_REQUEST, getDefaultCourse);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = __webpack_require__(37);

var _button2 = _interopRequireDefault(_button);

var _svgIcon = __webpack_require__(64);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _styled = __webpack_require__(516);

var _ok = __webpack_require__(1123);

var _ok2 = _interopRequireDefault(_ok);

var _cancel = __webpack_require__(1122);

var _cancel2 = _interopRequireDefault(_cancel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArchiveCourse = function (_PureComponent) {
    _inherits(ArchiveCourse, _PureComponent);

    function ArchiveCourse(props) {
        _classCallCheck(this, ArchiveCourse);

        var _this = _possibleConstructorReturn(this, (ArchiveCourse.__proto__ || Object.getPrototypeOf(ArchiveCourse)).call(this, props));

        _this.showArchiveCourseConfirmation = function (status) {
            _this.setState({
                showArchiveConfirmation: status
            });
        };

        _this.archiveCourse = function () {
            var _this$props$selectedC = _this.props.selectedCourse,
                productId = _this$props$selectedC.productId,
                courseId = _this$props$selectedC.id,
                courseVersion = _this$props$selectedC.version;

            _this.props.archiveSelectedCourse({ productId: productId, courseId: courseId, courseVersion: courseVersion });
        };

        _this.state = {
            showArchiveConfirmation: false
        };
        return _this;
    }

    _createClass(ArchiveCourse, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.state.showArchiveConfirmation) {
                return _react2.default.createElement(
                    _styled.ConfirmationContainer,
                    null,
                    _react2.default.createElement(
                        _styled.CancelIconContainer,
                        { onClick: function onClick() {
                                return _this2.showArchiveCourseConfirmation(false);
                            } },
                        _react2.default.createElement(_svgIcon2.default, { icon: _cancel2.default })
                    ),
                    _react2.default.createElement(
                        _styled.OkIconContainer,
                        { onClick: this.archiveCourse },
                        _react2.default.createElement(_svgIcon2.default, { icon: _ok2.default })
                    )
                );
            }

            return _react2.default.createElement(_button2.default, { handleOnClick: function handleOnClick() {
                    return _this2.showArchiveCourseConfirmation(true);
                }, label: 'Archive', warning: true });
        }
    }]);

    return ArchiveCourse;
}(_react.PureComponent);

ArchiveCourse.propTypes = {
    archiveSelectedCourse: _propTypes2.default.func.isRequired,
    selectedCourse: _propTypes2.default.object.isRequired
};

exports.default = ArchiveCourse;

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OkIconContainer = exports.CancelIconContainer = exports.ConfirmationContainer = undefined;

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _flexbox = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmationContainer = _styledComponents2.default.div(function () {
    return '\n    ' + (0, _flexbox.flexbox)() + '\n    ' + (0, _flexbox.justifyContent)('center') + '\n    ' + (0, _flexbox.alignItems)('center') + '\n \n    position: relative;\n    width: 80px;\n    height: 36px;\n';
});

var CancelIconContainer = _styledComponents2.default.div(function () {
    return '\n    ' + (0, _flexbox.flexbox)() + '\n \n    height: 100%;\n    cursor: pointer;\n    margin-right: 5px;\n    border: 1px solid #FCB290;\n    border-radius: 20%;\n\n    &:hover {\n        background-color: #FCB290;\n        \n    }\n';
});

var OkIconContainer = (0, _styledComponents2.default)(CancelIconContainer)(function () {
    return '\n    border: 1px solid #9BE49D;\n\n    &:hover {\n        background-color: #9BE49D;\n    }\n';
});

exports.ConfirmationContainer = ConfirmationContainer;
exports.CancelIconContainer = CancelIconContainer;
exports.OkIconContainer = OkIconContainer;

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ThreePCourses = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(52);

var _redux = __webpack_require__(43);

var _reactIntl = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = __webpack_require__(1116);

var _index2 = _interopRequireDefault(_index);

var _messages = __webpack_require__(518);

var _messages2 = _interopRequireDefault(_messages);

var _constants = __webpack_require__(19);

var _actions = __webpack_require__(96);

var _actions2 = __webpack_require__(118);

var _utils = __webpack_require__(97);

var _courseFilter = __webpack_require__(249);

var _courseFilter2 = _interopRequireDefault(_courseFilter);

var _button = __webpack_require__(37);

var _button2 = _interopRequireDefault(_button);

var _dropdownList = __webpack_require__(63);

var _dropdownList2 = _interopRequireDefault(_dropdownList);

var _textInput = __webpack_require__(161);

var _textInput2 = _interopRequireDefault(_textInput);

var _withLoader = __webpack_require__(116);

var _withLoader2 = _interopRequireDefault(_withLoader);

var _header = __webpack_require__(115);

var _header2 = _interopRequireDefault(_header);

var _courseTypeSelector = __webpack_require__(250);

var _courseTypeSelector2 = _interopRequireDefault(_courseTypeSelector);

var _container = __webpack_require__(114);

var _container2 = _interopRequireDefault(_container);

var _dataTable = __webpack_require__(251);

var _archiveCourse = __webpack_require__(515);

var _archiveCourse2 = _interopRequireDefault(_archiveCourse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThreePCourses = exports.ThreePCourses = function (_PureComponent) {
    _inherits(ThreePCourses, _PureComponent);

    function ThreePCourses(props) {
        _classCallCheck(this, ThreePCourses);

        var _this = _possibleConstructorReturn(this, (ThreePCourses.__proto__ || Object.getPrototypeOf(ThreePCourses)).call(this, props));

        _this.editCourse = function (selectedItem, actionType) {
            var id = selectedItem.id,
                version = selectedItem.version,
                productId = selectedItem.productId;

            _this.context.router.history.push('' + _constants.COURSE_CREATOR_ROUTE + _constants.DEFAULT_COURSES_ROUTE + '/' + actionType + '/' + productId + '/' + id + '/version/' + version);
        };

        _this.archiveCourse = function (selectedCourse) {
            var productId = selectedCourse.productId,
                courseId = selectedCourse.courseId,
                courseVersion = selectedCourse.courseVersion;

            _this.props.archiveSelectedCourse({ productId: productId, courseId: courseId, courseVersion: courseVersion });
            _this.textInputRef.current.handleClearText();
        };

        _this.handleOnCourseTypeChange = function (value) {
            _this.props.applySearchFilter('country', '');
            _this.setState({
                selectedCourseType: Number(value)
            });
        };

        _this.editCourse = _this.editCourse.bind(_this);
        _this.onSubjectChange = _this.onSubjectChange.bind(_this);
        _this.handleOnCourseTypeChange = _this.handleOnCourseTypeChange.bind(_this);
        _this.textInputRef = _react2.default.createRef();
        _this.state = {
            selectedCourseType: _constants.DEFAULT_CURRICULUM_TYPE_ID
        };

        _this.courseTypeOptions = [{ value: 'Curriculum type', key: -1 }, { value: 'Global', key: 0 }, { value: 'Country Specific', key: 2 }];

        _this.globalCourseId = 0;
        return _this;
    }

    _createClass(ThreePCourses, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var isCountryLoaded = this.props.isCountryLoaded;

            if (!isCountryLoaded) {
                this.props.getMasterCoursesCountries();
            }
            this.props.getDefaultCourses(this.props.selectedProductId);
        }
    }, {
        key: 'onSubjectChange',
        value: function onSubjectChange(name, value) {
            this.props.getDefaultCourses(parseInt(value, 10));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var emptyContent = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'b',
                    null,
                    this.props.intl.formatMessage(_messages2.default.emptyMessage)
                )
            );
            var headers = [{
                id: 'courseName',
                accessor: function accessor(course) {
                    return course.courseName;
                },
                Header: 'Course Name',
                sort: { sortAs: 'string', sortDir: 'desc' },
                Cell: _dataTable.CellRenderer
            }, {
                id: 'version',
                accessor: function accessor(course) {
                    return course.id + 'v' + course.version;
                },
                Header: 'Version',
                width: 80,
                Cell: _dataTable.CellRenderer,
                sortable: false
            }, {
                id: 'Subject',
                accessor: function accessor() {
                    return (0, _utils.getProductList)(_this2.props.selectedProductId);
                },
                Header: 'Product',
                width: 150,
                Cell: _dataTable.CellRenderer,
                sortable: false
            }, {
                id: 'country',
                accessor: function accessor(course) {
                    return course.country;
                },
                Header: 'Country',
                width: 150,
                Cell: _dataTable.CellRenderer
            }, { accessor: 'state', Header: 'State', Cell: _dataTable.CellRenderer, width: 100 }, {
                id: 'dateModified',
                accessor: function accessor(course) {
                    return course.dateModified;
                },
                Header: 'Date Modified',
                sort: { sortAs: 'string', sortDir: 'desc' },
                Cell: _dataTable.DateTimeRenderer,
                width: 200
            }, {
                id: 'statusLabel',
                accessor: function accessor(course) {
                    return course.statusLabel;
                },
                Header: 'Status',
                Cell: _dataTable.CellRenderer,
                width: 120
            }, {
                id: 'hasChanges',
                accessor: function accessor(course) {
                    return course.hasChanges;
                },
                Header: 'Changes',
                width: 100,
                Cell: _dataTable.CellRenderer,
                sortable: false
            }, {
                id: 'action',
                accessor: function accessor(course) {
                    return course.action;
                },
                Header: 'Action',
                sortable: false,
                width: 250
            }];

            var courseActions = function courseActions(item) {
                var COPY = _constants.COURSE_CREATOR_SUB_ROUTES.COPY,
                    EDIT = _constants.COURSE_CREATOR_SUB_ROUTES.EDIT;


                if (Number(_this2.props.status) !== _constants.ARCHIVE_STATUS_KEY) {
                    return _react2.default.createElement(
                        'div',
                        { className: _index2.default.actionButtons },
                        _react2.default.createElement(
                            'div',
                            null,
                            Number(item.status) === _constants.RETIRED_COURSE_ID ? _react2.default.createElement('span', null) : _react2.default.createElement(_button2.default, { basic: true, handleOnClick: function handleOnClick() {
                                    return _this2.editCourse(item, COPY);
                                }, label: 'Copy' })
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_button2.default, {
                                basic: true,
                                handleOnClick: function handleOnClick() {
                                    return _this2.editCourse(item, EDIT);
                                },
                                label: Number(item.status) === _constants.RETIRED_COURSE_ID ? 'View' : 'Edit' })
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            Number(item.status) === _constants.RETIRED_COURSE_ID ? _react2.default.createElement('span', null) : _react2.default.createElement(_archiveCourse2.default, {
                                archiveSelectedCourse: _this2.archiveCourse,
                                selectedCourse: item,
                                textInputRef: _this2.textInputRef
                            })
                        )
                    );
                }return null;
            };

            var filteredCourses = this.props.courses.filter(function (item) {
                if (item.status && (Number(_this2.props.status) === _constants.ARCHIVE_STATUS_KEY || Number(_this2.props.status) === _constants.RETIRED_COURSE_ID ? true : Number(item.status) !== _constants.ARCHIVE_STATUS_KEY && Number(item.status) !== _constants.RETIRED_COURSE_ID)) {
                    item.hasChanges = item.changes ? 'YES' : 'NO';
                    item.statusLabel = _constants.STATUSES_AS_KEY[item.status];
                    item.action = _react2.default.createElement(
                        _dataTable.ActionRenderer,
                        null,
                        courseActions(item)
                    );
                    return item;
                }return null;
            });

            if (this.state.selectedCourseType !== _constants.DEFAULT_CURRICULUM_TYPE_ID) {
                filteredCourses = filteredCourses.filter(function (course) {
                    return course.accessLevelType === _this2.state.selectedCourseType;
                });
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_header2.default, { subtitle: '3P Courses', title: 'Internal Course Manager' }),
                _react2.default.createElement(
                    _container2.default,
                    null,
                    _react2.default.createElement(
                        _courseFilter2.default,
                        null,
                        _react2.default.createElement(_textInput2.default, {
                            clearText: true,
                            handleOnChange: function handleOnChange(value) {
                                return _this2.props.applySearchFilter('search', value);
                            },
                            ref: this.textInputRef }),
                        _react2.default.createElement(_dropdownList2.default, {
                            onChange: this.onSubjectChange,
                            optionKey: 'id',
                            options: (0, _utils.getProductList)(),
                            optionText: 'name',
                            value: this.props.selectedProductId }),
                        _react2.default.createElement(_courseTypeSelector2.default, {
                            onChange: this.handleOnCourseTypeChange,
                            options: this.courseTypeOptions
                        }),
                        _react2.default.createElement(_dropdownList2.default, {
                            disabled: Number(this.state.selectedCourseType) === this.globalCourseId,
                            name: 'country',
                            onChange: this.props.applySearchFilter,
                            optionKey: 'name',
                            options: this.props.countries,
                            optionText: 'name',
                            placeholder: 'All countries',
                            value: this.props.country }),
                        _react2.default.createElement(_dropdownList2.default, {
                            name: 'year',
                            onChange: this.props.applySearchFilter,
                            optionKey: 'id',
                            options: _constants.YEAR_GROUPS,
                            placeholder: 'All years',
                            value: this.props.year }),
                        _react2.default.createElement(_dropdownList2.default, {
                            name: 'status',
                            onChange: this.props.applySearchFilter,
                            optionKey: 'id',
                            options: _constants.STATUSES,
                            placeholder: 'Status',
                            value: this.props.status })
                    ),
                    _react2.default.createElement(_dataTable.DataTable, {
                        className: '-striped',
                        columns: headers,
                        data: filteredCourses,
                        defaultPageSize: 50,
                        noDataText: emptyContent })
                )
            );
        }
    }]);

    return ThreePCourses;
}(_react.PureComponent);

ThreePCourses.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    getMasterCoursesCountries: _propTypes2.default.func,
    countries: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
    isCountryLoaded: _propTypes2.default.bool,
    getDefaultCourses: _propTypes2.default.func,
    courses: _propTypes2.default.arrayOf(_propTypes2.default.object),
    applySearchFilter: _propTypes2.default.func,
    country: _propTypes2.default.string,
    year: _propTypes2.default.string,
    status: _propTypes2.default.string,
    selectedProductId: _propTypes2.default.number,
    archiveSelectedCourse: _propTypes2.default.func
};
ThreePCourses.contextTypes = {
    router: _propTypes2.default.object.isRequired
};


function mapStateToProps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return {
        countries: state.masterCourse.countries.items || [],
        isCountryLoaded: state.masterCourse.countries.isLoaded,
        courses: state.defaultCourse.filteredCourses,
        isLoading: state.defaultCourse.isLoading,
        country: state.defaultCourse.filters.country,
        year: state.defaultCourse.filters.year,
        status: state.defaultCourse.filters.status,
        selectedProductId: state.defaultCourse.selectedProductId
    };
}

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getMasterCoursesCountries: _actions.getMasterCoursesCountries,
        getDefaultCourses: _actions2.getDefaultCourses,
        applySearchFilter: _actions2.applySearchFilter,
        archiveSelectedCourse: _actions2.archiveSelectedCourse
    }, dispatch);
}

var ThreePCoursesWithLoader = (0, _withLoader2.default)('isLoading')(ThreePCourses);
exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ThreePCoursesWithLoader));

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(15);

exports.default = (0, _reactIntl.defineMessages)({
    emptyMessage: {
        id: 'app.containers.dataGrid.emptyMessage',
        defaultMessage: 'No data found!'
    },
    subject: {
        id: 'app.containers.defaultCourses.subject',
        defaultMessage: 'Subject'
    }
}); /*
     * PrivacySettings Messages
     *
     * This contains all the text for the PrivacySettings component.
     */

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actions.GET_DEFAULT_COURSES_REQUEST:
            {
                return _extends({}, state, {
                    selectedProductId: action.productId,
                    courses: [],
                    filteredCourses: [],
                    isLoaded: false,
                    isLoading: true
                });
            }
        case actions.GET_DEFAULT_COURSES_SUCCESS:
            {
                var courses = action.courses;

                var genericCourses = courses.filter(function (course) {
                    return parseInt(course.status, 10) === _constants.PUBLISHED_COURSES;
                });

                return _extends({}, state, {
                    courses: courses,
                    genericCourses: genericCourses,
                    isLoaded: true,
                    isLoading: false
                });
            }
        case actions.GET_DEFAULT_COURSES_FAILURE:
            {
                return _extends({}, state, {
                    isLoaded: false,
                    isLoading: false
                });
            }
        case actions.APPLY_SEARCH_FILTER:
            {
                var updatedfilters = _extends({}, state.filters);
                updatedfilters[action.label] = action.value;

                return _extends({}, state, {
                    filters: updatedfilters
                });
            }
        case actions.RESET_SEARCH_FILTER:
            {
                return _extends({}, state, {
                    filters: _extends({}, state.filters, {
                        search: ''
                    })
                });
            }
        case actions.FILTER_DEFAULT_COURSES:
            {
                return _extends({}, state);
            }
        case actions.FILTER_DEFAULT_SUCCESS:
            {
                return _extends({}, state, {
                    filteredCourses: action.filteredCourses
                });
            }
        case actions.ARCHIVE_SELECTED_COURSE_REQUEST:
            {
                return _extends({}, state, {
                    isLoaded: false,
                    isLoading: true
                });
            }
        case actions.ARCHIVE_SELECTED_COURSE_FAILURE:
            {
                return _extends({}, state, {
                    isLoaded: false,
                    isLoading: false
                });
            }
        default:
            return _extends({}, state);
    }
};

var _actions = __webpack_require__(118);

var actions = _interopRequireWildcard(_actions);

var _constants = __webpack_require__(19);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    filteredCourses: [],
    filters: {
        search: '',
        country: _constants.DROPDOWN_DEFAULT_COUNTRY_LONG,
        status: '',
        year: ''
    },
    selectedProductId: 1,
    courses: [],
    genericCourses: []
};

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDefaultCourses = getDefaultCourses;
exports.getDefaultCoursesSaga = getDefaultCoursesSaga;
exports.applySearchFilter = applySearchFilter;
exports.applySearchFilterSaga = applySearchFilterSaga;
exports.filterDefaultCourses = filterDefaultCourses;
exports.filterDefaultCoursesSaga = filterDefaultCoursesSaga;
exports.archiveSelectedCourse = archiveSelectedCourse;
exports.archiveSelectedCourseSaga = archiveSelectedCourseSaga;

var _effects = __webpack_require__(81);

var _filter = __webpack_require__(202);

var _filter2 = _interopRequireDefault(_filter);

var _actions = __webpack_require__(118);

var actions = _interopRequireWildcard(_actions);

var _api = __webpack_require__(94);

var api = _interopRequireWildcard(_api);

var _utils = __webpack_require__(97);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getDefaultCourses),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getDefaultCoursesSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(applySearchFilter),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(applySearchFilterSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(filterDefaultCourses),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(filterDefaultCoursesSaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(archiveSelectedCourse),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(archiveSelectedCourseSaga);

function getDefaultCourses(productId) {
    var payload, courses;
    return regeneratorRuntime.wrap(function getDefaultCourses$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.put)(actions.resetSearchFilter());

                case 2:
                    _context.next = 4;
                    return (0, _effects.call)(api.getDefaultCourses, productId);

                case 4:
                    payload = _context.sent;

                    if (!(payload.status === 200)) {
                        _context.next = 13;
                        break;
                    }

                    courses = payload.data.map(function (item) {
                        var yearGroups = [];
                        item.yearGroups.forEach(function (yearGroup) {
                            yearGroups.push(yearGroup.yearGroupEnum);
                        });
                        item.yearGroupCombined = yearGroups.join(', ');
                        item.yearGroupList = yearGroups;
                        return item;
                    });
                    _context.next = 9;
                    return (0, _effects.put)(actions.getDefaultCoursesSuccess(courses));

                case 9:
                    _context.next = 11;
                    return (0, _effects.put)(actions.filterDefaultCourses());

                case 11:
                    _context.next = 15;
                    break;

                case 13:
                    _context.next = 15;
                    return (0, _effects.put)(actions.getDefaultCoursesFailure());

                case 15:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function getDefaultCoursesSaga() {
    return regeneratorRuntime.wrap(function getDefaultCoursesSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_DEFAULT_COURSES_REQUEST, getDefaultCourses);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function applySearchFilter(_ref) {
    var label = _ref.label,
        value = _ref.value;

    var _ref2, defaultCourse;

    return regeneratorRuntime.wrap(function applySearchFilter$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.select)();

                case 2:
                    _ref2 = _context3.sent;
                    defaultCourse = _ref2.defaultCourse;

                    defaultCourse.filters[label] = value;
                    _context3.next = 7;
                    return (0, _effects.put)(actions.filterDefaultCourses());

                case 7:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function applySearchFilterSaga() {
    return regeneratorRuntime.wrap(function applySearchFilterSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.APPLY_SEARCH_FILTER, applySearchFilter);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function filterDefaultCourses() {
    var _ref3, defaultCourse, filters, courses, search, country, year, status, results;

    return regeneratorRuntime.wrap(function filterDefaultCourses$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.select)();

                case 2:
                    _ref3 = _context5.sent;
                    defaultCourse = _ref3.defaultCourse;
                    filters = defaultCourse.filters, courses = defaultCourse.courses;
                    search = filters.search, country = filters.country, year = filters.year, status = filters.status;
                    results = (0, _utils.searchByText)(courses, search);


                    if (country !== '') {
                        results = (0, _filter2.default)(results, { country: country });
                    }
                    if (year) {
                        results = (0, _filter2.default)(results, function (item) {
                            return item.yearGroupList.indexOf(parseInt(year, 10)) !== -1;
                        });
                    }
                    if (status) {
                        results = (0, _filter2.default)(results, function (item) {
                            return item.status === status;
                        });
                    }
                    _context5.next = 12;
                    return (0, _effects.put)(actions.filterDefaultCoursesSuccess(results));

                case 12:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function filterDefaultCoursesSaga() {
    return regeneratorRuntime.wrap(function filterDefaultCoursesSaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.FILTER_DEFAULT_COURSES, filterDefaultCourses);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function archiveSelectedCourse(_ref4) {
    var productId = _ref4.productId,
        courseId = _ref4.courseId,
        courseVersion = _ref4.courseVersion;
    var payload;
    return regeneratorRuntime.wrap(function archiveSelectedCourse$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.call)(api.archiveSelectedCourse, productId, courseId, courseVersion);

                case 2:
                    payload = _context7.sent;

                    if (!(payload.status === 200)) {
                        _context7.next = 8;
                        break;
                    }

                    _context7.next = 6;
                    return (0, _effects.put)(actions.archiveSelectedCourseSuccess(productId));

                case 6:
                    _context7.next = 10;
                    break;

                case 8:
                    _context7.next = 10;
                    return (0, _effects.put)(actions.archiveSelectedCourseFailure());

                case 10:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function archiveSelectedCourseSaga() {
    return regeneratorRuntime.wrap(function archiveSelectedCourseSaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actions.ARCHIVE_SELECTED_COURSE_REQUEST, archiveSelectedCourse);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 *
 * LanguageProvider constants
 *
 */
var CHANGE_LOCALE = 'app/LanguageProvider/CHANGE_LOCALE';
exports.default = CHANGE_LOCALE;

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LanguageProvider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(52);

var _reselect = __webpack_require__(378);

var _reactIntl = __webpack_require__(15);

var _selectors = __webpack_require__(524);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LanguageProvider
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * this component connects the redux state language locale to the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IntlProvider component and i18n messages (loaded from `app/translations`)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var LanguageProvider = exports.LanguageProvider = function (_PureComponent) {
    _inherits(LanguageProvider, _PureComponent);

    function LanguageProvider() {
        _classCallCheck(this, LanguageProvider);

        return _possibleConstructorReturn(this, (LanguageProvider.__proto__ || Object.getPrototypeOf(LanguageProvider)).apply(this, arguments));
    }

    _createClass(LanguageProvider, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactIntl.IntlProvider,
                {
                    key: this.props.locale,
                    locale: this.props.locale,
                    messages: this.props.messages[this.props.locale]
                },
                _react2.default.Children.only(this.props.children)
            );
        }
    }]);

    return LanguageProvider;
}(_react.PureComponent);

LanguageProvider.propTypes = {
    locale: _propTypes2.default.string,
    messages: _propTypes2.default.object,
    children: _propTypes2.default.element.isRequired
};

var mapStateToProps = (0, _reselect.createSelector)((0, _selectors.makeSelectLocale)(), function (locale) {
    return {
        locale: locale
    };
});

exports.default = (0, _reactRedux.connect)(mapStateToProps)(LanguageProvider);

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * LanguageProvider reducer
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   */

var _constants = __webpack_require__(521);

var _constants2 = _interopRequireDefault(_constants);

var _i18n = __webpack_require__(255);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
    locale: _i18n.DEFAULT_LOCALE
};

function languageProviderReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _constants2.default:
            {
                return _extends({}, state, { locale: action.locale });
            }
        default:
            return state;
    }
}

exports.default = languageProviderReducer;

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSelectLocale = exports.selectLanguage = undefined;

var _reselect = __webpack_require__(378);

/**
 * Direct selector to the languageToggle state domain
 */
var selectLanguage = function selectLanguage(state) {
  return state.language;
};

/**
 * Select the language locale
 */

var makeSelectLocale = function makeSelectLocale() {
  return (0, _reselect.createSelector)(selectLanguage, function (languageState) {
    return languageState.locale;
  });
};

exports.selectLanguage = selectLanguage;
exports.makeSelectLocale = makeSelectLocale;

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(52);

var _redux = __webpack_require__(43);

var _reactIntl = __webpack_require__(15);

var _messages = __webpack_require__(526);

var _messages2 = _interopRequireDefault(_messages);

var _actions = __webpack_require__(96);

var _constants = __webpack_require__(19);

var _courseFilter = __webpack_require__(249);

var _courseFilter2 = _interopRequireDefault(_courseFilter);

var _header = __webpack_require__(115);

var _header2 = _interopRequireDefault(_header);

var _container = __webpack_require__(114);

var _container2 = _interopRequireDefault(_container);

var _button = __webpack_require__(37);

var _button2 = _interopRequireDefault(_button);

var _dropdownList = __webpack_require__(63);

var _dropdownList2 = _interopRequireDefault(_dropdownList);

var _textInput = __webpack_require__(161);

var _textInput2 = _interopRequireDefault(_textInput);

var _withLoader = __webpack_require__(116);

var _withLoader2 = _interopRequireDefault(_withLoader);

var _courseTypeSelector = __webpack_require__(250);

var _courseTypeSelector2 = _interopRequireDefault(_courseTypeSelector);

var _dataTable = __webpack_require__(251);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MasterCourses = function (_PureComponent) {
    _inherits(MasterCourses, _PureComponent);

    function MasterCourses(props) {
        _classCallCheck(this, MasterCourses);

        var _this = _possibleConstructorReturn(this, (MasterCourses.__proto__ || Object.getPrototypeOf(MasterCourses)).call(this, props));

        _this.handleOnCourseTypeChange = function (value) {
            _this.props.getMasterCourses(value);
            _this.setState({
                selectedCourseType: Number(value)
            });
        };

        _this.cloneMasterCourse = _this.cloneMasterCourse.bind(_this);
        _this.onTextSearch = _this.onTextSearch.bind(_this);
        _this.onYearGroupChange = _this.onYearGroupChange.bind(_this);
        _this.onSubjectChange = _this.onSubjectChange.bind(_this);
        _this.onCountryChange = _this.onCountryChange.bind(_this);
        _this.handleOnCourseTypeChange = _this.handleOnCourseTypeChange.bind(_this);

        _this.state = {
            selectedCourseType: _constants.DEFAULT_CURRICULUM_TYPE_ID,
            selectedCountry: 'AUS'
        };

        _this.courseTypeOptions = [{ value: 'Curriculum type', key: -1 }, { value: 'Global', key: 1 }, { value: 'Country Specific', key: 0 }];

        _this.globalCourseId = 1;
        _this.countryCourseId = 0;
        return _this;
    }

    _createClass(MasterCourses, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                isCountryLoaded = _props.isCountryLoaded,
                isSubjectLoaded = _props.isSubjectLoaded;

            if (!isSubjectLoaded) {
                this.props.getSubjects();
            }
            if (!isCountryLoaded) {
                this.props.getMasterCoursesCountries();
            }
            this.props.getMasterCourses(this.countryCourseId);
        }
    }, {
        key: 'cloneMasterCourse',
        value: function cloneMasterCourse(_ref) {
            var subjectId = _ref.subjectId,
                id = _ref.id,
                version = _ref.version;
            var CLONE = _constants.COURSE_CREATOR_SUB_ROUTES.CLONE;

            this.context.router.history.push('' + _constants.COURSE_CREATOR_ROUTE + _constants.MASTER_COURSES_ROUTE + '/' + CLONE + '/' + subjectId + '/' + id + '/' + version);
        }
    }, {
        key: 'onTextSearch',
        value: function onTextSearch(searchTerm) {
            this.props.filterMasterCourses(_extends({}, this.props.searchFilter, { searchTerm: searchTerm }));
        }
    }, {
        key: 'onCountryChange',
        value: function onCountryChange(name, value) {
            this.setState({
                selectedCountry: value
            });
        }
    }, {
        key: 'onYearGroupChange',
        value: function onYearGroupChange(field, yearGroup) {
            this.props.filterMasterCourses(_extends({}, this.props.searchFilter, { yearGroup: yearGroup }));
        }
    }, {
        key: 'onSubjectChange',
        value: function onSubjectChange(name, subjectId) {
            this.props.filterMasterCourses(_extends({}, this.props.searchFilter, { subjectId: subjectId }));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var isMasterCoursesLoading = this.props.isMasterCoursesLoading;
            var selectedCourseType = this.state.selectedCourseType;

            var dataTableMessage = isMasterCoursesLoading ? _messages2.default.loadingMessage : _messages2.default.emptyMessage;
            var emptyContent = _react2.default.createElement(
                'div',
                null,
                this.props.intl.formatMessage(dataTableMessage)
            );

            var headers = [{
                id: 'name',
                accessor: function accessor(d) {
                    return d.name;
                },
                Header: this.props.intl.formatMessage(_messages2.default.curriculumLabel)
            }, {
                id: 'Subject',
                accessor: function accessor(d) {
                    return d.subject;
                },
                Header: _react2.default.createElement(_dropdownList2.default, {
                    onChange: this.onSubjectChange,
                    optionKey: 'id',
                    options: this.props.subjects,
                    optionText: 'name',
                    value: this.props.searchFilter.subjectId }),
                width: 150,
                Cell: _dataTable.CellRenderer,
                sortable: false
            }, {
                id: 'yearGroupCombined',
                accessor: function accessor(d) {
                    return d.yearGroupCombined;
                },
                Header: this.props.intl.formatMessage(_messages2.default.yearLabel),
                width: 100
            }, {
                id: 'version',
                accessor: function accessor(d) {
                    return d.version;
                },
                Header: this.props.intl.formatMessage(_messages2.default.versionLabel),
                width: 100
            }, {
                id: 'countryCode',
                accessor: function accessor(d) {
                    return d.countryCode;
                },
                Header: this.props.intl.formatMessage(_messages2.default.countryLabel),
                width: 100,
                Cell: _dataTable.CellRenderer
            }, {
                id: 'state',
                accessor: function accessor(d) {
                    return d.state;
                },
                Header: this.props.intl.formatMessage(_messages2.default.stateLabel),
                Cell: _dataTable.CellRenderer,
                width: 300
            }, {
                id: 'action',
                accessor: function accessor(d) {
                    return d.action;
                },
                Header: this.props.intl.formatMessage(_messages2.default.actionLabel),
                width: 150,
                sortable: false
            }];
            var itemActions = function itemActions(item) {
                return _react2.default.createElement(_button2.default, {
                    handleOnClick: function handleOnClick() {
                        return _this2.cloneMasterCourse(item);
                    },
                    inline: true,
                    label: _this2.props.intl.formatMessage(_messages2.default.copyLabel),
                    primary: true });
            };

            var shouldFilterCourses = this.state.selectedCourseType === _constants.DEFAULT_CURRICULUM_TYPE_ID || this.state.selectedCourseType === this.countryCourseId;

            var filteredCourses = this.props.filteredCourses.filter(function (course) {
                return !shouldFilterCourses || course.countryCode === _this2.state.selectedCountry;
            }).map(function (item) {
                return _extends({}, item, {
                    action: _react2.default.createElement(
                        _dataTable.ActionRenderer,
                        null,
                        itemActions(item)
                    )
                });
            });

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_header2.default, {
                    subtitle: this.props.intl.formatMessage(_messages2.default.curriculumLabel),
                    title: this.props.intl.formatMessage(_messages2.default.title) }),
                _react2.default.createElement(
                    _container2.default,
                    null,
                    _react2.default.createElement(
                        _courseFilter2.default,
                        this.props,
                        _react2.default.createElement(_textInput2.default, {
                            clearText: true,
                            disabled: isMasterCoursesLoading,
                            handleOnChange: this.onTextSearch }),
                        _react2.default.createElement(_courseTypeSelector2.default, {
                            onChange: this.handleOnCourseTypeChange,
                            options: this.courseTypeOptions
                        }),
                        _react2.default.createElement(_dropdownList2.default, {
                            disabled: isMasterCoursesLoading || this.globalCourseId === selectedCourseType,
                            name: 'countryCode',
                            onChange: this.onCountryChange,
                            optionKey: 'code',
                            options: this.props.countries,
                            optionText: 'name',
                            value: this.state.selectedCountry }),
                        _react2.default.createElement(_dropdownList2.default, {
                            disabled: isMasterCoursesLoading,
                            name: 'year',
                            onChange: this.onYearGroupChange,
                            optionKey: 'id',
                            options: _constants.YEAR_GROUPS,
                            placeholder: this.props.intl.formatMessage(_messages2.default.yearLabel),
                            value: this.props.searchFilter.yearGroup })
                    ),
                    _react2.default.createElement(_dataTable.DataTable, {
                        className: '-striped',
                        columns: headers,
                        data: filteredCourses,
                        defaultPageSize: 50,
                        noDataText: emptyContent })
                )
            );
        }
    }]);

    return MasterCourses;
}(_react.PureComponent);

MasterCourses.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    getMasterCoursesCountries: _propTypes2.default.func,
    getMasterCoursesByCountry: _propTypes2.default.func,
    getMasterCourses: _propTypes2.default.func,
    getSubjects: _propTypes2.default.func,
    changeSubject: _propTypes2.default.func,
    masterCourses: _propTypes2.default.array,
    filterMasterCourses: _propTypes2.default.func,
    countries: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
    filteredCourses: _propTypes2.default.array,
    isCountryLoaded: _propTypes2.default.bool,
    isMasterCoursesLoading: _propTypes2.default.bool,
    isMasterCoursesLoaded: _propTypes2.default.bool,
    isSubjectLoaded: _propTypes2.default.bool,
    selectedCountry: _propTypes2.default.string,
    searchFilter: _propTypes2.default.object,
    subjects: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array])
};
MasterCourses.contextTypes = {
    router: _propTypes2.default.object.isRequired
};
MasterCourses.defaultProps = {
    masterCourses: []
};


function mapStateToProps() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return _extends({}, state, {
        countries: state.masterCourse.countries.items || [],
        isCountryLoaded: state.masterCourse.countries.isLoaded,
        fetching: state.masterCourse.isLoading,
        masterCourses: state.masterCourse.masterCourses,
        filteredCourses: state.masterCourse.filteredCourses,
        isMasterCoursesLoading: state.masterCourse.isLoading,
        isMasterCoursesLoaded: state.masterCourse.isLoaded,
        selectedCountry: state.masterCourse.selectedCountry,
        searchFilter: state.masterCourse.searchFilter,
        subjects: state.masterCourse.subjects.items || [],
        isSubjectLoaded: state.masterCourse.subjects.isLoaded
    });
}

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getMasterCoursesCountries: _actions.getMasterCoursesCountries,
        getMasterCoursesByCountry: _actions.getMasterCoursesByCountry,
        getSubjects: _actions.getSubjects,
        changeCountry: _actions.changeCountry,
        changeSubject: _actions.changeSubject,
        filterMasterCourses: _actions.filterMasterCourses,
        getMasterCourses: _actions.getMasterCourses
    }, dispatch);
}

var MasterCoursesWithLoader = (0, _withLoader2.default)('fetching')(MasterCourses);
exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MasterCoursesWithLoader));

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(15);

exports.default = (0, _reactIntl.defineMessages)({
    emptyMessage: {
        id: 'app.containers.dataGrid.emptyMessage',
        defaultMessage: 'No data found!'
    },
    loadingMessage: {
        id: 'app.containers.dataGrid.loadingMessage',
        defaultMessage: 'Loading...'
    },
    copyLabel: {
        id: 'app.containers.masterCourses.copyLabel',
        defaultMessage: 'Copy'
    },
    title: {
        id: 'app.containers.masterCourses.title',
        defaultMessage: 'Internal Course Manager'
    },
    subtitle: {
        id: 'app.containers.masterCourses.subtitle',
        defaultMessage: 'Master Courses'
    },
    countryLabel: {
        id: 'app.containers.masterCourses.countryLabel',
        defaultMessage: 'Country'
    },
    yearLabel: {
        id: 'app.containers.masterCourses.yearLabel',
        defaultMessage: 'Year'
    },
    curriculumLabel: {
        id: 'app.containers.masterCourses.curriculumLabel',
        defaultMessage: 'Curriculum'
    },
    stateLabel: {
        id: 'app.containers.masterCourses.stateLabel',
        defaultMessage: 'State/Province'
    },
    actionLabel: {
        id: 'app.containers.masterCourses.actionLabel',
        defaultMessage: 'Action'
    },
    dateModifiedLabel: {
        id: 'app.containers.masterCourses.dateModifiedLabel',
        defaultMessage: 'Date modified'
    },
    versionLabel: {
        id: 'app.containers.masterCourses.versionLabel',
        defaultMessage: 'Version'
    },
    subject: {
        id: 'app.containers.masterCourses.subject',
        defaultMessage: 'Subject'
    }
}); /*
     * PrivacySettings Messages
     *
     * This contains all the text for the PrivacySettings component.
     */

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actions.GET_SUBJECTS_REQUEST:
            {
                return _extends({}, state, {
                    subjects: {
                        items: [],
                        isLoaded: true,
                        isLoading: false
                    }
                });
            }
        case actions.GET_SUBJECTS_SUCCESS:
            {
                return _extends({}, state, {
                    subjects: {
                        items: action.subjects,
                        isLoaded: true,
                        isLoading: false
                    }
                });
            }
        case actions.GET_SUBJECTS_FAILURE:
            {
                return _extends({}, state, {
                    subjects: {
                        items: [],
                        isLoaded: false,
                        isLoading: false
                    }
                });
            }
        case actions.GET_MASTER_COURSES_COUNTRIES_REQUEST:
            {
                return _extends({}, state, {
                    countries: {
                        items: [],
                        isLoaded: false,
                        isLoading: true
                    }
                });
            }
        case actions.GET_MASTER_COURSES_COUNTRIES_SUCCESS:
            {
                return _extends({}, state, {
                    countries: {
                        items: action.countries,
                        isLoaded: true,
                        isLoading: false
                    }
                });
            }
        case actions.GET_MASTER_COURSES_COUNTRIES_FAILURE:
            {
                return _extends({}, state, {
                    countries: {
                        items: [],
                        isLoaded: false,
                        isLoading: false
                    }
                });
            }
        case actions.GET_MASTER_COURSES_BY_COUNTRY_REQUEST:
            {
                return _extends({}, state, {
                    selectedCountry: action.countryCode,
                    masterCourses: [],
                    isLoaded: false,
                    isLoading: true
                });
            }
        case actions.GET_MASTER_COURSES_BY_COUNTRY_SUCCESS:
            {
                var filteredCourses = filterCourses(action.masterCourses, state.searchFilter);
                return _extends({}, state, {
                    masterCourses: action.masterCourses,
                    filteredCourses: filteredCourses,
                    isLoaded: true,
                    isLoading: false
                });
            }
        case actions.GET_MASTER_COURSES_BY_COUNTRY_FAILURE:
            {
                return _extends({}, state, {
                    isLoaded: false,
                    isLoading: false
                });
            }
        case actions.CHANGE_SUBJECT:
            {
                return _extends({}, state, {
                    selectedProductId: action.productId
                });
            }
        case actions.CHANGE_COUNTRY:
            {
                return _extends({}, state, {
                    selectedCountry: action.countryCode
                });
            }
        case actions.FILTER_MASTER_COURSES:
            {
                var _filteredCourses = filterCourses(state.masterCourses, action.searchFilter);
                return _extends({}, state, {
                    searchFilter: action.searchFilter,
                    filteredCourses: _filteredCourses
                });
            }
        case actions.GET_MASTER_COURSES_REQUEST:
            {
                return _extends({}, state, {
                    masterCourses: [],
                    isLoading: true
                });
            }
        case actions.RESET_MASTER_COURSES:
            {
                return _extends({}, state, {
                    masterCourses: []
                });
            }
        case actions.GET_MASTER_COURSES_SUCCESS:
            {
                var _filteredCourses2 = filterCourses(action.masterCourses, state.searchFilter);
                return _extends({}, state, {
                    masterCourses: action.masterCourses,
                    filteredCourses: _filteredCourses2,
                    isLoaded: true,
                    isLoading: false
                });
            }

        default:
            return _extends({}, state);
    }
};

var _filter = __webpack_require__(202);

var _filter2 = _interopRequireDefault(_filter);

var _actions = __webpack_require__(96);

var actions = _interopRequireWildcard(_actions);

var _utils = __webpack_require__(97);

var _constants = __webpack_require__(19);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    countries: [],
    subjects: [],
    filteredCourses: [],
    selectedCountry: _constants.DROPDOWN_DEFAULT_COUNTRY,
    masterCourses: [],
    selectedProductId: null,
    searchFilter: { searchTerm: '', yearGroup: undefined, subjectId: _constants.DROPDOWN_DEFAULT_COURSE_ID }
};

function filterCourses(masterCourses, searchFilter) {
    var results = (0, _utils.searchByText)(masterCourses, searchFilter.searchTerm);
    if (searchFilter.yearGroup) {
        results = (0, _filter2.default)(results, function (item) {
            return item.yearGroupList.indexOf(parseInt(searchFilter.yearGroup, 10)) !== -1;
        });
    }

    if (searchFilter.subjectId !== '0') {
        results = (0, _filter2.default)(results, function (course) {
            return course.subjectId === parseInt(searchFilter.subjectId, 10);
        });
    }

    return results;
}

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getMasterCoursesCountries = getMasterCoursesCountries;
exports.getMasterCoursesCountriesSaga = getMasterCoursesCountriesSaga;
exports.getSubjects = getSubjects;
exports.getSubjectsSaga = getSubjectsSaga;
exports.getMasterCoursesByCountry = getMasterCoursesByCountry;
exports.getMasterCoursesByCountrySaga = getMasterCoursesByCountrySaga;
exports.getMasterCourses = getMasterCourses;
exports.getMasterCoursesSaga = getMasterCoursesSaga;

var _effects = __webpack_require__(81);

var _actions = __webpack_require__(96);

var actions = _interopRequireWildcard(_actions);

var _api = __webpack_require__(94);

var api = _interopRequireWildcard(_api);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getMasterCoursesCountries),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getMasterCoursesCountriesSaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getSubjects),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getSubjectsSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getMasterCoursesByCountry),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(getMasterCoursesByCountrySaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(getMasterCourses),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(getMasterCoursesSaga);

function getMasterCoursesCountries() {
    var payload;
    return regeneratorRuntime.wrap(function getMasterCoursesCountries$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.getMasterCoursesCountries);

                case 2:
                    payload = _context.sent;

                    if (!(payload.status === 200)) {
                        _context.next = 8;
                        break;
                    }

                    _context.next = 6;
                    return (0, _effects.put)(actions.getMasterCoursesCountriesSuccess(payload.data));

                case 6:
                    _context.next = 10;
                    break;

                case 8:
                    _context.next = 10;
                    return (0, _effects.put)(actions.getMasterCoursesCountriesFailure());

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function getMasterCoursesCountriesSaga() {
    return regeneratorRuntime.wrap(function getMasterCoursesCountriesSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_MASTER_COURSES_COUNTRIES_REQUEST, getMasterCoursesCountries);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function getSubjects() {
    var payload;
    return regeneratorRuntime.wrap(function getSubjects$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.getSubjects);

                case 2:
                    payload = _context3.sent;

                    if (!(payload.status === 200)) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 6;
                    return (0, _effects.put)(actions.getSubjectsSuccess(payload.data));

                case 6:
                    _context3.next = 10;
                    break;

                case 8:
                    _context3.next = 10;
                    return (0, _effects.put)(actions.getSubjectsFailure());

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function getSubjectsSaga() {
    return regeneratorRuntime.wrap(function getSubjectsSaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_SUBJECTS_REQUEST, getSubjects);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function getMasterCoursesByCountry(countryCode) {
    var payload, courses;
    return regeneratorRuntime.wrap(function getMasterCoursesByCountry$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.call)(api.getMasterCoursesByCountry, countryCode);

                case 2:
                    payload = _context5.sent;

                    if (!(payload.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    courses = payload.data.map(function (item) {
                        var yearGroups = [];
                        item.yearGroups.forEach(function (yearGroup) {
                            yearGroups.push(yearGroup.yearGroupEnum);
                        });
                        item.yearGroupCombined = yearGroups.join(', ');
                        item.yearGroupList = yearGroups;
                        return item;
                    });
                    _context5.next = 7;
                    return (0, _effects.put)(actions.getMasterCoursesByCountrySuccess(courses));

                case 7:
                    _context5.next = 11;
                    break;

                case 9:
                    _context5.next = 11;
                    return (0, _effects.put)(actions.getMasterCoursesByCountryFailure());

                case 11:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function getMasterCoursesByCountrySaga() {
    return regeneratorRuntime.wrap(function getMasterCoursesByCountrySaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_MASTER_COURSES_BY_COUNTRY_REQUEST, getMasterCoursesByCountry);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function getMasterCourses(accessStatus) {
    var payload, courses;
    return regeneratorRuntime.wrap(function getMasterCourses$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.call)(api.getMasterCourses, accessStatus);

                case 2:
                    payload = _context7.sent;

                    if (!(payload.status === 200)) {
                        _context7.next = 9;
                        break;
                    }

                    courses = payload.data.map(function (item) {
                        var yearGroups = item.yearGroups.map(function (yearGroup) {
                            return yearGroup.yearGroupEnum;
                        });
                        return _extends({}, item, {
                            yearGroupCombined: yearGroups.join(', '),
                            yearGroupList: yearGroups
                        });
                    });
                    _context7.next = 7;
                    return (0, _effects.put)(actions.getMasterCoursesSuccess(courses));

                case 7:
                    _context7.next = 11;
                    break;

                case 9:
                    _context7.next = 11;
                    return (0, _effects.put)(actions.getMasterCoursesFailure());

                case 11:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function getMasterCoursesSaga() {
    return regeneratorRuntime.wrap(function getMasterCoursesSaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_MASTER_COURSES_REQUEST, getMasterCourses);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SetDefaultCourses = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(52);

var _redux = __webpack_require__(43);

var _reactIntl = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _memoizeOne = __webpack_require__(146);

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

var _portalComms = __webpack_require__(165);

var _portalComms2 = _interopRequireDefault(_portalComms);

var _withLoader = __webpack_require__(116);

var _withLoader2 = _interopRequireDefault(_withLoader);

var _header = __webpack_require__(115);

var _header2 = _interopRequireDefault(_header);

var _defaultCourses = __webpack_require__(482);

var _defaultCourses2 = _interopRequireDefault(_defaultCourses);

var _messages = __webpack_require__(530);

var _messages2 = _interopRequireDefault(_messages);

var _actions = __webpack_require__(163);

var _styled = __webpack_require__(533);

var _constants = __webpack_require__(19);

var _actions2 = __webpack_require__(118);

var _actions3 = __webpack_require__(95);

var _utils = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SetDefaultCourses = exports.SetDefaultCourses = function (_Component) {
    _inherits(SetDefaultCourses, _Component);

    function SetDefaultCourses(props) {
        _classCallCheck(this, SetDefaultCourses);

        var _this = _possibleConstructorReturn(this, (SetDefaultCourses.__proto__ || Object.getPrototypeOf(SetDefaultCourses)).call(this, props));

        _this.updatedDefaultCourses = [];
        _this.isSaved = true;
        _this.defaultCourses = [];
        _this.years = [];
        _this.selectedCountry = _constants.DROPDOWN_DEFAULT_COUNTRY;
        _this.country = _constants.DROPDOWN_DEFAULT_COUNTRY_LONG;
        _this.accessStatus = _constants.COUNTRY_ACCESS_STATUS;
        _this.hasCountryChanged = false;
        _this.hasProductChanged = false;
        _this.hasStateChanged = false;
        _this.allowBack = true;
        _this.products = (0, _utils.getProductList)();
        _this.state = {
            filters: {
                defaultCountry: _constants.DROPDOWN_DEFAULT_COUNTRY
            },
            defaultCourses: props.defaultCourses,
            filteredCourses: [],
            productId: _constants.DEFAULT_PRODUCT_ID,
            selectedState: ''
        };
        if (!props.countries.length) {
            props.getMasterCoursesCountries();
        }
        if (!props.genericCourses.length) {
            props.getDefaultCourses(_this.state.productId);
            _this.props.getCoursesRequest(_this.accessStatus, _constants.DROPDOWN_DEFAULT_COUNTRY, _this.state.selectedState, _this.state.productId);
        }
        _this.onDefaultCourseChange = _this.onDefaultCourseChange.bind(_this);
        _this.setCountry = _this.setCountry.bind(_this);
        _this.handleOnSave = _this.handleOnSave.bind(_this);
        _this.setDefaultCourse = _this.setDefaultCourse.bind(_this);
        _this.handleBackButton = _this.handleBackButton.bind(_this);
        _this.handleOnProductSelect = _this.handleOnProductSelect.bind(_this);
        _this.handleOnStateSelect = _this.handleOnStateSelect.bind(_this);
        return _this;
    }

    _createClass(SetDefaultCourses, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.getCoursesRequest(this.accessStatus, _constants.DROPDOWN_DEFAULT_COUNTRY, this.state.selectedState, this.state.productId);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            this.setState({ filteredCourses: nextProps.genericCourses });

            this.defaultCourses = nextProps.defaultCourses;
            this.isSaved = nextProps.dataSaved;

            var selectedCountry = nextProps.countries.items.find(function (item) {
                return item.code === _this2.selectedCountry;
            });
            this.getYearGroup(selectedCountry);

            var saveSuccessful = nextProps.saveSuccessful,
                years = nextProps.years;

            this.updatedDefaultCourses = years.map(function (y) {
                var courseId = _this2.defaultCourses[Number(y.id)] && _this2.defaultCourses[Number(y.id)].courseId;
                return {
                    yearGroupEnum: y.id,
                    courseId: courseId === undefined || courseId === null ? _constants.DEFAULT_COURSE_ID : courseId
                };
            });

            if (nextProps.saveSuccessful && !this.hasCountryChanged && !this.hasStateChanged && !this.hasProductChanged) {
                this.allowBack = true;
                this.props.showToast(this.props.intl.formatMessage(_messages2.default.defaultCoursesSaved, { country: this.country }), 'success');
            } else if (saveSuccessful !== null && !saveSuccessful) {
                this.allowBack = false;
                this.props.showToast(this.props.intl.formatMessage(_messages2.default.defaultCoursesFailure, { country: this.country }), 'error');
            }
        }
    }, {
        key: 'getYearGroup',
        value: function getYearGroup(selectedCountry) {
            if (selectedCountry) {
                this.years = selectedCountry.yearGroups.map(function (year) {
                    return {
                        id: year.yearGroupEnum.toString(),
                        value: year.longName
                    };
                });
            }
        }
    }, {
        key: 'handleBackButton',
        value: function handleBackButton() {
            if (this.allowBack) {
                _portalComms2.default.navigateToLandingScreen(_constants.COURSE_MANAGER_LANDING_SCREEN);
                return;
            }

            this.allowBack = true;
            this.props.showToast(this.props.intl.formatMessage(_messages2.default.changeWillBeLost), 'warning');
        }
    }, {
        key: 'onDefaultCourseChange',
        value: function onDefaultCourseChange(year, courseName, id) {
            var yearId = year.id;

            if (courseName !== '') {
                var index = this.updatedDefaultCourses.findIndex(function (course) {
                    return course.yearGroupEnum === yearId;
                });
                this.updatedDefaultCourses[index] = { yearGroupEnum: yearId, courseId: id };
            }
            this.setDefaultCourse(yearId, courseName);
            if (this.updatedDefaultCourses.length) {
                this.isSaved = false;
            } else {
                this.isSaved = true;
            }
            this.allowBack = false;
        }
    }, {
        key: 'setDefaultCourse',
        value: function setDefaultCourse(yearId, courseName) {
            this.defaultCourses[yearId] = this.defaultCourses[yearId] || {};
            this.defaultCourses[yearId].name = courseName;
            this.setState({ defaultCourses: this.defaultCourses });
        }
    }, {
        key: 'checkForUnsavedChanges',
        value: function checkForUnsavedChanges() {
            if (!this.isSaved) {
                this.isSaved = true;
                this.props.showToast(this.props.intl.formatMessage(_messages2.default.unsavedChanges), 'warning');
                return true;
            }
            return false;
        }
    }, {
        key: 'setCountry',
        value: function setCountry(name, value) {
            if (this.checkForUnsavedChanges()) {
                return;
            }
            this.updatedDefaultCourses = [];

            var selectedCountry = this.props.countries.items.find(function (country) {
                return country.code === value;
            });
            this.getYearGroup(selectedCountry);

            this.country = selectedCountry && selectedCountry.name;
            this.selectedCountry = value;
            this.setState({
                filters: {
                    defaultCountry: this.selectedCountry
                }
            });

            this.props.getCoursesRequest(this.accessStatus, value, this.state.selectedState, this.state.productId);
            this.setState({ filteredCourses: this.props.genericCourses });
            this.hasCountryChanged = true;
            this.handleOnStateSelect(null, '');
        }
    }, {
        key: 'handleOnProductSelect',
        value: function handleOnProductSelect(name, productId) {
            if (this.checkForUnsavedChanges()) {
                return;
            }

            this.updatedDefaultCourses = [];

            this.setState({ productId: productId });

            this.hasProductChanged = true;
            this.props.getDefaultCourses(productId);
            this.props.getCoursesRequest(this.accessStatus, this.selectedCountry, this.state.selectedState, productId);
        }
    }, {
        key: 'handleOnStateSelect',
        value: function handleOnStateSelect(name, selectedState) {
            this.hasStateChanged = true;
            this.accessStatus = selectedState === '' ? _constants.COUNTRY_ACCESS_STATUS : _constants.STATE_ACCESS_STATUS;

            if (this.checkForUnsavedChanges()) {
                return;
            }

            this.updatedDefaultCourses = [];

            this.setState({ selectedState: selectedState });

            this.props.getCoursesRequest(this.accessStatus, this.selectedCountry, selectedState, this.state.productId);
        }
    }, {
        key: 'handleOnSave',
        value: function handleOnSave() {
            this.hasStateChanged = false;
            this.hasCountryChanged = false;
            this.hasProductChanged = false;
            this.allowBack = true;
            this.props.saveDefaultCoursesRequest(this.accessStatus, this.selectedCountry, this.state.selectedState, this.state.productId, this.updatedDefaultCourses);
        }
    }, {
        key: 'render',
        value: function render() {
            var countriesList = (0, _memoizeOne2.default)(function (countries) {
                return countries;
            });
            var countries = this.props.countries;
            var defaultCountry = this.state.filters.defaultCountry;
            var _state = this.state,
                filteredCourses = _state.filteredCourses,
                defaultCourses = _state.defaultCourses,
                productId = _state.productId,
                selectedState = _state.selectedState;


            return _react2.default.createElement(
                _styled.SetDefaultCoursesWrapper,
                null,
                _react2.default.createElement(_header2.default, {
                    subtitle: this.props.intl.formatMessage(_messages2.default.setDefault),
                    title: this.props.intl.formatMessage(_messages2.default.title) }),
                _react2.default.createElement(_defaultCourses2.default, _extends({
                    countries: countriesList(countries),
                    defaultCountry: defaultCountry,
                    defaultCourses: defaultCourses,
                    handleBackButton: this.handleBackButton,
                    handleOnSave: this.handleOnSave,
                    handleOnStateSelect: this.handleOnStateSelect,
                    isSaved: this.isSaved,
                    onDefaultCourseChange: this.onDefaultCourseChange,
                    products: this.products,
                    selectedProductId: productId,
                    selectedState: selectedState,
                    setCountry: this.setCountry,
                    setProduct: this.handleOnProductSelect
                }, this.props, {
                    courses: filteredCourses,
                    years: this.years }))
            );
        }
    }]);

    return SetDefaultCourses;
}(_react.Component);

SetDefaultCourses.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    getMasterCoursesCountries: _propTypes.PropTypes.func,
    getCoursesRequest: _propTypes.PropTypes.func,
    saveDefaultCoursesRequest: _propTypes.PropTypes.func,
    showToast: _propTypes.PropTypes.func,
    getDefaultCourses: _propTypes.PropTypes.func,
    genericCourses: _propTypes.PropTypes.array,
    defaultCourses: _propTypes.PropTypes.object,
    dataSaved: _propTypes.PropTypes.bool,
    saveSuccessful: _propTypes.PropTypes.bool,
    countries: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.array.isRequired, _propTypes.PropTypes.object.isRequired]),
    years: _propTypes.PropTypes.array.isRequired
};
SetDefaultCourses.defaultProps = {
    countries: [],
    genericCourses: []
};


function mapStateToProps(state) {
    return {
        countries: state.masterCourse.countries,
        years: state.setDefaultCourse.years,
        defaultCourses: state.setDefaultCourse.defaultCourses,
        genericCourses: state.defaultCourse.genericCourses,
        dataSaved: state.setDefaultCourse.dataSaved,
        saveSuccessful: state.setDefaultCourse.saveSuccessful
    };
}

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        getMasterCoursesCountries: _actions.getMasterCoursesCountries,
        getCoursesRequest: _actions.getCoursesRequest,
        getDefaultCourses: _actions2.getDefaultCourses,
        saveDefaultCoursesRequest: _actions.saveDefaultCoursesRequest,
        showToast: _actions3.showToast
    }, dispatch);
}

var SetDefaultCoursesWithLoader = (0, _withLoader2.default)('fetching')(SetDefaultCourses);
exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SetDefaultCoursesWithLoader));

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = __webpack_require__(15);

exports.default = (0, _reactIntl.defineMessages)({
    title: {
        id: 'app.containers.setDefaultCourses.title',
        defaultMessage: 'Internal Course Manager'
    },
    setDefault: {
        id: 'app.containers.setDefaultCourses.setDefault',
        defaultMessage: 'Set Default'
    },
    unsavedChanges: {
        id: 'app.containers.setDefaultCourses.unsavedChanges',
        defaultMessage: 'You have unsaved changes and will lose these if you change country'
    },
    defaultCoursesSaved: {
        id: 'app.containers.setDefaultCourses.defaultCoursesSaved',
        defaultMessage: 'Default courses for {country} have been saved'
    },
    defaultCoursesFailure: {
        id: 'app.containers.setDefaultCourses.defaultCoursesFailure',
        defaultMessage: 'Errors have prevented your change from being saved for {country}'
    },
    changeWillBeLost: {
        id: 'app.containers.setDefaultCourses.changeWillBeLost',
        defaultMessage: 'Your changes have not been saved, and will be lost'
    }
});

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actions.GET_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS:
            {
                return _extends({}, state, {
                    defaultCourses: action.defaultCourses
                });
            }

        case actions.GET_COURSES_FOR_COUNTRY_SUCCESS:
            {
                return _extends({}, state, {
                    courses: action.courses
                });
            }

        case actions.SAVE_DEFAULT_COURSES_FOR_COUNTRY_REQUEST:
            {
                return _extends({}, state, {
                    dataSaved: false,
                    saveSuccessful: null
                });
            }

        case actions.SAVE_DEFAULT_COURSES_FOR_COUNTRY_SUCCESS:
            {
                return _extends({}, state, {
                    dataSaved: true,
                    saveSuccessful: true
                });
            }

        case actions.SAVE_DEFAULT_COURSES_FOR_COUNTRY_FAILURE:
            {
                return _extends({}, state, {
                    dataSaved: false,
                    saveSuccessful: false
                });
            }

        case actions.GET_COURSES_SUCCESS:
            {
                return _extends({}, state, {
                    defaultCourses: action.courses
                });
            }

        case actions.SAVE_DEFAULT_COURSES_REQUEST:
            {
                return _extends({}, state, {
                    saveSuccessful: null,
                    dataSaved: false
                });
            }

        case actions.SAVE_DEFAULT_COURSES_SUCCESS:
            {
                return _extends({}, state, {
                    saveSuccessful: true,
                    dataSaved: true,
                    defaultCourses: action.defaultCourses
                });
            }

        case actions.SAVE_DEFAULT_COURSES_FAILURE:
            {
                return _extends({}, state, {
                    saveSuccessful: false,
                    dataSaved: false
                });
            }

        default:
            return _extends({}, state);
    }
};

var _constants = __webpack_require__(19);

var _actions = __webpack_require__(163);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    years: _constants.YEAR_GROUPS,
    defaultCourses: {},
    courses: [],
    dataSaved: true,
    saveSuccessful: null
};

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDefaultCoursesForCountry = getDefaultCoursesForCountry;
exports.getDefaulCoursesForCountrySaga = getDefaulCoursesForCountrySaga;
exports.getCoursesForCountry = getCoursesForCountry;
exports.getCoursesForCountrySaga = getCoursesForCountrySaga;
exports.saveDefaultCoursesForCountry = saveDefaultCoursesForCountry;
exports.saveDefaultCoursesForCountrySaga = saveDefaultCoursesForCountrySaga;
exports.getCourses = getCourses;
exports.getCoursesSaga = getCoursesSaga;
exports.saveDefaultCourses = saveDefaultCourses;
exports.saveDefaultCoursesSaga = saveDefaultCoursesSaga;

var _effects = __webpack_require__(81);

var _actions = __webpack_require__(163);

var actions = _interopRequireWildcard(_actions);

var _api = __webpack_require__(94);

var api = _interopRequireWildcard(_api);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getDefaultCoursesForCountry),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getDefaulCoursesForCountrySaga),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getCoursesForCountry),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getCoursesForCountrySaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(saveDefaultCoursesForCountry),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(saveDefaultCoursesForCountrySaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(getCourses),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(getCoursesSaga),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(saveDefaultCourses),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(saveDefaultCoursesSaga);

function getDefaultCoursesForCountry(_ref) {
    var accessCode = _ref.accessCode,
        productId = _ref.productId;
    var payload;
    return regeneratorRuntime.wrap(function getDefaultCoursesForCountry$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(api.getDefaultCoursesForCountry, { accessCode: accessCode, productId: productId });

                case 2:
                    payload = _context.sent;

                    if (!(payload.status === 200)) {
                        _context.next = 8;
                        break;
                    }

                    _context.next = 6;
                    return (0, _effects.put)(actions.getDefaultCoursesForCountrySuccess(payload.data));

                case 6:
                    _context.next = 10;
                    break;

                case 8:
                    _context.next = 10;
                    return (0, _effects.put)(actions.getDefaultCoursesForCountryFailure());

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function getDefaulCoursesForCountrySaga() {
    return regeneratorRuntime.wrap(function getDefaulCoursesForCountrySaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_DEFAULT_COURSES_FOR_COUNTRY_REQUEST, getDefaultCoursesForCountry);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function getCoursesForCountry(_ref2) {
    var countryCode = _ref2.countryCode,
        productId = _ref2.productId;
    var payload;
    return regeneratorRuntime.wrap(function getCoursesForCountry$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.call)(api.getCoursesForCountry, { countryCode: countryCode, productId: productId });

                case 2:
                    payload = _context3.sent;

                    if (!(payload.status === 200)) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 6;
                    return (0, _effects.put)(actions.getCoursesForCountrySuccess(payload.data));

                case 6:
                    _context3.next = 10;
                    break;

                case 8:
                    _context3.next = 10;
                    return (0, _effects.put)(actions.getCoursesForCountryFailure());

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function getCoursesForCountrySaga() {
    return regeneratorRuntime.wrap(function getCoursesForCountrySaga$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_COURSES_FOR_COUNTRY_REQUEST, getCoursesForCountry);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function saveDefaultCoursesForCountry(_ref3) {
    var accessCode = _ref3.accessCode,
        productId = _ref3.productId,
        defaultCourses = _ref3.defaultCourses;
    var payload;
    return regeneratorRuntime.wrap(function saveDefaultCoursesForCountry$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.call)(api.saveDefaultCoursesForCountry, accessCode, productId, defaultCourses);

                case 2:
                    payload = _context5.sent;

                    if (!(payload.status === 200)) {
                        _context5.next = 8;
                        break;
                    }

                    _context5.next = 6;
                    return (0, _effects.put)(actions.saveDefaultCoursesForCountrySuccess());

                case 6:
                    _context5.next = 10;
                    break;

                case 8:
                    _context5.next = 10;
                    return (0, _effects.put)(actions.saveDefaultCoursesForCountryFailure());

                case 10:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function saveDefaultCoursesForCountrySaga() {
    return regeneratorRuntime.wrap(function saveDefaultCoursesForCountrySaga$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(actions.SAVE_DEFAULT_COURSES_FOR_COUNTRY_REQUEST, saveDefaultCoursesForCountry);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function getCourses(_ref4) {
    var accessStatus = _ref4.accessStatus,
        countryCode = _ref4.countryCode,
        stateCode = _ref4.stateCode,
        productId = _ref4.productId;
    var payload;
    return regeneratorRuntime.wrap(function getCourses$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.call)(api.getCourses, { accessStatus: accessStatus, countryCode: countryCode, stateCode: stateCode, productId: productId });

                case 2:
                    payload = _context7.sent;

                    if (!(payload.status === 200)) {
                        _context7.next = 8;
                        break;
                    }

                    _context7.next = 6;
                    return (0, _effects.put)(actions.getCoursesSuccess(payload.data));

                case 6:
                    _context7.next = 10;
                    break;

                case 8:
                    _context7.next = 10;
                    return (0, _effects.put)(actions.getCoursesFailure());

                case 10:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function getCoursesSaga() {
    return regeneratorRuntime.wrap(function getCoursesSaga$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(actions.GET_COURSES_REQUEST, getCourses);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function saveDefaultCourses(_ref5) {
    var accessStatus = _ref5.accessStatus,
        countryCode = _ref5.countryCode,
        stateCode = _ref5.stateCode,
        productId = _ref5.productId,
        defaultCourses = _ref5.defaultCourses;
    var payload;
    return regeneratorRuntime.wrap(function saveDefaultCourses$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return (0, _effects.call)(api.saveDefaultCourses, { accessStatus: accessStatus, countryCode: countryCode, stateCode: stateCode, productId: productId, defaultCourses: defaultCourses });

                case 2:
                    payload = _context9.sent;

                    if (!(payload.status === 200)) {
                        _context9.next = 8;
                        break;
                    }

                    _context9.next = 6;
                    return (0, _effects.put)(actions.saveDefaultCoursesSuccess(defaultCourses));

                case 6:
                    _context9.next = 10;
                    break;

                case 8:
                    _context9.next = 10;
                    return (0, _effects.put)(actions.saveDefaultCoursesFailure());

                case 10:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function saveDefaultCoursesSaga() {
    return regeneratorRuntime.wrap(function saveDefaultCoursesSaga$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(actions.SAVE_DEFAULT_COURSES_REQUEST, saveDefaultCourses);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SetDefaultCoursesWrapper = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n'], ['\n    position: relative;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable */


var SetDefaultCoursesWrapper = _styledComponents2.default.div(_templateObject);

exports.SetDefaultCoursesWrapper = SetDefaultCoursesWrapper;

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _resource = __webpack_require__(390);

var _resource2 = _interopRequireDefault(_resource);

var _localResourceConfig = __webpack_require__(538);

var _localResourceConfig2 = _interopRequireDefault(_localResourceConfig);

var _constants = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BasicResources = function () {
    function BasicResources() {
        _classCallCheck(this, BasicResources);
    }

    _createClass(BasicResources, null, [{
        key: 'initialise',
        value: function initialise(envName, credentials) {
            // Race condition here. The result is inconsistent. In configuration: { values: ... }
            var env = (0, _resource2.default)(envName, _constants.appName);
            var location = window.location;
            var runningOnDeveloperMachine = /^https?:\/\/localhost/.test(location);

            if (runningOnDeveloperMachine) {
                if (envName === 'local') {
                    // This implies we'll be hitting the mock REST server,
                    // which does not require authentication.

                    env.bypassAuthentication();
                    env.setConfiguration(_localResourceConfig2.default);
                } else if (credentials.authToken) {
                    env.authToken = credentials.authToken;
                } else {
                    env.setCredentials(credentials.username, credentials.password);
                }
            } else if (credentials.authToken) {
                env.authToken = credentials.authToken;
            } else if (credentials.username && credentials.password) {
                env.username = credentials.username;
                env.password = credentials.password;
            } else {
                // The caller should have provided a valid set of credentials, so
                // hopefully this will never happen.
                /* eslint-disable no-console */
                console.log('BasicResources.initialise() - to execute, we need either an authToken or' + ' a username/password pair.  The credentials object that was provided does not' + ' contain either.  So, expect things to fail badly :-(.');
                /* eslint-enable no-console */
            }

            return env;
        }
    }]);

    return BasicResources;
}();

exports.default = BasicResources;

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _queryString = __webpack_require__(210);

var queryString = _interopRequireWildcard(_queryString);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function ConserveParameters(importantParams) {
    function modifyPath(path) {
        var currentParams = queryString.parse(window.location.search);

        var paramList = {};
        var paramsToAdd = false;

        importantParams.forEach(function (param) {
            if (currentParams[param]) {
                if (!path.match('(\\?|&)' + param + '=')) {
                    paramList[param] = currentParams[param];
                    paramsToAdd = true;
                }
            }
        });

        if (paramsToAdd) {
            path += path.indexOf('?') === -1 ? '?' : '&';
            path += queryString.stringify(paramList);
        }

        return path;
    }

    var oldPushState = window.history.pushState;
    var oldReplaceState = window.history.replaceState;

    window.history.pushState = function newPushState() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        args[2] = modifyPath(args[2]);
        oldPushState.apply(this, args);
    };

    window.history.replaceState = function newReplaceState() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        args[2] = modifyPath(args[2]);
        oldReplaceState.apply(this, args);
    };
}

exports.default = ConserveParameters;

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deselectIsSelectedProp = deselectIsSelectedProp;
exports.findNode = findNode;
exports.default = updateTreeSelection;
exports.updateIndexes = updateIndexes;
exports.nodeExpandCollapse = nodeExpandCollapse;
exports.findSpineNode = findSpineNode;
exports.deleteNode = deleteNode;
exports.buildTopicObject = buildTopicObject;
exports.getCourseTopics = getCourseTopics;
exports.onToggle = onToggle;
exports.handleOnExpandCollapse = handleOnExpandCollapse;
exports.updateTopicName = updateTopicName;
exports.getStrandSubstrand = getStrandSubstrand;
exports.trimStringWithEllipsis = trimStringWithEllipsis;
exports.getCurriculumDescriptions = getCurriculumDescriptions;
exports.filterSpineOnStrandSubStrand = filterSpineOnStrandSubStrand;

var _util = __webpack_require__(1142);

var girlIdx = 0;
var spineIdx = 0;
var DESCRIPTION_LENGTH = 40;

function deselectIsSelectedProp(items) {
    return items.childNodes.map(function (item) {
        item.isSelected = false;
        if (item.childNodes.length > 0) {
            deselectIsSelectedProp(item);
        }
        return undefined;
    });
}

function findNode(id, items) {
    if (items) {
        var nodes = items.childNodes || items;
        return nodes.find(function (d) {
            return d.id === id;
        }) || findNode(id, nodes.flatMap(function (d) {
            return d.childNodes || [];
        })) || undefined;
    }

    return undefined;
}

function updateTreeSelection(id, topicTree, selectedTopic) {
    var topicId = '';
    var topicNode = {};
    if (id.indexOf('#') !== -1) {
        var filteredTopics = topicTree.childNodes.find(function (item) {
            return item.id === id.split('#')[id.split('#').length - 1];
        });
        if (id === selectedTopic) {
            topicNode = findNode(id, filteredTopics);
            if (topicNode) {
                topicNode.isSelected = false;
            }
        } else {
            deselectIsSelectedProp(topicTree);
            topicNode = findNode(id, filteredTopics);
            if (topicNode) {
                topicNode.isSelected = true;
                topicId = id;
            }
        }
    } else if (id.indexOf('#') === -1 && id === selectedTopic) {
        topicNode = topicTree.childNodes.find(function (t) {
            return t.id === id;
        });
        if (topicNode) {
            topicNode.isSelected = false;
        }
    } else {
        deselectIsSelectedProp(topicTree);
        topicNode = topicTree.childNodes.find(function (t) {
            return t.id === id;
        });
        if (topicNode) {
            topicNode.isSelected = true;
            topicId = id;
        }
    }

    return topicId;
}

function updateIndexes(id, topics) {
    var parentId = 0;
    var spineId = 0;
    var subTopic = {};
    var items = topics.childNodes;

    if (id.indexOf('#') !== -1 || id.indexOf('-') !== -1) {
        if (id.toLowerCase().indexOf('girl') !== -1) {
            parentId = id.split('-')[0];
            spineId = id.split('-')[2];
            var spine = findNode(parentId + '-' + spineId + '-spine', topics.childNodes);
            items = spine.childNodes;
        } else if (id.indexOf('-') !== -1) {
            parentId = id.split('-')[0];
            subTopic = findNode(parentId, topics.childNodes);
            items = subTopic.childNodes;
        } else {
            parentId = id.substring(id.indexOf('#') + 1);
            subTopic = findNode(parentId, topics.childNodes);
            items = subTopic.childNodes;
        }
    }

    items.map(function (item, index) {
        item.index = index;
        return item;
    });

    return topics;
}

function updateIsExpandedProp(id, items, status, spineId) {
    var topic = items.childNodes.find(function (item) {
        return item.id === id.split('#')[id.split('#').length - 1];
    });
    var node = findNode(spineId || id, topic);
    node.isExpanded = status;
}

function nodeExpandCollapse(id, status, topics) {
    if (id.indexOf('spine') !== -1) {
        if (id.indexOf('#') !== -1) {
            var stParentId = id.split('-')[0];
            updateIsExpandedProp(stParentId, topics, status, id);
        } else {
            var topic = topics.childNodes.find(function (item) {
                return item.id === id.split('-')[0];
            });
            var node = findNode(id, topic);
            node.isExpanded = status;
        }
    } else if (id.indexOf('#') !== -1) {
        updateIsExpandedProp(id, topics, status);
    } else {
        var _topic = topics.childNodes.find(function (t) {
            return t.id === id;
        });
        _topic.isExpanded = status;
    }
    return topics;
}

function deleteTreeNodes(id, items) {
    return items.map(function (item, index) {
        if (id === item.id) {
            items.splice(index, 1);
            return item;
        } else if (item.childNodes.length > 0) {
            return deleteTreeNodes(id, item.childNodes);
        }
        return null;
    });
}

function findSpineNode(items, spineIds) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = items.childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item.id.indexOf('spine') !== -1) {
                spineIds.push(item.id.split('-')[1]);
            }

            if (item.childNodes.length > 0) {
                findSpineNode(item, spineIds);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

function deleteNode(id, topics) {
    var matchItem = findNode(id, topics);
    deleteTreeNodes(id, topics.childNodes);
    return matchItem;
}

function getGirlResources(items) {
    var girls = [];
    if (items.length > 0) {
        var includedGirls = items.filter(function (item) {
            return item.isIncluded;
        });
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = includedGirls[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var girl = _step2.value;

                girls.push(girl.id.split('-')[1]);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    return girls;
}

function buildSubTopics(node, parentNode) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = node.childNodes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var val = _step3.value;

            var subItem = {};
            subItem.name = val.name;
            subItem.type = val.type;
            subItem.strand = val.strand;
            subItem.subStrand = val.subStrand;
            subItem.description = val.description;
            subItem.externalKey = val.externalKey;
            subItem.curriculumLevelCode = val.curriculumLevelCode;
            subItem.childTopics = [];
            subItem.spineNodes = [];
            if (val.id.indexOf('-') !== -1) {
                parentNode.spineNodes.push({
                    id: val.id.split('-')[1],
                    girlIds: parentNode.type.toLowerCase() === 'step' ? [] : getGirlResources(val.childNodes)
                });
            } else if (val.childNodes.length > 0) {
                parentNode.childTopics.push(buildSubTopics(val, subItem));
            } else {
                parentNode.childTopics.push(subItem);
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return parentNode;
}

function getChildTopics(node, parentNode) {
    var item = {};
    item.name = node.name;
    item.childTopics = [];
    item.spineNodes = [];
    item.type = node.type;
    item.strand = node.strand;
    item.subStrand = node.subStrand;
    item.description = node.description;
    item.externalKey = node.externalKey;
    item.curriculumLevelCode = node.curriculumLevelCode;

    parentNode.childTopics.push(buildSubTopics(node, item));
    return parentNode;
}

function buildTopicObject(topicTree) {
    var topics = topicTree.childNodes.map(function (val) {
        var course = {};
        course.name = val.name;
        course.type = val.type;
        course.strand = val.strand;
        course.subStrand = val.subStrand;
        course.description = val.description;
        course.externalKey = val.externalKey;
        course.curriculumLevelCode = val.curriculumLevelCode;
        course.childTopics = [];
        course.spineNodes = [];
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = val.childNodes[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var node = _step4.value;

                if (node.id.indexOf('#') === -1) {
                    course.spineNodes.push({
                        id: node.id.split('-')[1],
                        girlIds: getGirlResources(node.childNodes)
                    });
                } else {
                    getChildTopics(node, course);
                }
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }

        return course;
    });

    return topics;
}

function getSpineGirls(spine) {
    return spine.girls.map(function (girl, idx) {
        girl.name = girl.id + '-' + girl.teacherTitle;
        girl.id = spine.id.split('-')[0] + '-' + girl.id + '-' + spine.id.split('-')[1];
        girl.index = idx;
        girl.groupName = 'girl' + girlIdx;
        girl.groupType = 'girl' + girlIdx;
        girl.childNodes = [];
        girl.isEditable = false;
        girl.isIncluded = girl.isEnabled;
        girl.previewUrl = girl.previewUrl;
        return girl;
    });
}

function getSpineNodes(topic, isSubTopic, spineIndex, parentNode) {
    var index = 0;
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
        for (var _iterator5 = topic.spineNodes[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var spine = _step5.value;

            spine.name = spine.id + ': ' + spine.description;
            spine.id = parentNode.id + '-' + spine.id + '-spine';
            spine.index = index;
            spine.groupName = isSubTopic ? 'subTopic' + spineIndex : 'spine' + parentNode.spineIndex;
            spine.groupType = isSubTopic ? 'subTopic' + spineIndex : 'spine' + parentNode.spineIndex;
            spine.girlIndex = girlIdx;
            spine.isExpanded = false;
            spine.childNodes = getSpineGirls(spine);
            girlIdx += 1;
            index += 1;
            spine.isEditable = false;
            parentNode.childNodes.push(spine);
        }
    } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
            }
        } finally {
            if (_didIteratorError5) {
                throw _iteratorError5;
            }
        }
    }

    return parentNode;
}

function getSubTopics(node, startIndex, parentNode) {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
        for (var _iterator6 = node.childTopics[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var val = _step6.value;

            var item = {};
            spineIdx += 1;
            item.name = val.name;
            item.id = val.id.toString() + '#' + parentNode.id;
            item.index = startIndex;
            item.groupName = 'spine' + parentNode.spineIndex;
            item.groupType = 'spine' + parentNode.spineIndex;
            item.isEditable = true;
            item.isExpanded = false;
            item.isSelected = false;
            item.spineIndex = spineIdx;
            item.externalKey = val.externalKey;
            item.type = val.type;
            item.description = val.description;
            item.strand = val.strand;
            item.subStrand = val.subStrand;
            item.childNodes = [];
            item.curriculumLevelCode = val.curriculumLevelCode;
            if (val.spineNodes.length > 0) {
                getSpineNodes(val, true, spineIdx, item);
            }
            if (val.childTopics.length > 0) {
                getSubTopics(val, item.childNodes.length, item);
            }
            startIndex += 1;
            parentNode.childNodes.push(item);
        }
    } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
            }
        } finally {
            if (_didIteratorError6) {
                throw _iteratorError6;
            }
        }
    }

    return parentNode;
}

function getCourseTopics(topics, girlIndex, spineIndex) {
    girlIdx = girlIndex;
    spineIdx = spineIndex;
    var topicId = 0;
    var childNodes = topics.map(function (topic, topicIndex) {
        var course = {};
        topicId = topic.id;
        course.id = topic.id.toString();
        course.name = topic.name;
        course.childNodes = [];
        course.index = topicIndex;
        course.groupName = 'topicList';
        course.groupType = 'topic';
        course.isEditable = true;
        course.isSelected = false;
        course.spineIndex = spineIdx;
        course.isExpanded = true;
        course.externalKey = topic.externalKey;
        course.type = topic.type;
        course.description = topic.description;
        course.strand = topic.strand;
        course.subStrand = topic.subStrand;
        course.curriculumLevelCode = topic.curriculumLevelCode;
        course.childNodes = [];
        if (topic.spineNodes.length > 0) {
            getSpineNodes(topic, false, spineIdx, course);
        }
        if (topic.childTopics.length > 0) {
            getSubTopics(topic, course.childNodes.length, course);
        }
        spineIdx += 1;
        return course;
    });

    return { childNodes: childNodes, girlIdx: girlIdx, spineIdx: spineIdx, topicId: topicId };
}

function onToggle(id, status, topics) {
    var node = findNode(id, topics);
    node.isIncluded = status;
    return topics;
}

function handleOnExpandCollapse(status, topicTree) {
    if (topicTree.childNodes.length > 0) {
        topicTree.childNodes = topicTree.childNodes.map(function (topic) {
            topic.isExpanded = status;
            topic.childNodes.map(function (spine) {
                spine.isExpanded = status;
                if (spine.id.indexOf('#') !== -1) {
                    spine.childNodes.map(function (val) {
                        val.isExpanded = status;
                        return val;
                    });
                }
                return spine;
            });
            return topic;
        });
    }
    return topicTree;
}

function updateTopicName(response, topics) {
    if (response.id.indexOf('#') !== -1) {
        var subTopic = findNode(response.id, topics);
        subTopic.name = response.name;
        subTopic.strand = response.strand;
        subTopic.subStrand = response.subStrand;
        subTopic.externalKey = response.externalKey;
        subTopic.description = response.description;
        subTopic.curriculumLevelCode = response.curriculumLevelCode;
    } else {
        var topic = topics.childNodes.find(function (item) {
            return item.id === response.id;
        });
        topic.name = response.name;
        topic.strand = response.strand;
        topic.subStrand = response.subStrand;
        topic.externalKey = response.externalKey;
        topic.description = response.description;
        topic.curriculumLevelCode = response.curriculumLevelCode;
    }
    return topics;
}

function getStrandSubstrand(id, topics) {
    var standInfo = {
        name: '',
        strand: 'None',
        subStrand: 'None',
        externalKey: '',
        description: '',
        curriculumLevelCode: '',
        topicType: ''
    };
    if (id) {
        if (id.indexOf('#') !== -1) {
            var subTopic = findNode(id, topics);
            standInfo = {
                name: subTopic.name,
                strand: subTopic.strand,
                subStrand: subTopic.subStrand,
                externalKey: subTopic.externalKey,
                description: subTopic.description,
                curriculumLevelCode: subTopic.curriculumLevelCode,
                type: subTopic.type
            };
        } else {
            var topic = topics.childNodes.find(function (item) {
                return item.id === id;
            });
            standInfo = {
                name: topic.name,
                strand: topic.strand,
                subStrand: topic.subStrand,
                externalKey: topic.externalKey,
                description: topic.description,
                curriculumLevelCode: topic.curriculumLevelCode,
                type: topic.type
            };
        }
    }
    return standInfo;
}

function trimStringWithEllipsis() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DESCRIPTION_LENGTH;

    return string.length > length ? string.substring(0, length) + '...' : string;
}

function getCurriculumDescriptions(response) {
    if ((0, _util.isArray)(response) && response.length) {
        var curriculumDescriptions = response.map(function (item) {
            var _item$code = item.code,
                code = _item$code === undefined ? '' : _item$code,
                _item$id = item.id,
                id = _item$id === undefined ? '' : _item$id,
                _item$description = item.description,
                description = _item$description === undefined ? '' : _item$description;

            var label = trimStringWithEllipsis(description, DESCRIPTION_LENGTH);
            return { label: label, code: code, value: description, id: id };
        });
        return curriculumDescriptions;
    }return null;
}

function filterSpineOnStrandSubStrand() {
    var topic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var spineList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (topic && topic.strand) {
        if ((0, _util.isArray)(spineList) && spineList.length) {
            return spineList.filter(function (item) {
                var pattern = new RegExp('^' + topic.strand.toLowerCase() + '.*$');
                var subStrand = topic && topic.subStrand.toLowerCase();
                var id = item && item.id.toLowerCase();
                if (subStrand && subStrand.toLowerCase() !== 'none') {
                    if (pattern.test(id) && id.indexOf(subStrand) !== -1) return item;
                } else if (pattern.test(id)) return item;
                return null;
            });
        }
    }
    return spineList;
}

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _resources = __webpack_require__(164);

var _resources2 = _interopRequireDefault(_resources);

var _portalComms = __webpack_require__(165);

var _portalComms2 = _interopRequireDefault(_portalComms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MESSAGE = {
    UNKNOWN: 'Something went wrong. Please try again.',
    INVALID_TOKEN: 'Invalid session. Please login and try again.'
};

var ErrorHandling = function () {
    function ErrorHandling() {
        _classCallCheck(this, ErrorHandling);
    }

    _createClass(ErrorHandling, null, [{
        key: 'addResourceResponseErrorInterceptor',
        value: function addResourceResponseErrorInterceptor() {
            var interceptor = ErrorHandling.handleErrors;

            _resources2.default.env.addResponseInterceptor(interceptor);
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(result) {
            var message = void 0;
            var valid = false;

            try {
                switch (result.status) {
                    case 200:case 201:case 204:
                        valid = true;
                        break;

                    case 400:case 401:case 404:case 409:
                        // bad request handle locally
                        valid = true;
                        break;

                    default:
                        message = result.message;
                }
            } catch (e) {
                message = MESSAGE.UNKNOWN;
            }

            // Global Error handling
            if (valid === false) {
                _portalComms2.default.serverError(message);
            }

            // Pass Errors to Local actions to handle explicitly
            // when result.valid === true BUT
            // result contains result.message && result.code,
            // it means it requires to handle in async functions response
            result.valid = valid;

            return result;
        }
    }]);

    return ErrorHandling;
}();

exports.default = ErrorHandling;

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// For local development, we can use mock-rest-server (or a similar REST server like json-server)
//
// You should be able to use this code as is, apart from perhaps changing MOCK_SERVICE_PORT to whatever
// port you're using for your mock server.

var MOCK_SERVICES_PORT = 8080; // TODO: DEFINE THE PORT YOUR MOCK SERVER IS LISTENING ON

var MOCK_SERVICES_HOST = 'localhost';
var MOCK_SERVICES_URL = 'http://' + MOCK_SERVICES_HOST + ':' + MOCK_SERVICES_PORT;

// The app's configuration will have a base URL for each service we use.  For local testing, we define
// the configuration to point to our local server.
//
// For each resource, we have a constant for the base URL, as it would be in production. For example,
// below we have "AvatarAdminBaseUrl" which represents the base of the URL for access to all of
// the Avatar Admin application's resources.  Replace that with the resource(s) your application uses.

var COMMON_CONFIG = {
    BaseName: '',
    SchoolRollGatewayUrl: MOCK_SERVICES_URL + '/SchoolRollGateway/api/v1'
};

exports.default = {
    local: _extends({}, COMMON_CONFIG),

    live: _extends({}, COMMON_CONFIG, {
        'Shared.AuthenticationServicePathUrl': 'http://mzaue2.phoenix.mathletics.com/AuthenticationService-R170/'
    }),

    qa: _extends({}, COMMON_CONFIG, {
        'Shared.AuthenticationServicePathUrl': 'http://qa.phoenix.mathletics.com/AuthenticationService-R170/'
    }),

    demo: _extends({}, COMMON_CONFIG, {
        'Shared.AuthenticationServicePathUrl': 'http://demo.3plearning.com/AuthenticationService/'
    })
};

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var productEnum = function productEnum() {
    _classCallCheck(this, productEnum);
};

productEnum.MATHLETICS = { id: 1, name: 'Mathletics' };
productEnum.SPELLODROME = { id: 3, name: 'Spellodrome' };
productEnum.INTOSICENCE = { id: 6, name: 'Intoscience' };
productEnum.PHONICS = { id: 8, name: 'Phonics' };
exports.default = productEnum;

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _queryString = __webpack_require__(210);

var _queryString2 = _interopRequireDefault(_queryString);

var _productEnum = __webpack_require__(539);

var _productEnum2 = _interopRequireDefault(_productEnum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var productService = function () {
    function productService() {
        _classCallCheck(this, productService);
    }

    _createClass(productService, null, [{
        key: 'Configure',
        value: function Configure() {
            var selectedProductId = void 0;

            var productIdInQueryString = _queryString2.default.parse(location.search);

            if (productIdInQueryString.productId) {
                selectedProductId = Number.parseInt(productIdInQueryString.productId, 10);
            }
            var initialState = {
                product: {
                    id: selectedProductId,
                    name: this.getProductNameById(selectedProductId)
                } };
            return initialState;
        }
    }, {
        key: 'getProductNameById',
        value: function getProductNameById(id) {
            var productName = '';
            if (id) {
                for (var key in _productEnum2.default) {
                    if (_productEnum2.default[key].id === id) {
                        productName = _productEnum2.default[key].name;
                        break;
                    }
                }
            }
            return productName;
        }
    }]);

    return productService;
}();

exports.default = productService;

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = __webpack_require__(81);

var _saga = __webpack_require__(528);

var masterCourseSagas = _interopRequireWildcard(_saga);

var _saga2 = __webpack_require__(514);

var courseCreatorSagas = _interopRequireWildcard(_saga2);

var _saga3 = __webpack_require__(520);

var defaultCoursesSagas = _interopRequireWildcard(_saga3);

var _saga4 = __webpack_require__(532);

var setDefaultCourses = _interopRequireWildcard(_saga4);

var _saga5 = __webpack_require__(507);

var authenticationSagas = _interopRequireWildcard(_saga5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(mainSaga);

function mainSaga() {
    return regeneratorRuntime.wrap(function mainSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.all)([masterCourseSagas.getMasterCoursesCountriesSaga(), masterCourseSagas.getMasterCoursesByCountrySaga(), masterCourseSagas.getMasterCoursesSaga(), masterCourseSagas.getSubjectsSaga(), courseCreatorSagas.getMasterCourseSaga(), courseCreatorSagas.saveCourseSaga(), courseCreatorSagas.publishCourseSaga(), courseCreatorSagas.getDefaultCourseSaga(), defaultCoursesSagas.getDefaultCoursesSaga(), defaultCoursesSagas.applySearchFilterSaga(), defaultCoursesSagas.filterDefaultCoursesSaga(), defaultCoursesSagas.archiveSelectedCourseSaga(), setDefaultCourses.getDefaulCoursesForCountrySaga(), setDefaultCourses.getCoursesForCountrySaga(), setDefaultCourses.saveDefaultCoursesForCountrySaga(), setDefaultCourses.saveDefaultCoursesSaga(), setDefaultCourses.getCoursesSaga(), authenticationSagas.checkUserIsAuthorizedSaga()]);

                case 2:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

exports.default = mainSaga;

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = __webpack_require__(43);

var _reducer = __webpack_require__(523);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(527);

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__(519);

var _reducer6 = _interopRequireDefault(_reducer5);

var _reducer7 = __webpack_require__(513);

var _reducer8 = _interopRequireDefault(_reducer7);

var _reducer9 = __webpack_require__(502);

var _reducer10 = _interopRequireDefault(_reducer9);

var _reducer11 = __webpack_require__(531);

var _reducer12 = _interopRequireDefault(_reducer11);

var _reducer13 = __webpack_require__(506);

var _reducer14 = _interopRequireDefault(_reducer13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducers = (0, _redux.combineReducers)({
    product: function product(state) {
        return _extends({}, state);
    },
    language: _reducer2.default,
    masterCourse: _reducer4.default,
    courseCreator: _reducer8.default,
    defaultCourse: _reducer6.default,
    toast: _reducer10.default,
    setDefaultCourse: _reducer12.default,
    authorization: _reducer14.default
});

exports.default = reducers;

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(214);

var _index = __webpack_require__(511);

var _index2 = _interopRequireDefault(_index);

var _defaultCourses = __webpack_require__(517);

var _defaultCourses2 = _interopRequireDefault(_defaultCourses);

var _masterCourses = __webpack_require__(525);

var _masterCourses2 = _interopRequireDefault(_masterCourses);

var _setDefaultCourses = __webpack_require__(529);

var _setDefaultCourses2 = _interopRequireDefault(_setDefaultCourses);

var _constants = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Routes = function Routes() {
    return _react2.default.createElement(
        _reactRouterDom.Switch,
        null,
        _react2.default.createElement(_reactRouterDom.Route, { component: _defaultCourses2.default, path: _constants.DEFAULT_COURSES_ROUTE }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _masterCourses2.default, path: _constants.MASTER_COURSES_ROUTE }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _setDefaultCourses2.default, path: _constants.SET_DEFAULT_COURSES_ROUTE }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _index2.default, path: '' + _constants.COURSE_CREATOR_ROUTE + _constants.MASTER_COURSES_ROUTE + '/:actionType/:productId/:masterCourseId/:version' }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _index2.default, path: '' + _constants.COURSE_CREATOR_ROUTE + _constants.DEFAULT_COURSES_ROUTE + '/:actionType/:productId/:defaultCourseId/version/:version' }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _defaultCourses2.default, path: '/' })
    );
};

exports.default = Routes;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = configureStore;

var _redux = __webpack_require__(43);

var _reduxSaga = __webpack_require__(1094);

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _reducers = __webpack_require__(542);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sagaMiddleware = (0, _reduxSaga2.default)();

function configureStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // Create the store with middlewares
    var middlewares = [sagaMiddleware];

    var enhancers = [_redux.applyMiddleware.apply(undefined, middlewares)];

    // If Redux DevTools Extension is installed use it, otherwise use Redux compose
    /* eslint-disable no-underscore-dangle */
    var composeEnhancers =  false ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : _redux.compose;
    /* eslint-enable */

    var store = (0, _redux.createStore)(_reducers2.default, initialState, composeEnhancers.apply(undefined, enhancers));

    // Extensions
    store.runSaga = sagaMiddleware.run;

    return store;
}

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    grey: {
        100: '#e7e9ea',
        200: '#e1e1e1',
        300: '#d6d6d6',
        400: '#cfd2d4',
        500: '#999b9d',
        600: '#808080',
        700: '#777',
        800: '#595959',
        900: '#484848'
    },

    iron: '#d7dbdd',
    nevada: 'rgb(78, 92, 103)',
    lightGreyShadow: 'rgba(0, 0, 0, 0.3)',
    silverDark: '#cdcdcd',
    emperor: '#555555',
    buttercup: '#f69e13',
    porcelain: '#e7e9ea',
    scandal: '#c7fbe6',
    mercury: '#e6e6e6',
    hitGray: '#adb6bc',
    oxfordBlue: '#3b4e5e'
};

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _palette = __webpack_require__(256);

var _palette2 = _interopRequireDefault(_palette);

var _colours = __webpack_require__(545);

var _colours2 = _interopRequireDefault(_colours);

var _shadows = __webpack_require__(549);

var _shadows2 = _interopRequireDefault(_shadows);

var _layout = __webpack_require__(547);

var _layout2 = _interopRequireDefault(_layout);

var _typography = __webpack_require__(550);

var _typography2 = _interopRequireDefault(_typography);

var _zIndex = __webpack_require__(551);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _overrides = __webpack_require__(548);

var _overrides2 = _interopRequireDefault(_overrides);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    palette: _palette2.default,
    colours: _colours2.default,
    shadows: _shadows2.default,
    layout: _layout2.default,
    typography: _typography2.default,
    zIndex: _zIndex2.default,
    overrides: _overrides2.default
};

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    borderRadius: '5px',
    spacing: 8
};

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * Override styles for specific components
 * All available overrides are listed here but set to null
 */

exports.default = {
    dropdownMenu: {
        optionPadding: null
    }
};

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    black: {
        100: 'rgba(0, 0, 0, 0.07)',
        200: 'rgba(0, 0, 0, 0.2)',
        300: 'rgba(0, 0, 0, 0.33)',
        400: 'rgba(0, 0, 0, 0.4)',
        500: 'rgba(0, 0, 0, 0.5)',
        600: 'rgba(0, 0, 0, 0.6)',
        700: 'rgba(0, 0, 0, 0.7)',
        800: 'rgba(0, 0, 0, 0.8)',
        900: 'rgba(0, 0, 0, 0.9)'
    },
    grey: {
        100: 'rgba(72, 72, 72, 0.07)',
        200: 'rgba(72, 72, 72, 0.2)',
        300: 'rgba(72, 72, 72, 0.33)',
        400: 'rgba(72, 72, 72, 0.4)',
        500: 'rgba(72, 72, 72, 0.5)',
        600: 'rgba(72, 72, 72, 0.6)',
        700: 'rgba(72, 72, 72, 0.7)',
        800: 'rgba(72, 72, 72, 0.8)',
        900: 'rgba(72, 72, 72, 0.9)'
    }
};

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _palette = __webpack_require__(256);

var _palette2 = _interopRequireDefault(_palette);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var typography = {
    family: 'poppins, Arial, sans-serif',
    size: '14px',
    lineHeight: '18px',
    weightLight: 400,
    weightNormal: 500,
    weightBold: 600,
    colour: _palette2.default.primary.dark
};

typography.title = {
    size: '30px',
    weight: typography.weightBold,
    colour: typography.colour
};

typography.subtitle = {
    size: '16px',
    weight: typography.weightNormal,
    colour: _palette2.default.primary.main
};

typography.heading = {
    size: '25px',
    weight: typography.weightBold
};

typography.modalTitle = {
    size: '20px',
    weight: typography.weightNormal
};

typography.info = {
    size: '13px',
    weight: typography.weightNormal
};

exports.default = typography;

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dropdown: 90,
    modal: 100
};

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _truncate = __webpack_require__(961);

var _truncate2 = _interopRequireDefault(_truncate);

var _styled = __webpack_require__(485);

var _styled2 = _interopRequireDefault(_styled);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_OPTION_LENGTH = 60;

var DropdownList = function (_PureComponent) {
    _inherits(DropdownList, _PureComponent);

    function DropdownList() {
        _classCallCheck(this, DropdownList);

        return _possibleConstructorReturn(this, (DropdownList.__proto__ || Object.getPrototypeOf(DropdownList)).apply(this, arguments));
    }

    _createClass(DropdownList, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var index = 1;
            var keyAttr = !this.props.optionKey ? 'key' : this.props.optionKey;
            var stringAttr = !this.props.optionText ? 'value' : this.props.optionText;

            // Custom label generator that uses function to use current item's properties
            var customLabelFn = this.props.customLabelFn;

            var customItemLabelGenerator = customLabelFn || function () {};

            var listOptions = this.props.options ? this.props.options.map(function (option) {
                var text = customLabelFn ? customItemLabelGenerator(option) : option[stringAttr];
                var truncatedText = (0, _truncate2.default)(text, { length: _this2.props.optionLength > 0 ? _this2.props.optionLength : MAX_OPTION_LENGTH });
                index += 1;
                var disabled = option.disabled ? { disabled: 'disabled' } : {};
                return _react2.default.createElement(
                    'option',
                    _extends({}, disabled, {
                        key: option[keyAttr] + '_' + index,
                        title: text,
                        value: option[keyAttr]
                    }),
                    truncatedText
                );
            }) : '';

            var placeholderText = '';

            if (this.props.isLoading) {
                placeholderText = this.props.loadingPlaceholder ? this.props.loadingPlaceholder : this.props.placeholder + ' ...';
            } else {
                placeholderText = this.props.placeholder;
            }
            var placeholderOption = this.props.placeholder ? _react2.default.createElement(
                'option',
                {
                    key: '-1',
                    value: ''
                },
                placeholderText
            ) : '';

            var isDropdownDisabled = this.props.disabled ? { disabled: 'disabled' } : {};
            return _react2.default.createElement(
                _styled2.default,
                null,
                _react2.default.createElement(
                    'select',
                    _extends({}, isDropdownDisabled, {
                        name: this.props.name,
                        onChange: function onChange(e) {
                            _this2.props.onChange(e.currentTarget.name, e.currentTarget.value);
                        },
                        value: this.props.value }),
                    placeholderOption,
                    listOptions
                ),
                _react2.default.createElement('div', { className: 'icon' })
            );
        }
    }]);

    return DropdownList;
}(_react.PureComponent);

DropdownList.propTypes = {
    css: _propTypes2.default.object,
    customLabelFn: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    loadingPlaceholder: _propTypes2.default.string,
    name: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    options: _propTypes2.default.array,
    optionLength: _propTypes2.default.number,
    optionKey: _propTypes2.default.string,
    optionText: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    value: _propTypes2.default.string,
    variant: _propTypes2.default.string
};

exports.default = DropdownList;

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactStyleable = __webpack_require__(218);

var _reactStyleable2 = _interopRequireDefault(_reactStyleable);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = __webpack_require__(1011);

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

__webpack_require__(1117);

var _svgIcon = __webpack_require__(1113);

var _svgIcon2 = _interopRequireDefault(_svgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIcon = function SvgIcon(_ref) {
    var _ref$icon = _ref.icon,
        icon = _ref$icon === undefined ? '' : _ref$icon;

    var svg = icon ? _react2.default.createElement(_reactInlinesvg2.default, { src: icon }) : '';
    return _react2.default.createElement(
        'div',
        { className: _svgIcon2.default.svgIconComponent },
        svg
    );
};

SvgIcon.propTypes = {
    icon: _propTypes2.default.string
};

exports.default = (0, _reactStyleable2.default)(_svgIcon2.default)(SvgIcon);

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Delete = exports.Warning = exports.Down = exports.Up = exports.Left = exports.Right = exports.Preview = exports.Hidden = exports.Visible = exports.Edit = exports.Cross = exports.Collapse = exports.Expand = exports.Move = exports.Tick = undefined;

var _icon_tick = __webpack_require__(1134);

var _icon_tick2 = _interopRequireDefault(_icon_tick);

var _icon_move = __webpack_require__(1131);

var _icon_move2 = _interopRequireDefault(_icon_move);

var _icon_dropdown = __webpack_require__(1127);

var _icon_dropdown2 = _interopRequireDefault(_icon_dropdown);

var _icon_up_solid = __webpack_require__(1136);

var _icon_up_solid2 = _interopRequireDefault(_icon_up_solid);

var _icon_cross = __webpack_require__(1124);

var _icon_cross2 = _interopRequireDefault(_icon_cross);

var _icon_edit = __webpack_require__(1128);

var _icon_edit2 = _interopRequireDefault(_icon_edit);

var _icon_visible = __webpack_require__(1137);

var _icon_visible2 = _interopRequireDefault(_icon_visible);

var _icon_hidden = __webpack_require__(1129);

var _icon_hidden2 = _interopRequireDefault(_icon_hidden);

var _icon_preview = __webpack_require__(1132);

var _icon_preview2 = _interopRequireDefault(_icon_preview);

var _icon_right_solid = __webpack_require__(1133);

var _icon_right_solid2 = _interopRequireDefault(_icon_right_solid);

var _icon_left_solid = __webpack_require__(1130);

var _icon_left_solid2 = _interopRequireDefault(_icon_left_solid);

var _icon_up = __webpack_require__(1135);

var _icon_up2 = _interopRequireDefault(_icon_up);

var _icon_down = __webpack_require__(1126);

var _icon_down2 = _interopRequireDefault(_icon_down);

var _icon_warning = __webpack_require__(1138);

var _icon_warning2 = _interopRequireDefault(_icon_warning);

var _icon_delete = __webpack_require__(1125);

var _icon_delete2 = _interopRequireDefault(_icon_delete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Tick = _icon_tick2.default;
exports.Move = _icon_move2.default;
exports.Expand = _icon_dropdown2.default;
exports.Collapse = _icon_up_solid2.default;
exports.Cross = _icon_cross2.default;
exports.Edit = _icon_edit2.default;
exports.Visible = _icon_visible2.default;
exports.Hidden = _icon_hidden2.default;
exports.Preview = _icon_preview2.default;
exports.Right = _icon_right_solid2.default;
exports.Left = _icon_left_solid2.default;
exports.Up = _icon_up2.default;
exports.Down = _icon_down2.default;
exports.Warning = _icon_warning2.default;
exports.Delete = _icon_delete2.default;

/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(33)();
// imports


// module
exports.push([module.i, ".component---1QTPR {\n  display: inline-block; }\n\n.componentDisabled---1Ifui {\n  cursor: not-allowed; }\n\n.buttonContainer---3Ctpt, .reverseButtonContainer---2hWzH, .buttonContainerDisabled---1Ho9p {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  outline: none; }\n\n.reverseButtonContainer---2hWzH {\n  -ms-flex-flow: row-reverse wrap;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n          flex-flow: row-reverse wrap; }\n\n.buttonContainerDisabled---1Ho9p {\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: not-allowed; }\n\n/**\n * Rounded button\n */\n\n.dark---1A8ui, .denim---3SXJQ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  height: 45px;\n  min-width: 80px;\n  border: 1px solid #959595;\n  border-radius: 25px;\n  background-color: #415667;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.2em; }\n\n.dark---1A8ui > div, .denim---3SXJQ > div {\n    padding: 9px 18px;\n    width: 100%;\n    height: 100%; }\n\n.dark---1A8ui > div > span, .denim---3SXJQ > div > span {\n    white-space: nowrap; }\n\n.light---3fZNV {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  height: 40px;\n  width: auto;\n  border: 1px solid #e1e1e1;\n  background-color: #fff;\n  border-radius: 24px;\n  margin: auto;\n  text-align: center;\n  padding: 9px;\n  color: #444;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer; }\n\n.light---3fZNV > div {\n    padding: 9px 18px;\n    width: 100%;\n    height: 100%; }\n\n.light---3fZNV > div > span {\n    white-space: nowrap; }\n\n.denim---3SXJQ {\n  border: 1px solid #1981c4;\n  background-color: #1981c4; }\n\n.defaultIcon---2UzRv, .darkIcon---17M66, .lightIcon---2HyJs {\n  width: 25px;\n  height: 25px;\n  margin: 7px; }\n\n.darkIcon---17M66 svg path {\n  fill: #fff !important; }\n\n.lightIcon---2HyJs svg path {\n  fill: #415667 !important; }\n\n/**\n * Circle button\n */\n\n.circleBtn---2JUxP, .circleSuccess---3rbB_, .circleDanger---29XAW {\n  height: 90px;\n  width: 90px;\n  border-radius: 90px;\n  background-color: #5cb85c; }\n\n.circleSuccess---3rbB_ {\n  background-color: #5cb85c; }\n\n.circleIconSvg---2ik4p {\n  width: 40px;\n  height: 40px;\n  margin: 22px; }\n\n.circleIconSvg---2ik4p svg path {\n    fill: white !important; }\n\n.circleDanger---29XAW {\n  background-color: #c53902; }\n\n/**\n * Icon only button\n */\n\n.iconOnly---2p_vJ {\n  width: 20px;\n  height: 21px; }\n\n.iconOnlySvg----thXv {\n  width: 100%;\n  height: 100%; }\n\n.iconOnlySvg----thXv svg path {\n    fill: #1981c4 !important; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1QTPR",
	"componentDisabled": "componentDisabled---1Ifui",
	"buttonContainer": "buttonContainer---3Ctpt",
	"reverseButtonContainer": "reverseButtonContainer---2hWzH",
	"buttonContainerDisabled": "buttonContainerDisabled---1Ho9p",
	"dark": "dark---1A8ui",
	"denim": "denim---3SXJQ",
	"light": "light---3fZNV",
	"defaultIcon": "defaultIcon---2UzRv",
	"darkIcon": "darkIcon---17M66",
	"lightIcon": "lightIcon---2HyJs",
	"circleBtn": "circleBtn---2JUxP",
	"circleSuccess": "circleSuccess---3rbB_",
	"circleDanger": "circleDanger---29XAW",
	"circleIconSvg": "circleIconSvg---2ik4p",
	"iconOnly": "iconOnly---2p_vJ",
	"iconOnlySvg": "iconOnlySvg----thXv"
};

/***/ }),

/***/ 756:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(33)();
// imports


// module
exports.push([module.i, ".footer---1MePj {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  position: fixed;\n  height: 50px;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 100%;\n  padding-right: 10px;\n  padding-left: 10px;\n  background-color: #adb6bc; }\n  .footer---1MePj .backPanel---2cMzr {\n    width: 10%; }\n  .footer---1MePj .savePanel---3AvMa {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    width: 90%; }\n  .footer---1MePj .savePanel---3AvMa > div {\n      margin-left: 10px; }\n", ""]);

// exports
exports.locals = {
	"footer": "footer---1MePj",
	"backPanel": "backPanel---2cMzr",
	"savePanel": "savePanel---3AvMa"
};

/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(33)();
// imports


// module
exports.push([module.i, "/**\n * Basic Breakpoint\n * url: https://responsivedesign.is/develop/getting-started-with-sass-and-breakpoint-mixin\n *\n * Usage:\n *\n * breakpoint(small-only | medium-up | medium-only | large-up | large-only) {\n * styles goes here\n * }\n*/\n.modal---1os_3 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  height: 100%;\n  background-color: rgba(255, 255, 255, .85);\n  border-radius: 5px;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 30px;\n  z-index: 99991; }\n@media screen and (max-width: 39.9375em) {\n    .modal---1os_3 {\n      padding: 10px; } }\n.modalBackdrop---3EUUD {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(255, 255, 255, .85);\n  padding: 10px;\n  z-index: 99990; }\n@media print {\n  body,\n  div {\n    display: block !important;\n    height: 100%;\n    width: 100%; }\n  div[class^=\"modalBackdrop-\"],\n  div[class*=\"modalBackdrop-\"] {\n    position: absolute;\n    page-break-inside: avoid;\n    height: 100% !important;\n    display: block !important; }\n  div[class^=\"modal-\"],\n  div[class*=\"modal-\"] {\n    height: 100% !important; } }\n", ""]);

// exports
exports.locals = {
	"modal": "modal---1os_3",
	"modalBackdrop": "modalBackdrop---3EUUD"
};

/***/ }),

/***/ 758:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(33)();
// imports


// module
exports.push([module.i, ".pulseLoader---2yixX {\n  display: inline-block;\n  position: relative;\n  width: 64px;\n  min-height: 15px; }\n  .pulseLoader---2yixX div {\n    position: absolute;\n    top: 35%;\n    width: 11px;\n    height: 11px;\n    border-radius: 50%;\n    background: #cfd2d4;\n    -webkit-animation-timing-function: cubic-bezier(0, 1, 1, 0);\n            animation-timing-function: cubic-bezier(0, 1, 1, 0); }\n  .pulseLoader---2yixX div:nth-child(1) {\n    left: 6px;\n    -webkit-animation: lds-ellipsis1----G_mv 0.6s infinite;\n            animation: lds-ellipsis1----G_mv 0.6s infinite; }\n  .pulseLoader---2yixX div:nth-child(2) {\n    left: 6px;\n    -webkit-animation: lds-ellipsis2---V6TJT 0.6s infinite;\n            animation: lds-ellipsis2---V6TJT 0.6s infinite; }\n  .pulseLoader---2yixX div:nth-child(3) {\n    left: 26px;\n    -webkit-animation: lds-ellipsis2---V6TJT 0.6s infinite;\n            animation: lds-ellipsis2---V6TJT 0.6s infinite; }\n  .pulseLoader---2yixX div:nth-child(4) {\n    left: 45px;\n    -webkit-animation: lds-ellipsis3---NZMgJ 0.6s infinite;\n            animation: lds-ellipsis3---NZMgJ 0.6s infinite; }\n  @-webkit-keyframes lds-ellipsis1----G_mv {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n  @keyframes lds-ellipsis1----G_mv {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n  @-webkit-keyframes lds-ellipsis3---NZMgJ {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  100% {\n    -webkit-transform: scale(0);\n            transform: scale(0); } }\n  @keyframes lds-ellipsis3---NZMgJ {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  100% {\n    -webkit-transform: scale(0);\n            transform: scale(0); } }\n  @-webkit-keyframes lds-ellipsis2---V6TJT {\n  0% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); }\n  100% {\n    -webkit-transform: translate(19px, 0);\n            transform: translate(19px, 0); } }\n  @keyframes lds-ellipsis2---V6TJT {\n  0% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); }\n  100% {\n    -webkit-transform: translate(19px, 0);\n            transform: translate(19px, 0); } }\n", ""]);

// exports
exports.locals = {
	"pulseLoader": "pulseLoader---2yixX",
	"lds-ellipsis1": "lds-ellipsis1----G_mv",
	"lds-ellipsis2": "lds-ellipsis2---V6TJT",
	"lds-ellipsis3": "lds-ellipsis3---NZMgJ"
};

/***/ }),

/***/ 759:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(33)();
// imports


// module
exports.push([module.i, ".rootContainer---1XRuo {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 100%; }\n", ""]);

// exports
exports.locals = {
	"rootContainer": "rootContainer---1XRuo"
};

/***/ }),

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(33)();
// imports


// module
exports.push([module.i, ".info---32b5Q {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 48px;\n  border: 1px solid #cdcdcd;\n  border-radius: 7px;\n  -webkit-box-shadow: 10px 5px 5px rgba(0, 0, 0, .1);\n          box-shadow: 10px 5px 5px rgba(0, 0, 0, .1);\n  background: white; }\n\n.checkbox---FVRHw {\n  display: -webkit-inline-box;\n  display: -moz-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin: 8px;\n  width: 98%; }\n\n.checkbox---FVRHw .chklabel---27cY4 {\n  width: 20px;\n  height: 20px;\n  border: 1px solid #cdcdcd;\n  margin-top: 4px; }\n\n.checkbox---FVRHw .name---BdXNB {\n  display: none; }\n\n.checkbox---FVRHw .description---1WoGi {\n  width: 93%;\n  padding-left: 10px;\n  padding-top: 5px;\n  color: #555555;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.name---BdXNB + label {\n  position: relative;\n  overflow: hidden;\n  border-radius: 3px;\n  -webkit-appearance: none;\n  cursor: pointer;\n  width: 5%; }\n\n.name---BdXNB:checked + label::after {\n  background-color: white !important;\n  content: \"\\F00C\";\n  color: black;\n  font-family: \"FontAwesome\";\n  font-size: 16px; }\n", ""]);

// exports
exports.locals = {
	"info": "info---32b5Q",
	"checkbox": "checkbox---FVRHw",
	"chklabel": "chklabel---27cY4",
	"name": "name---BdXNB",
	"description": "description---1WoGi"
};

/***/ }),

/***/ 761:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(33)();
// imports


// module
exports.push([module.i, "@-webkit-keyframes spin---3e23d {\n  from {\n    -webkit-transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(360deg); } }\n\n@keyframes spin---3e23d {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.loadingIcon---z4lLP {\n  height: 132px;\n  width: 132px; }\n\n.loader---2OSoq {\n  border-width: 6px;\n  border-style: solid;\n  border-color: #3498db transparent transparent;\n  -o-border-image: none;\n     border-image: none;\n  -o-border-image: initial;\n     border-image: initial;\n  border-radius: 50%;\n  width: 100%;\n  height: 100%; }\n\n.loaderSpeed---UPTKZ {\n  -webkit-animation: spin---3e23d 1.5s linear infinite;\n          animation: spin---3e23d 1.5s linear infinite; }\n", ""]);

// exports
exports.locals = {
	"loadingIcon": "loadingIcon---z4lLP",
	"loader": "loader---2OSoq",
	"loaderSpeed": "loaderSpeed---UPTKZ",
	"spin": "spin---3e23d"
};

/***/ }),

/***/ 762:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(33)();
// imports


// module
exports.push([module.i, ".svgIconComponent---2bpZU {\n  display: inline;\n  pointer-events: none; }\n", ""]);

// exports
exports.locals = {
	"svgIconComponent": "svgIconComponent---2bpZU"
};

/***/ }),

/***/ 763:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(33)();
// imports


// module
exports.push([module.i, ".toast---2L2-i {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  visibility: visible;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  opacity: 0;\n  -webkit-animation: fadeIn---s7cFb 7s;\n          animation: fadeIn---s7cFb 7s;\n  font-family: poppins, Arial, sans-serif !important;\n  font-size: 17px;\n  z-index: 2147483647; }\n  .toastContent---1Zj3X {\n    padding: 15px;\n    width: 100%; }\n  .message---2WI7- {\n  color: white; }\n  @-webkit-keyframes fadeIn---s7cFb {\n  0% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n  @keyframes fadeIn---s7cFb {\n  0% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n  @media print {\n  .empty---1za14 {\n    display: none !important;\n    height: 0.001px !important; } }\n", ""]);

// exports
exports.locals = {
	"toast": "toast---2L2-i",
	"fadeIn": "fadeIn---s7cFb",
	"toastContent": "toastContent---1Zj3X",
	"message": "message---2WI7-",
	"empty": "empty---1za14"
};

/***/ }),

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(33)();
// imports


// module
exports.push([module.i, ".loadingContainer---CbhAk {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  position: fixed;\n  left: 0;\n  top: 0;\n  display: flex;\n  background: #dbe3e9;\n  z-index: 100000;\n  opacity: 0.3;\n  height: 100%;\n  width: 100%; }\n", ""]);

// exports
exports.locals = {
	"loadingContainer": "loadingContainer---CbhAk"
};

/***/ }),

/***/ 765:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(33)();
// imports


// module
exports.push([module.i, ".component---1BHxF {\n  display: block; }\n\n.actionButtons---3gK3n {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  width: 250px; }\n\n.actionButtons---3gK3n div {\n    padding: 2px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1BHxF",
	"actionButtons": "actionButtons---3gK3n"
};

/***/ }),

/***/ 766:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(33)();
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n/* React Core CSS */\n/**\n * Extra class applied to VirtualScroll through className prop\n */\n.rst__virtualScrollOverride {\n  overflow: auto !important;\n}\n.rst__virtualScrollOverride * {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.ReactVirtualized__Grid__innerScrollContainer {\n  overflow: visible !important;\n}\n.rst__rtl .ReactVirtualized__Grid__innerScrollContainer {\n  direction: rtl;\n}\n.ReactVirtualized__Grid {\n  outline: none;\n}\n.rst__node {\n  min-width: 100%;\n  white-space: nowrap;\n  position: relative;\n  text-align: left;\n}\n.rst__node.rst__rtl {\n  text-align: right;\n}\n.rst__nodeContent {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n}\n/* ==========================================================================\n   Scaffold\n\n    Line-overlaid blocks used for showing the tree structure\n   ========================================================================== */\n.rst__lineBlock,\n.rst__absoluteLineBlock {\n  height: 100%;\n  position: relative;\n  display: inline-block;\n}\n.rst__absoluteLineBlock {\n  position: absolute;\n  top: 0;\n}\n.rst__lineHalfHorizontalRight::before,\n.rst__lineFullVertical::after,\n.rst__lineHalfVerticalTop::after,\n.rst__lineHalfVerticalBottom::after {\n  position: absolute;\n  content: '';\n  background-color: black;\n}\n/**\n * +-----+\n * |     |\n * |  +--+\n * |     |\n * +-----+\n */\n.rst__lineHalfHorizontalRight::before {\n  height: 1px;\n  top: 50%;\n  right: 0;\n  width: 50%;\n}\n.rst__rtl.rst__lineHalfHorizontalRight::before {\n  left: 0;\n  right: auto;\n  right: initial;\n}\n/**\n * +--+--+\n * |  |  |\n * |  |  |\n * |  |  |\n * +--+--+\n */\n.rst__lineFullVertical::after,\n.rst__lineHalfVerticalTop::after,\n.rst__lineHalfVerticalBottom::after {\n  width: 1px;\n  left: 50%;\n  top: 0;\n  height: 100%;\n}\n/**\n * +--+--+\n * |  |  |\n * |  |  |\n * |  |  |\n * +--+--+\n */\n.rst__rtl.rst__lineFullVertical::after,\n.rst__rtl.rst__lineHalfVerticalTop::after,\n.rst__rtl.rst__lineHalfVerticalBottom::after {\n  right: 50%;\n  left: auto;\n  left: initial;\n}\n/**\n * +-----+\n * |  |  |\n * |  +  |\n * |     |\n * +-----+\n */\n.rst__lineHalfVerticalTop::after {\n  height: 50%;\n}\n/**\n * +-----+\n * |     |\n * |  +  |\n * |  |  |\n * +-----+\n */\n.rst__lineHalfVerticalBottom::after {\n  top: auto;\n  bottom: 0;\n  height: 50%;\n}\n/* Highlight line for pointing to dragged row destination\n   ========================================================================== */\n/**\n * +--+--+\n * |  |  |\n * |  |  |\n * |  |  |\n * +--+--+\n */\n.rst__highlightLineVertical {\n  z-index: 3;\n}\n.rst__highlightLineVertical::before {\n  position: absolute;\n  content: '';\n  background-color: #36c2f6;\n  width: 8px;\n  margin-left: -4px;\n  left: 50%;\n  top: 0;\n  height: 100%;\n}\n.rst__rtl.rst__highlightLineVertical::before {\n  margin-left: 0;\n  margin-left: initial;\n  margin-right: -4px;\n  left: auto;\n  left: initial;\n  right: 50%;\n}\n@-webkit-keyframes arrow-pulse {\n  0% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0);\n    opacity: 0;\n  }\n  30% {\n    -webkit-transform: translate(0, 300%);\n            transform: translate(0, 300%);\n    opacity: 1;\n  }\n  70% {\n    -webkit-transform: translate(0, 700%);\n            transform: translate(0, 700%);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translate(0, 1000%);\n            transform: translate(0, 1000%);\n    opacity: 0;\n  }\n}\n@keyframes arrow-pulse {\n  0% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0);\n    opacity: 0;\n  }\n  30% {\n    -webkit-transform: translate(0, 300%);\n            transform: translate(0, 300%);\n    opacity: 1;\n  }\n  70% {\n    -webkit-transform: translate(0, 700%);\n            transform: translate(0, 700%);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translate(0, 1000%);\n            transform: translate(0, 1000%);\n    opacity: 0;\n  }\n}\n.rst__highlightLineVertical::after {\n  content: '';\n  position: absolute;\n  height: 0;\n  margin-left: -4px;\n  left: 50%;\n  top: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid white;\n  -webkit-animation: arrow-pulse 1s infinite linear both;\n          animation: arrow-pulse 1s infinite linear both;\n}\n.rst__rtl.rst__highlightLineVertical::after {\n  margin-left: 0;\n  margin-left: initial;\n  margin-right: -4px;\n  right: 50%;\n  left: auto;\n  left: initial;\n}\n/**\n * +-----+\n * |     |\n * |  +--+\n * |  |  |\n * +--+--+\n */\n.rst__highlightTopLeftCorner::before {\n  z-index: 3;\n  content: '';\n  position: absolute;\n  border-top: solid 8px #36c2f6;\n  border-left: solid 8px #36c2f6;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: calc(50% + 4px);\n  top: 50%;\n  margin-top: -4px;\n  right: 0;\n  width: calc(50% + 4px);\n}\n.rst__rtl.rst__highlightTopLeftCorner::before {\n  border-right: solid 8px #36c2f6;\n  border-left: none;\n  left: 0;\n  right: auto;\n  right: initial;\n}\n/**\n * +--+--+\n * |  |  |\n * |  |  |\n * |  +->|\n * +-----+\n */\n.rst__highlightBottomLeftCorner {\n  z-index: 3;\n}\n.rst__highlightBottomLeftCorner::before {\n  content: '';\n  position: absolute;\n  border-bottom: solid 8px #36c2f6;\n  border-left: solid 8px #36c2f6;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: calc(100% + 4px);\n  top: 0;\n  right: 12px;\n  width: calc(50% - 8px);\n}\n.rst__rtl.rst__highlightBottomLeftCorner::before {\n  border-right: solid 8px #36c2f6;\n  border-left: none;\n  left: 12px;\n  right: auto;\n  right: initial;\n}\n.rst__highlightBottomLeftCorner::after {\n  content: '';\n  position: absolute;\n  height: 0;\n  right: 0;\n  top: 100%;\n  margin-top: -12px;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n  border-left: 12px solid #36c2f6;\n}\n.rst__rtl.rst__highlightBottomLeftCorner::after {\n  left: 0;\n  right: auto;\n  right: initial;\n  border-right: 12px solid #36c2f6;\n  border-left: none;\n}\n.rst__rowWrapper {\n  padding: 10px 10px 10px 0;\n  height: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.rst__rtl.rst__rowWrapper {\n  padding: 10px 0 10px 10px;\n}\n.rst__row {\n  height: 100%;\n  white-space: nowrap;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.rst__row > * {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n/**\n * The outline of where the element will go if dropped, displayed while dragging\n */\n.rst__rowLandingPad,\n.rst__rowCancelPad {\n  border: none !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  outline: none !important;\n}\n.rst__rowLandingPad > *,\n.rst__rowCancelPad > * {\n  opacity: 0 !important;\n}\n.rst__rowLandingPad::before,\n.rst__rowCancelPad::before {\n  background-color: lightblue;\n  border: 3px dashed white;\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1;\n}\n/**\n * Alternate appearance of the landing pad when the dragged location is invalid\n */\n.rst__rowCancelPad::before {\n  background-color: #e6a8ad;\n}\n/**\n * Nodes matching the search conditions are highlighted\n */\n.rst__rowSearchMatch {\n  outline: solid 3px #0080ff;\n}\n/**\n * The node that matches the search conditions and is currently focused\n */\n.rst__rowSearchFocus {\n  outline: solid 3px #fc6421;\n}\n.rst__rowContents,\n.rst__rowLabel,\n.rst__rowToolbar,\n.rst__moveHandle,\n.rst__toolbarButton {\n  display: inline-block;\n  vertical-align: middle;\n}\n.rst__rowContents {\n  position: relative;\n  height: 100%;\n  border: solid #bbb 1px;\n  border-left: none;\n  -webkit-box-shadow: 0 2px 2px -2px;\n          box-shadow: 0 2px 2px -2px;\n  padding: 0 5px 0 10px;\n  border-radius: 2px;\n  min-width: 230px;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  background-color: white;\n}\n.rst__rtl.rst__rowContents {\n  border-right: none;\n  border-left: solid #bbb 1px;\n  padding: 0 10px 0 5px;\n}\n.rst__rowContentsDragDisabled {\n  border-left: solid #bbb 1px;\n}\n.rst__rtl.rst__rowContentsDragDisabled {\n  border-right: solid #bbb 1px;\n  border-left: solid #bbb 1px;\n}\n.rst__rowLabel {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 1 auto;\n          flex: 0 1 auto;\n  padding-right: 20px;\n}\n.rst__rtl.rst__rowLabel {\n  padding-left: 20px;\n  padding-right: inherit;\n}\n.rst__rowToolbar {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 1 auto;\n          flex: 0 1 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.rst__moveHandle,\n.rst__loadingHandle {\n  height: 100%;\n  width: 44px;\n  background: #d9d9d9\n    url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+')\n    no-repeat center;\n  border: solid #aaa 1px;\n  -webkit-box-shadow: 0 2px 2px -2px;\n          box-shadow: 0 2px 2px -2px;\n  cursor: move;\n  border-radius: 1px;\n  z-index: 1;\n}\n.rst__loadingHandle {\n  cursor: default;\n  background: #d9d9d9;\n}\n@-webkit-keyframes pointFade {\n  0%,\n  19.999%,\n  100% {\n    opacity: 0;\n  }\n  20% {\n    opacity: 1;\n  }\n}\n@keyframes pointFade {\n  0%,\n  19.999%,\n  100% {\n    opacity: 0;\n  }\n  20% {\n    opacity: 1;\n  }\n}\n.rst__loadingCircle {\n  width: 80%;\n  height: 80%;\n  margin: 10%;\n  position: relative;\n}\n.rst__loadingCirclePoint {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.rst__rtl.rst__loadingCirclePoint {\n  right: 0;\n  left: auto;\n  left: initial;\n}\n.rst__loadingCirclePoint::before {\n  content: '';\n  display: block;\n  margin: 0 auto;\n  width: 11%;\n  height: 30%;\n  background-color: #fff;\n  border-radius: 30%;\n  -webkit-animation: pointFade 800ms infinite ease-in-out both;\n          animation: pointFade 800ms infinite ease-in-out both;\n}\n.rst__loadingCirclePoint:nth-of-type(1) {\n  -webkit-transform: rotate(0deg);\n          transform: rotate(0deg);\n}\n.rst__loadingCirclePoint:nth-of-type(7) {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n.rst__loadingCirclePoint:nth-of-type(1)::before,\n.rst__loadingCirclePoint:nth-of-type(7)::before {\n  -webkit-animation-delay: -800ms;\n          animation-delay: -800ms;\n}\n.rst__loadingCirclePoint:nth-of-type(2) {\n  -webkit-transform: rotate(30deg);\n          transform: rotate(30deg);\n}\n.rst__loadingCirclePoint:nth-of-type(8) {\n  -webkit-transform: rotate(210deg);\n          transform: rotate(210deg);\n}\n.rst__loadingCirclePoint:nth-of-type(2)::before,\n.rst__loadingCirclePoint:nth-of-type(8)::before {\n  -webkit-animation-delay: -666ms;\n          animation-delay: -666ms;\n}\n.rst__loadingCirclePoint:nth-of-type(3) {\n  -webkit-transform: rotate(60deg);\n          transform: rotate(60deg);\n}\n.rst__loadingCirclePoint:nth-of-type(9) {\n  -webkit-transform: rotate(240deg);\n          transform: rotate(240deg);\n}\n.rst__loadingCirclePoint:nth-of-type(3)::before,\n.rst__loadingCirclePoint:nth-of-type(9)::before {\n  -webkit-animation-delay: -533ms;\n          animation-delay: -533ms;\n}\n.rst__loadingCirclePoint:nth-of-type(4) {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.rst__loadingCirclePoint:nth-of-type(10) {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n.rst__loadingCirclePoint:nth-of-type(4)::before,\n.rst__loadingCirclePoint:nth-of-type(10)::before {\n  -webkit-animation-delay: -400ms;\n          animation-delay: -400ms;\n}\n.rst__loadingCirclePoint:nth-of-type(5) {\n  -webkit-transform: rotate(120deg);\n          transform: rotate(120deg);\n}\n.rst__loadingCirclePoint:nth-of-type(11) {\n  -webkit-transform: rotate(300deg);\n          transform: rotate(300deg);\n}\n.rst__loadingCirclePoint:nth-of-type(5)::before,\n.rst__loadingCirclePoint:nth-of-type(11)::before {\n  -webkit-animation-delay: -266ms;\n          animation-delay: -266ms;\n}\n.rst__loadingCirclePoint:nth-of-type(6) {\n  -webkit-transform: rotate(150deg);\n          transform: rotate(150deg);\n}\n.rst__loadingCirclePoint:nth-of-type(12) {\n  -webkit-transform: rotate(330deg);\n          transform: rotate(330deg);\n}\n.rst__loadingCirclePoint:nth-of-type(6)::before,\n.rst__loadingCirclePoint:nth-of-type(12)::before {\n  -webkit-animation-delay: -133ms;\n          animation-delay: -133ms;\n}\n.rst__loadingCirclePoint:nth-of-type(7) {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n.rst__loadingCirclePoint:nth-of-type(13) {\n  -webkit-transform: rotate(360deg);\n          transform: rotate(360deg);\n}\n.rst__loadingCirclePoint:nth-of-type(7)::before,\n.rst__loadingCirclePoint:nth-of-type(13)::before {\n  -webkit-animation-delay: 0ms;\n          animation-delay: 0ms;\n}\n.rst__rowTitle {\n  font-weight: bold;\n}\n.rst__rowTitleWithSubtitle {\n  font-size: 85%;\n  display: block;\n  height: 12.8px;\n  height: 0.8rem;\n}\n.rst__rowSubtitle {\n  font-size: 70%;\n  line-height: 1;\n}\n.rst__collapseButton,\n.rst__expandButton {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border: none;\n  position: absolute;\n  border-radius: 100%;\n  -webkit-box-shadow: 0 0 0 1px #000;\n          box-shadow: 0 0 0 1px #000;\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n.rst__rtl.rst__collapseButton,\n.rst__rtl.rst__expandButton {\n  -webkit-transform: translate(50%, -50%);\n          transform: translate(50%, -50%);\n}\n.rst__collapseButton:focus,\n.rst__expandButton:focus {\n  outline: none;\n  -webkit-box-shadow: 0 0 0 1px #000, 0 0 1px 3px #83bef9;\n          box-shadow: 0 0 0 1px #000, 0 0 1px 3px #83bef9;\n}\n.rst__collapseButton:hover:not(:active),\n.rst__expandButton:hover:not(:active) {\n  background-size: 24px;\n  height: 20px;\n  width: 20px;\n}\n.rst__collapseButton {\n  background: #fff\n    url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48L2c+Cjwvc3ZnPg==')\n    no-repeat center;\n}\n.rst__expandButton {\n  background: #fff\n    url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48cGF0aCBkPSJNOSA0LjV2OSIvPjwvZz4KPC9zdmc+')\n    no-repeat center;\n}\n/**\n * Line for under a node with children\n */\n.rst__lineChildren {\n  height: 100%;\n  display: inline-block;\n  position: absolute;\n}\n.rst__lineChildren::after {\n  content: '';\n  position: absolute;\n  background-color: black;\n  width: 1px;\n  left: 50%;\n  bottom: 0;\n  height: 10px;\n}\n.rst__rtl.rst__lineChildren::after {\n  right: 50%;\n  left: auto;\n  left: initial;\n}\n.rst__placeholder {\n  position: relative;\n  height: 68px;\n  max-width: 300px;\n  padding: 10px;\n}\n.rst__placeholder,\n.rst__placeholder > * {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.rst__placeholder::before {\n  border: 3px dashed #d9d9d9;\n  content: '';\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  bottom: 5px;\n  left: 5px;\n  z-index: -1;\n}\n/**\n * The outline of where the element will go if dropped, displayed while dragging\n */\n.rst__placeholderLandingPad,\n.rst__placeholderCancelPad {\n  border: none !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  outline: none !important;\n}\n.rst__placeholderLandingPad *,\n.rst__placeholderCancelPad * {\n  opacity: 0 !important;\n}\n.rst__placeholderLandingPad::before,\n.rst__placeholderCancelPad::before {\n  background-color: lightblue;\n  border-color: white;\n}\n/**\n * Alternate appearance of the landing pad when the dragged location is invalid\n */\n.rst__placeholderCancelPad::before {\n  background-color: #e6a8ad;\n}\n/* Collection default theme */\n.ReactVirtualized__Collection {\n}\n.ReactVirtualized__Collection__innerScrollContainer {\n}\n/* Grid default theme */\n.ReactVirtualized__Grid {\n}\n.ReactVirtualized__Grid__innerScrollContainer {\n}\n/* Table default theme */\n.ReactVirtualized__Table {\n}\n.ReactVirtualized__Table__Grid {\n}\n.ReactVirtualized__Table__headerRow {\n  font-weight: 700;\n  text-transform: uppercase;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.ReactVirtualized__Table__row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.ReactVirtualized__Table__headerTruncatedText {\n  display: inline-block;\n  max-width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.ReactVirtualized__Table__headerColumn,\n.ReactVirtualized__Table__rowColumn {\n  margin-right: 10px;\n  min-width: 0px;\n}\n.ReactVirtualized__Table__rowColumn {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ReactVirtualized__Table__headerColumn:first-of-type,\n.ReactVirtualized__Table__rowColumn:first-of-type {\n  margin-left: 10px;\n}\n.ReactVirtualized__Table__sortableHeaderColumn {\n  cursor: pointer;\n}\n.ReactVirtualized__Table__sortableHeaderIconContainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.ReactVirtualized__Table__sortableHeaderIcon {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 24px;\n          flex: 0 0 24px;\n  height: 1em;\n  width: 1em;\n  fill: currentColor;\n}\n/* List default theme */\n.ReactVirtualized__List {\n}\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font-family: inherit;\n  vertical-align: baseline; }\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block; }\nol,\nul {\n  list-style: none; }\nblockquote,\nq {\n  quotes: none; }\nblockquote::before,\nblockquote::after,\nq::before,\nq::after {\n  content: '';\n  content: none; }\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block; }\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline; }\naudio:not([controls]) {\n  display: none;\n  height: 0; }\n[hidden],\ntemplate {\n  display: none; }\na {\n  background-color: transparent; }\na:active,\na:hover {\n  outline: 0; }\nabbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted; }\nb,\nstrong {\n  font-weight: inherit; }\nb,\nstrong {\n  font-weight: bolder; }\ndfn {\n  font-style: italic; }\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0; }\nmark {\n  background-color: #ff0;\n  color: #000; }\nsmall {\n  font-size: 80%; }\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline; }\nsup {\n  top: -0.5em; }\nsub {\n  bottom: -0.25em; }\nimg {\n  border: 0; }\nsvg:not(:root) {\n  overflow: hidden; }\nfigure {\n  margin: 1em 40px; }\nhr {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  height: 0;\n  overflow: visible; }\npre {\n  overflow: auto; }\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace;\n  font-size: 1em; }\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit;\n  margin: 0; }\nbutton {\n  overflow: visible; }\nbutton,\nselect {\n  text-transform: none; }\nbutton,\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer; }\nbutton[disabled] {\n  cursor: default; }\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0; }\nbutton:-moz-focusring,\ninput:-moz-focusring {\n  outline: 1px dotted ButtonText; }\ninput {\n  line-height: normal; }\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0; }\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; }\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em; }\nlegend {\n  border: 0;\n  padding: 0; }\ntextarea {\n  overflow: auto; }\noptgroup {\n  font-weight: bold; }\n@font-face {\n  font-family: 'Poppins';\n  src: url(\"//west.cdn.mathletics.com/html/fonts/Poppins/Poppins_400.ttf\") format(\"truetype\"); }\n/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */\n/* FONT PATH\n * -------------------------- */\n@font-face {\n  font-family: 'FontAwesome';\n  src: url(" + __webpack_require__(297) + ");\n  src: url(" + __webpack_require__(297) + "#iefix) format(\"embedded-opentype\"), url(" + __webpack_require__(795) + ") format(\"woff2\"), url(" + __webpack_require__(796) + ") format(\"woff\"), url(" + __webpack_require__(794) + ") format(\"truetype\"), url(" + __webpack_require__(797) + "#fontawesomeregular) format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n.fa {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n/* makes the font 33% larger relative to the icon container */\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -15%; }\n.fa-2x {\n  font-size: 2em; }\n.fa-3x {\n  font-size: 3em; }\n.fa-4x {\n  font-size: 4em; }\n.fa-5x {\n  font-size: 5em; }\n.fa-fw {\n  width: 1.28571em;\n  text-align: center; }\n.fa-ul {\n  padding-left: 0;\n  margin-left: 2.14286em;\n  list-style-type: none; }\n.fa-ul > li {\n    position: relative; }\n.fa-li {\n  position: absolute;\n  left: -2.14286em;\n  width: 2.14286em;\n  top: 0.14286em;\n  text-align: center; }\n.fa-li.fa-lg {\n    left: -1.85714em; }\n.fa-border {\n  padding: .2em .25em .15em;\n  border: solid 0.08em #eee;\n  border-radius: .1em; }\n.fa-pull-left {\n  float: left; }\n.fa-pull-right {\n  float: right; }\n.fa.fa-pull-left {\n  margin-right: .3em; }\n.fa.fa-pull-right {\n  margin-left: .3em; }\n/* Deprecated as of 4.4.0 */\n.pull-right {\n  float: right; }\n.pull-left {\n  float: left; }\n.fa.pull-left {\n  margin-right: .3em; }\n.fa.pull-right {\n  margin-left: .3em; }\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n  animation: fa-spin 2s infinite linear; }\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n  animation: fa-spin 1s infinite steps(8); }\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg); } }\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg); } }\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg); }\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg); }\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n  transform: rotate(270deg); }\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n  transform: scale(-1, 1); }\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n  transform: scale(1, -1); }\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical {\n  -webkit-filter: none;\n          filter: none; }\n.fa-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle; }\n.fa-stack-1x, .fa-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center; }\n.fa-stack-1x {\n  line-height: inherit; }\n.fa-stack-2x {\n  font-size: 2em; }\n.fa-inverse {\n  color: #fff; }\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\n   readers do not read off random characters that represent icons */\n.fa-glass:before {\n  content: \"\\F000\"; }\n.fa-music:before {\n  content: \"\\F001\"; }\n.fa-search:before {\n  content: \"\\F002\"; }\n.fa-envelope-o:before {\n  content: \"\\F003\"; }\n.fa-heart:before {\n  content: \"\\F004\"; }\n.fa-star:before {\n  content: \"\\F005\"; }\n.fa-star-o:before {\n  content: \"\\F006\"; }\n.fa-user:before {\n  content: \"\\F007\"; }\n.fa-film:before {\n  content: \"\\F008\"; }\n.fa-th-large:before {\n  content: \"\\F009\"; }\n.fa-th:before {\n  content: \"\\F00A\"; }\n.fa-th-list:before {\n  content: \"\\F00B\"; }\n.fa-check:before {\n  content: \"\\F00C\"; }\n.fa-remove:before,\n.fa-close:before,\n.fa-times:before {\n  content: \"\\F00D\"; }\n.fa-search-plus:before {\n  content: \"\\F00E\"; }\n.fa-search-minus:before {\n  content: \"\\F010\"; }\n.fa-power-off:before {\n  content: \"\\F011\"; }\n.fa-signal:before {\n  content: \"\\F012\"; }\n.fa-gear:before,\n.fa-cog:before {\n  content: \"\\F013\"; }\n.fa-trash-o:before {\n  content: \"\\F014\"; }\n.fa-home:before {\n  content: \"\\F015\"; }\n.fa-file-o:before {\n  content: \"\\F016\"; }\n.fa-clock-o:before {\n  content: \"\\F017\"; }\n.fa-road:before {\n  content: \"\\F018\"; }\n.fa-download:before {\n  content: \"\\F019\"; }\n.fa-arrow-circle-o-down:before {\n  content: \"\\F01A\"; }\n.fa-arrow-circle-o-up:before {\n  content: \"\\F01B\"; }\n.fa-inbox:before {\n  content: \"\\F01C\"; }\n.fa-play-circle-o:before {\n  content: \"\\F01D\"; }\n.fa-rotate-right:before,\n.fa-repeat:before {\n  content: \"\\F01E\"; }\n.fa-refresh:before {\n  content: \"\\F021\"; }\n.fa-list-alt:before {\n  content: \"\\F022\"; }\n.fa-lock:before {\n  content: \"\\F023\"; }\n.fa-flag:before {\n  content: \"\\F024\"; }\n.fa-headphones:before {\n  content: \"\\F025\"; }\n.fa-volume-off:before {\n  content: \"\\F026\"; }\n.fa-volume-down:before {\n  content: \"\\F027\"; }\n.fa-volume-up:before {\n  content: \"\\F028\"; }\n.fa-qrcode:before {\n  content: \"\\F029\"; }\n.fa-barcode:before {\n  content: \"\\F02A\"; }\n.fa-tag:before {\n  content: \"\\F02B\"; }\n.fa-tags:before {\n  content: \"\\F02C\"; }\n.fa-book:before {\n  content: \"\\F02D\"; }\n.fa-bookmark:before {\n  content: \"\\F02E\"; }\n.fa-print:before {\n  content: \"\\F02F\"; }\n.fa-camera:before {\n  content: \"\\F030\"; }\n.fa-font:before {\n  content: \"\\F031\"; }\n.fa-bold:before {\n  content: \"\\F032\"; }\n.fa-italic:before {\n  content: \"\\F033\"; }\n.fa-text-height:before {\n  content: \"\\F034\"; }\n.fa-text-width:before {\n  content: \"\\F035\"; }\n.fa-align-left:before {\n  content: \"\\F036\"; }\n.fa-align-center:before {\n  content: \"\\F037\"; }\n.fa-align-right:before {\n  content: \"\\F038\"; }\n.fa-align-justify:before {\n  content: \"\\F039\"; }\n.fa-list:before {\n  content: \"\\F03A\"; }\n.fa-dedent:before,\n.fa-outdent:before {\n  content: \"\\F03B\"; }\n.fa-indent:before {\n  content: \"\\F03C\"; }\n.fa-video-camera:before {\n  content: \"\\F03D\"; }\n.fa-photo:before,\n.fa-image:before,\n.fa-picture-o:before {\n  content: \"\\F03E\"; }\n.fa-pencil:before {\n  content: \"\\F040\"; }\n.fa-map-marker:before {\n  content: \"\\F041\"; }\n.fa-adjust:before {\n  content: \"\\F042\"; }\n.fa-tint:before {\n  content: \"\\F043\"; }\n.fa-edit:before,\n.fa-pencil-square-o:before {\n  content: \"\\F044\"; }\n.fa-share-square-o:before {\n  content: \"\\F045\"; }\n.fa-check-square-o:before {\n  content: \"\\F046\"; }\n.fa-arrows:before {\n  content: \"\\F047\"; }\n.fa-step-backward:before {\n  content: \"\\F048\"; }\n.fa-fast-backward:before {\n  content: \"\\F049\"; }\n.fa-backward:before {\n  content: \"\\F04A\"; }\n.fa-play:before {\n  content: \"\\F04B\"; }\n.fa-pause:before {\n  content: \"\\F04C\"; }\n.fa-stop:before {\n  content: \"\\F04D\"; }\n.fa-forward:before {\n  content: \"\\F04E\"; }\n.fa-fast-forward:before {\n  content: \"\\F050\"; }\n.fa-step-forward:before {\n  content: \"\\F051\"; }\n.fa-eject:before {\n  content: \"\\F052\"; }\n.fa-chevron-left:before {\n  content: \"\\F053\"; }\n.fa-chevron-right:before {\n  content: \"\\F054\"; }\n.fa-plus-circle:before {\n  content: \"\\F055\"; }\n.fa-minus-circle:before {\n  content: \"\\F056\"; }\n.fa-times-circle:before {\n  content: \"\\F057\"; }\n.fa-check-circle:before {\n  content: \"\\F058\"; }\n.fa-question-circle:before {\n  content: \"\\F059\"; }\n.fa-info-circle:before {\n  content: \"\\F05A\"; }\n.fa-crosshairs:before {\n  content: \"\\F05B\"; }\n.fa-times-circle-o:before {\n  content: \"\\F05C\"; }\n.fa-check-circle-o:before {\n  content: \"\\F05D\"; }\n.fa-ban:before {\n  content: \"\\F05E\"; }\n.fa-arrow-left:before {\n  content: \"\\F060\"; }\n.fa-arrow-right:before {\n  content: \"\\F061\"; }\n.fa-arrow-up:before {\n  content: \"\\F062\"; }\n.fa-arrow-down:before {\n  content: \"\\F063\"; }\n.fa-mail-forward:before,\n.fa-share:before {\n  content: \"\\F064\"; }\n.fa-expand:before {\n  content: \"\\F065\"; }\n.fa-compress:before {\n  content: \"\\F066\"; }\n.fa-plus:before {\n  content: \"\\F067\"; }\n.fa-minus:before {\n  content: \"\\F068\"; }\n.fa-asterisk:before {\n  content: \"\\F069\"; }\n.fa-exclamation-circle:before {\n  content: \"\\F06A\"; }\n.fa-gift:before {\n  content: \"\\F06B\"; }\n.fa-leaf:before {\n  content: \"\\F06C\"; }\n.fa-fire:before {\n  content: \"\\F06D\"; }\n.fa-eye:before {\n  content: \"\\F06E\"; }\n.fa-eye-slash:before {\n  content: \"\\F070\"; }\n.fa-warning:before,\n.fa-exclamation-triangle:before {\n  content: \"\\F071\"; }\n.fa-plane:before {\n  content: \"\\F072\"; }\n.fa-calendar:before {\n  content: \"\\F073\"; }\n.fa-random:before {\n  content: \"\\F074\"; }\n.fa-comment:before {\n  content: \"\\F075\"; }\n.fa-magnet:before {\n  content: \"\\F076\"; }\n.fa-chevron-up:before {\n  content: \"\\F077\"; }\n.fa-chevron-down:before {\n  content: \"\\F078\"; }\n.fa-retweet:before {\n  content: \"\\F079\"; }\n.fa-shopping-cart:before {\n  content: \"\\F07A\"; }\n.fa-folder:before {\n  content: \"\\F07B\"; }\n.fa-folder-open:before {\n  content: \"\\F07C\"; }\n.fa-arrows-v:before {\n  content: \"\\F07D\"; }\n.fa-arrows-h:before {\n  content: \"\\F07E\"; }\n.fa-bar-chart-o:before,\n.fa-bar-chart:before {\n  content: \"\\F080\"; }\n.fa-twitter-square:before {\n  content: \"\\F081\"; }\n.fa-facebook-square:before {\n  content: \"\\F082\"; }\n.fa-camera-retro:before {\n  content: \"\\F083\"; }\n.fa-key:before {\n  content: \"\\F084\"; }\n.fa-gears:before,\n.fa-cogs:before {\n  content: \"\\F085\"; }\n.fa-comments:before {\n  content: \"\\F086\"; }\n.fa-thumbs-o-up:before {\n  content: \"\\F087\"; }\n.fa-thumbs-o-down:before {\n  content: \"\\F088\"; }\n.fa-star-half:before {\n  content: \"\\F089\"; }\n.fa-heart-o:before {\n  content: \"\\F08A\"; }\n.fa-sign-out:before {\n  content: \"\\F08B\"; }\n.fa-linkedin-square:before {\n  content: \"\\F08C\"; }\n.fa-thumb-tack:before {\n  content: \"\\F08D\"; }\n.fa-external-link:before {\n  content: \"\\F08E\"; }\n.fa-sign-in:before {\n  content: \"\\F090\"; }\n.fa-trophy:before {\n  content: \"\\F091\"; }\n.fa-github-square:before {\n  content: \"\\F092\"; }\n.fa-upload:before {\n  content: \"\\F093\"; }\n.fa-lemon-o:before {\n  content: \"\\F094\"; }\n.fa-phone:before {\n  content: \"\\F095\"; }\n.fa-square-o:before {\n  content: \"\\F096\"; }\n.fa-bookmark-o:before {\n  content: \"\\F097\"; }\n.fa-phone-square:before {\n  content: \"\\F098\"; }\n.fa-twitter:before {\n  content: \"\\F099\"; }\n.fa-facebook-f:before,\n.fa-facebook:before {\n  content: \"\\F09A\"; }\n.fa-github:before {\n  content: \"\\F09B\"; }\n.fa-unlock:before {\n  content: \"\\F09C\"; }\n.fa-credit-card:before {\n  content: \"\\F09D\"; }\n.fa-feed:before,\n.fa-rss:before {\n  content: \"\\F09E\"; }\n.fa-hdd-o:before {\n  content: \"\\F0A0\"; }\n.fa-bullhorn:before {\n  content: \"\\F0A1\"; }\n.fa-bell:before {\n  content: \"\\F0F3\"; }\n.fa-certificate:before {\n  content: \"\\F0A3\"; }\n.fa-hand-o-right:before {\n  content: \"\\F0A4\"; }\n.fa-hand-o-left:before {\n  content: \"\\F0A5\"; }\n.fa-hand-o-up:before {\n  content: \"\\F0A6\"; }\n.fa-hand-o-down:before {\n  content: \"\\F0A7\"; }\n.fa-arrow-circle-left:before {\n  content: \"\\F0A8\"; }\n.fa-arrow-circle-right:before {\n  content: \"\\F0A9\"; }\n.fa-arrow-circle-up:before {\n  content: \"\\F0AA\"; }\n.fa-arrow-circle-down:before {\n  content: \"\\F0AB\"; }\n.fa-globe:before {\n  content: \"\\F0AC\"; }\n.fa-wrench:before {\n  content: \"\\F0AD\"; }\n.fa-tasks:before {\n  content: \"\\F0AE\"; }\n.fa-filter:before {\n  content: \"\\F0B0\"; }\n.fa-briefcase:before {\n  content: \"\\F0B1\"; }\n.fa-arrows-alt:before {\n  content: \"\\F0B2\"; }\n.fa-group:before,\n.fa-users:before {\n  content: \"\\F0C0\"; }\n.fa-chain:before,\n.fa-link:before {\n  content: \"\\F0C1\"; }\n.fa-cloud:before {\n  content: \"\\F0C2\"; }\n.fa-flask:before {\n  content: \"\\F0C3\"; }\n.fa-cut:before,\n.fa-scissors:before {\n  content: \"\\F0C4\"; }\n.fa-copy:before,\n.fa-files-o:before {\n  content: \"\\F0C5\"; }\n.fa-paperclip:before {\n  content: \"\\F0C6\"; }\n.fa-save:before,\n.fa-floppy-o:before {\n  content: \"\\F0C7\"; }\n.fa-square:before {\n  content: \"\\F0C8\"; }\n.fa-navicon:before,\n.fa-reorder:before,\n.fa-bars:before {\n  content: \"\\F0C9\"; }\n.fa-list-ul:before {\n  content: \"\\F0CA\"; }\n.fa-list-ol:before {\n  content: \"\\F0CB\"; }\n.fa-strikethrough:before {\n  content: \"\\F0CC\"; }\n.fa-underline:before {\n  content: \"\\F0CD\"; }\n.fa-table:before {\n  content: \"\\F0CE\"; }\n.fa-magic:before {\n  content: \"\\F0D0\"; }\n.fa-truck:before {\n  content: \"\\F0D1\"; }\n.fa-pinterest:before {\n  content: \"\\F0D2\"; }\n.fa-pinterest-square:before {\n  content: \"\\F0D3\"; }\n.fa-google-plus-square:before {\n  content: \"\\F0D4\"; }\n.fa-google-plus:before {\n  content: \"\\F0D5\"; }\n.fa-money:before {\n  content: \"\\F0D6\"; }\n.fa-caret-down:before {\n  content: \"\\F0D7\"; }\n.fa-caret-up:before {\n  content: \"\\F0D8\"; }\n.fa-caret-left:before {\n  content: \"\\F0D9\"; }\n.fa-caret-right:before {\n  content: \"\\F0DA\"; }\n.fa-columns:before {\n  content: \"\\F0DB\"; }\n.fa-unsorted:before,\n.fa-sort:before {\n  content: \"\\F0DC\"; }\n.fa-sort-down:before,\n.fa-sort-desc:before {\n  content: \"\\F0DD\"; }\n.fa-sort-up:before,\n.fa-sort-asc:before {\n  content: \"\\F0DE\"; }\n.fa-envelope:before {\n  content: \"\\F0E0\"; }\n.fa-linkedin:before {\n  content: \"\\F0E1\"; }\n.fa-rotate-left:before,\n.fa-undo:before {\n  content: \"\\F0E2\"; }\n.fa-legal:before,\n.fa-gavel:before {\n  content: \"\\F0E3\"; }\n.fa-dashboard:before,\n.fa-tachometer:before {\n  content: \"\\F0E4\"; }\n.fa-comment-o:before {\n  content: \"\\F0E5\"; }\n.fa-comments-o:before {\n  content: \"\\F0E6\"; }\n.fa-flash:before,\n.fa-bolt:before {\n  content: \"\\F0E7\"; }\n.fa-sitemap:before {\n  content: \"\\F0E8\"; }\n.fa-umbrella:before {\n  content: \"\\F0E9\"; }\n.fa-paste:before,\n.fa-clipboard:before {\n  content: \"\\F0EA\"; }\n.fa-lightbulb-o:before {\n  content: \"\\F0EB\"; }\n.fa-exchange:before {\n  content: \"\\F0EC\"; }\n.fa-cloud-download:before {\n  content: \"\\F0ED\"; }\n.fa-cloud-upload:before {\n  content: \"\\F0EE\"; }\n.fa-user-md:before {\n  content: \"\\F0F0\"; }\n.fa-stethoscope:before {\n  content: \"\\F0F1\"; }\n.fa-suitcase:before {\n  content: \"\\F0F2\"; }\n.fa-bell-o:before {\n  content: \"\\F0A2\"; }\n.fa-coffee:before {\n  content: \"\\F0F4\"; }\n.fa-cutlery:before {\n  content: \"\\F0F5\"; }\n.fa-file-text-o:before {\n  content: \"\\F0F6\"; }\n.fa-building-o:before {\n  content: \"\\F0F7\"; }\n.fa-hospital-o:before {\n  content: \"\\F0F8\"; }\n.fa-ambulance:before {\n  content: \"\\F0F9\"; }\n.fa-medkit:before {\n  content: \"\\F0FA\"; }\n.fa-fighter-jet:before {\n  content: \"\\F0FB\"; }\n.fa-beer:before {\n  content: \"\\F0FC\"; }\n.fa-h-square:before {\n  content: \"\\F0FD\"; }\n.fa-plus-square:before {\n  content: \"\\F0FE\"; }\n.fa-angle-double-left:before {\n  content: \"\\F100\"; }\n.fa-angle-double-right:before {\n  content: \"\\F101\"; }\n.fa-angle-double-up:before {\n  content: \"\\F102\"; }\n.fa-angle-double-down:before {\n  content: \"\\F103\"; }\n.fa-angle-left:before {\n  content: \"\\F104\"; }\n.fa-angle-right:before {\n  content: \"\\F105\"; }\n.fa-angle-up:before {\n  content: \"\\F106\"; }\n.fa-angle-down:before {\n  content: \"\\F107\"; }\n.fa-desktop:before {\n  content: \"\\F108\"; }\n.fa-laptop:before {\n  content: \"\\F109\"; }\n.fa-tablet:before {\n  content: \"\\F10A\"; }\n.fa-mobile-phone:before,\n.fa-mobile:before {\n  content: \"\\F10B\"; }\n.fa-circle-o:before {\n  content: \"\\F10C\"; }\n.fa-quote-left:before {\n  content: \"\\F10D\"; }\n.fa-quote-right:before {\n  content: \"\\F10E\"; }\n.fa-spinner:before {\n  content: \"\\F110\"; }\n.fa-circle:before {\n  content: \"\\F111\"; }\n.fa-mail-reply:before,\n.fa-reply:before {\n  content: \"\\F112\"; }\n.fa-github-alt:before {\n  content: \"\\F113\"; }\n.fa-folder-o:before {\n  content: \"\\F114\"; }\n.fa-folder-open-o:before {\n  content: \"\\F115\"; }\n.fa-smile-o:before {\n  content: \"\\F118\"; }\n.fa-frown-o:before {\n  content: \"\\F119\"; }\n.fa-meh-o:before {\n  content: \"\\F11A\"; }\n.fa-gamepad:before {\n  content: \"\\F11B\"; }\n.fa-keyboard-o:before {\n  content: \"\\F11C\"; }\n.fa-flag-o:before {\n  content: \"\\F11D\"; }\n.fa-flag-checkered:before {\n  content: \"\\F11E\"; }\n.fa-terminal:before {\n  content: \"\\F120\"; }\n.fa-code:before {\n  content: \"\\F121\"; }\n.fa-mail-reply-all:before,\n.fa-reply-all:before {\n  content: \"\\F122\"; }\n.fa-star-half-empty:before,\n.fa-star-half-full:before,\n.fa-star-half-o:before {\n  content: \"\\F123\"; }\n.fa-location-arrow:before {\n  content: \"\\F124\"; }\n.fa-crop:before {\n  content: \"\\F125\"; }\n.fa-code-fork:before {\n  content: \"\\F126\"; }\n.fa-unlink:before,\n.fa-chain-broken:before {\n  content: \"\\F127\"; }\n.fa-question:before {\n  content: \"\\F128\"; }\n.fa-info:before {\n  content: \"\\F129\"; }\n.fa-exclamation:before {\n  content: \"\\F12A\"; }\n.fa-superscript:before {\n  content: \"\\F12B\"; }\n.fa-subscript:before {\n  content: \"\\F12C\"; }\n.fa-eraser:before {\n  content: \"\\F12D\"; }\n.fa-puzzle-piece:before {\n  content: \"\\F12E\"; }\n.fa-microphone:before {\n  content: \"\\F130\"; }\n.fa-microphone-slash:before {\n  content: \"\\F131\"; }\n.fa-shield:before {\n  content: \"\\F132\"; }\n.fa-calendar-o:before {\n  content: \"\\F133\"; }\n.fa-fire-extinguisher:before {\n  content: \"\\F134\"; }\n.fa-rocket:before {\n  content: \"\\F135\"; }\n.fa-maxcdn:before {\n  content: \"\\F136\"; }\n.fa-chevron-circle-left:before {\n  content: \"\\F137\"; }\n.fa-chevron-circle-right:before {\n  content: \"\\F138\"; }\n.fa-chevron-circle-up:before {\n  content: \"\\F139\"; }\n.fa-chevron-circle-down:before {\n  content: \"\\F13A\"; }\n.fa-html5:before {\n  content: \"\\F13B\"; }\n.fa-css3:before {\n  content: \"\\F13C\"; }\n.fa-anchor:before {\n  content: \"\\F13D\"; }\n.fa-unlock-alt:before {\n  content: \"\\F13E\"; }\n.fa-bullseye:before {\n  content: \"\\F140\"; }\n.fa-ellipsis-h:before {\n  content: \"\\F141\"; }\n.fa-ellipsis-v:before {\n  content: \"\\F142\"; }\n.fa-rss-square:before {\n  content: \"\\F143\"; }\n.fa-play-circle:before {\n  content: \"\\F144\"; }\n.fa-ticket:before {\n  content: \"\\F145\"; }\n.fa-minus-square:before {\n  content: \"\\F146\"; }\n.fa-minus-square-o:before {\n  content: \"\\F147\"; }\n.fa-level-up:before {\n  content: \"\\F148\"; }\n.fa-level-down:before {\n  content: \"\\F149\"; }\n.fa-check-square:before {\n  content: \"\\F14A\"; }\n.fa-pencil-square:before {\n  content: \"\\F14B\"; }\n.fa-external-link-square:before {\n  content: \"\\F14C\"; }\n.fa-share-square:before {\n  content: \"\\F14D\"; }\n.fa-compass:before {\n  content: \"\\F14E\"; }\n.fa-toggle-down:before,\n.fa-caret-square-o-down:before {\n  content: \"\\F150\"; }\n.fa-toggle-up:before,\n.fa-caret-square-o-up:before {\n  content: \"\\F151\"; }\n.fa-toggle-right:before,\n.fa-caret-square-o-right:before {\n  content: \"\\F152\"; }\n.fa-euro:before,\n.fa-eur:before {\n  content: \"\\F153\"; }\n.fa-gbp:before {\n  content: \"\\F154\"; }\n.fa-dollar:before,\n.fa-usd:before {\n  content: \"\\F155\"; }\n.fa-rupee:before,\n.fa-inr:before {\n  content: \"\\F156\"; }\n.fa-cny:before,\n.fa-rmb:before,\n.fa-yen:before,\n.fa-jpy:before {\n  content: \"\\F157\"; }\n.fa-ruble:before,\n.fa-rouble:before,\n.fa-rub:before {\n  content: \"\\F158\"; }\n.fa-won:before,\n.fa-krw:before {\n  content: \"\\F159\"; }\n.fa-bitcoin:before,\n.fa-btc:before {\n  content: \"\\F15A\"; }\n.fa-file:before {\n  content: \"\\F15B\"; }\n.fa-file-text:before {\n  content: \"\\F15C\"; }\n.fa-sort-alpha-asc:before {\n  content: \"\\F15D\"; }\n.fa-sort-alpha-desc:before {\n  content: \"\\F15E\"; }\n.fa-sort-amount-asc:before {\n  content: \"\\F160\"; }\n.fa-sort-amount-desc:before {\n  content: \"\\F161\"; }\n.fa-sort-numeric-asc:before {\n  content: \"\\F162\"; }\n.fa-sort-numeric-desc:before {\n  content: \"\\F163\"; }\n.fa-thumbs-up:before {\n  content: \"\\F164\"; }\n.fa-thumbs-down:before {\n  content: \"\\F165\"; }\n.fa-youtube-square:before {\n  content: \"\\F166\"; }\n.fa-youtube:before {\n  content: \"\\F167\"; }\n.fa-xing:before {\n  content: \"\\F168\"; }\n.fa-xing-square:before {\n  content: \"\\F169\"; }\n.fa-youtube-play:before {\n  content: \"\\F16A\"; }\n.fa-dropbox:before {\n  content: \"\\F16B\"; }\n.fa-stack-overflow:before {\n  content: \"\\F16C\"; }\n.fa-instagram:before {\n  content: \"\\F16D\"; }\n.fa-flickr:before {\n  content: \"\\F16E\"; }\n.fa-adn:before {\n  content: \"\\F170\"; }\n.fa-bitbucket:before {\n  content: \"\\F171\"; }\n.fa-bitbucket-square:before {\n  content: \"\\F172\"; }\n.fa-tumblr:before {\n  content: \"\\F173\"; }\n.fa-tumblr-square:before {\n  content: \"\\F174\"; }\n.fa-long-arrow-down:before {\n  content: \"\\F175\"; }\n.fa-long-arrow-up:before {\n  content: \"\\F176\"; }\n.fa-long-arrow-left:before {\n  content: \"\\F177\"; }\n.fa-long-arrow-right:before {\n  content: \"\\F178\"; }\n.fa-apple:before {\n  content: \"\\F179\"; }\n.fa-windows:before {\n  content: \"\\F17A\"; }\n.fa-android:before {\n  content: \"\\F17B\"; }\n.fa-linux:before {\n  content: \"\\F17C\"; }\n.fa-dribbble:before {\n  content: \"\\F17D\"; }\n.fa-skype:before {\n  content: \"\\F17E\"; }\n.fa-foursquare:before {\n  content: \"\\F180\"; }\n.fa-trello:before {\n  content: \"\\F181\"; }\n.fa-female:before {\n  content: \"\\F182\"; }\n.fa-male:before {\n  content: \"\\F183\"; }\n.fa-gittip:before,\n.fa-gratipay:before {\n  content: \"\\F184\"; }\n.fa-sun-o:before {\n  content: \"\\F185\"; }\n.fa-moon-o:before {\n  content: \"\\F186\"; }\n.fa-archive:before {\n  content: \"\\F187\"; }\n.fa-bug:before {\n  content: \"\\F188\"; }\n.fa-vk:before {\n  content: \"\\F189\"; }\n.fa-weibo:before {\n  content: \"\\F18A\"; }\n.fa-renren:before {\n  content: \"\\F18B\"; }\n.fa-pagelines:before {\n  content: \"\\F18C\"; }\n.fa-stack-exchange:before {\n  content: \"\\F18D\"; }\n.fa-arrow-circle-o-right:before {\n  content: \"\\F18E\"; }\n.fa-arrow-circle-o-left:before {\n  content: \"\\F190\"; }\n.fa-toggle-left:before,\n.fa-caret-square-o-left:before {\n  content: \"\\F191\"; }\n.fa-dot-circle-o:before {\n  content: \"\\F192\"; }\n.fa-wheelchair:before {\n  content: \"\\F193\"; }\n.fa-vimeo-square:before {\n  content: \"\\F194\"; }\n.fa-turkish-lira:before,\n.fa-try:before {\n  content: \"\\F195\"; }\n.fa-plus-square-o:before {\n  content: \"\\F196\"; }\n.fa-space-shuttle:before {\n  content: \"\\F197\"; }\n.fa-slack:before {\n  content: \"\\F198\"; }\n.fa-envelope-square:before {\n  content: \"\\F199\"; }\n.fa-wordpress:before {\n  content: \"\\F19A\"; }\n.fa-openid:before {\n  content: \"\\F19B\"; }\n.fa-institution:before,\n.fa-bank:before,\n.fa-university:before {\n  content: \"\\F19C\"; }\n.fa-mortar-board:before,\n.fa-graduation-cap:before {\n  content: \"\\F19D\"; }\n.fa-yahoo:before {\n  content: \"\\F19E\"; }\n.fa-google:before {\n  content: \"\\F1A0\"; }\n.fa-reddit:before {\n  content: \"\\F1A1\"; }\n.fa-reddit-square:before {\n  content: \"\\F1A2\"; }\n.fa-stumbleupon-circle:before {\n  content: \"\\F1A3\"; }\n.fa-stumbleupon:before {\n  content: \"\\F1A4\"; }\n.fa-delicious:before {\n  content: \"\\F1A5\"; }\n.fa-digg:before {\n  content: \"\\F1A6\"; }\n.fa-pied-piper-pp:before {\n  content: \"\\F1A7\"; }\n.fa-pied-piper-alt:before {\n  content: \"\\F1A8\"; }\n.fa-drupal:before {\n  content: \"\\F1A9\"; }\n.fa-joomla:before {\n  content: \"\\F1AA\"; }\n.fa-language:before {\n  content: \"\\F1AB\"; }\n.fa-fax:before {\n  content: \"\\F1AC\"; }\n.fa-building:before {\n  content: \"\\F1AD\"; }\n.fa-child:before {\n  content: \"\\F1AE\"; }\n.fa-paw:before {\n  content: \"\\F1B0\"; }\n.fa-spoon:before {\n  content: \"\\F1B1\"; }\n.fa-cube:before {\n  content: \"\\F1B2\"; }\n.fa-cubes:before {\n  content: \"\\F1B3\"; }\n.fa-behance:before {\n  content: \"\\F1B4\"; }\n.fa-behance-square:before {\n  content: \"\\F1B5\"; }\n.fa-steam:before {\n  content: \"\\F1B6\"; }\n.fa-steam-square:before {\n  content: \"\\F1B7\"; }\n.fa-recycle:before {\n  content: \"\\F1B8\"; }\n.fa-automobile:before,\n.fa-car:before {\n  content: \"\\F1B9\"; }\n.fa-cab:before,\n.fa-taxi:before {\n  content: \"\\F1BA\"; }\n.fa-tree:before {\n  content: \"\\F1BB\"; }\n.fa-spotify:before {\n  content: \"\\F1BC\"; }\n.fa-deviantart:before {\n  content: \"\\F1BD\"; }\n.fa-soundcloud:before {\n  content: \"\\F1BE\"; }\n.fa-database:before {\n  content: \"\\F1C0\"; }\n.fa-file-pdf-o:before {\n  content: \"\\F1C1\"; }\n.fa-file-word-o:before {\n  content: \"\\F1C2\"; }\n.fa-file-excel-o:before {\n  content: \"\\F1C3\"; }\n.fa-file-powerpoint-o:before {\n  content: \"\\F1C4\"; }\n.fa-file-photo-o:before,\n.fa-file-picture-o:before,\n.fa-file-image-o:before {\n  content: \"\\F1C5\"; }\n.fa-file-zip-o:before,\n.fa-file-archive-o:before {\n  content: \"\\F1C6\"; }\n.fa-file-sound-o:before,\n.fa-file-audio-o:before {\n  content: \"\\F1C7\"; }\n.fa-file-movie-o:before,\n.fa-file-video-o:before {\n  content: \"\\F1C8\"; }\n.fa-file-code-o:before {\n  content: \"\\F1C9\"; }\n.fa-vine:before {\n  content: \"\\F1CA\"; }\n.fa-codepen:before {\n  content: \"\\F1CB\"; }\n.fa-jsfiddle:before {\n  content: \"\\F1CC\"; }\n.fa-life-bouy:before,\n.fa-life-buoy:before,\n.fa-life-saver:before,\n.fa-support:before,\n.fa-life-ring:before {\n  content: \"\\F1CD\"; }\n.fa-circle-o-notch:before {\n  content: \"\\F1CE\"; }\n.fa-ra:before,\n.fa-resistance:before,\n.fa-rebel:before {\n  content: \"\\F1D0\"; }\n.fa-ge:before,\n.fa-empire:before {\n  content: \"\\F1D1\"; }\n.fa-git-square:before {\n  content: \"\\F1D2\"; }\n.fa-git:before {\n  content: \"\\F1D3\"; }\n.fa-y-combinator-square:before,\n.fa-yc-square:before,\n.fa-hacker-news:before {\n  content: \"\\F1D4\"; }\n.fa-tencent-weibo:before {\n  content: \"\\F1D5\"; }\n.fa-qq:before {\n  content: \"\\F1D6\"; }\n.fa-wechat:before,\n.fa-weixin:before {\n  content: \"\\F1D7\"; }\n.fa-send:before,\n.fa-paper-plane:before {\n  content: \"\\F1D8\"; }\n.fa-send-o:before,\n.fa-paper-plane-o:before {\n  content: \"\\F1D9\"; }\n.fa-history:before {\n  content: \"\\F1DA\"; }\n.fa-circle-thin:before {\n  content: \"\\F1DB\"; }\n.fa-header:before {\n  content: \"\\F1DC\"; }\n.fa-paragraph:before {\n  content: \"\\F1DD\"; }\n.fa-sliders:before {\n  content: \"\\F1DE\"; }\n.fa-share-alt:before {\n  content: \"\\F1E0\"; }\n.fa-share-alt-square:before {\n  content: \"\\F1E1\"; }\n.fa-bomb:before {\n  content: \"\\F1E2\"; }\n.fa-soccer-ball-o:before,\n.fa-futbol-o:before {\n  content: \"\\F1E3\"; }\n.fa-tty:before {\n  content: \"\\F1E4\"; }\n.fa-binoculars:before {\n  content: \"\\F1E5\"; }\n.fa-plug:before {\n  content: \"\\F1E6\"; }\n.fa-slideshare:before {\n  content: \"\\F1E7\"; }\n.fa-twitch:before {\n  content: \"\\F1E8\"; }\n.fa-yelp:before {\n  content: \"\\F1E9\"; }\n.fa-newspaper-o:before {\n  content: \"\\F1EA\"; }\n.fa-wifi:before {\n  content: \"\\F1EB\"; }\n.fa-calculator:before {\n  content: \"\\F1EC\"; }\n.fa-paypal:before {\n  content: \"\\F1ED\"; }\n.fa-google-wallet:before {\n  content: \"\\F1EE\"; }\n.fa-cc-visa:before {\n  content: \"\\F1F0\"; }\n.fa-cc-mastercard:before {\n  content: \"\\F1F1\"; }\n.fa-cc-discover:before {\n  content: \"\\F1F2\"; }\n.fa-cc-amex:before {\n  content: \"\\F1F3\"; }\n.fa-cc-paypal:before {\n  content: \"\\F1F4\"; }\n.fa-cc-stripe:before {\n  content: \"\\F1F5\"; }\n.fa-bell-slash:before {\n  content: \"\\F1F6\"; }\n.fa-bell-slash-o:before {\n  content: \"\\F1F7\"; }\n.fa-trash:before {\n  content: \"\\F1F8\"; }\n.fa-copyright:before {\n  content: \"\\F1F9\"; }\n.fa-at:before {\n  content: \"\\F1FA\"; }\n.fa-eyedropper:before {\n  content: \"\\F1FB\"; }\n.fa-paint-brush:before {\n  content: \"\\F1FC\"; }\n.fa-birthday-cake:before {\n  content: \"\\F1FD\"; }\n.fa-area-chart:before {\n  content: \"\\F1FE\"; }\n.fa-pie-chart:before {\n  content: \"\\F200\"; }\n.fa-line-chart:before {\n  content: \"\\F201\"; }\n.fa-lastfm:before {\n  content: \"\\F202\"; }\n.fa-lastfm-square:before {\n  content: \"\\F203\"; }\n.fa-toggle-off:before {\n  content: \"\\F204\"; }\n.fa-toggle-on:before {\n  content: \"\\F205\"; }\n.fa-bicycle:before {\n  content: \"\\F206\"; }\n.fa-bus:before {\n  content: \"\\F207\"; }\n.fa-ioxhost:before {\n  content: \"\\F208\"; }\n.fa-angellist:before {\n  content: \"\\F209\"; }\n.fa-cc:before {\n  content: \"\\F20A\"; }\n.fa-shekel:before,\n.fa-sheqel:before,\n.fa-ils:before {\n  content: \"\\F20B\"; }\n.fa-meanpath:before {\n  content: \"\\F20C\"; }\n.fa-buysellads:before {\n  content: \"\\F20D\"; }\n.fa-connectdevelop:before {\n  content: \"\\F20E\"; }\n.fa-dashcube:before {\n  content: \"\\F210\"; }\n.fa-forumbee:before {\n  content: \"\\F211\"; }\n.fa-leanpub:before {\n  content: \"\\F212\"; }\n.fa-sellsy:before {\n  content: \"\\F213\"; }\n.fa-shirtsinbulk:before {\n  content: \"\\F214\"; }\n.fa-simplybuilt:before {\n  content: \"\\F215\"; }\n.fa-skyatlas:before {\n  content: \"\\F216\"; }\n.fa-cart-plus:before {\n  content: \"\\F217\"; }\n.fa-cart-arrow-down:before {\n  content: \"\\F218\"; }\n.fa-diamond:before {\n  content: \"\\F219\"; }\n.fa-ship:before {\n  content: \"\\F21A\"; }\n.fa-user-secret:before {\n  content: \"\\F21B\"; }\n.fa-motorcycle:before {\n  content: \"\\F21C\"; }\n.fa-street-view:before {\n  content: \"\\F21D\"; }\n.fa-heartbeat:before {\n  content: \"\\F21E\"; }\n.fa-venus:before {\n  content: \"\\F221\"; }\n.fa-mars:before {\n  content: \"\\F222\"; }\n.fa-mercury:before {\n  content: \"\\F223\"; }\n.fa-intersex:before,\n.fa-transgender:before {\n  content: \"\\F224\"; }\n.fa-transgender-alt:before {\n  content: \"\\F225\"; }\n.fa-venus-double:before {\n  content: \"\\F226\"; }\n.fa-mars-double:before {\n  content: \"\\F227\"; }\n.fa-venus-mars:before {\n  content: \"\\F228\"; }\n.fa-mars-stroke:before {\n  content: \"\\F229\"; }\n.fa-mars-stroke-v:before {\n  content: \"\\F22A\"; }\n.fa-mars-stroke-h:before {\n  content: \"\\F22B\"; }\n.fa-neuter:before {\n  content: \"\\F22C\"; }\n.fa-genderless:before {\n  content: \"\\F22D\"; }\n.fa-facebook-official:before {\n  content: \"\\F230\"; }\n.fa-pinterest-p:before {\n  content: \"\\F231\"; }\n.fa-whatsapp:before {\n  content: \"\\F232\"; }\n.fa-server:before {\n  content: \"\\F233\"; }\n.fa-user-plus:before {\n  content: \"\\F234\"; }\n.fa-user-times:before {\n  content: \"\\F235\"; }\n.fa-hotel:before,\n.fa-bed:before {\n  content: \"\\F236\"; }\n.fa-viacoin:before {\n  content: \"\\F237\"; }\n.fa-train:before {\n  content: \"\\F238\"; }\n.fa-subway:before {\n  content: \"\\F239\"; }\n.fa-medium:before {\n  content: \"\\F23A\"; }\n.fa-yc:before,\n.fa-y-combinator:before {\n  content: \"\\F23B\"; }\n.fa-optin-monster:before {\n  content: \"\\F23C\"; }\n.fa-opencart:before {\n  content: \"\\F23D\"; }\n.fa-expeditedssl:before {\n  content: \"\\F23E\"; }\n.fa-battery-4:before,\n.fa-battery:before,\n.fa-battery-full:before {\n  content: \"\\F240\"; }\n.fa-battery-3:before,\n.fa-battery-three-quarters:before {\n  content: \"\\F241\"; }\n.fa-battery-2:before,\n.fa-battery-half:before {\n  content: \"\\F242\"; }\n.fa-battery-1:before,\n.fa-battery-quarter:before {\n  content: \"\\F243\"; }\n.fa-battery-0:before,\n.fa-battery-empty:before {\n  content: \"\\F244\"; }\n.fa-mouse-pointer:before {\n  content: \"\\F245\"; }\n.fa-i-cursor:before {\n  content: \"\\F246\"; }\n.fa-object-group:before {\n  content: \"\\F247\"; }\n.fa-object-ungroup:before {\n  content: \"\\F248\"; }\n.fa-sticky-note:before {\n  content: \"\\F249\"; }\n.fa-sticky-note-o:before {\n  content: \"\\F24A\"; }\n.fa-cc-jcb:before {\n  content: \"\\F24B\"; }\n.fa-cc-diners-club:before {\n  content: \"\\F24C\"; }\n.fa-clone:before {\n  content: \"\\F24D\"; }\n.fa-balance-scale:before {\n  content: \"\\F24E\"; }\n.fa-hourglass-o:before {\n  content: \"\\F250\"; }\n.fa-hourglass-1:before,\n.fa-hourglass-start:before {\n  content: \"\\F251\"; }\n.fa-hourglass-2:before,\n.fa-hourglass-half:before {\n  content: \"\\F252\"; }\n.fa-hourglass-3:before,\n.fa-hourglass-end:before {\n  content: \"\\F253\"; }\n.fa-hourglass:before {\n  content: \"\\F254\"; }\n.fa-hand-grab-o:before,\n.fa-hand-rock-o:before {\n  content: \"\\F255\"; }\n.fa-hand-stop-o:before,\n.fa-hand-paper-o:before {\n  content: \"\\F256\"; }\n.fa-hand-scissors-o:before {\n  content: \"\\F257\"; }\n.fa-hand-lizard-o:before {\n  content: \"\\F258\"; }\n.fa-hand-spock-o:before {\n  content: \"\\F259\"; }\n.fa-hand-pointer-o:before {\n  content: \"\\F25A\"; }\n.fa-hand-peace-o:before {\n  content: \"\\F25B\"; }\n.fa-trademark:before {\n  content: \"\\F25C\"; }\n.fa-registered:before {\n  content: \"\\F25D\"; }\n.fa-creative-commons:before {\n  content: \"\\F25E\"; }\n.fa-gg:before {\n  content: \"\\F260\"; }\n.fa-gg-circle:before {\n  content: \"\\F261\"; }\n.fa-tripadvisor:before {\n  content: \"\\F262\"; }\n.fa-odnoklassniki:before {\n  content: \"\\F263\"; }\n.fa-odnoklassniki-square:before {\n  content: \"\\F264\"; }\n.fa-get-pocket:before {\n  content: \"\\F265\"; }\n.fa-wikipedia-w:before {\n  content: \"\\F266\"; }\n.fa-safari:before {\n  content: \"\\F267\"; }\n.fa-chrome:before {\n  content: \"\\F268\"; }\n.fa-firefox:before {\n  content: \"\\F269\"; }\n.fa-opera:before {\n  content: \"\\F26A\"; }\n.fa-internet-explorer:before {\n  content: \"\\F26B\"; }\n.fa-tv:before,\n.fa-television:before {\n  content: \"\\F26C\"; }\n.fa-contao:before {\n  content: \"\\F26D\"; }\n.fa-500px:before {\n  content: \"\\F26E\"; }\n.fa-amazon:before {\n  content: \"\\F270\"; }\n.fa-calendar-plus-o:before {\n  content: \"\\F271\"; }\n.fa-calendar-minus-o:before {\n  content: \"\\F272\"; }\n.fa-calendar-times-o:before {\n  content: \"\\F273\"; }\n.fa-calendar-check-o:before {\n  content: \"\\F274\"; }\n.fa-industry:before {\n  content: \"\\F275\"; }\n.fa-map-pin:before {\n  content: \"\\F276\"; }\n.fa-map-signs:before {\n  content: \"\\F277\"; }\n.fa-map-o:before {\n  content: \"\\F278\"; }\n.fa-map:before {\n  content: \"\\F279\"; }\n.fa-commenting:before {\n  content: \"\\F27A\"; }\n.fa-commenting-o:before {\n  content: \"\\F27B\"; }\n.fa-houzz:before {\n  content: \"\\F27C\"; }\n.fa-vimeo:before {\n  content: \"\\F27D\"; }\n.fa-black-tie:before {\n  content: \"\\F27E\"; }\n.fa-fonticons:before {\n  content: \"\\F280\"; }\n.fa-reddit-alien:before {\n  content: \"\\F281\"; }\n.fa-edge:before {\n  content: \"\\F282\"; }\n.fa-credit-card-alt:before {\n  content: \"\\F283\"; }\n.fa-codiepie:before {\n  content: \"\\F284\"; }\n.fa-modx:before {\n  content: \"\\F285\"; }\n.fa-fort-awesome:before {\n  content: \"\\F286\"; }\n.fa-usb:before {\n  content: \"\\F287\"; }\n.fa-product-hunt:before {\n  content: \"\\F288\"; }\n.fa-mixcloud:before {\n  content: \"\\F289\"; }\n.fa-scribd:before {\n  content: \"\\F28A\"; }\n.fa-pause-circle:before {\n  content: \"\\F28B\"; }\n.fa-pause-circle-o:before {\n  content: \"\\F28C\"; }\n.fa-stop-circle:before {\n  content: \"\\F28D\"; }\n.fa-stop-circle-o:before {\n  content: \"\\F28E\"; }\n.fa-shopping-bag:before {\n  content: \"\\F290\"; }\n.fa-shopping-basket:before {\n  content: \"\\F291\"; }\n.fa-hashtag:before {\n  content: \"\\F292\"; }\n.fa-bluetooth:before {\n  content: \"\\F293\"; }\n.fa-bluetooth-b:before {\n  content: \"\\F294\"; }\n.fa-percent:before {\n  content: \"\\F295\"; }\n.fa-gitlab:before {\n  content: \"\\F296\"; }\n.fa-wpbeginner:before {\n  content: \"\\F297\"; }\n.fa-wpforms:before {\n  content: \"\\F298\"; }\n.fa-envira:before {\n  content: \"\\F299\"; }\n.fa-universal-access:before {\n  content: \"\\F29A\"; }\n.fa-wheelchair-alt:before {\n  content: \"\\F29B\"; }\n.fa-question-circle-o:before {\n  content: \"\\F29C\"; }\n.fa-blind:before {\n  content: \"\\F29D\"; }\n.fa-audio-description:before {\n  content: \"\\F29E\"; }\n.fa-volume-control-phone:before {\n  content: \"\\F2A0\"; }\n.fa-braille:before {\n  content: \"\\F2A1\"; }\n.fa-assistive-listening-systems:before {\n  content: \"\\F2A2\"; }\n.fa-asl-interpreting:before,\n.fa-american-sign-language-interpreting:before {\n  content: \"\\F2A3\"; }\n.fa-deafness:before,\n.fa-hard-of-hearing:before,\n.fa-deaf:before {\n  content: \"\\F2A4\"; }\n.fa-glide:before {\n  content: \"\\F2A5\"; }\n.fa-glide-g:before {\n  content: \"\\F2A6\"; }\n.fa-signing:before,\n.fa-sign-language:before {\n  content: \"\\F2A7\"; }\n.fa-low-vision:before {\n  content: \"\\F2A8\"; }\n.fa-viadeo:before {\n  content: \"\\F2A9\"; }\n.fa-viadeo-square:before {\n  content: \"\\F2AA\"; }\n.fa-snapchat:before {\n  content: \"\\F2AB\"; }\n.fa-snapchat-ghost:before {\n  content: \"\\F2AC\"; }\n.fa-snapchat-square:before {\n  content: \"\\F2AD\"; }\n.fa-pied-piper:before {\n  content: \"\\F2AE\"; }\n.fa-first-order:before {\n  content: \"\\F2B0\"; }\n.fa-yoast:before {\n  content: \"\\F2B1\"; }\n.fa-themeisle:before {\n  content: \"\\F2B2\"; }\n.fa-google-plus-circle:before,\n.fa-google-plus-official:before {\n  content: \"\\F2B3\"; }\n.fa-fa:before,\n.fa-font-awesome:before {\n  content: \"\\F2B4\"; }\n.fa-handshake-o:before {\n  content: \"\\F2B5\"; }\n.fa-envelope-open:before {\n  content: \"\\F2B6\"; }\n.fa-envelope-open-o:before {\n  content: \"\\F2B7\"; }\n.fa-linode:before {\n  content: \"\\F2B8\"; }\n.fa-address-book:before {\n  content: \"\\F2B9\"; }\n.fa-address-book-o:before {\n  content: \"\\F2BA\"; }\n.fa-vcard:before,\n.fa-address-card:before {\n  content: \"\\F2BB\"; }\n.fa-vcard-o:before,\n.fa-address-card-o:before {\n  content: \"\\F2BC\"; }\n.fa-user-circle:before {\n  content: \"\\F2BD\"; }\n.fa-user-circle-o:before {\n  content: \"\\F2BE\"; }\n.fa-user-o:before {\n  content: \"\\F2C0\"; }\n.fa-id-badge:before {\n  content: \"\\F2C1\"; }\n.fa-drivers-license:before,\n.fa-id-card:before {\n  content: \"\\F2C2\"; }\n.fa-drivers-license-o:before,\n.fa-id-card-o:before {\n  content: \"\\F2C3\"; }\n.fa-quora:before {\n  content: \"\\F2C4\"; }\n.fa-free-code-camp:before {\n  content: \"\\F2C5\"; }\n.fa-telegram:before {\n  content: \"\\F2C6\"; }\n.fa-thermometer-4:before,\n.fa-thermometer:before,\n.fa-thermometer-full:before {\n  content: \"\\F2C7\"; }\n.fa-thermometer-3:before,\n.fa-thermometer-three-quarters:before {\n  content: \"\\F2C8\"; }\n.fa-thermometer-2:before,\n.fa-thermometer-half:before {\n  content: \"\\F2C9\"; }\n.fa-thermometer-1:before,\n.fa-thermometer-quarter:before {\n  content: \"\\F2CA\"; }\n.fa-thermometer-0:before,\n.fa-thermometer-empty:before {\n  content: \"\\F2CB\"; }\n.fa-shower:before {\n  content: \"\\F2CC\"; }\n.fa-bathtub:before,\n.fa-s15:before,\n.fa-bath:before {\n  content: \"\\F2CD\"; }\n.fa-podcast:before {\n  content: \"\\F2CE\"; }\n.fa-window-maximize:before {\n  content: \"\\F2D0\"; }\n.fa-window-minimize:before {\n  content: \"\\F2D1\"; }\n.fa-window-restore:before {\n  content: \"\\F2D2\"; }\n.fa-times-rectangle:before,\n.fa-window-close:before {\n  content: \"\\F2D3\"; }\n.fa-times-rectangle-o:before,\n.fa-window-close-o:before {\n  content: \"\\F2D4\"; }\n.fa-bandcamp:before {\n  content: \"\\F2D5\"; }\n.fa-grav:before {\n  content: \"\\F2D6\"; }\n.fa-etsy:before {\n  content: \"\\F2D7\"; }\n.fa-imdb:before {\n  content: \"\\F2D8\"; }\n.fa-ravelry:before {\n  content: \"\\F2D9\"; }\n.fa-eercast:before {\n  content: \"\\F2DA\"; }\n.fa-microchip:before {\n  content: \"\\F2DB\"; }\n.fa-snowflake-o:before {\n  content: \"\\F2DC\"; }\n.fa-superpowers:before {\n  content: \"\\F2DD\"; }\n.fa-wpexplorer:before {\n  content: \"\\F2DE\"; }\n.fa-meetup:before {\n  content: \"\\F2E0\"; }\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0; }\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto; }\nhtml,\nbody,\n.application {\n  height: 100%;\n  background-color: #e7e9ea; }\n.ReactTable {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  border: 1px solid rgba(0, 0, 0, .1); }\n.ReactTable * {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box; }\n.ReactTable .rt-table {\n  -webkit-box-flex: 1;\n  -ms-flex: auto 1;\n  flex: auto 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  width: 100%;\n  border-collapse: collapse;\n  overflow: auto; }\n.ReactTable .rt-thead {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n.ReactTable .rt-thead.-headerGroups {\n  background: rgba(0, 0, 0, .03);\n  border-bottom: 1px solid rgba(0, 0, 0, .05); }\n.ReactTable .rt-thead.-filters {\n  border-bottom: 1px solid rgba(0, 0, 0, .05); }\n.ReactTable .rt-thead.-filters input, .ReactTable .rt-thead.-filters select {\n  border: 1px solid rgba(0, 0, 0, .1);\n  background: #fff;\n  padding: 5px 7px;\n  font-size: inherit;\n  border-radius: 3px;\n  font-weight: normal;\n  outline-width: 0; }\n.ReactTable .rt-thead.-filters .rt-th {\n  border-right: 1px solid rgba(0, 0, 0, .02); }\n.ReactTable .rt-thead.-header {\n  -webkit-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, .15);\n          box-shadow: 0 2px 15px 0 rgba(0, 0, 0, .15); }\n.ReactTable .rt-thead .rt-tr {\n  text-align: center; }\n.ReactTable .rt-thead .rt-th, .ReactTable .rt-thead .rt-td {\n  padding: 5px 5px;\n  line-height: normal;\n  position: relative;\n  border-right: 1px solid rgba(0, 0, 0, .05);\n  -webkit-transition: -webkit-box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  transition: -webkit-box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), -webkit-box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  -webkit-box-shadow: inset 0 0 0 0 transparent;\n          box-shadow: inset 0 0 0 0 transparent; }\n.ReactTable .rt-thead .rt-th.-sort-asc, .ReactTable .rt-thead .rt-td.-sort-asc {\n  -webkit-box-shadow: inset 0 3px 0 0 rgba(0, 0, 0, .6);\n          box-shadow: inset 0 3px 0 0 rgba(0, 0, 0, .6); }\n.ReactTable .rt-thead .rt-th.-sort-desc, .ReactTable .rt-thead .rt-td.-sort-desc {\n  -webkit-box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, .6);\n          box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, .6); }\n.ReactTable .rt-thead .rt-th.-cursor-pointer, .ReactTable .rt-thead .rt-td.-cursor-pointer {\n  cursor: pointer; }\n.ReactTable .rt-thead .rt-th:last-child, .ReactTable .rt-thead .rt-td:last-child {\n  border-right: 0; }\n.ReactTable .rt-thead .rt-th:focus {\n  outline-width: 0; }\n.ReactTable .rt-thead .rt-resizable-header {\n  overflow: visible; }\n.ReactTable .rt-thead .rt-resizable-header:last-child {\n  overflow: hidden; }\n.ReactTable .rt-thead .rt-resizable-header-content {\n  overflow: hidden;\n  text-overflow: ellipsis; }\n.ReactTable .rt-thead .rt-header-pivot {\n  border-right-color: #f7f7f7; }\n.ReactTable .rt-thead .rt-header-pivot:after, .ReactTable .rt-thead .rt-header-pivot:before {\n  left: 100%;\n  top: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none; }\n.ReactTable .rt-thead .rt-header-pivot:after {\n  border-color: rgba(255, 255, 255, 0);\n  border-left-color: #fff;\n  border-width: 8px;\n  margin-top: -8px; }\n.ReactTable .rt-thead .rt-header-pivot:before {\n  border-color: rgba(102, 102, 102, 0);\n  border-left-color: #f7f7f7;\n  border-width: 10px;\n  margin-top: -10px; }\n.ReactTable .rt-tbody {\n  -webkit-box-flex: 99999;\n  -ms-flex: 99999 1 auto;\n  flex: 99999 1 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  overflow: auto; }\n.ReactTable .rt-tbody .rt-tr-group {\n  border-bottom: solid 1px rgba(0, 0, 0, .05); }\n.ReactTable .rt-tbody .rt-tr-group:last-child {\n  border-bottom: 0; }\n.ReactTable .rt-tbody .rt-td {\n  border-right: 1px solid rgba(0, 0, 0, .02); }\n.ReactTable .rt-tbody .rt-td:last-child {\n  border-right: 0; }\n.ReactTable .rt-tbody .rt-expandable {\n  cursor: pointer;\n  text-overflow: clip; }\n.ReactTable .rt-tr-group {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch; }\n.ReactTable .rt-tr {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n.ReactTable .rt-th, .ReactTable .rt-td {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding: 7px 5px;\n  overflow: hidden;\n  -webkit-transition: .3s ease;\n  transition: .3s ease;\n  -webkit-transition-property: width,min-width,padding,opacity;\n  transition-property: width,min-width,padding,opacity; }\n.ReactTable .rt-th.-hidden, .ReactTable .rt-td.-hidden {\n  width: 0 !important;\n  min-width: 0 !important;\n  padding: 0 !important;\n  border: 0 !important;\n  opacity: 0 !important; }\n.ReactTable .rt-expander {\n  display: inline-block;\n  position: relative;\n  margin: 0;\n  color: transparent;\n  margin: 0 10px; }\n.ReactTable .rt-expander:after {\n  content: '';\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%) rotate(-90deg);\n  transform: translate(-50%, -50%) rotate(-90deg);\n  border-left: 5.04px solid transparent;\n  border-right: 5.04px solid transparent;\n  border-top: 7px solid rgba(0, 0, 0, .8);\n  -webkit-transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  cursor: pointer; }\n.ReactTable .rt-expander.-open:after {\n  -webkit-transform: translate(-50%, -50%) rotate(0);\n  transform: translate(-50%, -50%) rotate(0); }\n.ReactTable .rt-resizer {\n  display: inline-block;\n  position: absolute;\n  width: 36px;\n  top: 0;\n  bottom: 0;\n  right: -18px;\n  cursor: col-resize;\n  z-index: 10; }\n.ReactTable .rt-tfoot {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, .15);\n          box-shadow: 0 0 15px 0 rgba(0, 0, 0, .15); }\n.ReactTable .rt-tfoot .rt-td {\n  border-right: 1px solid rgba(0, 0, 0, .05); }\n.ReactTable .rt-tfoot .rt-td:last-child {\n  border-right: 0; }\n.ReactTable.-striped .rt-tr.-odd {\n  background: rgba(0, 0, 0, .03); }\n.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\n  background: rgba(0, 0, 0, .05); }\n.ReactTable .-pagination {\n  z-index: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding: 3px;\n  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, .1);\n          box-shadow: 0 0 15px 0 rgba(0, 0, 0, .1);\n  border-top: 2px solid rgba(0, 0, 0, .1); }\n.ReactTable .-pagination input, .ReactTable .-pagination select {\n  border: 1px solid rgba(0, 0, 0, .1);\n  background: #fff;\n  padding: 5px 7px;\n  font-size: inherit;\n  border-radius: 3px;\n  font-weight: normal;\n  outline-width: 0; }\n.ReactTable .-pagination .-btn {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  border-radius: 3px;\n  padding: 6px;\n  font-size: 1em;\n  color: rgba(0, 0, 0, .6);\n  background: rgba(0, 0, 0, .1);\n  -webkit-transition: all .1s ease;\n  transition: all .1s ease;\n  cursor: pointer;\n  outline-width: 0; }\n.ReactTable .-pagination .-btn[disabled] {\n  opacity: .5;\n  cursor: default; }\n.ReactTable .-pagination .-btn:not([disabled]):hover {\n  background: rgba(0, 0, 0, .3);\n  color: #fff; }\n.ReactTable .-pagination .-previous, .ReactTable .-pagination .-next {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  text-align: center; }\n.ReactTable .-pagination .-center {\n  -webkit-box-flex: 1.5;\n  -ms-flex: 1.5;\n  flex: 1.5;\n  text-align: center;\n  margin-bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: distribute;\n  justify-content: space-around; }\n.ReactTable .-pagination .-pageInfo {\n  display: inline-block;\n  margin: 3px 10px;\n  white-space: nowrap; }\n.ReactTable .-pagination .-pageJump {\n  display: inline-block; }\n.ReactTable .-pagination .-pageJump input {\n  width: 70px;\n  text-align: center; }\n.ReactTable .-pagination .-pageSizeOptions {\n  margin: 3px 10px; }\n.ReactTable .rt-noData {\n  display: block;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, .8);\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n  z-index: 1;\n  pointer-events: none;\n  padding: 20px;\n  color: rgba(0, 0, 0, .5); }\n.ReactTable .-loading {\n  display: block;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, .8);\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none; }\n.ReactTable .-loading > div {\n  position: absolute;\n  display: block;\n  text-align: center;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  font-size: 15px;\n  color: rgba(0, 0, 0, .6);\n  -webkit-transform: translateY(-52%);\n  transform: translateY(-52%);\n  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n.ReactTable .-loading.-active {\n  opacity: 1;\n  z-index: 2;\n  pointer-events: all; }\n.ReactTable .-loading.-active > div {\n  -webkit-transform: translateY(50%);\n  transform: translateY(50%); }\n.ReactTable .rt-resizing .rt-th, .ReactTable .rt-resizing .rt-td {\n  -webkit-transition: none !important;\n  transition: none !important;\n  cursor: col-resize;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n", ""]);

// exports


/***/ }),

/***/ 834:
/***/ (function(module, exports) {

module.exports = {"app.components.Toast.header":"This is the Toast component !","app.containers.PrivacySettings.header":"This is PrivacySettings container !","privacySettings.components.cancel":"Cancel","privacySettings.components.option1":"First name with first initial (e.g. John S.)","privacySettings.components.option2":"Initials only (e.g. JS)","privacySettings.components.option3":"Initials with surname first (e.g. SJ)","privacySettings.components.pageTitle":"Privacy settings","privacySettings.components.save":"Save","privacySettings.components.studentNameDisplay":"Student name display"}

/***/ }),

/***/ 835:
/***/ (function(module, exports) {

module.exports = {"app.components.Toast.header":"¡Este es el elemento emergente!","app.containers.PrivacySettings.header":"¡Este es el contenedor de la Configuración de Privacidad!","privacySettings.components.cancel":"Cancelar","privacySettings.components.option1":"Nombre con la inicial del apellido (p.ej., Juan S.)","privacySettings.components.option2":"Solo iniciales (p.ej., JS)","privacySettings.components.option3":"Iniciales con el apellido primero (p.ej., SJ)","privacySettings.components.pageTitle":"Configuración de Privacidad","privacySettings.components.save":"Guardar","privacySettings.components.studentNameDisplay":"Nombre para mostrar del estudiante"}

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkUserIsAuthorised = exports.getSubjects = exports.getMasterCourse = exports.getMasterCoursesByCountry = exports.getMasterCoursesCountries = exports.getMasterCourses = exports.archiveSelectedCourse = exports.publishDefaultCourse = exports.saveDefaultCourse = exports.saveDefaultCoursesForCountry = exports.saveDefaultCourses = exports.getCoursesForCountry = exports.getCourses = exports.getDefaultCoursesForCountry = exports.getDefaultCourse = exports.getDefaultCourses = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resources = __webpack_require__(164);

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * COURSES
 */
var getDefaultCourses = exports.getDefaultCourses = function getDefaultCourses(_ref) {
    var productId = _ref.productId;
    return _resources2.default.getDefaultCourses.get().withParams({ productId: productId }).send();
};

var getDefaultCourse = exports.getDefaultCourse = function getDefaultCourse(_ref2) {
    var productId = _ref2.productId,
        courseId = _ref2.courseId,
        version = _ref2.version,
        switchToMasterCourseId = _ref2.switchToMasterCourseId,
        switchToMasterCourseVersion = _ref2.switchToMasterCourseVersion;
    return _resources2.default.getDefaultCourse.get({ courseId: courseId, version: version }).withParams(_extends({
        productId: productId
    }, switchToMasterCourseId && { switchToMasterCourseId: switchToMasterCourseId }, switchToMasterCourseVersion && { switchToMasterCourseVersion: switchToMasterCourseVersion })).withBody().send();
};

var getDefaultCoursesForCountry = exports.getDefaultCoursesForCountry = function getDefaultCoursesForCountry(_ref3) {
    var accessCode = _ref3.accessCode,
        productId = _ref3.productId;
    return _resources2.default.getDefaultCourseForCountry.get().withParams({ accessCode: accessCode, productId: productId }).withBody().send();
};

var getCourses = exports.getCourses = function getCourses(_ref4) {
    var accessStatus = _ref4.accessStatus,
        countryCode = _ref4.countryCode,
        stateCode = _ref4.stateCode,
        productId = _ref4.productId;
    return _resources2.default.getCourses.post().withBody({ accessStatus: accessStatus, countryCode: countryCode, stateCode: stateCode, productId: productId }).send();
};

var getCoursesForCountry = exports.getCoursesForCountry = function getCoursesForCountry(_ref5) {
    var countryCode = _ref5.countryCode,
        productId = _ref5.productId;
    return _resources2.default.getCoursesForCountry.get().withParams({ countryCode: countryCode, productId: productId }).withBody({ countryCode: countryCode }).send();
};

var saveDefaultCourses = exports.saveDefaultCourses = function saveDefaultCourses(_ref6) {
    var accessStatus = _ref6.accessStatus,
        countryCode = _ref6.countryCode,
        stateCode = _ref6.stateCode,
        productId = _ref6.productId,
        defaultCourses = _ref6.defaultCourses;
    return _resources2.default.saveDefaultCourses.post().withBody({ accessStatus: accessStatus, countryCode: countryCode, stateCode: stateCode, productId: productId, defaultCourses: defaultCourses }).send();
};

var saveDefaultCoursesForCountry = exports.saveDefaultCoursesForCountry = function saveDefaultCoursesForCountry(accessCode, productId, defaultCourses) {
    return _resources2.default.getDefaultCourseForCountry.put().withParams({ accessCode: accessCode, productId: productId }).withBody(defaultCourses).raw().send();
};

var saveDefaultCourse = exports.saveDefaultCourse = function saveDefaultCourse(requestBody) {
    return _resources2.default.saveDefaultCourse.post().withBody(requestBody).send();
};

var publishDefaultCourse = exports.publishDefaultCourse = function publishDefaultCourse(_ref7) {
    var courseId = _ref7.courseId,
        productId = _ref7.productId;
    return _resources2.default.publishDefaultCourse.put({ courseId: courseId }).withParams({ productId: productId }).withBody().raw().send();
};

var archiveSelectedCourse = exports.archiveSelectedCourse = function archiveSelectedCourse(productId, courseId, courseVersion) {
    return _resources2.default.archiveSelectedCourse.delete({ courseId: courseId, courseVersion: courseVersion }).withParams({ productId: productId }).withBody().raw().send();
};

/**
 * CURRICULUM/MASTER COURSE
 */
var getMasterCourses = exports.getMasterCourses = function getMasterCourses(_ref8) {
    var accessStatus = _ref8.accessStatus;
    return _resources2.default.getMasterCoursesByAccessStatus.post().withBody({ accessStatus: accessStatus }).send();
};

var getMasterCoursesCountries = exports.getMasterCoursesCountries = function getMasterCoursesCountries() {
    return _resources2.default.getMasterCoursesCountries.get().send();
};

var getMasterCoursesByCountry = exports.getMasterCoursesByCountry = function getMasterCoursesByCountry(_ref9) {
    var countryCode = _ref9.countryCode;
    return _resources2.default.getMasterCoursesByCountry.get().withParams({ countryCode: countryCode }).send();
};

var getMasterCourse = exports.getMasterCourse = function getMasterCourse(masterCourseId, version) {
    return _resources2.default.getMasterCourse.get({ masterCourseId: masterCourseId, version: version }).send();
};

/**
 * SUBJECTS
 */
var getSubjects = exports.getSubjects = function getSubjects() {
    return _resources2.default.getSubjects.get().send();
};

/**
 * AUTH
 */
var checkUserIsAuthorised = exports.checkUserIsAuthorised = function checkUserIsAuthorised() {
    return _resources2.default.checkUserIsAuthorised.get().send();
};

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SHOW_TOAST = exports.SHOW_TOAST = 'SHOW_TOAST';
var showToast = exports.showToast = function showToast(message, messageType) {
    return { type: SHOW_TOAST, isToastVisible: true, message: message, messageType: messageType };
};

var HIDE_TOAST = exports.HIDE_TOAST = 'HIDE_TOAST';
var hideToast = exports.hideToast = function hideToast() {
    return { type: HIDE_TOAST, isToastVisible: false };
};

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GET_MASTER_COURSES_COUNTRIES_REQUEST = exports.GET_MASTER_COURSES_COUNTRIES_REQUEST = 'GET_MASTER_COURSES_COUNTRIES_REQUEST';
var GET_MASTER_COURSES_COUNTRIES_SUCCESS = exports.GET_MASTER_COURSES_COUNTRIES_SUCCESS = 'GET_MASTER_COURSES_COUNTRIES_SUCCESS';
var GET_MASTER_COURSES_COUNTRIES_FAILURE = exports.GET_MASTER_COURSES_COUNTRIES_FAILURE = 'GET_MASTER_COURSES_COUNTRIES_FAILURE';

var getMasterCoursesCountries = exports.getMasterCoursesCountries = function getMasterCoursesCountries() {
    return { type: GET_MASTER_COURSES_COUNTRIES_REQUEST };
};

var getMasterCoursesCountriesSuccess = exports.getMasterCoursesCountriesSuccess = function getMasterCoursesCountriesSuccess(countries) {
    return { type: GET_MASTER_COURSES_COUNTRIES_SUCCESS, countries: countries };
};

var getMasterCoursesCountriesFailure = exports.getMasterCoursesCountriesFailure = function getMasterCoursesCountriesFailure() {
    return { type: GET_MASTER_COURSES_COUNTRIES_FAILURE };
};

var GET_MASTER_COURSES_BY_COUNTRY_REQUEST = exports.GET_MASTER_COURSES_BY_COUNTRY_REQUEST = 'GET_MASTER_COURSES_BY_COUNTRY_REQUEST';
var GET_MASTER_COURSES_BY_COUNTRY_SUCCESS = exports.GET_MASTER_COURSES_BY_COUNTRY_SUCCESS = 'GET_MASTER_COURSES_BY_COUNTRY_SUCCESS';
var GET_MASTER_COURSES_BY_COUNTRY_FAILURE = exports.GET_MASTER_COURSES_BY_COUNTRY_FAILURE = 'GET_MASTER_COURSES_BY_COUNTRY_FAILURE';

var getMasterCoursesByCountry = exports.getMasterCoursesByCountry = function getMasterCoursesByCountry() {
    var countryCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'AUS';
    return { type: GET_MASTER_COURSES_BY_COUNTRY_REQUEST, countryCode: countryCode };
};

var getMasterCoursesByCountrySuccess = exports.getMasterCoursesByCountrySuccess = function getMasterCoursesByCountrySuccess(masterCourses) {
    return { type: GET_MASTER_COURSES_BY_COUNTRY_SUCCESS, masterCourses: masterCourses };
};

var getMasterCoursesByCountryFailure = exports.getMasterCoursesByCountryFailure = function getMasterCoursesByCountryFailure() {
    return { type: GET_MASTER_COURSES_BY_COUNTRY_FAILURE };
};

var GET_SUBJECTS_REQUEST = exports.GET_SUBJECTS_REQUEST = 'GET_SUBJECTS_REQUEST';
var GET_SUBJECTS_SUCCESS = exports.GET_SUBJECTS_SUCCESS = 'GET_SUBJECTS_SUCCESS';
var GET_SUBJECTS_FAILURE = exports.GET_SUBJECTS_FAILURE = 'GET_SUBJECTS_FAILURE';

var getSubjects = exports.getSubjects = function getSubjects() {
    return { type: GET_SUBJECTS_REQUEST };
};

var getSubjectsSuccess = exports.getSubjectsSuccess = function getSubjectsSuccess(subjects) {
    return { type: GET_SUBJECTS_SUCCESS, subjects: subjects };
};

var getSubjectsFailure = exports.getSubjectsFailure = function getSubjectsFailure() {
    return { type: GET_SUBJECTS_FAILURE };
};

var CHANGE_SUBJECT = exports.CHANGE_SUBJECT = 'CHANGE_SUBJECT';

var changeSubject = exports.changeSubject = function changeSubject(productId) {
    return { type: CHANGE_SUBJECT, productId: productId };
};

var CHANGE_COUNTRY = exports.CHANGE_COUNTRY = 'CHANGE_COUNTRY';

var changeCountry = exports.changeCountry = function changeCountry(countryCode) {
    return { type: CHANGE_COUNTRY, countryCode: countryCode };
};

var FILTER_MASTER_COURSES = exports.FILTER_MASTER_COURSES = 'FILTER_MASTER_COURSES';

var filterMasterCourses = exports.filterMasterCourses = function filterMasterCourses(searchFilter) {
    return { type: FILTER_MASTER_COURSES, searchFilter: searchFilter };
};

var GET_MASTER_COURSES_REQUEST = exports.GET_MASTER_COURSES_REQUEST = 'GET_MASTER_COURSES_REQUEST';
var GET_MASTER_COURSES_SUCCESS = exports.GET_MASTER_COURSES_SUCCESS = 'GET_MASTER_COURSES_SUCCESS';
var GET_MASTER_COURSES_FAILURE = exports.GET_MASTER_COURSES_FAILURE = 'GET_MASTER_COURSES_FAILURE';

var getMasterCourses = exports.getMasterCourses = function getMasterCourses(accessStatus) {
    return { type: GET_MASTER_COURSES_REQUEST, accessStatus: accessStatus };
};

var getMasterCoursesSuccess = exports.getMasterCoursesSuccess = function getMasterCoursesSuccess(masterCourses) {
    return { type: GET_MASTER_COURSES_SUCCESS, masterCourses: masterCourses };
};

var getMasterCoursesFailure = exports.getMasterCoursesFailure = function getMasterCoursesFailure() {
    return { type: GET_MASTER_COURSES_FAILURE };
};

var RESET_MASTER_COURSES = exports.RESET_MASTER_COURSES = 'RESET_MASTER_COURSES';

var resetMasterCourses = exports.resetMasterCourses = function resetMasterCourses() {
    return { type: RESET_MASTER_COURSES };
};

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProductList = exports.searchByText = exports.searchByProperty = exports.getQueryParams = undefined;
exports.handleDefaults = handleDefaults;
exports.getAlphaNumericCharacters = getAlphaNumericCharacters;
exports.invalidCharaters = invalidCharaters;
exports.invalidEmailCharaters = invalidEmailCharaters;
exports.isValidEmail = isValidEmail;
exports.getSchoolPreferenceNameFormats = getSchoolPreferenceNameFormats;

var _filter = __webpack_require__(202);

var _filter2 = _interopRequireDefault(_filter);

var _lodash = __webpack_require__(950);

var _lodash2 = _interopRequireDefault(_lodash);

var _querystring = __webpack_require__(332);

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getQueryParams = exports.getQueryParams = function getQueryParams() {
    var queryParams = location.search;
    var query = queryParams.replace('?', '');
    return _querystring2.default.parse(query);
};

function handleDefaults(defaultObj, dynamicObj) {
    for (var key in dynamicObj) {
        defaultObj[key] = dynamicObj[key];
    }
    return defaultObj;
}

function getAlphaNumericCharacters() {
    return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
}

function invalidCharaters() {
    return '^[^!@#$%^&+={}/?<>]+$';
}

function invalidEmailCharaters() {
    return '^[^()<>,;:\\/"{}]+$';
}

function isValidEmail(emailAddress) {
    var re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/igm;
    return re.test(emailAddress);
}

function getSchoolPreferenceNameFormats(nameFormats) {
    var options = nameFormats.availableOptions.map(function (item) {
        return {
            id: item.value,
            name: item.text,
            isDefault: nameFormats.preferredValue === item.value
        };
    });

    return options;
}

var searchByProperty = exports.searchByProperty = function searchByProperty(collection, needleObj) {
    return (0, _filter2.default)(collection, needleObj);
};

var searchByText = exports.searchByText = function searchByText(collection, text) {
    var exclude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['id'];

    var filterWithByProperty = exclude.length > 0 ? _lodash2.default.omit : _lodash2.default.omit;
    return _lodash2.default.filter(collection, _lodash2.default.flow(_lodash2.default.partial(filterWithByProperty, _lodash2.default, exclude), _lodash2.default.partial(_lodash2.default.some, _lodash2.default, _lodash2.default.flow(_lodash2.default.toLower, _lodash2.default.partial(_lodash2.default.includes, _lodash2.default, _lodash2.default.toLower(text), 0)))));
};

var getProductList = exports.getProductList = function getProductList() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var products = [{ id: 1, name: 'Mathletics' }, { id: 10, name: 'Spelling' }, { id: 11, name: 'Writing' }];
    if (id === null) {
        return products;
    }
    var product = products.filter(function (p) {
        return p.id === id;
    });
    var name = product[0] !== undefined ? product[0].name : '';
    return name;
};

/***/ })

},[1147]);


// WEBPACK FOOTER //
// entry-app.77cb852cccb198a07923.js